/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listColorPallete:{
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ColorPalleteOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateColorPallete:{
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ColorPalleteOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateColorPallete:{
			data:{
				type:"ColorPalleteCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ColorPalleteUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCover:{
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CoverOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCover:{
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CoverOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCover:{
			data:{
				type:"CoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventLocale:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventLocale:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventLocale:{
			data:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageItem:{
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageItem:{
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageItem:{
			data:{
				type:"ImageItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMedium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMedium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMedium:{
			data:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBlog:{
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlog:{
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBlog:{
			data:{
				type:"BlogCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BlogUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBlogLocale:{
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlogLocale:{
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBlogLocale:{
			data:{
				type:"BlogLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BlogLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPageLocale:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePageLocale:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePageLocale:{
			data:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeoLocale:{
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeoLocale:{
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeoLocale:{
			data:{
				type:"SeoLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLocalizedSeo:{
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocalizedSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocalizedSeo:{
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocalizedSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLocalizedSeo:{
			data:{
				type:"LocalizedSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LocalizedSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHero:{
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeroOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHero:{
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeroOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHero:{
			data:{
				type:"HeroCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeroUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialsAndApps:{
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialsAndAppsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialsAndApps:{
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialsAndAppsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialsAndApps:{
			data:{
				type:"SocialsAndAppsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialsAndAppsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSiteMenu:{
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SiteMenuOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSiteMenu:{
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SiteMenuOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSiteMenu:{
			data:{
				type:"SiteMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SiteMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMenuItem:{
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMenuItem:{
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMenuItem:{
			data:{
				type:"MenuItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MenuItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBlogPostList:{
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlogPostList:{
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBlogPostList:{
			data:{
				type:"BlogPostListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BlogPostListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBlogPostListItem:{
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlogPostListItem:{
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBlogPostListItem:{
			data:{
				type:"BlogPostListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BlogPostListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMenuLocale:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMenuLocale:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMenuLocale:{
			data:{
				type:"MenuLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MenuLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProductGrid:{
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProductGrid:{
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProductGrid:{
			data:{
				type:"ProductGridCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProductGridUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProductGridItem:{
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProductGridItem:{
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProductGridItem:{
			data:{
				type:"ProductGridItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProductGridItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfile:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfile:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfile:{
			data:{
				type:"ProfileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfileTag:{
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfileTag:{
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfileTag:{
			data:{
				type:"ProfileTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfileActivityRecord:{
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileActivityRecordOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfileActivityRecord:{
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileActivityRecordOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfileActivityRecord:{
			data:{
				type:"ProfileActivityRecordCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileActivityRecordUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfilePin:{
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfilePinOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfilePin:{
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfilePinOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfilePin:{
			data:{
				type:"ProfilePinCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfilePinUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfileGallery:{
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfileGallery:{
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfileGallery:{
			data:{
				type:"ProfileGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfileGalleryItem:{
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfileGalleryItem:{
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfileGalleryItem:{
			data:{
				type:"ProfileGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShoppingList:{
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShoppingList:{
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShoppingList:{
			data:{
				type:"ShoppingListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShoppingListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShoppingListItem:{
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShoppingListItem:{
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShoppingListItem:{
			data:{
				type:"ShoppingListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShoppingListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSupplier:{
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SupplierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSupplier:{
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SupplierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSupplier:{
			data:{
				type:"SupplierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SupplierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFavouriteItem:{
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FavouriteItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFavouriteItem:{
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FavouriteItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFavouriteItem:{
			data:{
				type:"FavouriteItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FavouriteItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBusinessOrderType:{
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBusinessOrderType:{
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBusinessOrderType:{
			data:{
				type:"BusinessOrderTypeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BusinessOrderTypeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBusinessOrderTypeLocale:{
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBusinessOrderTypeLocale:{
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBusinessOrderTypeLocale:{
			data:{
				type:"BusinessOrderTypeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BusinessOrderTypeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	UUID: "String",
	ColorPalleteUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ColorPalleteWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		background:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ColorPalleteWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ColorPalleteWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ColorPalleteWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UUIDCondition:{
		and:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StringCondition:{
		and:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contains:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		containsCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ColorPalleteOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		background:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OrderDirection: "enum",
	ColorPalleteCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		background:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ColorPalleteUpdateInput:{
		background:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Content:{
		blocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByReferences:{
			by:{
				type:"ContentBlocksByReferencesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentBlock:{
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		references:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReferences:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IntCondition:{
		and:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		jsonContent:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorPallete:{
			type:"ColorPalleteWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		misc:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		hero:{
			type:"HeroWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentSize:{
			type:"ContentSizeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsAndApps:{
			type:"SocialsAndAppsWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPosts:{
			type:"BlogPostListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		productGrid:{
			type:"ProductGridWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceTypeCondition:{
		and:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceType: "enum",
	MediumWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorTheme:{
			type:"ColorThemeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"VideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MediumWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MediumWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MediumWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumTypeCondition:{
		and:{
			type:"MediumTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"MediumTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"MediumTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"MediumType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"MediumType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumType: "enum",
	ColorThemeCondition:{
		and:{
			type:"ColorThemeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ColorThemeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ColorThemeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ColorTheme",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ColorTheme",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ColorTheme",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ColorTheme",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ColorTheme",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ColorTheme",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ColorTheme",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ColorTheme",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ColorTheme: "enum",
	ImageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"FloatCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"VideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"VideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"VideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FloatCondition:{
		and:{
			type:"FloatCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"FloatCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"FloatCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Float",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Float",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkTypeCondition:{
		and:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkType: "enum",
	LinkableWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"LocalizedSeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"PageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogs:{
			type:"BlogLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pages:{
			type:"PageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seos:{
			type:"SeoLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		menus:{
			type:"MenuLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		businessOrderTypes:{
			type:"BusinessOrderTypeLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"CoverWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"LocalizedSeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EventLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EventLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EventWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EventWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EventWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttonColors:{
			type:"ColorPalleteWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"CoverWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"CoverWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"CoverWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BooleanCondition:{
		and:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalizedSeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LocalizedSeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LocalizedSeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LocalizedSeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		pageName:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BlogWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BlogLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BlogLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BlogLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BlogLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BlogWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BlogWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BlogWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OneCondition:{
		and:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	One: "enum",
	SeoLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SeoLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SiteMenuWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MenuItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MenuLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MenuLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MenuLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"MenuLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SiteMenuWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SiteMenuWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SiteMenuWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		menu:{
			type:"MenuLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MenuItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MenuItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MenuItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BusinessOrderTypeWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BusinessOrderTypeLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BusinessOrderTypeLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BusinessOrderTypeLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BusinessOrderTypeLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BusinessOrderTypeWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BusinessOrderTypeWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BusinessOrderTypeWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeroWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		showLogo:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		middleContent:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeroWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeroWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeroWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentSizeCondition:{
		and:{
			type:"ContentSizeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentSizeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentSizeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentSize",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentSize",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentSize: "enum",
	SocialsAndAppsWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		appStore:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		googlePlay:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialsAndAppsWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialsAndAppsWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialsAndAppsWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BlogPostListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BlogPostListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BlogPostListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BlogPostListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BlogPostListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPost:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BlogPostListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BlogPostListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BlogPostListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ProductGridItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProductGridWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProductGridWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProductGridWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokProductId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ProductGridWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProductGridItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProductGridItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProductGridItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReference:{
		block:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		colorPallete:{
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		medium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		hero:{
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		gallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		socialsAndApps:{
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blogPosts:{
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		productGrid:{
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Medium:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		video:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Video:{
		poster:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Link:{
		internalLink:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Linkable:{
		page:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		event:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PageLocale:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		root:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Page:{
		locales:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"PageLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"PageLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"PageLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByContent:{
			by:{
				type:"PageLocalesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PageLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"LocalizedSeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"CoverOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"LocalizedSeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttonColors:{
			type:"ColorPalleteOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorTheme:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"VideoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalizedSeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogs:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pages:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seos:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		menus:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		businessOrderTypes:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"CoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalizedSeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BlogUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SiteMenuUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BusinessOrderTypeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocalesBySeoUniqueWhere:{
		seo:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocalesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Locale:{
		events:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blogs:{
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pages:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seos:{
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		menus:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		businessOrderTypes:{
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsByRoot:{
			by:{
				type:"LocaleEventsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsByCover:{
			by:{
				type:"LocaleEventsByCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsByContent:{
			by:{
				type:"LocaleEventsByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsByLink:{
			by:{
				type:"LocaleEventsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsBySeo:{
			by:{
				type:"LocaleEventsBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blogsByRoot:{
			by:{
				type:"LocaleBlogsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pagesByRoot:{
			by:{
				type:"LocalePagesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pagesByLink:{
			by:{
				type:"LocalePagesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pagesBySeo:{
			by:{
				type:"LocalePagesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pagesByContent:{
			by:{
				type:"LocalePagesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seosByRoot:{
			by:{
				type:"LocaleSeosByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		menusByRoot:{
			by:{
				type:"LocaleMenusByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		menusByItems:{
			by:{
				type:"LocaleMenusByItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		businessOrderTypesByRoot:{
			by:{
				type:"LocaleBusinessOrderTypesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEvents:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlogs:{
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePages:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeos:{
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMenus:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBusinessOrderTypes:{
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EventLocale:{
		root:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		cover:{
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Event:{
		locales:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"EventLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByCover:{
			by:{
				type:"EventLocalesByCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByContent:{
			by:{
				type:"EventLocalesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"EventLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"EventLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EventLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocalesByCoverUniqueWhere:{
		cover:{
			type:"CoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocalesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocalesBySeoUniqueWhere:{
		seo:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Cover:{
		buttonColors:{
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		medium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LocalizedSeo:{
		ogImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BlogLocale:{
		root:{
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Blog:{
		locales:{
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"BlogLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BlogLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		pageName:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BlogOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocale:{
		root:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Seo:{
		ogImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locales:{
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"SeoLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SeoLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocale:{
		root:{
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		items:{
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SiteMenu:{
		locales:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"SiteMenuLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByItems:{
			by:{
				type:"SiteMenuLocalesByItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MenuLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SiteMenuOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuLocalesByItemsUniqueWhere:{
		items:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItem:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		menu:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MenuItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		menu:{
			type:"MenuLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocale:{
		root:{
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BusinessOrderType:{
		locales:{
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"BusinessOrderTypeLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BusinessOrderTypeLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BusinessOrderTypeOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsByRootUniqueWhere:{
		root:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsByCoverUniqueWhere:{
		cover:{
			type:"CoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsBySeoUniqueWhere:{
		seo:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleBlogsByRootUniqueWhere:{
		root:{
			type:"BlogUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalePagesByRootUniqueWhere:{
		root:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalePagesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalePagesBySeoUniqueWhere:{
		seo:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalePagesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleSeosByRootUniqueWhere:{
		root:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleMenusByRootUniqueWhere:{
		root:{
			type:"SiteMenuUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleMenusByItemsUniqueWhere:{
		items:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleBusinessOrderTypesByRootUniqueWhere:{
		root:{
			type:"BusinessOrderTypeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Hero:{
		medium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Gallery:{
		items:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GalleryItem:{
		list:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		medium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GalleryItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostList:{
		items:{
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BlogPostListItem:{
		list:{
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blogPost:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BlogPostListItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BlogPostListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPost:{
			type:"EventLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGrid:{
		items:{
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProductGridItem:{
		list:{
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		medium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProductGridItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokProductId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ProductGridOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		jsonContent:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorPallete:{
			type:"ColorPalleteOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		misc:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		hero:{
			type:"HeroOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentSize:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsAndApps:{
			type:"SocialsAndAppsOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPosts:{
			type:"BlogPostListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		productGrid:{
			type:"ProductGridOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeroOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		showLogo:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		middleContent:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialsAndAppsOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		appStore:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		googlePlay:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlocksByReferencesUniqueWhere:{
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateBlocksEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateReferencesEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		jsonContent:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorPallete:{
			type:"ContentReferenceCreateColorPalleteEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"ContentReferenceCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		misc:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		hero:{
			type:"ContentReferenceCreateHeroEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentReferenceCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentSize:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsAndApps:{
			type:"ContentReferenceCreateSocialsAndAppsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPosts:{
			type:"ContentReferenceCreateBlogPostsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		productGrid:{
			type:"ContentReferenceCreateProductGridEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateColorPalleteEntityRelationInput:{
		connect:{
			type:"ColorPalleteUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ColorPalleteCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateMediumEntityRelationInput:{
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorTheme:{
			type:"ColorTheme",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MediumCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"MediumCreateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumCreateVideoEntityRelationInput:{
		connect:{
			type:"VideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"VideoCreatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoCreatePosterEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkCreateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreatePageEntityRelationInput:{
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutPagesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleCreateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleCreateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleCreateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleCreateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateEventsEntityRelationInput:{
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"EventLocaleCreateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateCoverEntityRelationInput:{
		connect:{
			type:"CoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttonColors:{
			type:"CoverCreateButtonColorsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"CoverCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverCreateButtonColorsEntityRelationInput:{
		connect:{
			type:"ColorPalleteUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ColorPalleteCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverCreateMediumEntityRelationInput:{
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutEventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocalizedSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalizedSeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"LocalizedSeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalizedSeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateBlogsEntityRelationInput:{
		connect:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		pageName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BlogLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"BlogUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateSeosEntityRelationInput:{
		connect:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateMenusEntityRelationInput:{
		connect:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MenuLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"MenuLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MenuLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"SiteMenuUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SiteMenuWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleCreateItemsEntityRelationInput:{
		connect:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MenuItemWithoutMenuCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemWithoutMenuCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"MenuItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateBusinessOrderTypesEntityRelationInput:{
		connect:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BusinessOrderTypeLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BusinessOrderTypeLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"BusinessOrderTypeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BusinessOrderTypeWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocalizedSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateEventEntityRelationInput:{
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"EventLocaleCreateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutEventsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutEventsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogs:{
			type:"LocaleCreateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleCreateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleCreateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleCreateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreatePagesEntityRelationInput:{
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateHeroEntityRelationInput:{
		connect:{
			type:"HeroUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeroCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeroUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeroCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		showLogo:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		middleContent:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"HeroCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeroCreateMediumEntityRelationInput:{
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateGalleryEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryCreateItemsEntityRelationInput:{
		connect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"GalleryItemCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateMediumEntityRelationInput:{
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateSocialsAndAppsEntityRelationInput:{
		connect:{
			type:"SocialsAndAppsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialsAndAppsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialsAndAppsUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialsAndAppsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		appStore:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		googlePlay:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateBlogPostsEntityRelationInput:{
		connect:{
			type:"BlogPostListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogPostListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BlogPostListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BlogPostListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListCreateItemsEntityRelationInput:{
		connect:{
			type:"BlogPostListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogPostListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPost:{
			type:"BlogPostListItemCreateBlogPostEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemCreateBlogPostEntityRelationInput:{
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"EventLocaleCreateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateProductGridEntityRelationInput:{
		connect:{
			type:"ProductGridUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductGridCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ProductGridItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ProductGridCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridCreateItemsEntityRelationInput:{
		connect:{
			type:"ProductGridItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductGridItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokProductId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"ProductGridItemCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ProductGridItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemCreateMediumEntityRelationInput:{
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateInput:{
		blocks:{
			type:"ContentUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentUpsertBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockUpdateReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		jsonContent:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorPallete:{
			type:"ContentReferenceUpdateColorPalleteEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"ContentReferenceUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		misc:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		hero:{
			type:"ContentReferenceUpdateHeroEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentReferenceUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentSize:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsAndApps:{
			type:"ContentReferenceUpdateSocialsAndAppsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPosts:{
			type:"ContentReferenceUpdateBlogPostsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		productGrid:{
			type:"ContentReferenceUpdateProductGridEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateColorPalleteEntityRelationInput:{
		create:{
			type:"ColorPalleteCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ColorPalleteUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertColorPalleteRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ColorPalleteUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertColorPalleteRelationInput:{
		update:{
			type:"ColorPalleteUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ColorPalleteCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateMediumEntityRelationInput:{
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertMediumRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpdateInput:{
		type:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorTheme:{
			type:"ColorTheme",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MediumUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"MediumUpdateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpdateVideoEntityRelationInput:{
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"VideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumUpsertVideoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"VideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpdateInput:{
		src:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"VideoUpdatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpdatePosterEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"VideoUpsertPosterRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpsertPosterRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpsertVideoRelationInput:{
		update:{
			type:"VideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertMediumRelationInput:{
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInput:{
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkUpdateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkUpsertInternalLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdatePageEntityRelationInput:{
		create:{
			type:"PageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"PageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutLocalesUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertRootRelationInput:{
		update:{
			type:"PageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutPagesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleUpdateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleUpdateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleUpdateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleUpdateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateEventsEntityRelationInput:{
		create:{
			type:"EventLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateEventsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertEventsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateEventsRelationInput:{
		by:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EventLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutLocaleUpdateInput:{
		root:{
			type:"EventLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"EventLocaleUpdateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"EventWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertRootRelationInput:{
		update:{
			type:"EventWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateCoverEntityRelationInput:{
		create:{
			type:"CoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CoverUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertCoverRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverUpdateInput:{
		primaryTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttonColors:{
			type:"CoverUpdateButtonColorsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"CoverUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverUpdateButtonColorsEntityRelationInput:{
		create:{
			type:"ColorPalleteCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ColorPalleteUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CoverUpsertButtonColorsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ColorPalleteUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverUpsertButtonColorsRelationInput:{
		update:{
			type:"ColorPalleteUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ColorPalleteCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverUpdateMediumEntityRelationInput:{
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CoverUpsertMediumRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CoverUpsertMediumRelationInput:{
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertCoverRelationInput:{
		update:{
			type:"CoverUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutEventUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"LocalizedSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocalizedSeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalizedSeoUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"LocalizedSeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalizedSeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocalizedSeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalizedSeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertSeoRelationInput:{
		update:{
			type:"LocalizedSeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocalizedSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertEventsRelationInput:{
		by:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateBlogsEntityRelationInput:{
		create:{
			type:"BlogLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateBlogsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertBlogsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateBlogsRelationInput:{
		by:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BlogLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleWithoutLocaleUpdateInput:{
		pageName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BlogLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"BlogWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BlogWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BlogLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BlogUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleUpsertRootRelationInput:{
		update:{
			type:"BlogWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertBlogsRelationInput:{
		by:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BlogLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateSeosEntityRelationInput:{
		create:{
			type:"SeoLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateSeosRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertSeosRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateSeosRelationInput:{
		by:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SeoLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"SeoWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWithoutLocalesUpdateInput:{
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleUpsertRootRelationInput:{
		update:{
			type:"SeoWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertSeosRelationInput:{
		by:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateMenusEntityRelationInput:{
		create:{
			type:"MenuLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateMenusRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertMenusRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateMenusRelationInput:{
		by:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"MenuLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleWithoutLocaleUpdateInput:{
		root:{
			type:"MenuLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MenuLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"SiteMenuWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SiteMenuWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MenuLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SiteMenuUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUpsertRootRelationInput:{
		update:{
			type:"SiteMenuWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SiteMenuWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUpdateItemsEntityRelationInput:{
		create:{
			type:"MenuItemWithoutMenuCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MenuLocaleUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MenuLocaleUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUpdateItemsRelationInput:{
		by:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"MenuItemWithoutMenuUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemWithoutMenuUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"MenuItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MenuItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUpsertItemsRelationInput:{
		by:{
			type:"MenuItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MenuItemWithoutMenuUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MenuItemWithoutMenuCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertMenusRelationInput:{
		by:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MenuLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MenuLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateBusinessOrderTypesEntityRelationInput:{
		create:{
			type:"BusinessOrderTypeLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateBusinessOrderTypesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertBusinessOrderTypesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateBusinessOrderTypesRelationInput:{
		by:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BusinessOrderTypeLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BusinessOrderTypeLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"BusinessOrderTypeWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BusinessOrderTypeWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BusinessOrderTypeLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BusinessOrderTypeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleUpsertRootRelationInput:{
		update:{
			type:"BusinessOrderTypeWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BusinessOrderTypeWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertBusinessOrderTypesRelationInput:{
		by:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BusinessOrderTypeLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BusinessOrderTypeLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"LocalizedSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocalizedSeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocalizedSeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertSeoRelationInput:{
		update:{
			type:"LocalizedSeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocalizedSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertPageRelationInput:{
		update:{
			type:"PageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateEventEntityRelationInput:{
		create:{
			type:"EventLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertEventRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutLinkUpdateInput:{
		root:{
			type:"EventLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"EventLocaleUpdateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutEventsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutEventsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutEventsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogs:{
			type:"LocaleUpdateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleUpdateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleUpdateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleUpdateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdatePagesEntityRelationInput:{
		create:{
			type:"PageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdatePagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertPagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdatePagesRelationInput:{
		by:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertPagesRelationInput:{
		by:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutEventsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutEventsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertEventRelationInput:{
		update:{
			type:"EventLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpsertInternalLinkRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateHeroEntityRelationInput:{
		create:{
			type:"HeroCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeroUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertHeroRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeroUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeroUpdateInput:{
		showLogo:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		middleContent:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"HeroUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeroUpdateMediumEntityRelationInput:{
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeroUpsertMediumRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeroUpsertMediumRelationInput:{
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertHeroRelationInput:{
		update:{
			type:"HeroUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeroCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateGalleryEntityRelationInput:{
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateInput:{
		items:{
			type:"GalleryUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateItemsEntityRelationInput:{
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateItemsRelationInput:{
		by:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"GalleryItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"GalleryItemUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateMediumEntityRelationInput:{
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryItemUpsertMediumRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpsertMediumRelationInput:{
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpsertItemsRelationInput:{
		by:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertGalleryRelationInput:{
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateSocialsAndAppsEntityRelationInput:{
		create:{
			type:"SocialsAndAppsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialsAndAppsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertSocialsAndAppsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialsAndAppsUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialsAndAppsUpdateInput:{
		instagram:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		appStore:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		googlePlay:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertSocialsAndAppsRelationInput:{
		update:{
			type:"SocialsAndAppsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialsAndAppsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateBlogPostsEntityRelationInput:{
		create:{
			type:"BlogPostListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BlogPostListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertBlogPostsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BlogPostListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListUpdateInput:{
		items:{
			type:"BlogPostListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListUpdateItemsEntityRelationInput:{
		create:{
			type:"BlogPostListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BlogPostListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BlogPostListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BlogPostListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BlogPostListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BlogPostListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListUpdateItemsRelationInput:{
		by:{
			type:"BlogPostListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BlogPostListItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPost:{
			type:"BlogPostListItemUpdateBlogPostEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemUpdateBlogPostEntityRelationInput:{
		create:{
			type:"EventLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BlogPostListItemUpsertBlogPostRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateInput:{
		root:{
			type:"EventLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"EventLocaleUpdateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemUpsertBlogPostRelationInput:{
		update:{
			type:"EventLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListUpsertItemsRelationInput:{
		by:{
			type:"BlogPostListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BlogPostListItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogPostListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertBlogPostsRelationInput:{
		update:{
			type:"BlogPostListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogPostListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateProductGridEntityRelationInput:{
		create:{
			type:"ProductGridCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProductGridUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertProductGridRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProductGridUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridUpdateInput:{
		items:{
			type:"ProductGridUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridUpdateItemsEntityRelationInput:{
		create:{
			type:"ProductGridItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProductGridUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProductGridUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProductGridItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProductGridItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProductGridItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridUpdateItemsRelationInput:{
		by:{
			type:"ProductGridItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProductGridItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokProductId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"ProductGridItemUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ProductGridItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemUpdateMediumEntityRelationInput:{
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProductGridItemUpsertMediumRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemUpsertMediumRelationInput:{
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProductGridItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridUpsertItemsRelationInput:{
		by:{
			type:"ProductGridItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProductGridItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductGridItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertProductGridRelationInput:{
		update:{
			type:"ProductGridUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductGridCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpsertBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateContentEntityRelationInput:{
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertContentRelationInput:{
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		jsonContent:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceCreateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorPallete:{
			type:"ContentReferenceCreateColorPalleteEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"ContentReferenceCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		misc:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		hero:{
			type:"ContentReferenceCreateHeroEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentReferenceCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentSize:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsAndApps:{
			type:"ContentReferenceCreateSocialsAndAppsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPosts:{
			type:"ContentReferenceCreateBlogPostsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		productGrid:{
			type:"ContentReferenceCreateProductGridEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateBlockEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		jsonContent:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceUpdateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		colorPallete:{
			type:"ContentReferenceUpdateColorPalleteEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"ContentReferenceUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		misc:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		hero:{
			type:"ContentReferenceUpdateHeroEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentReferenceUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentSize:{
			type:"ContentSize",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsAndApps:{
			type:"ContentReferenceUpdateSocialsAndAppsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPosts:{
			type:"ContentReferenceUpdateBlogPostsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		productGrid:{
			type:"ContentReferenceUpdateProductGridEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateBlockEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertBlockRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertBlockRelationInput:{
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EventCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateLocalesEntityRelationInput:{
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"EventLocaleCreateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EventUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateLocalesEntityRelationInput:{
		create:{
			type:"EventLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateLocalesRelationInput:{
		by:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EventLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutRootUpdateInput:{
		locale:{
			type:"EventLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"EventLocaleUpdateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForWeb:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		availableForMobile:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertLocalesRelationInput:{
		by:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageList:{
		items:{
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ImageItem:{
		list:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ImageListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListCreateItemsEntityRelationInput:{
		connect:{
			type:"ImageItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateInput:{
		items:{
			type:"ImageListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateItemsEntityRelationInput:{
		create:{
			type:"ImageItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ImageItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ImageItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateItemsRelationInput:{
		by:{
			type:"ImageItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ImageItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpsertItemsRelationInput:{
		by:{
			type:"ImageItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemCreateListEntityRelationInput:{
		connect:{
			type:"ImageListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemUpdateListEntityRelationInput:{
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageItemUpsertListRelationInput:{
		update:{
			type:"ImageListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleCreateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleCreateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleCreateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleCreateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleUpdateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleUpdateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleUpdateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleUpdateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BlogCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogCreateLocalesEntityRelationInput:{
		connect:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		pageName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BlogLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutBlogsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutBlogsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleCreateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleCreateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleCreateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BlogUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogUpdateLocalesEntityRelationInput:{
		create:{
			type:"BlogLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BlogUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BlogUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogUpdateLocalesRelationInput:{
		by:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BlogLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleWithoutRootUpdateInput:{
		pageName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BlogLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutBlogsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutBlogsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BlogLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutBlogsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleUpdateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleUpdateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleUpdateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutBlogsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutBlogsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogUpsertLocalesRelationInput:{
		by:{
			type:"BlogLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BlogLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		pageName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BlogLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BlogLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogLocaleUpdateInput:{
		pageName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BlogLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BlogLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"PageCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateLocalesEntityRelationInput:{
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateInput:{
		locales:{
			type:"PageUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateLocalesEntityRelationInput:{
		create:{
			type:"PageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateLocalesRelationInput:{
		by:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpsertLocalesRelationInput:{
		by:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SeoCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateLocalesEntityRelationInput:{
		connect:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SeoLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutSeosCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutSeosCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleCreateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleCreateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleCreateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateInput:{
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SeoUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateLocalesEntityRelationInput:{
		create:{
			type:"SeoLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateLocalesRelationInput:{
		by:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SeoLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SeoLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutSeosCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutSeosUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutSeosUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleUpdateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleUpdateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleUpdateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutSeosUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutSeosCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertLocalesRelationInput:{
		by:{
			type:"SeoLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SeoLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SeoLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"GalleryItemCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateListEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"GalleryItemUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateListEntityRelationInput:{
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpsertListRelationInput:{
		update:{
			type:"GalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SiteMenuCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuCreateLocalesEntityRelationInput:{
		connect:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MenuLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"MenuLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MenuLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutMenusCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutMenusCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleCreateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleCreateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleCreateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SiteMenuUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuUpdateLocalesEntityRelationInput:{
		create:{
			type:"MenuLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SiteMenuUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SiteMenuUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuUpdateLocalesRelationInput:{
		by:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"MenuLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleWithoutRootUpdateInput:{
		locale:{
			type:"MenuLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MenuLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutMenusCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutMenusUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MenuLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutMenusUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleUpdateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleUpdateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		businessOrderTypes:{
			type:"LocaleUpdateBusinessOrderTypesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutMenusUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutMenusCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SiteMenuUpsertLocalesRelationInput:{
		by:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MenuLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MenuLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"MenuItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		menu:{
			type:"MenuItemCreateMenuEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemCreateMenuEntityRelationInput:{
		connect:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MenuLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"MenuLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"MenuLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"MenuItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		menu:{
			type:"MenuItemUpdateMenuEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemUpdateMenuEntityRelationInput:{
		create:{
			type:"MenuLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MenuLocaleWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MenuItemUpsertMenuRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MenuLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleWithoutItemsUpdateInput:{
		root:{
			type:"MenuLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"MenuLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuItemUpsertMenuRelationInput:{
		update:{
			type:"MenuLocaleWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MenuLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BlogPostListItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPost:{
			type:"BlogPostListItemCreateBlogPostEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemCreateListEntityRelationInput:{
		connect:{
			type:"BlogPostListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogPostListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BlogPostListItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		blogPost:{
			type:"BlogPostListItemUpdateBlogPostEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemUpdateListEntityRelationInput:{
		create:{
			type:"BlogPostListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BlogPostListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BlogPostListItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BlogPostListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BlogPostListItemUpsertListRelationInput:{
		update:{
			type:"BlogPostListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BlogPostListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"MenuLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"MenuLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MenuLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MenuLocaleUpdateInput:{
		root:{
			type:"MenuLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"MenuLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MenuLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokProductId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ProductGridItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"ProductGridItemCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ProductGridItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemCreateListEntityRelationInput:{
		connect:{
			type:"ProductGridUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductGridWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokProductId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lead:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ProductGridItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"ProductGridItemUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ProductGridItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemUpdateListEntityRelationInput:{
		create:{
			type:"ProductGridWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProductGridWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProductGridItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProductGridUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductGridItemUpsertListRelationInput:{
		update:{
			type:"ProductGridWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductGridWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Profile:{
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		activityRecords:{
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileActivityRecordOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pins:{
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfilePinOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		gallery:{
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		tags:{
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pinsByActivityRecords:{
			by:{
				type:"ProfilePinsByActivityRecordsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateActivityRecords:{
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileActivityRecordOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePins:{
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfilePinOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTags:{
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProfileActivityRecord:{
		profile:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pin:{
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProfileActivityRecordType: "enum",
	DateTime: "String",
	ProfileWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileActivityRecordWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pins:{
			type:"ProfilePinWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ProfileGalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ProfileTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		familiarity:{
			type:"FamiliarityCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatusCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatusCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProfileWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProfileWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProfileWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ProfileActivityRecordTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		updatedAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		metadata:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pin:{
			type:"ProfilePinWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProfileActivityRecordWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProfileActivityRecordWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProfileActivityRecordWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordTypeCondition:{
		and:{
			type:"ProfileActivityRecordTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ProfileActivityRecordTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ProfileActivityRecordTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ProfileActivityRecordType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ProfileActivityRecordType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateTimeCondition:{
		and:{
			type:"DateTimeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"DateTimeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"DateTime",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"DateTime",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ProfilePinTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedBy:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		reason:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		solution:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileActivityRecordWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProfilePinWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProfilePinWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProfilePinWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinTypeCondition:{
		and:{
			type:"ProfilePinTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ProfilePinTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ProfilePinTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ProfilePinType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ProfilePinType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinType: "enum",
	ProfileGalleryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ProfileGalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProfileGalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProfileGalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProfileGalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ProfileGalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProfileGalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProfileGalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProfileGalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		profiles:{
			type:"ProfileWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProfileTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProfileTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProfileTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FamiliarityCondition:{
		and:{
			type:"FamiliarityCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"FamiliarityCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"FamiliarityCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Familiarity",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Familiarity",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Familiarity: "enum",
	VipStatusCondition:{
		and:{
			type:"VipStatusCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"VipStatusCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"VipStatusCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"VipStatus",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"VipStatus",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VipStatus: "enum",
	ProfileStatusCondition:{
		and:{
			type:"ProfileStatusCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ProfileStatusCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ProfileStatusCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ProfileStatus",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ProfileStatus",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileStatus: "enum",
	ProfilePin:{
		activityRecords:{
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileActivityRecordOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		profile:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateActivityRecords:{
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileActivityRecordOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProfileActivityRecordOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		updatedAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		metadata:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		pin:{
			type:"ProfilePinOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ProfileGalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		familiarity:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedBy:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		reason:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		solution:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGallery:{
		items:{
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		profile:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProfileGalleryItem:{
		gallery:{
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProfileGalleryItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ProfileGalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTag:{
		profiles:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfiles:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ProfileTagOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinsByActivityRecordsUniqueWhere:{
		activityRecords:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pins:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ProfileGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ProfileGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileCreateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pins:{
			type:"ProfileCreatePinsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		gallery:{
			type:"ProfileCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ProfileCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileCreateActivityRecordsEntityRelationInput:{
		connect:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileActivityRecordWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordWithoutProfileCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		updatedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		metadata:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pin:{
			type:"ProfileActivityRecordCreatePinEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordCreatePinEntityRelationInput:{
		connect:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfilePinWithoutActivityRecordsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinWithoutActivityRecordsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedBy:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		reason:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		solution:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfilePinCreateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinCreateProfileEntityRelationInput:{
		connect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileWithoutPinsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileWithoutPinsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileCreateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		gallery:{
			type:"ProfileCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ProfileCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileCreateGalleryEntityRelationInput:{
		connect:{
			type:"ProfileGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileGalleryWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryWithoutProfileCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ProfileGalleryCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryCreateItemsEntityRelationInput:{
		connect:{
			type:"ProfileGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileGalleryItemWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemWithoutGalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ProfileGalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileCreateTagsEntityRelationInput:{
		connect:{
			type:"ProfileTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileTagWithoutProfilesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagWithoutProfilesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileCreatePinsEntityRelationInput:{
		connect:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfilePinWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinWithoutProfileCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedBy:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		reason:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		solution:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfilePinCreateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinCreateActivityRecordsEntityRelationInput:{
		connect:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileActivityRecordWithoutPinCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordWithoutPinCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		updatedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		metadata:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileActivityRecordCreateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordCreateProfileEntityRelationInput:{
		connect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileWithoutActivityRecordsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileWithoutActivityRecordsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pins:{
			type:"ProfileCreatePinsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		gallery:{
			type:"ProfileCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ProfileCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdateInput:{
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileUpdateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pins:{
			type:"ProfileUpdatePinsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		gallery:{
			type:"ProfileUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ProfileUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdateActivityRecordsEntityRelationInput:{
		create:{
			type:"ProfileActivityRecordWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileUpdateActivityRecordsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileUpsertActivityRecordsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdateActivityRecordsRelationInput:{
		by:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProfileActivityRecordWithoutProfileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordWithoutProfileUpdateInput:{
		type:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		updatedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		metadata:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pin:{
			type:"ProfileActivityRecordUpdatePinEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordUpdatePinEntityRelationInput:{
		create:{
			type:"ProfilePinWithoutActivityRecordsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfilePinWithoutActivityRecordsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileActivityRecordUpsertPinRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinWithoutActivityRecordsUpdateInput:{
		type:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedBy:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		reason:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		solution:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfilePinUpdateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinUpdateProfileEntityRelationInput:{
		create:{
			type:"ProfileWithoutPinsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileWithoutPinsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfilePinUpsertProfileRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileWithoutPinsUpdateInput:{
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileUpdateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		gallery:{
			type:"ProfileUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ProfileUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdateGalleryEntityRelationInput:{
		create:{
			type:"ProfileGalleryWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileGalleryWithoutProfileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryWithoutProfileUpdateInput:{
		items:{
			type:"ProfileGalleryUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryUpdateItemsEntityRelationInput:{
		create:{
			type:"ProfileGalleryItemWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileGalleryUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileGalleryUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProfileGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProfileGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryUpdateItemsRelationInput:{
		by:{
			type:"ProfileGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProfileGalleryItemWithoutGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemWithoutGalleryUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ProfileGalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileGalleryItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryUpsertItemsRelationInput:{
		by:{
			type:"ProfileGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileGalleryItemWithoutGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileGalleryItemWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpsertGalleryRelationInput:{
		update:{
			type:"ProfileGalleryWithoutProfileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileGalleryWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdateTagsEntityRelationInput:{
		create:{
			type:"ProfileTagWithoutProfilesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileUpdateTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileUpsertTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProfileTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProfileTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdateTagsRelationInput:{
		by:{
			type:"ProfileTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProfileTagWithoutProfilesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagWithoutProfilesUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpsertTagsRelationInput:{
		by:{
			type:"ProfileTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileTagWithoutProfilesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileTagWithoutProfilesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinUpsertProfileRelationInput:{
		update:{
			type:"ProfileWithoutPinsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileWithoutPinsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordUpsertPinRelationInput:{
		update:{
			type:"ProfilePinWithoutActivityRecordsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfilePinWithoutActivityRecordsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpsertActivityRecordsRelationInput:{
		by:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileActivityRecordWithoutProfileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileActivityRecordWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdatePinsEntityRelationInput:{
		create:{
			type:"ProfilePinWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileUpdatePinsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileUpsertPinsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpdatePinsRelationInput:{
		by:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProfilePinWithoutProfileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinWithoutProfileUpdateInput:{
		type:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedBy:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		reason:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		solution:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfilePinUpdateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinUpdateActivityRecordsEntityRelationInput:{
		create:{
			type:"ProfileActivityRecordWithoutPinCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfilePinUpdateActivityRecordsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfilePinUpsertActivityRecordsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinUpdateActivityRecordsRelationInput:{
		by:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProfileActivityRecordWithoutPinUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordWithoutPinUpdateInput:{
		type:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		updatedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		metadata:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileActivityRecordUpdateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordUpdateProfileEntityRelationInput:{
		create:{
			type:"ProfileWithoutActivityRecordsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileWithoutActivityRecordsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileActivityRecordUpsertProfileRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileWithoutActivityRecordsUpdateInput:{
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pins:{
			type:"ProfileUpdatePinsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		gallery:{
			type:"ProfileUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ProfileUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordUpsertProfileRelationInput:{
		update:{
			type:"ProfileWithoutActivityRecordsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileWithoutActivityRecordsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinUpsertActivityRecordsRelationInput:{
		by:{
			type:"ProfileActivityRecordUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileActivityRecordWithoutPinUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileActivityRecordWithoutPinCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileUpsertPinsRelationInput:{
		by:{
			type:"ProfilePinUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfilePinWithoutProfileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfilePinWithoutProfileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		profiles:{
			type:"ProfileTagCreateProfilesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagCreateProfilesEntityRelationInput:{
		connect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileWithoutTagsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileCreateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pins:{
			type:"ProfileCreatePinsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		gallery:{
			type:"ProfileCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		profiles:{
			type:"ProfileTagUpdateProfilesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagUpdateProfilesEntityRelationInput:{
		create:{
			type:"ProfileWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileTagUpdateProfilesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileTagUpsertProfilesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagUpdateProfilesRelationInput:{
		by:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProfileWithoutTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileWithoutTagsUpdateInput:{
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileUpdateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pins:{
			type:"ProfileUpdatePinsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		gallery:{
			type:"ProfileUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileTagUpsertProfilesRelationInput:{
		by:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileWithoutTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		updatedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		metadata:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileActivityRecordCreateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pin:{
			type:"ProfileActivityRecordCreatePinEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileActivityRecordUpdateInput:{
		type:{
			type:"ProfileActivityRecordType",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		updatedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		metadata:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileActivityRecordUpdateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pin:{
			type:"ProfileActivityRecordUpdatePinEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedBy:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		reason:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		solution:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfilePinCreateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		profile:{
			type:"ProfilePinCreateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfilePinUpdateInput:{
		type:{
			type:"ProfilePinType",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dismissedBy:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		reason:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		solution:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfilePinUpdateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		profile:{
			type:"ProfilePinUpdateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ProfileGalleryCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		profile:{
			type:"ProfileGalleryCreateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryCreateProfileEntityRelationInput:{
		connect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileWithoutGalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileCreateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pins:{
			type:"ProfileCreatePinsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		tags:{
			type:"ProfileCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryUpdateInput:{
		items:{
			type:"ProfileGalleryUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		profile:{
			type:"ProfileGalleryUpdateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryUpdateProfileEntityRelationInput:{
		create:{
			type:"ProfileWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileWithoutGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileGalleryUpsertProfileRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileWithoutGalleryUpdateInput:{
		goodlokId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		importance:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vokativ:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fullName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		aliases:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		quickNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ProfileUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		activityRecords:{
			type:"ProfileUpdateActivityRecordsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pins:{
			type:"ProfileUpdatePinsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		tags:{
			type:"ProfileUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		familiarity:{
			type:"Familiarity",
			array:false,
			arrayRequired:false,
			required:false
		},
		vipStatus:{
			type:"VipStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitter:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tiktok:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ProfileStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		visited:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iosNearbyAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryUpsertProfileRelationInput:{
		update:{
			type:"ProfileWithoutGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ProfileGalleryItemCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ProfileGalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemCreateGalleryEntityRelationInput:{
		connect:{
			type:"ProfileGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileGalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		profile:{
			type:"ProfileGalleryCreateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		caption:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ProfileGalleryItemUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ProfileGalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemUpdateGalleryEntityRelationInput:{
		create:{
			type:"ProfileGalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProfileGalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProfileGalleryItemUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProfileGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryWithoutItemsUpdateInput:{
		profile:{
			type:"ProfileGalleryUpdateProfileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProfileGalleryItemUpsertGalleryRelationInput:{
		update:{
			type:"ProfileGalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProfileGalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingList:{
		items:{
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ShoppingListItem:{
		shoppingList:{
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		supplier:{
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Date: "String",
	ShoppingListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShoppingListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ShoppingListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ShoppingListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ShoppingListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		dueDate:{
			type:"DateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingList:{
			type:"ShoppingListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"SupplierWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ShoppingListItemStatusCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ShoppingListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ShoppingListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ShoppingListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateCondition:{
		and:{
			type:"DateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"DateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"DateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Date",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Date",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingListItems:{
			type:"ShoppingListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		favouriteItems:{
			type:"FavouriteItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SupplierWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SupplierWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SupplierWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"SupplierWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FavouriteItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FavouriteItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FavouriteItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemStatusCondition:{
		and:{
			type:"ShoppingListItemStatusCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ShoppingListItemStatusCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ShoppingListItemStatusCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ShoppingListItemStatus",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ShoppingListItemStatus",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemStatus: "enum",
	Supplier:{
		shoppingListItems:{
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		favouriteItems:{
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FavouriteItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShoppingListItems:{
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFavouriteItems:{
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FavouriteItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ShoppingListItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		dueDate:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingList:{
			type:"ShoppingListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"SupplierOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItem:{
		supplier:{
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FavouriteItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"SupplierOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShoppingListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListCreateItemsEntityRelationInput:{
		connect:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShoppingListItemWithoutShoppingListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemWithoutShoppingListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dueDate:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"ShoppingListItemCreateSupplierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemCreateSupplierEntityRelationInput:{
		connect:{
			type:"SupplierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SupplierWithoutShoppingListItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingListItems:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		favouriteItems:{
			type:"FavouriteItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierWithoutShoppingListItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"SupplierCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		favouriteItems:{
			type:"SupplierCreateFavouriteItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierCreateFavouriteItemsEntityRelationInput:{
		connect:{
			type:"FavouriteItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FavouriteItemWithoutSupplierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemWithoutSupplierCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShoppingListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListUpdateItemsEntityRelationInput:{
		create:{
			type:"ShoppingListItemWithoutShoppingListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShoppingListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShoppingListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListUpdateItemsRelationInput:{
		by:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ShoppingListItemWithoutShoppingListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemWithoutShoppingListUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dueDate:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"ShoppingListItemUpdateSupplierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemUpdateSupplierEntityRelationInput:{
		create:{
			type:"SupplierWithoutShoppingListItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SupplierWithoutShoppingListItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShoppingListItemUpsertSupplierRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SupplierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierWithoutShoppingListItemsUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"SupplierUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		favouriteItems:{
			type:"SupplierUpdateFavouriteItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SupplierUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpdateFavouriteItemsEntityRelationInput:{
		create:{
			type:"FavouriteItemWithoutSupplierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SupplierUpdateFavouriteItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SupplierUpsertFavouriteItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FavouriteItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FavouriteItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FavouriteItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpdateFavouriteItemsRelationInput:{
		by:{
			type:"FavouriteItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FavouriteItemWithoutSupplierUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemWithoutSupplierUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpsertFavouriteItemsRelationInput:{
		by:{
			type:"FavouriteItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FavouriteItemWithoutSupplierUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FavouriteItemWithoutSupplierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemUpsertSupplierRelationInput:{
		update:{
			type:"SupplierWithoutShoppingListItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SupplierWithoutShoppingListItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListUpsertItemsRelationInput:{
		by:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShoppingListItemWithoutShoppingListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShoppingListItemWithoutShoppingListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dueDate:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingList:{
			type:"ShoppingListItemCreateShoppingListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"ShoppingListItemCreateSupplierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemCreateShoppingListEntityRelationInput:{
		connect:{
			type:"ShoppingListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShoppingListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dueDate:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingList:{
			type:"ShoppingListItemUpdateShoppingListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"ShoppingListItemUpdateSupplierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemUpdateShoppingListEntityRelationInput:{
		create:{
			type:"ShoppingListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShoppingListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShoppingListItemUpsertShoppingListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShoppingListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListWithoutItemsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemUpsertShoppingListRelationInput:{
		update:{
			type:"ShoppingListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShoppingListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingListItems:{
			type:"SupplierCreateShoppingListItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		logo:{
			type:"SupplierCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		favouriteItems:{
			type:"SupplierCreateFavouriteItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierCreateShoppingListItemsEntityRelationInput:{
		connect:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShoppingListItemWithoutSupplierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemWithoutSupplierCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dueDate:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingList:{
			type:"ShoppingListItemCreateShoppingListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingListItems:{
			type:"SupplierUpdateShoppingListItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		logo:{
			type:"SupplierUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		favouriteItems:{
			type:"SupplierUpdateFavouriteItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpdateShoppingListItemsEntityRelationInput:{
		create:{
			type:"ShoppingListItemWithoutSupplierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SupplierUpdateShoppingListItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SupplierUpsertShoppingListItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpdateShoppingListItemsRelationInput:{
		by:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ShoppingListItemWithoutSupplierUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShoppingListItemWithoutSupplierUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dueDate:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingList:{
			type:"ShoppingListItemUpdateShoppingListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		status:{
			type:"ShoppingListItemStatus",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierUpsertShoppingListItemsRelationInput:{
		by:{
			type:"ShoppingListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShoppingListItemWithoutSupplierUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShoppingListItemWithoutSupplierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"FavouriteItemCreateSupplierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemCreateSupplierEntityRelationInput:{
		connect:{
			type:"SupplierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SupplierWithoutFavouriteItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierWithoutFavouriteItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingListItems:{
			type:"SupplierCreateShoppingListItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		logo:{
			type:"SupplierCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		amount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		supplier:{
			type:"FavouriteItemUpdateSupplierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemUpdateSupplierEntityRelationInput:{
		create:{
			type:"SupplierWithoutFavouriteItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SupplierWithoutFavouriteItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FavouriteItemUpsertSupplierRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SupplierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SupplierWithoutFavouriteItemsUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contact:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		shoppingListItems:{
			type:"SupplierUpdateShoppingListItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		logo:{
			type:"SupplierUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FavouriteItemUpsertSupplierRelationInput:{
		update:{
			type:"SupplierWithoutFavouriteItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SupplierWithoutFavouriteItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BusinessOrderTypeCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeCreateLocalesEntityRelationInput:{
		connect:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BusinessOrderTypeLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BusinessOrderTypeLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutBusinessOrderTypesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutBusinessOrderTypesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleCreateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleCreateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleCreateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BusinessOrderTypeUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeUpdateLocalesEntityRelationInput:{
		create:{
			type:"BusinessOrderTypeLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BusinessOrderTypeUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BusinessOrderTypeUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeUpdateLocalesRelationInput:{
		by:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BusinessOrderTypeLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutBusinessOrderTypesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutBusinessOrderTypesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BusinessOrderTypeLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutBusinessOrderTypesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		blogs:{
			type:"LocaleUpdateBlogsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seos:{
			type:"LocaleUpdateSeosEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		menus:{
			type:"LocaleUpdateMenusEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutBusinessOrderTypesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutBusinessOrderTypesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeUpsertLocalesRelationInput:{
		by:{
			type:"BusinessOrderTypeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BusinessOrderTypeLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BusinessOrderTypeLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BusinessOrderTypeLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BusinessOrderTypeLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BusinessOrderTypeLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BusinessOrderTypeLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	QueryTransaction:{
		getColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listColorPallete:{
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ColorPalleteOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateColorPallete:{
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ColorPalleteOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateColorPallete:{
			data:{
				type:"ColorPalleteCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ColorPalleteUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCover:{
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CoverOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCover:{
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CoverOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCover:{
			data:{
				type:"CoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventLocale:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventLocale:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventLocale:{
			data:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageItem:{
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageItem:{
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageItem:{
			data:{
				type:"ImageItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMedium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMedium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMedium:{
			data:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBlog:{
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlog:{
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBlog:{
			data:{
				type:"BlogCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BlogUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBlogLocale:{
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlogLocale:{
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBlogLocale:{
			data:{
				type:"BlogLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BlogLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPageLocale:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePageLocale:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePageLocale:{
			data:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeoLocale:{
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeoLocale:{
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeoLocale:{
			data:{
				type:"SeoLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLocalizedSeo:{
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocalizedSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocalizedSeo:{
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocalizedSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLocalizedSeo:{
			data:{
				type:"LocalizedSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LocalizedSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHero:{
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeroOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHero:{
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeroOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHero:{
			data:{
				type:"HeroCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeroUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialsAndApps:{
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialsAndAppsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialsAndApps:{
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialsAndAppsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialsAndApps:{
			data:{
				type:"SocialsAndAppsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialsAndAppsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSiteMenu:{
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SiteMenuOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSiteMenu:{
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SiteMenuOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSiteMenu:{
			data:{
				type:"SiteMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SiteMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMenuItem:{
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMenuItem:{
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMenuItem:{
			data:{
				type:"MenuItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MenuItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBlogPostList:{
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlogPostList:{
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBlogPostList:{
			data:{
				type:"BlogPostListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BlogPostListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBlogPostListItem:{
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlogPostListItem:{
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BlogPostListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBlogPostListItem:{
			data:{
				type:"BlogPostListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BlogPostListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMenuLocale:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMenuLocale:{
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MenuLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMenuLocale:{
			data:{
				type:"MenuLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MenuLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProductGrid:{
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProductGrid:{
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProductGrid:{
			data:{
				type:"ProductGridCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProductGridUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProductGridItem:{
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProductGridItem:{
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductGridItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProductGridItem:{
			data:{
				type:"ProductGridItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProductGridItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfile:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfile:{
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfile:{
			data:{
				type:"ProfileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfileTag:{
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfileTag:{
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfileTag:{
			data:{
				type:"ProfileTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfileActivityRecord:{
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileActivityRecordOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfileActivityRecord:{
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileActivityRecordOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfileActivityRecord:{
			data:{
				type:"ProfileActivityRecordCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileActivityRecordUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfilePin:{
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfilePinOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfilePin:{
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfilePinOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfilePin:{
			data:{
				type:"ProfilePinCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfilePinUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfileGallery:{
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfileGallery:{
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfileGallery:{
			data:{
				type:"ProfileGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProfileGalleryItem:{
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProfileGalleryItem:{
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProfileGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProfileGalleryItem:{
			data:{
				type:"ProfileGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProfileGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShoppingList:{
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShoppingList:{
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShoppingList:{
			data:{
				type:"ShoppingListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShoppingListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShoppingListItem:{
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShoppingListItem:{
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShoppingListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShoppingListItem:{
			data:{
				type:"ShoppingListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShoppingListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSupplier:{
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SupplierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSupplier:{
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SupplierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSupplier:{
			data:{
				type:"SupplierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SupplierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFavouriteItem:{
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FavouriteItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFavouriteItem:{
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FavouriteItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFavouriteItem:{
			data:{
				type:"FavouriteItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FavouriteItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBusinessOrderType:{
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBusinessOrderType:{
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBusinessOrderType:{
			data:{
				type:"BusinessOrderTypeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BusinessOrderTypeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBusinessOrderTypeLocale:{
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBusinessOrderTypeLocale:{
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BusinessOrderTypeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBusinessOrderTypeLocale:{
			data:{
				type:"BusinessOrderTypeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BusinessOrderTypeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Mutation:{
		createColorPallete:{
			data:{
				type:"ColorPalleteCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ColorPalleteUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ColorPalleteUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ColorPalleteCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCover:{
			data:{
				type:"CoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventLocale:{
			data:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageItem:{
			data:{
				type:"ImageItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMedium:{
			data:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBlog:{
			data:{
				type:"BlogCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BlogUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BlogUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BlogCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBlogLocale:{
			data:{
				type:"BlogLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BlogLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BlogLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BlogLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPageLocale:{
			data:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeoLocale:{
			data:{
				type:"SeoLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLocalizedSeo:{
			data:{
				type:"LocalizedSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LocalizedSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LocalizedSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LocalizedSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHero:{
			data:{
				type:"HeroCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeroUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeroUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeroCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialsAndApps:{
			data:{
				type:"SocialsAndAppsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialsAndAppsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialsAndAppsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialsAndAppsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSiteMenu:{
			data:{
				type:"SiteMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SiteMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SiteMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SiteMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMenuItem:{
			data:{
				type:"MenuItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MenuItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MenuItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MenuItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBlogPostList:{
			data:{
				type:"BlogPostListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BlogPostListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BlogPostListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BlogPostListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBlogPostListItem:{
			data:{
				type:"BlogPostListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BlogPostListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BlogPostListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BlogPostListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMenuLocale:{
			data:{
				type:"MenuLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MenuLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MenuLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MenuLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProductGrid:{
			data:{
				type:"ProductGridCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProductGridUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProductGridUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProductGridCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProductGridItem:{
			data:{
				type:"ProductGridItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProductGridItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProductGridItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProductGridItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfile:{
			data:{
				type:"ProfileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfileTag:{
			data:{
				type:"ProfileTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfileActivityRecord:{
			data:{
				type:"ProfileActivityRecordCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileActivityRecordUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileActivityRecordUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileActivityRecordCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfilePin:{
			data:{
				type:"ProfilePinCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfilePinUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfilePinUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfilePinCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfileGallery:{
			data:{
				type:"ProfileGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfileGalleryItem:{
			data:{
				type:"ProfileGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShoppingList:{
			data:{
				type:"ShoppingListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShoppingListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShoppingListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShoppingListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShoppingListItem:{
			data:{
				type:"ShoppingListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShoppingListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShoppingListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShoppingListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSupplier:{
			data:{
				type:"SupplierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SupplierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SupplierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SupplierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFavouriteItem:{
			data:{
				type:"FavouriteItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FavouriteItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FavouriteItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FavouriteItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBusinessOrderType:{
			data:{
				type:"BusinessOrderTypeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BusinessOrderTypeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BusinessOrderTypeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BusinessOrderTypeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBusinessOrderTypeLocale:{
			data:{
				type:"BusinessOrderTypeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BusinessOrderTypeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BusinessOrderTypeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BusinessOrderTypeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		generateUploadUrl:{
			contentType:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			prefix:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateReadUrl:{
			objectKey:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	_MutationErrorType: "enum",
	MutationTransaction:{
		createColorPallete:{
			data:{
				type:"ColorPalleteCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ColorPalleteUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertColorPallete:{
			by:{
				type:"ColorPalleteUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ColorPalleteWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ColorPalleteUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ColorPalleteCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCover:{
			data:{
				type:"CoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCover:{
			by:{
				type:"CoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventLocale:{
			data:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageItem:{
			data:{
				type:"ImageItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageItem:{
			by:{
				type:"ImageItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMedium:{
			data:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBlog:{
			data:{
				type:"BlogCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BlogUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBlog:{
			by:{
				type:"BlogUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BlogUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BlogCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBlogLocale:{
			data:{
				type:"BlogLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BlogLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBlogLocale:{
			by:{
				type:"BlogLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BlogLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BlogLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPageLocale:{
			data:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeoLocale:{
			data:{
				type:"SeoLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeoLocale:{
			by:{
				type:"SeoLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLocalizedSeo:{
			data:{
				type:"LocalizedSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LocalizedSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLocalizedSeo:{
			by:{
				type:"LocalizedSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocalizedSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LocalizedSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LocalizedSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHero:{
			data:{
				type:"HeroCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeroUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHero:{
			by:{
				type:"HeroUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeroWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeroUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeroCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialsAndApps:{
			data:{
				type:"SocialsAndAppsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialsAndAppsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialsAndApps:{
			by:{
				type:"SocialsAndAppsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialsAndAppsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialsAndAppsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialsAndAppsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSiteMenu:{
			data:{
				type:"SiteMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SiteMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSiteMenu:{
			by:{
				type:"SiteMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SiteMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SiteMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SiteMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMenuItem:{
			data:{
				type:"MenuItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MenuItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMenuItem:{
			by:{
				type:"MenuItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MenuItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MenuItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBlogPostList:{
			data:{
				type:"BlogPostListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BlogPostListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBlogPostList:{
			by:{
				type:"BlogPostListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BlogPostListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BlogPostListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBlogPostListItem:{
			data:{
				type:"BlogPostListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BlogPostListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBlogPostListItem:{
			by:{
				type:"BlogPostListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BlogPostListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BlogPostListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BlogPostListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMenuLocale:{
			data:{
				type:"MenuLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MenuLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMenuLocale:{
			by:{
				type:"MenuLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MenuLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MenuLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MenuLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProductGrid:{
			data:{
				type:"ProductGridCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProductGridUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProductGrid:{
			by:{
				type:"ProductGridUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProductGridUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProductGridCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProductGridItem:{
			data:{
				type:"ProductGridItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProductGridItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProductGridItem:{
			by:{
				type:"ProductGridItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductGridItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProductGridItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProductGridItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfile:{
			data:{
				type:"ProfileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfile:{
			by:{
				type:"ProfileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfileTag:{
			data:{
				type:"ProfileTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfileTag:{
			by:{
				type:"ProfileTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfileActivityRecord:{
			data:{
				type:"ProfileActivityRecordCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileActivityRecordUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfileActivityRecord:{
			by:{
				type:"ProfileActivityRecordUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileActivityRecordWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileActivityRecordUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileActivityRecordCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfilePin:{
			data:{
				type:"ProfilePinCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfilePinUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfilePin:{
			by:{
				type:"ProfilePinUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfilePinWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfilePinUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfilePinCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfileGallery:{
			data:{
				type:"ProfileGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfileGallery:{
			by:{
				type:"ProfileGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProfileGalleryItem:{
			data:{
				type:"ProfileGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProfileGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProfileGalleryItem:{
			by:{
				type:"ProfileGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProfileGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProfileGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProfileGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShoppingList:{
			data:{
				type:"ShoppingListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShoppingListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShoppingList:{
			by:{
				type:"ShoppingListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShoppingListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShoppingListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShoppingListItem:{
			data:{
				type:"ShoppingListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShoppingListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShoppingListItem:{
			by:{
				type:"ShoppingListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShoppingListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShoppingListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShoppingListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSupplier:{
			data:{
				type:"SupplierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SupplierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSupplier:{
			by:{
				type:"SupplierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SupplierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SupplierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SupplierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFavouriteItem:{
			data:{
				type:"FavouriteItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FavouriteItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFavouriteItem:{
			by:{
				type:"FavouriteItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FavouriteItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FavouriteItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FavouriteItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBusinessOrderType:{
			data:{
				type:"BusinessOrderTypeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BusinessOrderTypeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBusinessOrderType:{
			by:{
				type:"BusinessOrderTypeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BusinessOrderTypeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BusinessOrderTypeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBusinessOrderTypeLocale:{
			data:{
				type:"BusinessOrderTypeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BusinessOrderTypeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBusinessOrderTypeLocale:{
			by:{
				type:"BusinessOrderTypeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BusinessOrderTypeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BusinessOrderTypeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BusinessOrderTypeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Json: "String",
	_OnDeleteBehaviour: "enum",
	_RelationSide: "enum",
	_OrderByDirection: "enum"
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getColorPallete:"ColorPallete",
		listColorPallete:"ColorPallete",
		paginateColorPallete:"ColorPalleteConnection",
		validateCreateColorPallete:"_ValidationResult",
		validateUpdateColorPallete:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getCover:"Cover",
		listCover:"Cover",
		paginateCover:"CoverConnection",
		validateCreateCover:"_ValidationResult",
		validateUpdateCover:"_ValidationResult",
		getEvent:"Event",
		listEvent:"Event",
		paginateEvent:"EventConnection",
		validateCreateEvent:"_ValidationResult",
		validateUpdateEvent:"_ValidationResult",
		getEventLocale:"EventLocale",
		listEventLocale:"EventLocale",
		paginateEventLocale:"EventLocaleConnection",
		validateCreateEventLocale:"_ValidationResult",
		validateUpdateEventLocale:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageItem:"ImageItem",
		listImageItem:"ImageItem",
		paginateImageItem:"ImageItemConnection",
		validateCreateImageItem:"_ValidationResult",
		validateUpdateImageItem:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getBlog:"Blog",
		listBlog:"Blog",
		paginateBlog:"BlogConnection",
		validateCreateBlog:"_ValidationResult",
		validateUpdateBlog:"_ValidationResult",
		getBlogLocale:"BlogLocale",
		listBlogLocale:"BlogLocale",
		paginateBlogLocale:"BlogLocaleConnection",
		validateCreateBlogLocale:"_ValidationResult",
		validateUpdateBlogLocale:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		getPageLocale:"PageLocale",
		listPageLocale:"PageLocale",
		paginatePageLocale:"PageLocaleConnection",
		validateCreatePageLocale:"_ValidationResult",
		validateUpdatePageLocale:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getSeoLocale:"SeoLocale",
		listSeoLocale:"SeoLocale",
		paginateSeoLocale:"SeoLocaleConnection",
		validateCreateSeoLocale:"_ValidationResult",
		validateUpdateSeoLocale:"_ValidationResult",
		getLocalizedSeo:"LocalizedSeo",
		listLocalizedSeo:"LocalizedSeo",
		paginateLocalizedSeo:"LocalizedSeoConnection",
		validateCreateLocalizedSeo:"_ValidationResult",
		validateUpdateLocalizedSeo:"_ValidationResult",
		getHero:"Hero",
		listHero:"Hero",
		paginateHero:"HeroConnection",
		validateCreateHero:"_ValidationResult",
		validateUpdateHero:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getSocialsAndApps:"SocialsAndApps",
		listSocialsAndApps:"SocialsAndApps",
		paginateSocialsAndApps:"SocialsAndAppsConnection",
		validateCreateSocialsAndApps:"_ValidationResult",
		validateUpdateSocialsAndApps:"_ValidationResult",
		getSiteMenu:"SiteMenu",
		listSiteMenu:"SiteMenu",
		paginateSiteMenu:"SiteMenuConnection",
		validateCreateSiteMenu:"_ValidationResult",
		validateUpdateSiteMenu:"_ValidationResult",
		getMenuItem:"MenuItem",
		listMenuItem:"MenuItem",
		paginateMenuItem:"MenuItemConnection",
		validateCreateMenuItem:"_ValidationResult",
		validateUpdateMenuItem:"_ValidationResult",
		getBlogPostList:"BlogPostList",
		listBlogPostList:"BlogPostList",
		paginateBlogPostList:"BlogPostListConnection",
		validateCreateBlogPostList:"_ValidationResult",
		validateUpdateBlogPostList:"_ValidationResult",
		getBlogPostListItem:"BlogPostListItem",
		listBlogPostListItem:"BlogPostListItem",
		paginateBlogPostListItem:"BlogPostListItemConnection",
		validateCreateBlogPostListItem:"_ValidationResult",
		validateUpdateBlogPostListItem:"_ValidationResult",
		getMenuLocale:"MenuLocale",
		listMenuLocale:"MenuLocale",
		paginateMenuLocale:"MenuLocaleConnection",
		validateCreateMenuLocale:"_ValidationResult",
		validateUpdateMenuLocale:"_ValidationResult",
		getProductGrid:"ProductGrid",
		listProductGrid:"ProductGrid",
		paginateProductGrid:"ProductGridConnection",
		validateCreateProductGrid:"_ValidationResult",
		validateUpdateProductGrid:"_ValidationResult",
		getProductGridItem:"ProductGridItem",
		listProductGridItem:"ProductGridItem",
		paginateProductGridItem:"ProductGridItemConnection",
		validateCreateProductGridItem:"_ValidationResult",
		validateUpdateProductGridItem:"_ValidationResult",
		getProfile:"Profile",
		listProfile:"Profile",
		paginateProfile:"ProfileConnection",
		validateCreateProfile:"_ValidationResult",
		validateUpdateProfile:"_ValidationResult",
		getProfileTag:"ProfileTag",
		listProfileTag:"ProfileTag",
		paginateProfileTag:"ProfileTagConnection",
		validateCreateProfileTag:"_ValidationResult",
		validateUpdateProfileTag:"_ValidationResult",
		getProfileActivityRecord:"ProfileActivityRecord",
		listProfileActivityRecord:"ProfileActivityRecord",
		paginateProfileActivityRecord:"ProfileActivityRecordConnection",
		validateCreateProfileActivityRecord:"_ValidationResult",
		validateUpdateProfileActivityRecord:"_ValidationResult",
		getProfilePin:"ProfilePin",
		listProfilePin:"ProfilePin",
		paginateProfilePin:"ProfilePinConnection",
		validateCreateProfilePin:"_ValidationResult",
		validateUpdateProfilePin:"_ValidationResult",
		getProfileGallery:"ProfileGallery",
		listProfileGallery:"ProfileGallery",
		paginateProfileGallery:"ProfileGalleryConnection",
		validateCreateProfileGallery:"_ValidationResult",
		validateUpdateProfileGallery:"_ValidationResult",
		getProfileGalleryItem:"ProfileGalleryItem",
		listProfileGalleryItem:"ProfileGalleryItem",
		paginateProfileGalleryItem:"ProfileGalleryItemConnection",
		validateCreateProfileGalleryItem:"_ValidationResult",
		validateUpdateProfileGalleryItem:"_ValidationResult",
		getShoppingList:"ShoppingList",
		listShoppingList:"ShoppingList",
		paginateShoppingList:"ShoppingListConnection",
		validateCreateShoppingList:"_ValidationResult",
		validateUpdateShoppingList:"_ValidationResult",
		getShoppingListItem:"ShoppingListItem",
		listShoppingListItem:"ShoppingListItem",
		paginateShoppingListItem:"ShoppingListItemConnection",
		validateCreateShoppingListItem:"_ValidationResult",
		validateUpdateShoppingListItem:"_ValidationResult",
		getSupplier:"Supplier",
		listSupplier:"Supplier",
		paginateSupplier:"SupplierConnection",
		validateCreateSupplier:"_ValidationResult",
		validateUpdateSupplier:"_ValidationResult",
		getFavouriteItem:"FavouriteItem",
		listFavouriteItem:"FavouriteItem",
		paginateFavouriteItem:"FavouriteItemConnection",
		validateCreateFavouriteItem:"_ValidationResult",
		validateUpdateFavouriteItem:"_ValidationResult",
		getBusinessOrderType:"BusinessOrderType",
		listBusinessOrderType:"BusinessOrderType",
		paginateBusinessOrderType:"BusinessOrderTypeConnection",
		validateCreateBusinessOrderType:"_ValidationResult",
		validateUpdateBusinessOrderType:"_ValidationResult",
		getBusinessOrderTypeLocale:"BusinessOrderTypeLocale",
		listBusinessOrderTypeLocale:"BusinessOrderTypeLocale",
		paginateBusinessOrderTypeLocale:"BusinessOrderTypeLocaleConnection",
		validateCreateBusinessOrderTypeLocale:"_ValidationResult",
		validateUpdateBusinessOrderTypeLocale:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	ColorPallete:{
		_meta:"ColorPalleteMeta",
		id:"UUID",
		background:"String",
		text:"String"
	},
	ColorPalleteMeta:{
		id:"FieldMeta",
		background:"FieldMeta",
		text:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	ColorPalleteConnection:{
		pageInfo:"PageInfo",
		edges:"ColorPalleteEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	ColorPalleteEdge:{
		node:"ColorPallete"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		blocks:"ContentBlock",
		blocksByReferences:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		blocks:"FieldMeta"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		primaryText:"String",
		secondaryText:"String",
		jsonContent:"String",
		block:"ContentBlock",
		colorPallete:"ColorPallete",
		medium:"Medium",
		misc:"String",
		link:"Link",
		hero:"Hero",
		gallery:"Gallery",
		contentSize:"ContentSize",
		socialsAndApps:"SocialsAndApps",
		blogPosts:"BlogPostList",
		productGrid:"ProductGrid"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		primaryText:"FieldMeta",
		secondaryText:"FieldMeta",
		jsonContent:"FieldMeta",
		block:"FieldMeta",
		colorPallete:"FieldMeta",
		medium:"FieldMeta",
		misc:"FieldMeta",
		link:"FieldMeta",
		hero:"FieldMeta",
		gallery:"FieldMeta",
		contentSize:"FieldMeta",
		socialsAndApps:"FieldMeta",
		blogPosts:"FieldMeta",
		productGrid:"FieldMeta"
	},
	Medium:{
		_meta:"MediumMeta",
		id:"UUID",
		type:"MediumType",
		colorTheme:"ColorTheme",
		image:"Image",
		video:"Video"
	},
	MediumMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		colorTheme:"FieldMeta",
		image:"FieldMeta",
		video:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		title:"String",
		alt:"String"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		alt:"FieldMeta"
	},
	Video:{
		_meta:"VideoMeta",
		id:"UUID",
		src:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		duration:"Float",
		poster:"Image"
	},
	VideoMeta:{
		id:"FieldMeta",
		src:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		duration:"FieldMeta",
		poster:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		page:"PageLocale",
		event:"EventLocale"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		page:"FieldMeta",
		event:"FieldMeta"
	},
	PageLocale:{
		_meta:"PageLocaleMeta",
		id:"UUID",
		title:"String",
		link:"Linkable",
		root:"Page",
		locale:"Locale",
		seo:"LocalizedSeo",
		content:"Content"
	},
	PageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta",
		content:"FieldMeta"
	},
	Page:{
		_meta:"PageMeta",
		id:"UUID",
		locales:"PageLocale",
		localesByLocale:"PageLocale",
		localesByLink:"PageLocale",
		localesBySeo:"PageLocale",
		localesByContent:"PageLocale",
		paginateLocales:"PageLocaleConnection"
	},
	PageMeta:{
		id:"FieldMeta",
		locales:"FieldMeta"
	},
	PageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PageLocaleEdge"
	},
	PageLocaleEdge:{
		node:"PageLocale"
	},
	Locale:{
		_meta:"LocaleMeta",
		id:"UUID",
		code:"String",
		label:"String",
		events:"EventLocale",
		blogs:"BlogLocale",
		pages:"PageLocale",
		seos:"SeoLocale",
		menus:"MenuLocale",
		businessOrderTypes:"BusinessOrderTypeLocale",
		eventsByRoot:"EventLocale",
		eventsByCover:"EventLocale",
		eventsByContent:"EventLocale",
		eventsByLink:"EventLocale",
		eventsBySeo:"EventLocale",
		blogsByRoot:"BlogLocale",
		pagesByRoot:"PageLocale",
		pagesByLink:"PageLocale",
		pagesBySeo:"PageLocale",
		pagesByContent:"PageLocale",
		seosByRoot:"SeoLocale",
		menusByRoot:"MenuLocale",
		menusByItems:"MenuLocale",
		businessOrderTypesByRoot:"BusinessOrderTypeLocale",
		paginateEvents:"EventLocaleConnection",
		paginateBlogs:"BlogLocaleConnection",
		paginatePages:"PageLocaleConnection",
		paginateSeos:"SeoLocaleConnection",
		paginateMenus:"MenuLocaleConnection",
		paginateBusinessOrderTypes:"BusinessOrderTypeLocaleConnection"
	},
	LocaleMeta:{
		id:"FieldMeta",
		code:"FieldMeta",
		label:"FieldMeta",
		events:"FieldMeta",
		blogs:"FieldMeta",
		pages:"FieldMeta",
		seos:"FieldMeta",
		menus:"FieldMeta",
		businessOrderTypes:"FieldMeta"
	},
	EventLocale:{
		_meta:"EventLocaleMeta",
		id:"UUID",
		root:"Event",
		locale:"Locale",
		cover:"Cover",
		content:"Content",
		availableForWeb:"Boolean",
		availableForMobile:"Boolean",
		link:"Linkable",
		title:"String",
		seo:"LocalizedSeo"
	},
	EventLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		cover:"FieldMeta",
		content:"FieldMeta",
		availableForWeb:"FieldMeta",
		availableForMobile:"FieldMeta",
		link:"FieldMeta",
		title:"FieldMeta",
		seo:"FieldMeta"
	},
	Event:{
		_meta:"EventMeta",
		id:"UUID",
		order:"Int",
		locales:"EventLocale",
		localesByLocale:"EventLocale",
		localesByCover:"EventLocale",
		localesByContent:"EventLocale",
		localesByLink:"EventLocale",
		localesBySeo:"EventLocale",
		paginateLocales:"EventLocaleConnection"
	},
	EventMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		locales:"FieldMeta"
	},
	EventLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"EventLocaleEdge"
	},
	EventLocaleEdge:{
		node:"EventLocale"
	},
	Cover:{
		_meta:"CoverMeta",
		id:"UUID",
		primaryTitle:"String",
		secondaryTitle:"String",
		buttonColors:"ColorPallete",
		medium:"Medium"
	},
	CoverMeta:{
		id:"FieldMeta",
		primaryTitle:"FieldMeta",
		secondaryTitle:"FieldMeta",
		buttonColors:"FieldMeta",
		medium:"FieldMeta"
	},
	LocalizedSeo:{
		_meta:"LocalizedSeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		ogImage:"Image"
	},
	LocalizedSeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		ogImage:"FieldMeta"
	},
	BlogLocale:{
		_meta:"BlogLocaleMeta",
		id:"UUID",
		pageName:"String",
		title:"String",
		lead:"String",
		root:"Blog",
		locale:"Locale"
	},
	BlogLocaleMeta:{
		id:"FieldMeta",
		pageName:"FieldMeta",
		title:"FieldMeta",
		lead:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	Blog:{
		_meta:"BlogMeta",
		id:"UUID",
		unique:"One",
		locales:"BlogLocale",
		localesByLocale:"BlogLocale",
		paginateLocales:"BlogLocaleConnection"
	},
	BlogMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	BlogLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BlogLocaleEdge"
	},
	BlogLocaleEdge:{
		node:"BlogLocale"
	},
	SeoLocale:{
		_meta:"SeoLocaleMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		root:"Seo",
		locale:"Locale"
	},
	SeoLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		ogImage:"Image",
		locales:"SeoLocale",
		localesByLocale:"SeoLocale",
		paginateLocales:"SeoLocaleConnection"
	},
	SeoMeta:{
		id:"FieldMeta",
		ogImage:"FieldMeta",
		locales:"FieldMeta"
	},
	SeoLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"SeoLocaleEdge"
	},
	SeoLocaleEdge:{
		node:"SeoLocale"
	},
	MenuLocale:{
		_meta:"MenuLocaleMeta",
		id:"UUID",
		root:"SiteMenu",
		locale:"Locale",
		items:"MenuItem",
		paginateItems:"MenuItemConnection"
	},
	MenuLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		items:"FieldMeta"
	},
	SiteMenu:{
		_meta:"SiteMenuMeta",
		id:"UUID",
		unique:"One",
		locales:"MenuLocale",
		localesByLocale:"MenuLocale",
		localesByItems:"MenuLocale",
		paginateLocales:"MenuLocaleConnection"
	},
	SiteMenuMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	MenuLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"MenuLocaleEdge"
	},
	MenuLocaleEdge:{
		node:"MenuLocale"
	},
	MenuItem:{
		_meta:"MenuItemMeta",
		id:"UUID",
		order:"Int",
		link:"Link",
		menu:"MenuLocale"
	},
	MenuItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta",
		menu:"FieldMeta"
	},
	MenuItemConnection:{
		pageInfo:"PageInfo",
		edges:"MenuItemEdge"
	},
	MenuItemEdge:{
		node:"MenuItem"
	},
	BusinessOrderTypeLocale:{
		_meta:"BusinessOrderTypeLocaleMeta",
		id:"UUID",
		title:"String",
		root:"BusinessOrderType",
		locale:"Locale"
	},
	BusinessOrderTypeLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	BusinessOrderType:{
		_meta:"BusinessOrderTypeMeta",
		id:"UUID",
		order:"Int",
		locales:"BusinessOrderTypeLocale",
		localesByLocale:"BusinessOrderTypeLocale",
		paginateLocales:"BusinessOrderTypeLocaleConnection"
	},
	BusinessOrderTypeMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		locales:"FieldMeta"
	},
	BusinessOrderTypeLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessOrderTypeLocaleEdge"
	},
	BusinessOrderTypeLocaleEdge:{
		node:"BusinessOrderTypeLocale"
	},
	Hero:{
		_meta:"HeroMeta",
		id:"UUID",
		showLogo:"Boolean",
		middleContent:"String",
		medium:"Medium"
	},
	HeroMeta:{
		id:"FieldMeta",
		showLogo:"FieldMeta",
		middleContent:"FieldMeta",
		medium:"FieldMeta"
	},
	Gallery:{
		_meta:"GalleryMeta",
		id:"UUID",
		items:"GalleryItem",
		paginateItems:"GalleryItemConnection"
	},
	GalleryMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	GalleryItem:{
		_meta:"GalleryItemMeta",
		id:"UUID",
		order:"Int",
		caption:"String",
		list:"Gallery",
		medium:"Medium"
	},
	GalleryItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		caption:"FieldMeta",
		list:"FieldMeta",
		medium:"FieldMeta"
	},
	GalleryItemConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryItemEdge"
	},
	GalleryItemEdge:{
		node:"GalleryItem"
	},
	SocialsAndApps:{
		_meta:"SocialsAndAppsMeta",
		id:"UUID",
		instagram:"Boolean",
		appStore:"Boolean",
		googlePlay:"Boolean"
	},
	SocialsAndAppsMeta:{
		id:"FieldMeta",
		instagram:"FieldMeta",
		appStore:"FieldMeta",
		googlePlay:"FieldMeta"
	},
	BlogPostList:{
		_meta:"BlogPostListMeta",
		id:"UUID",
		items:"BlogPostListItem",
		paginateItems:"BlogPostListItemConnection"
	},
	BlogPostListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	BlogPostListItem:{
		_meta:"BlogPostListItemMeta",
		id:"UUID",
		order:"Int",
		caption:"String",
		list:"BlogPostList",
		blogPost:"EventLocale"
	},
	BlogPostListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		caption:"FieldMeta",
		list:"FieldMeta",
		blogPost:"FieldMeta"
	},
	BlogPostListItemConnection:{
		pageInfo:"PageInfo",
		edges:"BlogPostListItemEdge"
	},
	BlogPostListItemEdge:{
		node:"BlogPostListItem"
	},
	ProductGrid:{
		_meta:"ProductGridMeta",
		id:"UUID",
		items:"ProductGridItem",
		paginateItems:"ProductGridItemConnection"
	},
	ProductGridMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ProductGridItem:{
		_meta:"ProductGridItemMeta",
		id:"UUID",
		order:"Int",
		goodlokProductId:"String",
		title:"String",
		lead:"String",
		list:"ProductGrid",
		medium:"Medium",
		link:"Link"
	},
	ProductGridItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		goodlokProductId:"FieldMeta",
		title:"FieldMeta",
		lead:"FieldMeta",
		list:"FieldMeta",
		medium:"FieldMeta",
		link:"FieldMeta"
	},
	ProductGridItemConnection:{
		pageInfo:"PageInfo",
		edges:"ProductGridItemEdge"
	},
	ProductGridItemEdge:{
		node:"ProductGridItem"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	CoverConnection:{
		pageInfo:"PageInfo",
		edges:"CoverEdge"
	},
	CoverEdge:{
		node:"Cover"
	},
	EventConnection:{
		pageInfo:"PageInfo",
		edges:"EventEdge"
	},
	EventEdge:{
		node:"Event"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	ImageList:{
		_meta:"ImageListMeta",
		id:"UUID",
		items:"ImageItem",
		paginateItems:"ImageItemConnection"
	},
	ImageListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ImageItem:{
		_meta:"ImageItemMeta",
		id:"UUID",
		order:"Int",
		list:"ImageList",
		image:"Image"
	},
	ImageItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	ImageItemConnection:{
		pageInfo:"PageInfo",
		edges:"ImageItemEdge"
	},
	ImageItemEdge:{
		node:"ImageItem"
	},
	ImageListConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListEdge"
	},
	ImageListEdge:{
		node:"ImageList"
	},
	LocaleConnection:{
		pageInfo:"PageInfo",
		edges:"LocaleEdge"
	},
	LocaleEdge:{
		node:"Locale"
	},
	MediumConnection:{
		pageInfo:"PageInfo",
		edges:"MediumEdge"
	},
	MediumEdge:{
		node:"Medium"
	},
	VideoConnection:{
		pageInfo:"PageInfo",
		edges:"VideoEdge"
	},
	VideoEdge:{
		node:"Video"
	},
	BlogConnection:{
		pageInfo:"PageInfo",
		edges:"BlogEdge"
	},
	BlogEdge:{
		node:"Blog"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	PageConnection:{
		pageInfo:"PageInfo",
		edges:"PageEdge"
	},
	PageEdge:{
		node:"Page"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	LocalizedSeoConnection:{
		pageInfo:"PageInfo",
		edges:"LocalizedSeoEdge"
	},
	LocalizedSeoEdge:{
		node:"LocalizedSeo"
	},
	HeroConnection:{
		pageInfo:"PageInfo",
		edges:"HeroEdge"
	},
	HeroEdge:{
		node:"Hero"
	},
	GalleryConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryEdge"
	},
	GalleryEdge:{
		node:"Gallery"
	},
	SocialsAndAppsConnection:{
		pageInfo:"PageInfo",
		edges:"SocialsAndAppsEdge"
	},
	SocialsAndAppsEdge:{
		node:"SocialsAndApps"
	},
	SiteMenuConnection:{
		pageInfo:"PageInfo",
		edges:"SiteMenuEdge"
	},
	SiteMenuEdge:{
		node:"SiteMenu"
	},
	BlogPostListConnection:{
		pageInfo:"PageInfo",
		edges:"BlogPostListEdge"
	},
	BlogPostListEdge:{
		node:"BlogPostList"
	},
	ProductGridConnection:{
		pageInfo:"PageInfo",
		edges:"ProductGridEdge"
	},
	ProductGridEdge:{
		node:"ProductGrid"
	},
	Profile:{
		_meta:"ProfileMeta",
		id:"UUID",
		goodlokId:"String",
		importance:"Int",
		name:"String",
		vokativ:"String",
		fullName:"String",
		aliases:"String",
		quickNote:"String",
		content:"Content",
		activityRecords:"ProfileActivityRecord",
		pins:"ProfilePin",
		gallery:"ProfileGallery",
		tags:"ProfileTag",
		familiarity:"Familiarity",
		vipStatus:"VipStatus",
		instagram:"String",
		facebook:"String",
		twitter:"String",
		tiktok:"String",
		youtube:"String",
		status:"ProfileStatus",
		visited:"Int",
		iosNearbyAt:"DateTime",
		pinsByActivityRecords:"ProfilePin",
		paginateActivityRecords:"ProfileActivityRecordConnection",
		paginatePins:"ProfilePinConnection",
		paginateTags:"ProfileTagConnection"
	},
	ProfileMeta:{
		id:"FieldMeta",
		goodlokId:"FieldMeta",
		importance:"FieldMeta",
		name:"FieldMeta",
		vokativ:"FieldMeta",
		fullName:"FieldMeta",
		aliases:"FieldMeta",
		quickNote:"FieldMeta",
		content:"FieldMeta",
		activityRecords:"FieldMeta",
		pins:"FieldMeta",
		gallery:"FieldMeta",
		tags:"FieldMeta",
		familiarity:"FieldMeta",
		vipStatus:"FieldMeta",
		instagram:"FieldMeta",
		facebook:"FieldMeta",
		twitter:"FieldMeta",
		tiktok:"FieldMeta",
		youtube:"FieldMeta",
		status:"FieldMeta",
		visited:"FieldMeta",
		iosNearbyAt:"FieldMeta"
	},
	ProfileActivityRecord:{
		_meta:"ProfileActivityRecordMeta",
		id:"UUID",
		type:"ProfileActivityRecordType",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		metadata:"String",
		profile:"Profile",
		pin:"ProfilePin"
	},
	ProfileActivityRecordMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		createdAt:"FieldMeta",
		updatedAt:"FieldMeta",
		metadata:"FieldMeta",
		profile:"FieldMeta",
		pin:"FieldMeta"
	},
	ProfilePin:{
		_meta:"ProfilePinMeta",
		id:"UUID",
		type:"ProfilePinType",
		startsAt:"DateTime",
		endsAt:"DateTime",
		dismissedAt:"DateTime",
		dismissedBy:"String",
		reason:"String",
		solution:"String",
		activityRecords:"ProfileActivityRecord",
		profile:"Profile",
		paginateActivityRecords:"ProfileActivityRecordConnection"
	},
	ProfilePinMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		startsAt:"FieldMeta",
		endsAt:"FieldMeta",
		dismissedAt:"FieldMeta",
		dismissedBy:"FieldMeta",
		reason:"FieldMeta",
		solution:"FieldMeta",
		activityRecords:"FieldMeta",
		profile:"FieldMeta"
	},
	ProfileActivityRecordConnection:{
		pageInfo:"PageInfo",
		edges:"ProfileActivityRecordEdge"
	},
	ProfileActivityRecordEdge:{
		node:"ProfileActivityRecord"
	},
	ProfileGallery:{
		_meta:"ProfileGalleryMeta",
		id:"UUID",
		items:"ProfileGalleryItem",
		profile:"Profile",
		paginateItems:"ProfileGalleryItemConnection"
	},
	ProfileGalleryMeta:{
		id:"FieldMeta",
		items:"FieldMeta",
		profile:"FieldMeta"
	},
	ProfileGalleryItem:{
		_meta:"ProfileGalleryItemMeta",
		id:"UUID",
		order:"Int",
		caption:"String",
		gallery:"ProfileGallery",
		image:"Image"
	},
	ProfileGalleryItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		caption:"FieldMeta",
		gallery:"FieldMeta",
		image:"FieldMeta"
	},
	ProfileGalleryItemConnection:{
		pageInfo:"PageInfo",
		edges:"ProfileGalleryItemEdge"
	},
	ProfileGalleryItemEdge:{
		node:"ProfileGalleryItem"
	},
	ProfileTag:{
		_meta:"ProfileTagMeta",
		id:"UUID",
		name:"String",
		color:"String",
		profiles:"Profile",
		paginateProfiles:"ProfileConnection"
	},
	ProfileTagMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		color:"FieldMeta",
		profiles:"FieldMeta"
	},
	ProfileConnection:{
		pageInfo:"PageInfo",
		edges:"ProfileEdge"
	},
	ProfileEdge:{
		node:"Profile"
	},
	ProfilePinConnection:{
		pageInfo:"PageInfo",
		edges:"ProfilePinEdge"
	},
	ProfilePinEdge:{
		node:"ProfilePin"
	},
	ProfileTagConnection:{
		pageInfo:"PageInfo",
		edges:"ProfileTagEdge"
	},
	ProfileTagEdge:{
		node:"ProfileTag"
	},
	ProfileGalleryConnection:{
		pageInfo:"PageInfo",
		edges:"ProfileGalleryEdge"
	},
	ProfileGalleryEdge:{
		node:"ProfileGallery"
	},
	ShoppingList:{
		_meta:"ShoppingListMeta",
		id:"UUID",
		title:"String",
		items:"ShoppingListItem",
		paginateItems:"ShoppingListItemConnection"
	},
	ShoppingListMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		items:"FieldMeta"
	},
	ShoppingListItem:{
		_meta:"ShoppingListItemMeta",
		id:"UUID",
		title:"String",
		dueDate:"Date",
		shoppingList:"ShoppingList",
		amount:"String",
		supplier:"Supplier",
		status:"ShoppingListItemStatus"
	},
	ShoppingListItemMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		dueDate:"FieldMeta",
		shoppingList:"FieldMeta",
		amount:"FieldMeta",
		supplier:"FieldMeta",
		status:"FieldMeta"
	},
	Supplier:{
		_meta:"SupplierMeta",
		id:"UUID",
		name:"String",
		contact:"String",
		shoppingListItems:"ShoppingListItem",
		logo:"Image",
		favouriteItems:"FavouriteItem",
		paginateShoppingListItems:"ShoppingListItemConnection",
		paginateFavouriteItems:"FavouriteItemConnection"
	},
	SupplierMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		contact:"FieldMeta",
		shoppingListItems:"FieldMeta",
		logo:"FieldMeta",
		favouriteItems:"FieldMeta"
	},
	FavouriteItem:{
		_meta:"FavouriteItemMeta",
		id:"UUID",
		title:"String",
		amount:"String",
		supplier:"Supplier"
	},
	FavouriteItemMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		amount:"FieldMeta",
		supplier:"FieldMeta"
	},
	ShoppingListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ShoppingListItemEdge"
	},
	ShoppingListItemEdge:{
		node:"ShoppingListItem"
	},
	FavouriteItemConnection:{
		pageInfo:"PageInfo",
		edges:"FavouriteItemEdge"
	},
	FavouriteItemEdge:{
		node:"FavouriteItem"
	},
	ShoppingListConnection:{
		pageInfo:"PageInfo",
		edges:"ShoppingListEdge"
	},
	ShoppingListEdge:{
		node:"ShoppingList"
	},
	SupplierConnection:{
		pageInfo:"PageInfo",
		edges:"SupplierEdge"
	},
	SupplierEdge:{
		node:"Supplier"
	},
	BusinessOrderTypeConnection:{
		pageInfo:"PageInfo",
		edges:"BusinessOrderTypeEdge"
	},
	BusinessOrderTypeEdge:{
		node:"BusinessOrderType"
	},
	QueryTransaction:{
		getColorPallete:"ColorPallete",
		listColorPallete:"ColorPallete",
		paginateColorPallete:"ColorPalleteConnection",
		validateCreateColorPallete:"_ValidationResult",
		validateUpdateColorPallete:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getCover:"Cover",
		listCover:"Cover",
		paginateCover:"CoverConnection",
		validateCreateCover:"_ValidationResult",
		validateUpdateCover:"_ValidationResult",
		getEvent:"Event",
		listEvent:"Event",
		paginateEvent:"EventConnection",
		validateCreateEvent:"_ValidationResult",
		validateUpdateEvent:"_ValidationResult",
		getEventLocale:"EventLocale",
		listEventLocale:"EventLocale",
		paginateEventLocale:"EventLocaleConnection",
		validateCreateEventLocale:"_ValidationResult",
		validateUpdateEventLocale:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageItem:"ImageItem",
		listImageItem:"ImageItem",
		paginateImageItem:"ImageItemConnection",
		validateCreateImageItem:"_ValidationResult",
		validateUpdateImageItem:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getBlog:"Blog",
		listBlog:"Blog",
		paginateBlog:"BlogConnection",
		validateCreateBlog:"_ValidationResult",
		validateUpdateBlog:"_ValidationResult",
		getBlogLocale:"BlogLocale",
		listBlogLocale:"BlogLocale",
		paginateBlogLocale:"BlogLocaleConnection",
		validateCreateBlogLocale:"_ValidationResult",
		validateUpdateBlogLocale:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		getPageLocale:"PageLocale",
		listPageLocale:"PageLocale",
		paginatePageLocale:"PageLocaleConnection",
		validateCreatePageLocale:"_ValidationResult",
		validateUpdatePageLocale:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getSeoLocale:"SeoLocale",
		listSeoLocale:"SeoLocale",
		paginateSeoLocale:"SeoLocaleConnection",
		validateCreateSeoLocale:"_ValidationResult",
		validateUpdateSeoLocale:"_ValidationResult",
		getLocalizedSeo:"LocalizedSeo",
		listLocalizedSeo:"LocalizedSeo",
		paginateLocalizedSeo:"LocalizedSeoConnection",
		validateCreateLocalizedSeo:"_ValidationResult",
		validateUpdateLocalizedSeo:"_ValidationResult",
		getHero:"Hero",
		listHero:"Hero",
		paginateHero:"HeroConnection",
		validateCreateHero:"_ValidationResult",
		validateUpdateHero:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getSocialsAndApps:"SocialsAndApps",
		listSocialsAndApps:"SocialsAndApps",
		paginateSocialsAndApps:"SocialsAndAppsConnection",
		validateCreateSocialsAndApps:"_ValidationResult",
		validateUpdateSocialsAndApps:"_ValidationResult",
		getSiteMenu:"SiteMenu",
		listSiteMenu:"SiteMenu",
		paginateSiteMenu:"SiteMenuConnection",
		validateCreateSiteMenu:"_ValidationResult",
		validateUpdateSiteMenu:"_ValidationResult",
		getMenuItem:"MenuItem",
		listMenuItem:"MenuItem",
		paginateMenuItem:"MenuItemConnection",
		validateCreateMenuItem:"_ValidationResult",
		validateUpdateMenuItem:"_ValidationResult",
		getBlogPostList:"BlogPostList",
		listBlogPostList:"BlogPostList",
		paginateBlogPostList:"BlogPostListConnection",
		validateCreateBlogPostList:"_ValidationResult",
		validateUpdateBlogPostList:"_ValidationResult",
		getBlogPostListItem:"BlogPostListItem",
		listBlogPostListItem:"BlogPostListItem",
		paginateBlogPostListItem:"BlogPostListItemConnection",
		validateCreateBlogPostListItem:"_ValidationResult",
		validateUpdateBlogPostListItem:"_ValidationResult",
		getMenuLocale:"MenuLocale",
		listMenuLocale:"MenuLocale",
		paginateMenuLocale:"MenuLocaleConnection",
		validateCreateMenuLocale:"_ValidationResult",
		validateUpdateMenuLocale:"_ValidationResult",
		getProductGrid:"ProductGrid",
		listProductGrid:"ProductGrid",
		paginateProductGrid:"ProductGridConnection",
		validateCreateProductGrid:"_ValidationResult",
		validateUpdateProductGrid:"_ValidationResult",
		getProductGridItem:"ProductGridItem",
		listProductGridItem:"ProductGridItem",
		paginateProductGridItem:"ProductGridItemConnection",
		validateCreateProductGridItem:"_ValidationResult",
		validateUpdateProductGridItem:"_ValidationResult",
		getProfile:"Profile",
		listProfile:"Profile",
		paginateProfile:"ProfileConnection",
		validateCreateProfile:"_ValidationResult",
		validateUpdateProfile:"_ValidationResult",
		getProfileTag:"ProfileTag",
		listProfileTag:"ProfileTag",
		paginateProfileTag:"ProfileTagConnection",
		validateCreateProfileTag:"_ValidationResult",
		validateUpdateProfileTag:"_ValidationResult",
		getProfileActivityRecord:"ProfileActivityRecord",
		listProfileActivityRecord:"ProfileActivityRecord",
		paginateProfileActivityRecord:"ProfileActivityRecordConnection",
		validateCreateProfileActivityRecord:"_ValidationResult",
		validateUpdateProfileActivityRecord:"_ValidationResult",
		getProfilePin:"ProfilePin",
		listProfilePin:"ProfilePin",
		paginateProfilePin:"ProfilePinConnection",
		validateCreateProfilePin:"_ValidationResult",
		validateUpdateProfilePin:"_ValidationResult",
		getProfileGallery:"ProfileGallery",
		listProfileGallery:"ProfileGallery",
		paginateProfileGallery:"ProfileGalleryConnection",
		validateCreateProfileGallery:"_ValidationResult",
		validateUpdateProfileGallery:"_ValidationResult",
		getProfileGalleryItem:"ProfileGalleryItem",
		listProfileGalleryItem:"ProfileGalleryItem",
		paginateProfileGalleryItem:"ProfileGalleryItemConnection",
		validateCreateProfileGalleryItem:"_ValidationResult",
		validateUpdateProfileGalleryItem:"_ValidationResult",
		getShoppingList:"ShoppingList",
		listShoppingList:"ShoppingList",
		paginateShoppingList:"ShoppingListConnection",
		validateCreateShoppingList:"_ValidationResult",
		validateUpdateShoppingList:"_ValidationResult",
		getShoppingListItem:"ShoppingListItem",
		listShoppingListItem:"ShoppingListItem",
		paginateShoppingListItem:"ShoppingListItemConnection",
		validateCreateShoppingListItem:"_ValidationResult",
		validateUpdateShoppingListItem:"_ValidationResult",
		getSupplier:"Supplier",
		listSupplier:"Supplier",
		paginateSupplier:"SupplierConnection",
		validateCreateSupplier:"_ValidationResult",
		validateUpdateSupplier:"_ValidationResult",
		getFavouriteItem:"FavouriteItem",
		listFavouriteItem:"FavouriteItem",
		paginateFavouriteItem:"FavouriteItemConnection",
		validateCreateFavouriteItem:"_ValidationResult",
		validateUpdateFavouriteItem:"_ValidationResult",
		getBusinessOrderType:"BusinessOrderType",
		listBusinessOrderType:"BusinessOrderType",
		paginateBusinessOrderType:"BusinessOrderTypeConnection",
		validateCreateBusinessOrderType:"_ValidationResult",
		validateUpdateBusinessOrderType:"_ValidationResult",
		getBusinessOrderTypeLocale:"BusinessOrderTypeLocale",
		listBusinessOrderTypeLocale:"BusinessOrderTypeLocale",
		paginateBusinessOrderTypeLocale:"BusinessOrderTypeLocaleConnection",
		validateCreateBusinessOrderTypeLocale:"_ValidationResult",
		validateUpdateBusinessOrderTypeLocale:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createColorPallete:"ColorPalleteCreateResult",
		deleteColorPallete:"ColorPalleteDeleteResult",
		updateColorPallete:"ColorPalleteUpdateResult",
		upsertColorPallete:"ColorPalleteUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createCover:"CoverCreateResult",
		deleteCover:"CoverDeleteResult",
		updateCover:"CoverUpdateResult",
		upsertCover:"CoverUpsertResult",
		createEvent:"EventCreateResult",
		deleteEvent:"EventDeleteResult",
		updateEvent:"EventUpdateResult",
		upsertEvent:"EventUpsertResult",
		createEventLocale:"EventLocaleCreateResult",
		deleteEventLocale:"EventLocaleDeleteResult",
		updateEventLocale:"EventLocaleUpdateResult",
		upsertEventLocale:"EventLocaleUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageItem:"ImageItemCreateResult",
		deleteImageItem:"ImageItemDeleteResult",
		updateImageItem:"ImageItemUpdateResult",
		upsertImageItem:"ImageItemUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createBlog:"BlogCreateResult",
		deleteBlog:"BlogDeleteResult",
		updateBlog:"BlogUpdateResult",
		upsertBlog:"BlogUpsertResult",
		createBlogLocale:"BlogLocaleCreateResult",
		deleteBlogLocale:"BlogLocaleDeleteResult",
		updateBlogLocale:"BlogLocaleUpdateResult",
		upsertBlogLocale:"BlogLocaleUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		createPageLocale:"PageLocaleCreateResult",
		deletePageLocale:"PageLocaleDeleteResult",
		updatePageLocale:"PageLocaleUpdateResult",
		upsertPageLocale:"PageLocaleUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createSeoLocale:"SeoLocaleCreateResult",
		deleteSeoLocale:"SeoLocaleDeleteResult",
		updateSeoLocale:"SeoLocaleUpdateResult",
		upsertSeoLocale:"SeoLocaleUpsertResult",
		createLocalizedSeo:"LocalizedSeoCreateResult",
		deleteLocalizedSeo:"LocalizedSeoDeleteResult",
		updateLocalizedSeo:"LocalizedSeoUpdateResult",
		upsertLocalizedSeo:"LocalizedSeoUpsertResult",
		createHero:"HeroCreateResult",
		deleteHero:"HeroDeleteResult",
		updateHero:"HeroUpdateResult",
		upsertHero:"HeroUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createSocialsAndApps:"SocialsAndAppsCreateResult",
		deleteSocialsAndApps:"SocialsAndAppsDeleteResult",
		updateSocialsAndApps:"SocialsAndAppsUpdateResult",
		upsertSocialsAndApps:"SocialsAndAppsUpsertResult",
		createSiteMenu:"SiteMenuCreateResult",
		deleteSiteMenu:"SiteMenuDeleteResult",
		updateSiteMenu:"SiteMenuUpdateResult",
		upsertSiteMenu:"SiteMenuUpsertResult",
		createMenuItem:"MenuItemCreateResult",
		deleteMenuItem:"MenuItemDeleteResult",
		updateMenuItem:"MenuItemUpdateResult",
		upsertMenuItem:"MenuItemUpsertResult",
		createBlogPostList:"BlogPostListCreateResult",
		deleteBlogPostList:"BlogPostListDeleteResult",
		updateBlogPostList:"BlogPostListUpdateResult",
		upsertBlogPostList:"BlogPostListUpsertResult",
		createBlogPostListItem:"BlogPostListItemCreateResult",
		deleteBlogPostListItem:"BlogPostListItemDeleteResult",
		updateBlogPostListItem:"BlogPostListItemUpdateResult",
		upsertBlogPostListItem:"BlogPostListItemUpsertResult",
		createMenuLocale:"MenuLocaleCreateResult",
		deleteMenuLocale:"MenuLocaleDeleteResult",
		updateMenuLocale:"MenuLocaleUpdateResult",
		upsertMenuLocale:"MenuLocaleUpsertResult",
		createProductGrid:"ProductGridCreateResult",
		deleteProductGrid:"ProductGridDeleteResult",
		updateProductGrid:"ProductGridUpdateResult",
		upsertProductGrid:"ProductGridUpsertResult",
		createProductGridItem:"ProductGridItemCreateResult",
		deleteProductGridItem:"ProductGridItemDeleteResult",
		updateProductGridItem:"ProductGridItemUpdateResult",
		upsertProductGridItem:"ProductGridItemUpsertResult",
		createProfile:"ProfileCreateResult",
		deleteProfile:"ProfileDeleteResult",
		updateProfile:"ProfileUpdateResult",
		upsertProfile:"ProfileUpsertResult",
		createProfileTag:"ProfileTagCreateResult",
		deleteProfileTag:"ProfileTagDeleteResult",
		updateProfileTag:"ProfileTagUpdateResult",
		upsertProfileTag:"ProfileTagUpsertResult",
		createProfileActivityRecord:"ProfileActivityRecordCreateResult",
		deleteProfileActivityRecord:"ProfileActivityRecordDeleteResult",
		updateProfileActivityRecord:"ProfileActivityRecordUpdateResult",
		upsertProfileActivityRecord:"ProfileActivityRecordUpsertResult",
		createProfilePin:"ProfilePinCreateResult",
		deleteProfilePin:"ProfilePinDeleteResult",
		updateProfilePin:"ProfilePinUpdateResult",
		upsertProfilePin:"ProfilePinUpsertResult",
		createProfileGallery:"ProfileGalleryCreateResult",
		deleteProfileGallery:"ProfileGalleryDeleteResult",
		updateProfileGallery:"ProfileGalleryUpdateResult",
		upsertProfileGallery:"ProfileGalleryUpsertResult",
		createProfileGalleryItem:"ProfileGalleryItemCreateResult",
		deleteProfileGalleryItem:"ProfileGalleryItemDeleteResult",
		updateProfileGalleryItem:"ProfileGalleryItemUpdateResult",
		upsertProfileGalleryItem:"ProfileGalleryItemUpsertResult",
		createShoppingList:"ShoppingListCreateResult",
		deleteShoppingList:"ShoppingListDeleteResult",
		updateShoppingList:"ShoppingListUpdateResult",
		upsertShoppingList:"ShoppingListUpsertResult",
		createShoppingListItem:"ShoppingListItemCreateResult",
		deleteShoppingListItem:"ShoppingListItemDeleteResult",
		updateShoppingListItem:"ShoppingListItemUpdateResult",
		upsertShoppingListItem:"ShoppingListItemUpsertResult",
		createSupplier:"SupplierCreateResult",
		deleteSupplier:"SupplierDeleteResult",
		updateSupplier:"SupplierUpdateResult",
		upsertSupplier:"SupplierUpsertResult",
		createFavouriteItem:"FavouriteItemCreateResult",
		deleteFavouriteItem:"FavouriteItemDeleteResult",
		updateFavouriteItem:"FavouriteItemUpdateResult",
		upsertFavouriteItem:"FavouriteItemUpsertResult",
		createBusinessOrderType:"BusinessOrderTypeCreateResult",
		deleteBusinessOrderType:"BusinessOrderTypeDeleteResult",
		updateBusinessOrderType:"BusinessOrderTypeUpdateResult",
		upsertBusinessOrderType:"BusinessOrderTypeUpsertResult",
		createBusinessOrderTypeLocale:"BusinessOrderTypeLocaleCreateResult",
		deleteBusinessOrderTypeLocale:"BusinessOrderTypeLocaleDeleteResult",
		updateBusinessOrderTypeLocale:"BusinessOrderTypeLocaleUpdateResult",
		upsertBusinessOrderTypeLocale:"BusinessOrderTypeLocaleUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	ColorPalleteCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ColorPallete",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on ColorPalleteCreateResult": "ColorPalleteCreateResult",
		"...on ColorPalleteDeleteResult": "ColorPalleteDeleteResult",
		"...on ColorPalleteUpdateResult": "ColorPalleteUpdateResult",
		"...on ColorPalleteUpsertResult": "ColorPalleteUpsertResult",
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on CoverCreateResult": "CoverCreateResult",
		"...on CoverDeleteResult": "CoverDeleteResult",
		"...on CoverUpdateResult": "CoverUpdateResult",
		"...on CoverUpsertResult": "CoverUpsertResult",
		"...on EventCreateResult": "EventCreateResult",
		"...on EventDeleteResult": "EventDeleteResult",
		"...on EventUpdateResult": "EventUpdateResult",
		"...on EventUpsertResult": "EventUpsertResult",
		"...on EventLocaleCreateResult": "EventLocaleCreateResult",
		"...on EventLocaleDeleteResult": "EventLocaleDeleteResult",
		"...on EventLocaleUpdateResult": "EventLocaleUpdateResult",
		"...on EventLocaleUpsertResult": "EventLocaleUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on ImageListCreateResult": "ImageListCreateResult",
		"...on ImageListDeleteResult": "ImageListDeleteResult",
		"...on ImageListUpdateResult": "ImageListUpdateResult",
		"...on ImageListUpsertResult": "ImageListUpsertResult",
		"...on ImageItemCreateResult": "ImageItemCreateResult",
		"...on ImageItemDeleteResult": "ImageItemDeleteResult",
		"...on ImageItemUpdateResult": "ImageItemUpdateResult",
		"...on ImageItemUpsertResult": "ImageItemUpsertResult",
		"...on LocaleCreateResult": "LocaleCreateResult",
		"...on LocaleDeleteResult": "LocaleDeleteResult",
		"...on LocaleUpdateResult": "LocaleUpdateResult",
		"...on LocaleUpsertResult": "LocaleUpsertResult",
		"...on MediumCreateResult": "MediumCreateResult",
		"...on MediumDeleteResult": "MediumDeleteResult",
		"...on MediumUpdateResult": "MediumUpdateResult",
		"...on MediumUpsertResult": "MediumUpsertResult",
		"...on VideoCreateResult": "VideoCreateResult",
		"...on VideoDeleteResult": "VideoDeleteResult",
		"...on VideoUpdateResult": "VideoUpdateResult",
		"...on VideoUpsertResult": "VideoUpsertResult",
		"...on BlogCreateResult": "BlogCreateResult",
		"...on BlogDeleteResult": "BlogDeleteResult",
		"...on BlogUpdateResult": "BlogUpdateResult",
		"...on BlogUpsertResult": "BlogUpsertResult",
		"...on BlogLocaleCreateResult": "BlogLocaleCreateResult",
		"...on BlogLocaleDeleteResult": "BlogLocaleDeleteResult",
		"...on BlogLocaleUpdateResult": "BlogLocaleUpdateResult",
		"...on BlogLocaleUpsertResult": "BlogLocaleUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on PageCreateResult": "PageCreateResult",
		"...on PageDeleteResult": "PageDeleteResult",
		"...on PageUpdateResult": "PageUpdateResult",
		"...on PageUpsertResult": "PageUpsertResult",
		"...on PageLocaleCreateResult": "PageLocaleCreateResult",
		"...on PageLocaleDeleteResult": "PageLocaleDeleteResult",
		"...on PageLocaleUpdateResult": "PageLocaleUpdateResult",
		"...on PageLocaleUpsertResult": "PageLocaleUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on SeoLocaleCreateResult": "SeoLocaleCreateResult",
		"...on SeoLocaleDeleteResult": "SeoLocaleDeleteResult",
		"...on SeoLocaleUpdateResult": "SeoLocaleUpdateResult",
		"...on SeoLocaleUpsertResult": "SeoLocaleUpsertResult",
		"...on LocalizedSeoCreateResult": "LocalizedSeoCreateResult",
		"...on LocalizedSeoDeleteResult": "LocalizedSeoDeleteResult",
		"...on LocalizedSeoUpdateResult": "LocalizedSeoUpdateResult",
		"...on LocalizedSeoUpsertResult": "LocalizedSeoUpsertResult",
		"...on HeroCreateResult": "HeroCreateResult",
		"...on HeroDeleteResult": "HeroDeleteResult",
		"...on HeroUpdateResult": "HeroUpdateResult",
		"...on HeroUpsertResult": "HeroUpsertResult",
		"...on GalleryCreateResult": "GalleryCreateResult",
		"...on GalleryDeleteResult": "GalleryDeleteResult",
		"...on GalleryUpdateResult": "GalleryUpdateResult",
		"...on GalleryUpsertResult": "GalleryUpsertResult",
		"...on GalleryItemCreateResult": "GalleryItemCreateResult",
		"...on GalleryItemDeleteResult": "GalleryItemDeleteResult",
		"...on GalleryItemUpdateResult": "GalleryItemUpdateResult",
		"...on GalleryItemUpsertResult": "GalleryItemUpsertResult",
		"...on SocialsAndAppsCreateResult": "SocialsAndAppsCreateResult",
		"...on SocialsAndAppsDeleteResult": "SocialsAndAppsDeleteResult",
		"...on SocialsAndAppsUpdateResult": "SocialsAndAppsUpdateResult",
		"...on SocialsAndAppsUpsertResult": "SocialsAndAppsUpsertResult",
		"...on SiteMenuCreateResult": "SiteMenuCreateResult",
		"...on SiteMenuDeleteResult": "SiteMenuDeleteResult",
		"...on SiteMenuUpdateResult": "SiteMenuUpdateResult",
		"...on SiteMenuUpsertResult": "SiteMenuUpsertResult",
		"...on MenuItemCreateResult": "MenuItemCreateResult",
		"...on MenuItemDeleteResult": "MenuItemDeleteResult",
		"...on MenuItemUpdateResult": "MenuItemUpdateResult",
		"...on MenuItemUpsertResult": "MenuItemUpsertResult",
		"...on BlogPostListCreateResult": "BlogPostListCreateResult",
		"...on BlogPostListDeleteResult": "BlogPostListDeleteResult",
		"...on BlogPostListUpdateResult": "BlogPostListUpdateResult",
		"...on BlogPostListUpsertResult": "BlogPostListUpsertResult",
		"...on BlogPostListItemCreateResult": "BlogPostListItemCreateResult",
		"...on BlogPostListItemDeleteResult": "BlogPostListItemDeleteResult",
		"...on BlogPostListItemUpdateResult": "BlogPostListItemUpdateResult",
		"...on BlogPostListItemUpsertResult": "BlogPostListItemUpsertResult",
		"...on MenuLocaleCreateResult": "MenuLocaleCreateResult",
		"...on MenuLocaleDeleteResult": "MenuLocaleDeleteResult",
		"...on MenuLocaleUpdateResult": "MenuLocaleUpdateResult",
		"...on MenuLocaleUpsertResult": "MenuLocaleUpsertResult",
		"...on ProductGridCreateResult": "ProductGridCreateResult",
		"...on ProductGridDeleteResult": "ProductGridDeleteResult",
		"...on ProductGridUpdateResult": "ProductGridUpdateResult",
		"...on ProductGridUpsertResult": "ProductGridUpsertResult",
		"...on ProductGridItemCreateResult": "ProductGridItemCreateResult",
		"...on ProductGridItemDeleteResult": "ProductGridItemDeleteResult",
		"...on ProductGridItemUpdateResult": "ProductGridItemUpdateResult",
		"...on ProductGridItemUpsertResult": "ProductGridItemUpsertResult",
		"...on ProfileCreateResult": "ProfileCreateResult",
		"...on ProfileDeleteResult": "ProfileDeleteResult",
		"...on ProfileUpdateResult": "ProfileUpdateResult",
		"...on ProfileUpsertResult": "ProfileUpsertResult",
		"...on ProfileTagCreateResult": "ProfileTagCreateResult",
		"...on ProfileTagDeleteResult": "ProfileTagDeleteResult",
		"...on ProfileTagUpdateResult": "ProfileTagUpdateResult",
		"...on ProfileTagUpsertResult": "ProfileTagUpsertResult",
		"...on ProfileActivityRecordCreateResult": "ProfileActivityRecordCreateResult",
		"...on ProfileActivityRecordDeleteResult": "ProfileActivityRecordDeleteResult",
		"...on ProfileActivityRecordUpdateResult": "ProfileActivityRecordUpdateResult",
		"...on ProfileActivityRecordUpsertResult": "ProfileActivityRecordUpsertResult",
		"...on ProfilePinCreateResult": "ProfilePinCreateResult",
		"...on ProfilePinDeleteResult": "ProfilePinDeleteResult",
		"...on ProfilePinUpdateResult": "ProfilePinUpdateResult",
		"...on ProfilePinUpsertResult": "ProfilePinUpsertResult",
		"...on ProfileGalleryCreateResult": "ProfileGalleryCreateResult",
		"...on ProfileGalleryDeleteResult": "ProfileGalleryDeleteResult",
		"...on ProfileGalleryUpdateResult": "ProfileGalleryUpdateResult",
		"...on ProfileGalleryUpsertResult": "ProfileGalleryUpsertResult",
		"...on ProfileGalleryItemCreateResult": "ProfileGalleryItemCreateResult",
		"...on ProfileGalleryItemDeleteResult": "ProfileGalleryItemDeleteResult",
		"...on ProfileGalleryItemUpdateResult": "ProfileGalleryItemUpdateResult",
		"...on ProfileGalleryItemUpsertResult": "ProfileGalleryItemUpsertResult",
		"...on ShoppingListCreateResult": "ShoppingListCreateResult",
		"...on ShoppingListDeleteResult": "ShoppingListDeleteResult",
		"...on ShoppingListUpdateResult": "ShoppingListUpdateResult",
		"...on ShoppingListUpsertResult": "ShoppingListUpsertResult",
		"...on ShoppingListItemCreateResult": "ShoppingListItemCreateResult",
		"...on ShoppingListItemDeleteResult": "ShoppingListItemDeleteResult",
		"...on ShoppingListItemUpdateResult": "ShoppingListItemUpdateResult",
		"...on ShoppingListItemUpsertResult": "ShoppingListItemUpsertResult",
		"...on SupplierCreateResult": "SupplierCreateResult",
		"...on SupplierDeleteResult": "SupplierDeleteResult",
		"...on SupplierUpdateResult": "SupplierUpdateResult",
		"...on SupplierUpsertResult": "SupplierUpsertResult",
		"...on FavouriteItemCreateResult": "FavouriteItemCreateResult",
		"...on FavouriteItemDeleteResult": "FavouriteItemDeleteResult",
		"...on FavouriteItemUpdateResult": "FavouriteItemUpdateResult",
		"...on FavouriteItemUpsertResult": "FavouriteItemUpsertResult",
		"...on BusinessOrderTypeCreateResult": "BusinessOrderTypeCreateResult",
		"...on BusinessOrderTypeDeleteResult": "BusinessOrderTypeDeleteResult",
		"...on BusinessOrderTypeUpdateResult": "BusinessOrderTypeUpdateResult",
		"...on BusinessOrderTypeUpsertResult": "BusinessOrderTypeUpsertResult",
		"...on BusinessOrderTypeLocaleCreateResult": "BusinessOrderTypeLocaleCreateResult",
		"...on BusinessOrderTypeLocaleDeleteResult": "BusinessOrderTypeLocaleDeleteResult",
		"...on BusinessOrderTypeLocaleUpdateResult": "BusinessOrderTypeLocaleUpdateResult",
		"...on BusinessOrderTypeLocaleUpsertResult": "BusinessOrderTypeLocaleUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	ColorPalleteDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ColorPallete"
	},
	ColorPalleteUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ColorPallete",
		validation:"_ValidationResult"
	},
	ColorPalleteUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ColorPallete",
		validation:"_ValidationResult"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	CoverCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cover",
		validation:"_ValidationResult"
	},
	CoverDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cover"
	},
	CoverUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cover",
		validation:"_ValidationResult"
	},
	CoverUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Cover",
		validation:"_ValidationResult"
	},
	EventCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	EventDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event"
	},
	EventUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	EventUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	EventLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLocale",
		validation:"_ValidationResult"
	},
	EventLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLocale"
	},
	EventLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLocale",
		validation:"_ValidationResult"
	},
	EventLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLocale",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList"
	},
	ImageListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageItem",
		validation:"_ValidationResult"
	},
	ImageItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageItem"
	},
	ImageItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageItem",
		validation:"_ValidationResult"
	},
	ImageItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageItem",
		validation:"_ValidationResult"
	},
	LocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale"
	},
	LocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	MediumCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium"
	},
	MediumUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	VideoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video"
	},
	VideoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	BlogCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Blog",
		validation:"_ValidationResult"
	},
	BlogDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Blog"
	},
	BlogUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Blog",
		validation:"_ValidationResult"
	},
	BlogUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Blog",
		validation:"_ValidationResult"
	},
	BlogLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogLocale",
		validation:"_ValidationResult"
	},
	BlogLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogLocale"
	},
	BlogLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogLocale",
		validation:"_ValidationResult"
	},
	BlogLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogLocale",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	PageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page"
	},
	PageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	PageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale"
	},
	PageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	PageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoLocale",
		validation:"_ValidationResult"
	},
	SeoLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoLocale"
	},
	SeoLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoLocale",
		validation:"_ValidationResult"
	},
	SeoLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoLocale",
		validation:"_ValidationResult"
	},
	LocalizedSeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LocalizedSeo",
		validation:"_ValidationResult"
	},
	LocalizedSeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LocalizedSeo"
	},
	LocalizedSeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LocalizedSeo",
		validation:"_ValidationResult"
	},
	LocalizedSeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LocalizedSeo",
		validation:"_ValidationResult"
	},
	HeroCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Hero",
		validation:"_ValidationResult"
	},
	HeroDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Hero"
	},
	HeroUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Hero",
		validation:"_ValidationResult"
	},
	HeroUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Hero",
		validation:"_ValidationResult"
	},
	GalleryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery"
	},
	GalleryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem"
	},
	GalleryItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	SocialsAndAppsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialsAndApps",
		validation:"_ValidationResult"
	},
	SocialsAndAppsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialsAndApps"
	},
	SocialsAndAppsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialsAndApps",
		validation:"_ValidationResult"
	},
	SocialsAndAppsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialsAndApps",
		validation:"_ValidationResult"
	},
	SiteMenuCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteMenu",
		validation:"_ValidationResult"
	},
	SiteMenuDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteMenu"
	},
	SiteMenuUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteMenu",
		validation:"_ValidationResult"
	},
	SiteMenuUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SiteMenu",
		validation:"_ValidationResult"
	},
	MenuItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuItem",
		validation:"_ValidationResult"
	},
	MenuItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuItem"
	},
	MenuItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuItem",
		validation:"_ValidationResult"
	},
	MenuItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuItem",
		validation:"_ValidationResult"
	},
	BlogPostListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostList",
		validation:"_ValidationResult"
	},
	BlogPostListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostList"
	},
	BlogPostListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostList",
		validation:"_ValidationResult"
	},
	BlogPostListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostList",
		validation:"_ValidationResult"
	},
	BlogPostListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostListItem",
		validation:"_ValidationResult"
	},
	BlogPostListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostListItem"
	},
	BlogPostListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostListItem",
		validation:"_ValidationResult"
	},
	BlogPostListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BlogPostListItem",
		validation:"_ValidationResult"
	},
	MenuLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLocale",
		validation:"_ValidationResult"
	},
	MenuLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLocale"
	},
	MenuLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLocale",
		validation:"_ValidationResult"
	},
	MenuLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MenuLocale",
		validation:"_ValidationResult"
	},
	ProductGridCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGrid",
		validation:"_ValidationResult"
	},
	ProductGridDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGrid"
	},
	ProductGridUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGrid",
		validation:"_ValidationResult"
	},
	ProductGridUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGrid",
		validation:"_ValidationResult"
	},
	ProductGridItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridItem",
		validation:"_ValidationResult"
	},
	ProductGridItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridItem"
	},
	ProductGridItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridItem",
		validation:"_ValidationResult"
	},
	ProductGridItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProductGridItem",
		validation:"_ValidationResult"
	},
	ProfileCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Profile",
		validation:"_ValidationResult"
	},
	ProfileDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Profile"
	},
	ProfileUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Profile",
		validation:"_ValidationResult"
	},
	ProfileUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Profile",
		validation:"_ValidationResult"
	},
	ProfileTagCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileTag",
		validation:"_ValidationResult"
	},
	ProfileTagDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileTag"
	},
	ProfileTagUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileTag",
		validation:"_ValidationResult"
	},
	ProfileTagUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileTag",
		validation:"_ValidationResult"
	},
	ProfileActivityRecordCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileActivityRecord",
		validation:"_ValidationResult"
	},
	ProfileActivityRecordDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileActivityRecord"
	},
	ProfileActivityRecordUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileActivityRecord",
		validation:"_ValidationResult"
	},
	ProfileActivityRecordUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileActivityRecord",
		validation:"_ValidationResult"
	},
	ProfilePinCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfilePin",
		validation:"_ValidationResult"
	},
	ProfilePinDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfilePin"
	},
	ProfilePinUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfilePin",
		validation:"_ValidationResult"
	},
	ProfilePinUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfilePin",
		validation:"_ValidationResult"
	},
	ProfileGalleryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileGallery",
		validation:"_ValidationResult"
	},
	ProfileGalleryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileGallery"
	},
	ProfileGalleryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileGallery",
		validation:"_ValidationResult"
	},
	ProfileGalleryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileGallery",
		validation:"_ValidationResult"
	},
	ProfileGalleryItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileGalleryItem",
		validation:"_ValidationResult"
	},
	ProfileGalleryItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileGalleryItem"
	},
	ProfileGalleryItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileGalleryItem",
		validation:"_ValidationResult"
	},
	ProfileGalleryItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ProfileGalleryItem",
		validation:"_ValidationResult"
	},
	ShoppingListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingList",
		validation:"_ValidationResult"
	},
	ShoppingListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingList"
	},
	ShoppingListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingList",
		validation:"_ValidationResult"
	},
	ShoppingListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingList",
		validation:"_ValidationResult"
	},
	ShoppingListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingListItem",
		validation:"_ValidationResult"
	},
	ShoppingListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingListItem"
	},
	ShoppingListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingListItem",
		validation:"_ValidationResult"
	},
	ShoppingListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShoppingListItem",
		validation:"_ValidationResult"
	},
	SupplierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Supplier",
		validation:"_ValidationResult"
	},
	SupplierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Supplier"
	},
	SupplierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Supplier",
		validation:"_ValidationResult"
	},
	SupplierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Supplier",
		validation:"_ValidationResult"
	},
	FavouriteItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FavouriteItem",
		validation:"_ValidationResult"
	},
	FavouriteItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FavouriteItem"
	},
	FavouriteItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FavouriteItem",
		validation:"_ValidationResult"
	},
	FavouriteItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FavouriteItem",
		validation:"_ValidationResult"
	},
	BusinessOrderTypeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessOrderType",
		validation:"_ValidationResult"
	},
	BusinessOrderTypeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessOrderType"
	},
	BusinessOrderTypeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessOrderType",
		validation:"_ValidationResult"
	},
	BusinessOrderTypeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessOrderType",
		validation:"_ValidationResult"
	},
	BusinessOrderTypeLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessOrderTypeLocale",
		validation:"_ValidationResult"
	},
	BusinessOrderTypeLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessOrderTypeLocale"
	},
	BusinessOrderTypeLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessOrderTypeLocale",
		validation:"_ValidationResult"
	},
	BusinessOrderTypeLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BusinessOrderTypeLocale",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createColorPallete:"ColorPalleteCreateResult",
		deleteColorPallete:"ColorPalleteDeleteResult",
		updateColorPallete:"ColorPalleteUpdateResult",
		upsertColorPallete:"ColorPalleteUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createCover:"CoverCreateResult",
		deleteCover:"CoverDeleteResult",
		updateCover:"CoverUpdateResult",
		upsertCover:"CoverUpsertResult",
		createEvent:"EventCreateResult",
		deleteEvent:"EventDeleteResult",
		updateEvent:"EventUpdateResult",
		upsertEvent:"EventUpsertResult",
		createEventLocale:"EventLocaleCreateResult",
		deleteEventLocale:"EventLocaleDeleteResult",
		updateEventLocale:"EventLocaleUpdateResult",
		upsertEventLocale:"EventLocaleUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageItem:"ImageItemCreateResult",
		deleteImageItem:"ImageItemDeleteResult",
		updateImageItem:"ImageItemUpdateResult",
		upsertImageItem:"ImageItemUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createBlog:"BlogCreateResult",
		deleteBlog:"BlogDeleteResult",
		updateBlog:"BlogUpdateResult",
		upsertBlog:"BlogUpsertResult",
		createBlogLocale:"BlogLocaleCreateResult",
		deleteBlogLocale:"BlogLocaleDeleteResult",
		updateBlogLocale:"BlogLocaleUpdateResult",
		upsertBlogLocale:"BlogLocaleUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		createPageLocale:"PageLocaleCreateResult",
		deletePageLocale:"PageLocaleDeleteResult",
		updatePageLocale:"PageLocaleUpdateResult",
		upsertPageLocale:"PageLocaleUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createSeoLocale:"SeoLocaleCreateResult",
		deleteSeoLocale:"SeoLocaleDeleteResult",
		updateSeoLocale:"SeoLocaleUpdateResult",
		upsertSeoLocale:"SeoLocaleUpsertResult",
		createLocalizedSeo:"LocalizedSeoCreateResult",
		deleteLocalizedSeo:"LocalizedSeoDeleteResult",
		updateLocalizedSeo:"LocalizedSeoUpdateResult",
		upsertLocalizedSeo:"LocalizedSeoUpsertResult",
		createHero:"HeroCreateResult",
		deleteHero:"HeroDeleteResult",
		updateHero:"HeroUpdateResult",
		upsertHero:"HeroUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createSocialsAndApps:"SocialsAndAppsCreateResult",
		deleteSocialsAndApps:"SocialsAndAppsDeleteResult",
		updateSocialsAndApps:"SocialsAndAppsUpdateResult",
		upsertSocialsAndApps:"SocialsAndAppsUpsertResult",
		createSiteMenu:"SiteMenuCreateResult",
		deleteSiteMenu:"SiteMenuDeleteResult",
		updateSiteMenu:"SiteMenuUpdateResult",
		upsertSiteMenu:"SiteMenuUpsertResult",
		createMenuItem:"MenuItemCreateResult",
		deleteMenuItem:"MenuItemDeleteResult",
		updateMenuItem:"MenuItemUpdateResult",
		upsertMenuItem:"MenuItemUpsertResult",
		createBlogPostList:"BlogPostListCreateResult",
		deleteBlogPostList:"BlogPostListDeleteResult",
		updateBlogPostList:"BlogPostListUpdateResult",
		upsertBlogPostList:"BlogPostListUpsertResult",
		createBlogPostListItem:"BlogPostListItemCreateResult",
		deleteBlogPostListItem:"BlogPostListItemDeleteResult",
		updateBlogPostListItem:"BlogPostListItemUpdateResult",
		upsertBlogPostListItem:"BlogPostListItemUpsertResult",
		createMenuLocale:"MenuLocaleCreateResult",
		deleteMenuLocale:"MenuLocaleDeleteResult",
		updateMenuLocale:"MenuLocaleUpdateResult",
		upsertMenuLocale:"MenuLocaleUpsertResult",
		createProductGrid:"ProductGridCreateResult",
		deleteProductGrid:"ProductGridDeleteResult",
		updateProductGrid:"ProductGridUpdateResult",
		upsertProductGrid:"ProductGridUpsertResult",
		createProductGridItem:"ProductGridItemCreateResult",
		deleteProductGridItem:"ProductGridItemDeleteResult",
		updateProductGridItem:"ProductGridItemUpdateResult",
		upsertProductGridItem:"ProductGridItemUpsertResult",
		createProfile:"ProfileCreateResult",
		deleteProfile:"ProfileDeleteResult",
		updateProfile:"ProfileUpdateResult",
		upsertProfile:"ProfileUpsertResult",
		createProfileTag:"ProfileTagCreateResult",
		deleteProfileTag:"ProfileTagDeleteResult",
		updateProfileTag:"ProfileTagUpdateResult",
		upsertProfileTag:"ProfileTagUpsertResult",
		createProfileActivityRecord:"ProfileActivityRecordCreateResult",
		deleteProfileActivityRecord:"ProfileActivityRecordDeleteResult",
		updateProfileActivityRecord:"ProfileActivityRecordUpdateResult",
		upsertProfileActivityRecord:"ProfileActivityRecordUpsertResult",
		createProfilePin:"ProfilePinCreateResult",
		deleteProfilePin:"ProfilePinDeleteResult",
		updateProfilePin:"ProfilePinUpdateResult",
		upsertProfilePin:"ProfilePinUpsertResult",
		createProfileGallery:"ProfileGalleryCreateResult",
		deleteProfileGallery:"ProfileGalleryDeleteResult",
		updateProfileGallery:"ProfileGalleryUpdateResult",
		upsertProfileGallery:"ProfileGalleryUpsertResult",
		createProfileGalleryItem:"ProfileGalleryItemCreateResult",
		deleteProfileGalleryItem:"ProfileGalleryItemDeleteResult",
		updateProfileGalleryItem:"ProfileGalleryItemUpdateResult",
		upsertProfileGalleryItem:"ProfileGalleryItemUpsertResult",
		createShoppingList:"ShoppingListCreateResult",
		deleteShoppingList:"ShoppingListDeleteResult",
		updateShoppingList:"ShoppingListUpdateResult",
		upsertShoppingList:"ShoppingListUpsertResult",
		createShoppingListItem:"ShoppingListItemCreateResult",
		deleteShoppingListItem:"ShoppingListItemDeleteResult",
		updateShoppingListItem:"ShoppingListItemUpdateResult",
		upsertShoppingListItem:"ShoppingListItemUpsertResult",
		createSupplier:"SupplierCreateResult",
		deleteSupplier:"SupplierDeleteResult",
		updateSupplier:"SupplierUpdateResult",
		upsertSupplier:"SupplierUpsertResult",
		createFavouriteItem:"FavouriteItemCreateResult",
		deleteFavouriteItem:"FavouriteItemDeleteResult",
		updateFavouriteItem:"FavouriteItemUpdateResult",
		upsertFavouriteItem:"FavouriteItemUpsertResult",
		createBusinessOrderType:"BusinessOrderTypeCreateResult",
		deleteBusinessOrderType:"BusinessOrderTypeDeleteResult",
		updateBusinessOrderType:"BusinessOrderTypeUpdateResult",
		upsertBusinessOrderType:"BusinessOrderTypeUpsertResult",
		createBusinessOrderTypeLocale:"BusinessOrderTypeLocaleCreateResult",
		deleteBusinessOrderTypeLocale:"BusinessOrderTypeLocaleDeleteResult",
		updateBusinessOrderTypeLocale:"BusinessOrderTypeLocaleUpdateResult",
		upsertBusinessOrderTypeLocale:"BusinessOrderTypeLocaleUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}
type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	filter?:ValueTypes["ColorPalleteWhere"] | null},ValueTypes["ColorPallete"]],
listColorPallete?: [{	filter?:ValueTypes["ColorPalleteWhere"] | null,	orderBy?:ValueTypes["ColorPalleteOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ColorPallete"]],
paginateColorPallete?: [{	filter?:ValueTypes["ColorPalleteWhere"] | null,	orderBy?:ValueTypes["ColorPalleteOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ColorPalleteConnection"]],
validateCreateColorPallete?: [{	data:ValueTypes["ColorPalleteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	data:ValueTypes["ColorPalleteUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getCover?: [{	by:ValueTypes["CoverUniqueWhere"],	filter?:ValueTypes["CoverWhere"] | null},ValueTypes["Cover"]],
listCover?: [{	filter?:ValueTypes["CoverWhere"] | null,	orderBy?:ValueTypes["CoverOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Cover"]],
paginateCover?: [{	filter?:ValueTypes["CoverWhere"] | null,	orderBy?:ValueTypes["CoverOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CoverConnection"]],
validateCreateCover?: [{	data:ValueTypes["CoverCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCover?: [{	by:ValueTypes["CoverUniqueWhere"],	data:ValueTypes["CoverUpdateInput"]},ValueTypes["_ValidationResult"]],
getEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
listEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Event"]],
paginateEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventConnection"]],
validateCreateEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	data:ValueTypes["EventUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
listEventLocale?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLocale"]],
paginateEventLocale?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLocaleConnection"]],
validateCreateEventLocale?: [{	data:ValueTypes["EventLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	data:ValueTypes["EventLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
listImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	filter?:ValueTypes["ImageItemWhere"] | null},ValueTypes["ImageItem"]],
listImageItem?: [{	filter?:ValueTypes["ImageItemWhere"] | null,	orderBy?:ValueTypes["ImageItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageItem"]],
paginateImageItem?: [{	filter?:ValueTypes["ImageItemWhere"] | null,	orderBy?:ValueTypes["ImageItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageItemConnection"]],
validateCreateImageItem?: [{	data:ValueTypes["ImageItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	data:ValueTypes["ImageItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
listLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Locale"]],
paginateLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
listMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Medium"]],
paginateMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	data:ValueTypes["MediumUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
listVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	data:ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	filter?:ValueTypes["BlogWhere"] | null},ValueTypes["Blog"]],
listBlog?: [{	filter?:ValueTypes["BlogWhere"] | null,	orderBy?:ValueTypes["BlogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Blog"]],
paginateBlog?: [{	filter?:ValueTypes["BlogWhere"] | null,	orderBy?:ValueTypes["BlogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogConnection"]],
validateCreateBlog?: [{	data:ValueTypes["BlogCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	data:ValueTypes["BlogUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null},ValueTypes["BlogLocale"]],
listBlogLocale?: [{	filter?:ValueTypes["BlogLocaleWhere"] | null,	orderBy?:ValueTypes["BlogLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogLocale"]],
paginateBlogLocale?: [{	filter?:ValueTypes["BlogLocaleWhere"] | null,	orderBy?:ValueTypes["BlogLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogLocaleConnection"]],
validateCreateBlogLocale?: [{	data:ValueTypes["BlogLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	data:ValueTypes["BlogLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getPageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
listPageLocale?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PageLocale"]],
paginatePageLocale?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageLocaleConnection"]],
validateCreatePageLocale?: [{	data:ValueTypes["PageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	data:ValueTypes["PageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null},ValueTypes["SeoLocale"]],
listSeoLocale?: [{	filter?:ValueTypes["SeoLocaleWhere"] | null,	orderBy?:ValueTypes["SeoLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoLocale"]],
paginateSeoLocale?: [{	filter?:ValueTypes["SeoLocaleWhere"] | null,	orderBy?:ValueTypes["SeoLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoLocaleConnection"]],
validateCreateSeoLocale?: [{	data:ValueTypes["SeoLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	data:ValueTypes["SeoLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	filter?:ValueTypes["LocalizedSeoWhere"] | null},ValueTypes["LocalizedSeo"]],
listLocalizedSeo?: [{	filter?:ValueTypes["LocalizedSeoWhere"] | null,	orderBy?:ValueTypes["LocalizedSeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LocalizedSeo"]],
paginateLocalizedSeo?: [{	filter?:ValueTypes["LocalizedSeoWhere"] | null,	orderBy?:ValueTypes["LocalizedSeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LocalizedSeoConnection"]],
validateCreateLocalizedSeo?: [{	data:ValueTypes["LocalizedSeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	data:ValueTypes["LocalizedSeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getHero?: [{	by:ValueTypes["HeroUniqueWhere"],	filter?:ValueTypes["HeroWhere"] | null},ValueTypes["Hero"]],
listHero?: [{	filter?:ValueTypes["HeroWhere"] | null,	orderBy?:ValueTypes["HeroOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Hero"]],
paginateHero?: [{	filter?:ValueTypes["HeroWhere"] | null,	orderBy?:ValueTypes["HeroOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeroConnection"]],
validateCreateHero?: [{	data:ValueTypes["HeroCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHero?: [{	by:ValueTypes["HeroUniqueWhere"],	data:ValueTypes["HeroUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	filter?:ValueTypes["SocialsAndAppsWhere"] | null},ValueTypes["SocialsAndApps"]],
listSocialsAndApps?: [{	filter?:ValueTypes["SocialsAndAppsWhere"] | null,	orderBy?:ValueTypes["SocialsAndAppsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialsAndApps"]],
paginateSocialsAndApps?: [{	filter?:ValueTypes["SocialsAndAppsWhere"] | null,	orderBy?:ValueTypes["SocialsAndAppsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialsAndAppsConnection"]],
validateCreateSocialsAndApps?: [{	data:ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	data:ValueTypes["SocialsAndAppsUpdateInput"]},ValueTypes["_ValidationResult"]],
getSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	filter?:ValueTypes["SiteMenuWhere"] | null},ValueTypes["SiteMenu"]],
listSiteMenu?: [{	filter?:ValueTypes["SiteMenuWhere"] | null,	orderBy?:ValueTypes["SiteMenuOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SiteMenu"]],
paginateSiteMenu?: [{	filter?:ValueTypes["SiteMenuWhere"] | null,	orderBy?:ValueTypes["SiteMenuOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SiteMenuConnection"]],
validateCreateSiteMenu?: [{	data:ValueTypes["SiteMenuCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	data:ValueTypes["SiteMenuUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	filter?:ValueTypes["MenuItemWhere"] | null},ValueTypes["MenuItem"]],
listMenuItem?: [{	filter?:ValueTypes["MenuItemWhere"] | null,	orderBy?:ValueTypes["MenuItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MenuItem"]],
paginateMenuItem?: [{	filter?:ValueTypes["MenuItemWhere"] | null,	orderBy?:ValueTypes["MenuItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MenuItemConnection"]],
validateCreateMenuItem?: [{	data:ValueTypes["MenuItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	data:ValueTypes["MenuItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	filter?:ValueTypes["BlogPostListWhere"] | null},ValueTypes["BlogPostList"]],
listBlogPostList?: [{	filter?:ValueTypes["BlogPostListWhere"] | null,	orderBy?:ValueTypes["BlogPostListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostList"]],
paginateBlogPostList?: [{	filter?:ValueTypes["BlogPostListWhere"] | null,	orderBy?:ValueTypes["BlogPostListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostListConnection"]],
validateCreateBlogPostList?: [{	data:ValueTypes["BlogPostListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	data:ValueTypes["BlogPostListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	filter?:ValueTypes["BlogPostListItemWhere"] | null},ValueTypes["BlogPostListItem"]],
listBlogPostListItem?: [{	filter?:ValueTypes["BlogPostListItemWhere"] | null,	orderBy?:ValueTypes["BlogPostListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostListItem"]],
paginateBlogPostListItem?: [{	filter?:ValueTypes["BlogPostListItemWhere"] | null,	orderBy?:ValueTypes["BlogPostListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostListItemConnection"]],
validateCreateBlogPostListItem?: [{	data:ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	data:ValueTypes["BlogPostListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocale"]],
listMenuLocale?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null,	orderBy?:ValueTypes["MenuLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MenuLocale"]],
paginateMenuLocale?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null,	orderBy?:ValueTypes["MenuLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MenuLocaleConnection"]],
validateCreateMenuLocale?: [{	data:ValueTypes["MenuLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	data:ValueTypes["MenuLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	filter?:ValueTypes["ProductGridWhere"] | null},ValueTypes["ProductGrid"]],
listProductGrid?: [{	filter?:ValueTypes["ProductGridWhere"] | null,	orderBy?:ValueTypes["ProductGridOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductGrid"]],
paginateProductGrid?: [{	filter?:ValueTypes["ProductGridWhere"] | null,	orderBy?:ValueTypes["ProductGridOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductGridConnection"]],
validateCreateProductGrid?: [{	data:ValueTypes["ProductGridCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	data:ValueTypes["ProductGridUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	filter?:ValueTypes["ProductGridItemWhere"] | null},ValueTypes["ProductGridItem"]],
listProductGridItem?: [{	filter?:ValueTypes["ProductGridItemWhere"] | null,	orderBy?:ValueTypes["ProductGridItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductGridItem"]],
paginateProductGridItem?: [{	filter?:ValueTypes["ProductGridItemWhere"] | null,	orderBy?:ValueTypes["ProductGridItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductGridItemConnection"]],
validateCreateProductGridItem?: [{	data:ValueTypes["ProductGridItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	data:ValueTypes["ProductGridItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	filter?:ValueTypes["ProfileWhere"] | null},ValueTypes["Profile"]],
listProfile?: [{	filter?:ValueTypes["ProfileWhere"] | null,	orderBy?:ValueTypes["ProfileOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Profile"]],
paginateProfile?: [{	filter?:ValueTypes["ProfileWhere"] | null,	orderBy?:ValueTypes["ProfileOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileConnection"]],
validateCreateProfile?: [{	data:ValueTypes["ProfileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	data:ValueTypes["ProfileUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	filter?:ValueTypes["ProfileTagWhere"] | null},ValueTypes["ProfileTag"]],
listProfileTag?: [{	filter?:ValueTypes["ProfileTagWhere"] | null,	orderBy?:ValueTypes["ProfileTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileTag"]],
paginateProfileTag?: [{	filter?:ValueTypes["ProfileTagWhere"] | null,	orderBy?:ValueTypes["ProfileTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileTagConnection"]],
validateCreateProfileTag?: [{	data:ValueTypes["ProfileTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	data:ValueTypes["ProfileTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	filter?:ValueTypes["ProfileActivityRecordWhere"] | null},ValueTypes["ProfileActivityRecord"]],
listProfileActivityRecord?: [{	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	orderBy?:ValueTypes["ProfileActivityRecordOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileActivityRecord"]],
paginateProfileActivityRecord?: [{	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	orderBy?:ValueTypes["ProfileActivityRecordOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileActivityRecordConnection"]],
validateCreateProfileActivityRecord?: [{	data:ValueTypes["ProfileActivityRecordCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	data:ValueTypes["ProfileActivityRecordUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null},ValueTypes["ProfilePin"]],
listProfilePin?: [{	filter?:ValueTypes["ProfilePinWhere"] | null,	orderBy?:ValueTypes["ProfilePinOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfilePin"]],
paginateProfilePin?: [{	filter?:ValueTypes["ProfilePinWhere"] | null,	orderBy?:ValueTypes["ProfilePinOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfilePinConnection"]],
validateCreateProfilePin?: [{	data:ValueTypes["ProfilePinCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	data:ValueTypes["ProfilePinUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	filter?:ValueTypes["ProfileGalleryWhere"] | null},ValueTypes["ProfileGallery"]],
listProfileGallery?: [{	filter?:ValueTypes["ProfileGalleryWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileGallery"]],
paginateProfileGallery?: [{	filter?:ValueTypes["ProfileGalleryWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileGalleryConnection"]],
validateCreateProfileGallery?: [{	data:ValueTypes["ProfileGalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	data:ValueTypes["ProfileGalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	filter?:ValueTypes["ProfileGalleryItemWhere"] | null},ValueTypes["ProfileGalleryItem"]],
listProfileGalleryItem?: [{	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileGalleryItem"]],
paginateProfileGalleryItem?: [{	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileGalleryItemConnection"]],
validateCreateProfileGalleryItem?: [{	data:ValueTypes["ProfileGalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	data:ValueTypes["ProfileGalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	filter?:ValueTypes["ShoppingListWhere"] | null},ValueTypes["ShoppingList"]],
listShoppingList?: [{	filter?:ValueTypes["ShoppingListWhere"] | null,	orderBy?:ValueTypes["ShoppingListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShoppingList"]],
paginateShoppingList?: [{	filter?:ValueTypes["ShoppingListWhere"] | null,	orderBy?:ValueTypes["ShoppingListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShoppingListConnection"]],
validateCreateShoppingList?: [{	data:ValueTypes["ShoppingListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	data:ValueTypes["ShoppingListUpdateInput"]},ValueTypes["_ValidationResult"]],
getShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	filter?:ValueTypes["ShoppingListItemWhere"] | null},ValueTypes["ShoppingListItem"]],
listShoppingListItem?: [{	filter?:ValueTypes["ShoppingListItemWhere"] | null,	orderBy?:ValueTypes["ShoppingListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShoppingListItem"]],
paginateShoppingListItem?: [{	filter?:ValueTypes["ShoppingListItemWhere"] | null,	orderBy?:ValueTypes["ShoppingListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShoppingListItemConnection"]],
validateCreateShoppingListItem?: [{	data:ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	data:ValueTypes["ShoppingListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	filter?:ValueTypes["SupplierWhere"] | null},ValueTypes["Supplier"]],
listSupplier?: [{	filter?:ValueTypes["SupplierWhere"] | null,	orderBy?:ValueTypes["SupplierOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Supplier"]],
paginateSupplier?: [{	filter?:ValueTypes["SupplierWhere"] | null,	orderBy?:ValueTypes["SupplierOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SupplierConnection"]],
validateCreateSupplier?: [{	data:ValueTypes["SupplierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	data:ValueTypes["SupplierUpdateInput"]},ValueTypes["_ValidationResult"]],
getFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	filter?:ValueTypes["FavouriteItemWhere"] | null},ValueTypes["FavouriteItem"]],
listFavouriteItem?: [{	filter?:ValueTypes["FavouriteItemWhere"] | null,	orderBy?:ValueTypes["FavouriteItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FavouriteItem"]],
paginateFavouriteItem?: [{	filter?:ValueTypes["FavouriteItemWhere"] | null,	orderBy?:ValueTypes["FavouriteItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FavouriteItemConnection"]],
validateCreateFavouriteItem?: [{	data:ValueTypes["FavouriteItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	data:ValueTypes["FavouriteItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeWhere"] | null},ValueTypes["BusinessOrderType"]],
listBusinessOrderType?: [{	filter?:ValueTypes["BusinessOrderTypeWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BusinessOrderType"]],
paginateBusinessOrderType?: [{	filter?:ValueTypes["BusinessOrderTypeWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BusinessOrderTypeConnection"]],
validateCreateBusinessOrderType?: [{	data:ValueTypes["BusinessOrderTypeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	data:ValueTypes["BusinessOrderTypeUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null},ValueTypes["BusinessOrderTypeLocale"]],
listBusinessOrderTypeLocale?: [{	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BusinessOrderTypeLocale"]],
paginateBusinessOrderTypeLocale?: [{	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BusinessOrderTypeLocaleConnection"]],
validateCreateBusinessOrderTypeLocale?: [{	data:ValueTypes["BusinessOrderTypeLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	data:ValueTypes["BusinessOrderTypeLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:true,
		__typename?: true
}>;
	["ColorPallete"]: AliasType<{
	_meta?:ValueTypes["ColorPalleteMeta"],
	id?:true,
	background?:true,
	text?:true,
		__typename?: true
}>;
	["ColorPalleteMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	background?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FieldMeta"]: AliasType<{
	readable?:true,
	updatable?:true,
		__typename?: true
}>;
	["UUID"]:unknown;
	["ColorPalleteUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ColorPalleteWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	background?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ColorPalleteWhere"] | undefined | null)[],
	or?:(ValueTypes["ColorPalleteWhere"] | undefined | null)[],
	not?:ValueTypes["ColorPalleteWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["ColorPalleteOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	background?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null
};
	["OrderDirection"]:OrderDirection;
	["ColorPalleteConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ColorPalleteEdge"],
		__typename?: true
}>;
	["PageInfo"]: AliasType<{
	totalCount?:true,
		__typename?: true
}>;
	["ColorPalleteEdge"]: AliasType<{
	node?:ValueTypes["ColorPallete"],
		__typename?: true
}>;
	["_ValidationResult"]: AliasType<{
	valid?:true,
	errors?:ValueTypes["_ValidationError"],
		__typename?: true
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: true
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: true
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:true,
		__typename?: true
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:true,
	alias?:true,
		__typename?: true
}>;
	["_ValidationMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["ColorPalleteCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	background?:string | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["ColorPalleteUpdateInput"]: {
	background?:string | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:true,
blocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by:ValueTypes["ContentBlocksByReferencesUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
		__typename?: true
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:true,
	order?:true,
	json?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
references?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: true
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	blocks?:ValueTypes["ContentBlockWhere"] | null,
	and?:(ValueTypes["ContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentWhere"] | undefined | null)[],
	not?:ValueTypes["ContentWhere"] | null
};
	["ContentBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	references?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentBlockWhere"] | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["ContentReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ContentReferenceTypeCondition"] | null,
	primaryText?:ValueTypes["StringCondition"] | null,
	secondaryText?:ValueTypes["StringCondition"] | null,
	jsonContent?:ValueTypes["StringCondition"] | null,
	block?:ValueTypes["ContentBlockWhere"] | null,
	colorPallete?:ValueTypes["ColorPalleteWhere"] | null,
	medium?:ValueTypes["MediumWhere"] | null,
	misc?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	hero?:ValueTypes["HeroWhere"] | null,
	gallery?:ValueTypes["GalleryWhere"] | null,
	contentSize?:ValueTypes["ContentSizeCondition"] | null,
	socialsAndApps?:ValueTypes["SocialsAndAppsWhere"] | null,
	blogPosts?:ValueTypes["BlogPostListWhere"] | null,
	productGrid?:ValueTypes["ProductGridWhere"] | null,
	and?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceWhere"] | null
};
	["ContentReferenceTypeCondition"]: {
	and?:ValueTypes["ContentReferenceTypeCondition"][],
	or?:ValueTypes["ContentReferenceTypeCondition"][],
	not?:ValueTypes["ContentReferenceTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentReferenceType"] | null,
	notEq?:ValueTypes["ContentReferenceType"] | null,
	in?:ValueTypes["ContentReferenceType"][],
	notIn?:ValueTypes["ContentReferenceType"][],
	lt?:ValueTypes["ContentReferenceType"] | null,
	lte?:ValueTypes["ContentReferenceType"] | null,
	gt?:ValueTypes["ContentReferenceType"] | null,
	gte?:ValueTypes["ContentReferenceType"] | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["MediumWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["MediumTypeCondition"] | null,
	colorTheme?:ValueTypes["ColorThemeCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	video?:ValueTypes["VideoWhere"] | null,
	and?:(ValueTypes["MediumWhere"] | undefined | null)[],
	or?:(ValueTypes["MediumWhere"] | undefined | null)[],
	not?:ValueTypes["MediumWhere"] | null
};
	["MediumTypeCondition"]: {
	and?:ValueTypes["MediumTypeCondition"][],
	or?:ValueTypes["MediumTypeCondition"][],
	not?:ValueTypes["MediumTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["MediumType"] | null,
	notEq?:ValueTypes["MediumType"] | null,
	in?:ValueTypes["MediumType"][],
	notIn?:ValueTypes["MediumType"][],
	lt?:ValueTypes["MediumType"] | null,
	lte?:ValueTypes["MediumType"] | null,
	gt?:ValueTypes["MediumType"] | null,
	gte?:ValueTypes["MediumType"] | null
};
	["MediumType"]:MediumType;
	["ColorThemeCondition"]: {
	and?:ValueTypes["ColorThemeCondition"][],
	or?:ValueTypes["ColorThemeCondition"][],
	not?:ValueTypes["ColorThemeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ColorTheme"] | null,
	notEq?:ValueTypes["ColorTheme"] | null,
	in?:ValueTypes["ColorTheme"][],
	notIn?:ValueTypes["ColorTheme"][],
	lt?:ValueTypes["ColorTheme"] | null,
	lte?:ValueTypes["ColorTheme"] | null,
	gt?:ValueTypes["ColorTheme"] | null,
	gte?:ValueTypes["ColorTheme"] | null
};
	["ColorTheme"]:ColorTheme;
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	alt?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["VideoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	src?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	duration?:ValueTypes["FloatCondition"] | null,
	poster?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["VideoWhere"] | undefined | null)[],
	or?:(ValueTypes["VideoWhere"] | undefined | null)[],
	not?:ValueTypes["VideoWhere"] | null
};
	["FloatCondition"]: {
	and?:ValueTypes["FloatCondition"][],
	or?:ValueTypes["FloatCondition"][],
	not?:ValueTypes["FloatCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["LinkTypeCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	externalLink?:ValueTypes["StringCondition"] | null,
	internalLink?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["LinkTypeCondition"]: {
	and?:ValueTypes["LinkTypeCondition"][],
	or?:ValueTypes["LinkTypeCondition"][],
	not?:ValueTypes["LinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["LinkType"] | null,
	notEq?:ValueTypes["LinkType"] | null,
	in?:ValueTypes["LinkType"][],
	notIn?:ValueTypes["LinkType"][],
	lt?:ValueTypes["LinkType"] | null,
	lte?:ValueTypes["LinkType"] | null,
	gt?:ValueTypes["LinkType"] | null,
	gte?:ValueTypes["LinkType"] | null
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	page?:ValueTypes["PageLocaleWhere"] | null,
	event?:ValueTypes["EventLocaleWhere"] | null,
	and?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	not?:ValueTypes["LinkableWhere"] | null
};
	["PageLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	root?:ValueTypes["PageWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	seo?:ValueTypes["LocalizedSeoWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["PageLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["PageLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["PageLocaleWhere"] | null
};
	["PageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	locales?:ValueTypes["PageLocaleWhere"] | null,
	and?:(ValueTypes["PageWhere"] | undefined | null)[],
	or?:(ValueTypes["PageWhere"] | undefined | null)[],
	not?:ValueTypes["PageWhere"] | null
};
	["LocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	code?:ValueTypes["StringCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	events?:ValueTypes["EventLocaleWhere"] | null,
	blogs?:ValueTypes["BlogLocaleWhere"] | null,
	pages?:ValueTypes["PageLocaleWhere"] | null,
	seos?:ValueTypes["SeoLocaleWhere"] | null,
	menus?:ValueTypes["MenuLocaleWhere"] | null,
	businessOrderTypes?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,
	and?:(ValueTypes["LocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["LocaleWhere"] | undefined | null)[],
	not?:ValueTypes["LocaleWhere"] | null
};
	["EventLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	root?:ValueTypes["EventWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	cover?:ValueTypes["CoverWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	availableForWeb?:ValueTypes["BooleanCondition"] | null,
	availableForMobile?:ValueTypes["BooleanCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	title?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["LocalizedSeoWhere"] | null,
	and?:(ValueTypes["EventLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["EventLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["EventLocaleWhere"] | null
};
	["EventWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	locales?:ValueTypes["EventLocaleWhere"] | null,
	and?:(ValueTypes["EventWhere"] | undefined | null)[],
	or?:(ValueTypes["EventWhere"] | undefined | null)[],
	not?:ValueTypes["EventWhere"] | null
};
	["CoverWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	primaryTitle?:ValueTypes["StringCondition"] | null,
	secondaryTitle?:ValueTypes["StringCondition"] | null,
	buttonColors?:ValueTypes["ColorPalleteWhere"] | null,
	medium?:ValueTypes["MediumWhere"] | null,
	and?:(ValueTypes["CoverWhere"] | undefined | null)[],
	or?:(ValueTypes["CoverWhere"] | undefined | null)[],
	not?:ValueTypes["CoverWhere"] | null
};
	["BooleanCondition"]: {
	and?:ValueTypes["BooleanCondition"][],
	or?:ValueTypes["BooleanCondition"][],
	not?:ValueTypes["BooleanCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:boolean | null,
	notEq?:boolean | null,
	in?:boolean[],
	notIn?:boolean[],
	lt?:boolean | null,
	lte?:boolean | null,
	gt?:boolean | null,
	gte?:boolean | null
};
	["LocalizedSeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["LocalizedSeoWhere"] | undefined | null)[],
	or?:(ValueTypes["LocalizedSeoWhere"] | undefined | null)[],
	not?:ValueTypes["LocalizedSeoWhere"] | null
};
	["BlogLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	pageName?:ValueTypes["StringCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["BlogWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	and?:(ValueTypes["BlogLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["BlogLocaleWhere"] | null
};
	["BlogWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["BlogLocaleWhere"] | null,
	and?:(ValueTypes["BlogWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogWhere"] | undefined | null)[],
	not?:ValueTypes["BlogWhere"] | null
};
	["OneCondition"]: {
	and?:ValueTypes["OneCondition"][],
	or?:ValueTypes["OneCondition"][],
	not?:ValueTypes["OneCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["One"] | null,
	notEq?:ValueTypes["One"] | null,
	in?:ValueTypes["One"][],
	notIn?:ValueTypes["One"][],
	lt?:ValueTypes["One"] | null,
	lte?:ValueTypes["One"] | null,
	gt?:ValueTypes["One"] | null,
	gte?:ValueTypes["One"] | null
};
	["One"]:One;
	["SeoLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["SeoWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	and?:(ValueTypes["SeoLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["SeoLocaleWhere"] | null
};
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	locales?:ValueTypes["SeoLocaleWhere"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["MenuLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	root?:ValueTypes["SiteMenuWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	items?:ValueTypes["MenuItemWhere"] | null,
	and?:(ValueTypes["MenuLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["MenuLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["MenuLocaleWhere"] | null
};
	["SiteMenuWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["MenuLocaleWhere"] | null,
	and?:(ValueTypes["SiteMenuWhere"] | undefined | null)[],
	or?:(ValueTypes["SiteMenuWhere"] | undefined | null)[],
	not?:ValueTypes["SiteMenuWhere"] | null
};
	["MenuItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	menu?:ValueTypes["MenuLocaleWhere"] | null,
	and?:(ValueTypes["MenuItemWhere"] | undefined | null)[],
	or?:(ValueTypes["MenuItemWhere"] | undefined | null)[],
	not?:ValueTypes["MenuItemWhere"] | null
};
	["BusinessOrderTypeLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["BusinessOrderTypeWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	and?:(ValueTypes["BusinessOrderTypeLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["BusinessOrderTypeLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null
};
	["BusinessOrderTypeWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	locales?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,
	and?:(ValueTypes["BusinessOrderTypeWhere"] | undefined | null)[],
	or?:(ValueTypes["BusinessOrderTypeWhere"] | undefined | null)[],
	not?:ValueTypes["BusinessOrderTypeWhere"] | null
};
	["HeroWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	showLogo?:ValueTypes["BooleanCondition"] | null,
	middleContent?:ValueTypes["StringCondition"] | null,
	medium?:ValueTypes["MediumWhere"] | null,
	and?:(ValueTypes["HeroWhere"] | undefined | null)[],
	or?:(ValueTypes["HeroWhere"] | undefined | null)[],
	not?:ValueTypes["HeroWhere"] | null
};
	["GalleryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["GalleryItemWhere"] | null,
	and?:(ValueTypes["GalleryWhere"] | undefined | null)[],
	or?:(ValueTypes["GalleryWhere"] | undefined | null)[],
	not?:ValueTypes["GalleryWhere"] | null
};
	["GalleryItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	caption?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["GalleryWhere"] | null,
	medium?:ValueTypes["MediumWhere"] | null,
	and?:(ValueTypes["GalleryItemWhere"] | undefined | null)[],
	or?:(ValueTypes["GalleryItemWhere"] | undefined | null)[],
	not?:ValueTypes["GalleryItemWhere"] | null
};
	["ContentSizeCondition"]: {
	and?:ValueTypes["ContentSizeCondition"][],
	or?:ValueTypes["ContentSizeCondition"][],
	not?:ValueTypes["ContentSizeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentSize"] | null,
	notEq?:ValueTypes["ContentSize"] | null,
	in?:ValueTypes["ContentSize"][],
	notIn?:ValueTypes["ContentSize"][],
	lt?:ValueTypes["ContentSize"] | null,
	lte?:ValueTypes["ContentSize"] | null,
	gt?:ValueTypes["ContentSize"] | null,
	gte?:ValueTypes["ContentSize"] | null
};
	["ContentSize"]:ContentSize;
	["SocialsAndAppsWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	instagram?:ValueTypes["BooleanCondition"] | null,
	appStore?:ValueTypes["BooleanCondition"] | null,
	googlePlay?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["SocialsAndAppsWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialsAndAppsWhere"] | undefined | null)[],
	not?:ValueTypes["SocialsAndAppsWhere"] | null
};
	["BlogPostListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["BlogPostListItemWhere"] | null,
	and?:(ValueTypes["BlogPostListWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogPostListWhere"] | undefined | null)[],
	not?:ValueTypes["BlogPostListWhere"] | null
};
	["BlogPostListItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	caption?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["BlogPostListWhere"] | null,
	blogPost?:ValueTypes["EventLocaleWhere"] | null,
	and?:(ValueTypes["BlogPostListItemWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogPostListItemWhere"] | undefined | null)[],
	not?:ValueTypes["BlogPostListItemWhere"] | null
};
	["ProductGridWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ProductGridItemWhere"] | null,
	and?:(ValueTypes["ProductGridWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductGridWhere"] | undefined | null)[],
	not?:ValueTypes["ProductGridWhere"] | null
};
	["ProductGridItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	goodlokProductId?:ValueTypes["StringCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["ProductGridWhere"] | null,
	medium?:ValueTypes["MediumWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["ProductGridItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductGridItemWhere"] | undefined | null)[],
	not?:ValueTypes["ProductGridItemWhere"] | null
};
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:true,
	type?:true,
	primaryText?:true,
	secondaryText?:true,
	jsonContent?:true,
block?: [{	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
colorPallete?: [{	filter?:ValueTypes["ColorPalleteWhere"] | null},ValueTypes["ColorPallete"]],
medium?: [{	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
	misc?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
hero?: [{	filter?:ValueTypes["HeroWhere"] | null},ValueTypes["Hero"]],
gallery?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
	contentSize?:true,
socialsAndApps?: [{	filter?:ValueTypes["SocialsAndAppsWhere"] | null},ValueTypes["SocialsAndApps"]],
blogPosts?: [{	filter?:ValueTypes["BlogPostListWhere"] | null},ValueTypes["BlogPostList"]],
productGrid?: [{	filter?:ValueTypes["ProductGridWhere"] | null},ValueTypes["ProductGrid"]],
		__typename?: true
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	jsonContent?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	colorPallete?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
	misc?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	hero?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	contentSize?:ValueTypes["FieldMeta"],
	socialsAndApps?:ValueTypes["FieldMeta"],
	blogPosts?:ValueTypes["FieldMeta"],
	productGrid?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Medium"]: AliasType<{
	_meta?:ValueTypes["MediumMeta"],
	id?:true,
	type?:true,
	colorTheme?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
video?: [{	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
		__typename?: true
}>;
	["MediumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	colorTheme?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:true,
	url?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	title?:true,
	alt?:true,
		__typename?: true
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Video"]: AliasType<{
	_meta?:ValueTypes["VideoMeta"],
	id?:true,
	src?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	duration?:true,
poster?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["VideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	src?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	poster?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:true,
	type?:true,
	title?:true,
	externalLink?:true,
internalLink?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:true,
	url?:true,
page?: [{	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
event?: [{	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
		__typename?: true
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	page?:ValueTypes["FieldMeta"],
	event?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PageLocale"]: AliasType<{
	_meta?:ValueTypes["PageLocaleMeta"],
	id?:true,
	title?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
root?: [{	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
seo?: [{	filter?:ValueTypes["LocalizedSeoWhere"] | null},ValueTypes["LocalizedSeo"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
		__typename?: true
}>;
	["PageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Page"]: AliasType<{
	_meta?:ValueTypes["PageMeta"],
	id?:true,
locales?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PageLocale"]],
localesByLocale?: [{	by:ValueTypes["PageLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
localesByLink?: [{	by:ValueTypes["PageLocalesByLinkUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
localesBySeo?: [{	by:ValueTypes["PageLocalesBySeoUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
localesByContent?: [{	by:ValueTypes["PageLocalesByContentUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
paginateLocales?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageLocaleConnection"]],
		__typename?: true
}>;
	["PageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PageLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	root?:ValueTypes["PageOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	seo?:ValueTypes["LocalizedSeoOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["LinkableOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	page?:ValueTypes["PageLocaleOrderBy"] | null,
	event?:ValueTypes["EventLocaleOrderBy"] | null
};
	["EventLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["EventOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	cover?:ValueTypes["CoverOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	availableForWeb?:ValueTypes["OrderDirection"] | null,
	availableForMobile?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["LocalizedSeoOrderBy"] | null
};
	["EventOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["LocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	code?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null
};
	["CoverOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	primaryTitle?:ValueTypes["OrderDirection"] | null,
	secondaryTitle?:ValueTypes["OrderDirection"] | null,
	buttonColors?:ValueTypes["ColorPalleteOrderBy"] | null,
	medium?:ValueTypes["MediumOrderBy"] | null
};
	["MediumOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	colorTheme?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	video?:ValueTypes["VideoOrderBy"] | null
};
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	alt?:ValueTypes["OrderDirection"] | null
};
	["VideoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	src?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	duration?:ValueTypes["OrderDirection"] | null,
	poster?:ValueTypes["ImageOrderBy"] | null
};
	["ContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["LocalizedSeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null
};
	["PageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["PageLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["LocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	events?:ValueTypes["EventLocaleUniqueWhere"] | null,
	blogs?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	pages?:ValueTypes["PageLocaleUniqueWhere"] | null,
	seos?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	menus?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	businessOrderTypes?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null
};
	["EventLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["EventUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	cover?:ValueTypes["CoverUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["LocalizedSeoUniqueWhere"] | null
};
	["EventUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["EventLocaleUniqueWhere"] | null
};
	["CoverUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentBlockUniqueWhere"] | null
};
	["ContentBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["LinkableUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	page?:ValueTypes["PageLocaleUniqueWhere"] | null,
	event?:ValueTypes["EventLocaleUniqueWhere"] | null
};
	["PageLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["PageUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["LocalizedSeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["PageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["PageLocaleUniqueWhere"] | null
};
	["LocalizedSeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["BlogLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["BlogUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["BlogUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["BlogLocaleUniqueWhere"] | null
};
	["SeoLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["SeoUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null,
	locales?:ValueTypes["SeoLocaleUniqueWhere"] | null
};
	["MenuLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["SiteMenuUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	items?:ValueTypes["MenuItemUniqueWhere"] | null
};
	["SiteMenuUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["MenuLocaleUniqueWhere"] | null
};
	["MenuItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["BusinessOrderTypeLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["BusinessOrderTypeUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["BusinessOrderTypeUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null
};
	["PageLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["PageLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["LocalizedSeoUniqueWhere"] | null
};
	["PageLocalesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["PageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageLocaleEdge"],
		__typename?: true
}>;
	["PageLocaleEdge"]: AliasType<{
	node?:ValueTypes["PageLocale"],
		__typename?: true
}>;
	["Locale"]: AliasType<{
	_meta?:ValueTypes["LocaleMeta"],
	id?:true,
	code?:true,
	label?:true,
events?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLocale"]],
blogs?: [{	filter?:ValueTypes["BlogLocaleWhere"] | null,	orderBy?:ValueTypes["BlogLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogLocale"]],
pages?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PageLocale"]],
seos?: [{	filter?:ValueTypes["SeoLocaleWhere"] | null,	orderBy?:ValueTypes["SeoLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoLocale"]],
menus?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null,	orderBy?:ValueTypes["MenuLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MenuLocale"]],
businessOrderTypes?: [{	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BusinessOrderTypeLocale"]],
eventsByRoot?: [{	by:ValueTypes["LocaleEventsByRootUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
eventsByCover?: [{	by:ValueTypes["LocaleEventsByCoverUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
eventsByContent?: [{	by:ValueTypes["LocaleEventsByContentUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
eventsByLink?: [{	by:ValueTypes["LocaleEventsByLinkUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
eventsBySeo?: [{	by:ValueTypes["LocaleEventsBySeoUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
blogsByRoot?: [{	by:ValueTypes["LocaleBlogsByRootUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null},ValueTypes["BlogLocale"]],
pagesByRoot?: [{	by:ValueTypes["LocalePagesByRootUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
pagesByLink?: [{	by:ValueTypes["LocalePagesByLinkUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
pagesBySeo?: [{	by:ValueTypes["LocalePagesBySeoUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
pagesByContent?: [{	by:ValueTypes["LocalePagesByContentUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
seosByRoot?: [{	by:ValueTypes["LocaleSeosByRootUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null},ValueTypes["SeoLocale"]],
menusByRoot?: [{	by:ValueTypes["LocaleMenusByRootUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocale"]],
menusByItems?: [{	by:ValueTypes["LocaleMenusByItemsUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocale"]],
businessOrderTypesByRoot?: [{	by:ValueTypes["LocaleBusinessOrderTypesByRootUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null},ValueTypes["BusinessOrderTypeLocale"]],
paginateEvents?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLocaleConnection"]],
paginateBlogs?: [{	filter?:ValueTypes["BlogLocaleWhere"] | null,	orderBy?:ValueTypes["BlogLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogLocaleConnection"]],
paginatePages?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageLocaleConnection"]],
paginateSeos?: [{	filter?:ValueTypes["SeoLocaleWhere"] | null,	orderBy?:ValueTypes["SeoLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoLocaleConnection"]],
paginateMenus?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null,	orderBy?:ValueTypes["MenuLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MenuLocaleConnection"]],
paginateBusinessOrderTypes?: [{	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BusinessOrderTypeLocaleConnection"]],
		__typename?: true
}>;
	["LocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	events?:ValueTypes["FieldMeta"],
	blogs?:ValueTypes["FieldMeta"],
	pages?:ValueTypes["FieldMeta"],
	seos?:ValueTypes["FieldMeta"],
	menus?:ValueTypes["FieldMeta"],
	businessOrderTypes?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EventLocale"]: AliasType<{
	_meta?:ValueTypes["EventLocaleMeta"],
	id?:true,
root?: [{	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
cover?: [{	filter?:ValueTypes["CoverWhere"] | null},ValueTypes["Cover"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
	availableForWeb?:true,
	availableForMobile?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	title?:true,
seo?: [{	filter?:ValueTypes["LocalizedSeoWhere"] | null},ValueTypes["LocalizedSeo"]],
		__typename?: true
}>;
	["EventLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	cover?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	availableForWeb?:ValueTypes["FieldMeta"],
	availableForMobile?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Event"]: AliasType<{
	_meta?:ValueTypes["EventMeta"],
	id?:true,
	order?:true,
locales?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLocale"]],
localesByLocale?: [{	by:ValueTypes["EventLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
localesByCover?: [{	by:ValueTypes["EventLocalesByCoverUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
localesByContent?: [{	by:ValueTypes["EventLocalesByContentUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
localesByLink?: [{	by:ValueTypes["EventLocalesByLinkUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
localesBySeo?: [{	by:ValueTypes["EventLocalesBySeoUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
paginateLocales?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLocaleConnection"]],
		__typename?: true
}>;
	["EventMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EventLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["EventLocalesByCoverUniqueWhere"]: {
	cover?:ValueTypes["CoverUniqueWhere"] | null
};
	["EventLocalesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["EventLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["EventLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["LocalizedSeoUniqueWhere"] | null
};
	["EventLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EventLocaleEdge"],
		__typename?: true
}>;
	["EventLocaleEdge"]: AliasType<{
	node?:ValueTypes["EventLocale"],
		__typename?: true
}>;
	["Cover"]: AliasType<{
	_meta?:ValueTypes["CoverMeta"],
	id?:true,
	primaryTitle?:true,
	secondaryTitle?:true,
buttonColors?: [{	filter?:ValueTypes["ColorPalleteWhere"] | null},ValueTypes["ColorPallete"]],
medium?: [{	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
		__typename?: true
}>;
	["CoverMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	primaryTitle?:ValueTypes["FieldMeta"],
	secondaryTitle?:ValueTypes["FieldMeta"],
	buttonColors?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["LocalizedSeo"]: AliasType<{
	_meta?:ValueTypes["LocalizedSeoMeta"],
	id?:true,
	title?:true,
	description?:true,
	ogTitle?:true,
	ogDescription?:true,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["LocalizedSeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BlogLocale"]: AliasType<{
	_meta?:ValueTypes["BlogLocaleMeta"],
	id?:true,
	pageName?:true,
	title?:true,
	lead?:true,
root?: [{	filter?:ValueTypes["BlogWhere"] | null},ValueTypes["Blog"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
		__typename?: true
}>;
	["BlogLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	pageName?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Blog"]: AliasType<{
	_meta?:ValueTypes["BlogMeta"],
	id?:true,
	unique?:true,
locales?: [{	filter?:ValueTypes["BlogLocaleWhere"] | null,	orderBy?:ValueTypes["BlogLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogLocale"]],
localesByLocale?: [{	by:ValueTypes["BlogLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null},ValueTypes["BlogLocale"]],
paginateLocales?: [{	filter?:ValueTypes["BlogLocaleWhere"] | null,	orderBy?:ValueTypes["BlogLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogLocaleConnection"]],
		__typename?: true
}>;
	["BlogMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BlogLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	pageName?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["BlogOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null
};
	["BlogOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["BlogLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["BlogLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogLocaleEdge"],
		__typename?: true
}>;
	["BlogLocaleEdge"]: AliasType<{
	node?:ValueTypes["BlogLocale"],
		__typename?: true
}>;
	["SeoLocale"]: AliasType<{
	_meta?:ValueTypes["SeoLocaleMeta"],
	id?:true,
	title?:true,
	description?:true,
	ogTitle?:true,
	ogDescription?:true,
root?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
		__typename?: true
}>;
	["SeoLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:true,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
locales?: [{	filter?:ValueTypes["SeoLocaleWhere"] | null,	orderBy?:ValueTypes["SeoLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoLocale"]],
localesByLocale?: [{	by:ValueTypes["SeoLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null},ValueTypes["SeoLocale"]],
paginateLocales?: [{	filter?:ValueTypes["SeoLocaleWhere"] | null,	orderBy?:ValueTypes["SeoLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoLocaleConnection"]],
		__typename?: true
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SeoLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["SeoOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null
};
	["SeoLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["SeoLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoLocaleEdge"],
		__typename?: true
}>;
	["SeoLocaleEdge"]: AliasType<{
	node?:ValueTypes["SeoLocale"],
		__typename?: true
}>;
	["MenuLocale"]: AliasType<{
	_meta?:ValueTypes["MenuLocaleMeta"],
	id?:true,
root?: [{	filter?:ValueTypes["SiteMenuWhere"] | null},ValueTypes["SiteMenu"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
items?: [{	filter?:ValueTypes["MenuItemWhere"] | null,	orderBy?:ValueTypes["MenuItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MenuItem"]],
paginateItems?: [{	filter?:ValueTypes["MenuItemWhere"] | null,	orderBy?:ValueTypes["MenuItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MenuItemConnection"]],
		__typename?: true
}>;
	["MenuLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SiteMenu"]: AliasType<{
	_meta?:ValueTypes["SiteMenuMeta"],
	id?:true,
	unique?:true,
locales?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null,	orderBy?:ValueTypes["MenuLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MenuLocale"]],
localesByLocale?: [{	by:ValueTypes["SiteMenuLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocale"]],
localesByItems?: [{	by:ValueTypes["SiteMenuLocalesByItemsUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocale"]],
paginateLocales?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null,	orderBy?:ValueTypes["MenuLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MenuLocaleConnection"]],
		__typename?: true
}>;
	["SiteMenuMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MenuLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["SiteMenuOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null
};
	["SiteMenuOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["SiteMenuLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["SiteMenuLocalesByItemsUniqueWhere"]: {
	items?:ValueTypes["MenuItemUniqueWhere"] | null
};
	["MenuLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuLocaleEdge"],
		__typename?: true
}>;
	["MenuLocaleEdge"]: AliasType<{
	node?:ValueTypes["MenuLocale"],
		__typename?: true
}>;
	["MenuItem"]: AliasType<{
	_meta?:ValueTypes["MenuItemMeta"],
	id?:true,
	order?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
menu?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocale"]],
		__typename?: true
}>;
	["MenuItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	menu?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MenuItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	menu?:ValueTypes["MenuLocaleOrderBy"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	externalLink?:ValueTypes["OrderDirection"] | null,
	internalLink?:ValueTypes["LinkableOrderBy"] | null
};
	["MenuItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MenuItemEdge"],
		__typename?: true
}>;
	["MenuItemEdge"]: AliasType<{
	node?:ValueTypes["MenuItem"],
		__typename?: true
}>;
	["BusinessOrderTypeLocale"]: AliasType<{
	_meta?:ValueTypes["BusinessOrderTypeLocaleMeta"],
	id?:true,
	title?:true,
root?: [{	filter?:ValueTypes["BusinessOrderTypeWhere"] | null},ValueTypes["BusinessOrderType"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
		__typename?: true
}>;
	["BusinessOrderTypeLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BusinessOrderType"]: AliasType<{
	_meta?:ValueTypes["BusinessOrderTypeMeta"],
	id?:true,
	order?:true,
locales?: [{	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BusinessOrderTypeLocale"]],
localesByLocale?: [{	by:ValueTypes["BusinessOrderTypeLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null},ValueTypes["BusinessOrderTypeLocale"]],
paginateLocales?: [{	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BusinessOrderTypeLocaleConnection"]],
		__typename?: true
}>;
	["BusinessOrderTypeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BusinessOrderTypeLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["BusinessOrderTypeOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null
};
	["BusinessOrderTypeOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["BusinessOrderTypeLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["BusinessOrderTypeLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessOrderTypeLocaleEdge"],
		__typename?: true
}>;
	["BusinessOrderTypeLocaleEdge"]: AliasType<{
	node?:ValueTypes["BusinessOrderTypeLocale"],
		__typename?: true
}>;
	["LocaleEventsByRootUniqueWhere"]: {
	root?:ValueTypes["EventUniqueWhere"] | null
};
	["LocaleEventsByCoverUniqueWhere"]: {
	cover?:ValueTypes["CoverUniqueWhere"] | null
};
	["LocaleEventsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["LocaleEventsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleEventsBySeoUniqueWhere"]: {
	seo?:ValueTypes["LocalizedSeoUniqueWhere"] | null
};
	["LocaleBlogsByRootUniqueWhere"]: {
	root?:ValueTypes["BlogUniqueWhere"] | null
};
	["LocalePagesByRootUniqueWhere"]: {
	root?:ValueTypes["PageUniqueWhere"] | null
};
	["LocalePagesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocalePagesBySeoUniqueWhere"]: {
	seo?:ValueTypes["LocalizedSeoUniqueWhere"] | null
};
	["LocalePagesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["LocaleSeosByRootUniqueWhere"]: {
	root?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocaleMenusByRootUniqueWhere"]: {
	root?:ValueTypes["SiteMenuUniqueWhere"] | null
};
	["LocaleMenusByItemsUniqueWhere"]: {
	items?:ValueTypes["MenuItemUniqueWhere"] | null
};
	["LocaleBusinessOrderTypesByRootUniqueWhere"]: {
	root?:ValueTypes["BusinessOrderTypeUniqueWhere"] | null
};
	["Hero"]: AliasType<{
	_meta?:ValueTypes["HeroMeta"],
	id?:true,
	showLogo?:true,
	middleContent?:true,
medium?: [{	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
		__typename?: true
}>;
	["HeroMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	showLogo?:ValueTypes["FieldMeta"],
	middleContent?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Gallery"]: AliasType<{
	_meta?:ValueTypes["GalleryMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateItems?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
		__typename?: true
}>;
	["GalleryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GalleryItem"]: AliasType<{
	_meta?:ValueTypes["GalleryItemMeta"],
	id?:true,
	order?:true,
	caption?:true,
list?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
medium?: [{	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
		__typename?: true
}>;
	["GalleryItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	caption?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GalleryItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	caption?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["GalleryOrderBy"] | null,
	medium?:ValueTypes["MediumOrderBy"] | null
};
	["GalleryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["GalleryItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryItemEdge"],
		__typename?: true
}>;
	["GalleryItemEdge"]: AliasType<{
	node?:ValueTypes["GalleryItem"],
		__typename?: true
}>;
	["SocialsAndApps"]: AliasType<{
	_meta?:ValueTypes["SocialsAndAppsMeta"],
	id?:true,
	instagram?:true,
	appStore?:true,
	googlePlay?:true,
		__typename?: true
}>;
	["SocialsAndAppsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	instagram?:ValueTypes["FieldMeta"],
	appStore?:ValueTypes["FieldMeta"],
	googlePlay?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BlogPostList"]: AliasType<{
	_meta?:ValueTypes["BlogPostListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["BlogPostListItemWhere"] | null,	orderBy?:ValueTypes["BlogPostListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostListItem"]],
paginateItems?: [{	filter?:ValueTypes["BlogPostListItemWhere"] | null,	orderBy?:ValueTypes["BlogPostListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostListItemConnection"]],
		__typename?: true
}>;
	["BlogPostListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BlogPostListItem"]: AliasType<{
	_meta?:ValueTypes["BlogPostListItemMeta"],
	id?:true,
	order?:true,
	caption?:true,
list?: [{	filter?:ValueTypes["BlogPostListWhere"] | null},ValueTypes["BlogPostList"]],
blogPost?: [{	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
		__typename?: true
}>;
	["BlogPostListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	caption?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	blogPost?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BlogPostListItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	caption?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["BlogPostListOrderBy"] | null,
	blogPost?:ValueTypes["EventLocaleOrderBy"] | null
};
	["BlogPostListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["BlogPostListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostListItemEdge"],
		__typename?: true
}>;
	["BlogPostListItemEdge"]: AliasType<{
	node?:ValueTypes["BlogPostListItem"],
		__typename?: true
}>;
	["ProductGrid"]: AliasType<{
	_meta?:ValueTypes["ProductGridMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["ProductGridItemWhere"] | null,	orderBy?:ValueTypes["ProductGridItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductGridItem"]],
paginateItems?: [{	filter?:ValueTypes["ProductGridItemWhere"] | null,	orderBy?:ValueTypes["ProductGridItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductGridItemConnection"]],
		__typename?: true
}>;
	["ProductGridMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProductGridItem"]: AliasType<{
	_meta?:ValueTypes["ProductGridItemMeta"],
	id?:true,
	order?:true,
	goodlokProductId?:true,
	title?:true,
	lead?:true,
list?: [{	filter?:ValueTypes["ProductGridWhere"] | null},ValueTypes["ProductGrid"]],
medium?: [{	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["ProductGridItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	goodlokProductId?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProductGridItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	goodlokProductId?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ProductGridOrderBy"] | null,
	medium?:ValueTypes["MediumOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["ProductGridOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ProductGridItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductGridItemEdge"],
		__typename?: true
}>;
	["ProductGridItemEdge"]: AliasType<{
	node?:ValueTypes["ProductGridItem"],
		__typename?: true
}>;
	["ContentReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	primaryText?:ValueTypes["OrderDirection"] | null,
	secondaryText?:ValueTypes["OrderDirection"] | null,
	jsonContent?:ValueTypes["OrderDirection"] | null,
	block?:ValueTypes["ContentBlockOrderBy"] | null,
	colorPallete?:ValueTypes["ColorPalleteOrderBy"] | null,
	medium?:ValueTypes["MediumOrderBy"] | null,
	misc?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	hero?:ValueTypes["HeroOrderBy"] | null,
	gallery?:ValueTypes["GalleryOrderBy"] | null,
	contentSize?:ValueTypes["OrderDirection"] | null,
	socialsAndApps?:ValueTypes["SocialsAndAppsOrderBy"] | null,
	blogPosts?:ValueTypes["BlogPostListOrderBy"] | null,
	productGrid?:ValueTypes["ProductGridOrderBy"] | null
};
	["ContentBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["HeroOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	showLogo?:ValueTypes["OrderDirection"] | null,
	middleContent?:ValueTypes["OrderDirection"] | null,
	medium?:ValueTypes["MediumOrderBy"] | null
};
	["SocialsAndAppsOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	instagram?:ValueTypes["OrderDirection"] | null,
	appStore?:ValueTypes["OrderDirection"] | null,
	googlePlay?:ValueTypes["OrderDirection"] | null
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: true
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: true
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: true
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["ContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	jsonContent?:string | null,
	colorPallete?:ValueTypes["ContentReferenceCreateColorPalleteEntityRelationInput"] | null,
	medium?:ValueTypes["ContentReferenceCreateMediumEntityRelationInput"] | null,
	misc?:string | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	hero?:ValueTypes["ContentReferenceCreateHeroEntityRelationInput"] | null,
	gallery?:ValueTypes["ContentReferenceCreateGalleryEntityRelationInput"] | null,
	contentSize?:ValueTypes["ContentSize"] | null,
	socialsAndApps?:ValueTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"] | null,
	blogPosts?:ValueTypes["ContentReferenceCreateBlogPostsEntityRelationInput"] | null,
	productGrid?:ValueTypes["ContentReferenceCreateProductGridEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateColorPalleteEntityRelationInput"]: {
	connect?:ValueTypes["ColorPalleteUniqueWhere"] | null,
	create?:ValueTypes["ColorPalleteCreateInput"] | null
};
	["ContentReferenceCreateMediumEntityRelationInput"]: {
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["MediumUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["MediumCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["MediumType"] | null,
	colorTheme?:ValueTypes["ColorTheme"] | null,
	image?:ValueTypes["MediumCreateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumCreateVideoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	title?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	create?:ValueTypes["VideoCreateInput"] | null
};
	["VideoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["VideoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	src?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	duration?:number | null,
	poster?:ValueTypes["VideoCreatePosterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreatePageEntityRelationInput"]: {
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	create?:ValueTypes["PageLocaleWithoutLinkCreateInput"] | null
};
	["PageLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["PageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["PageUniqueWhere"] | null,
	create?:ValueTypes["PageWithoutLocalesCreateInput"] | null
};
	["PageWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutPagesCreateInput"] | null
};
	["LocaleWithoutPagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleCreateBlogsEntityRelationInput"][],
	seos?:ValueTypes["LocaleCreateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleCreateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateEventsEntityRelationInput"]: {
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	create?:ValueTypes["EventLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["EventLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["EventLocaleCreateRootEntityRelationInput"] | null,
	cover?:ValueTypes["EventLocaleCreateCoverEntityRelationInput"] | null,
	content?:ValueTypes["EventLocaleCreateContentEntityRelationInput"] | null,
	availableForWeb?:boolean | null,
	availableForMobile?:boolean | null,
	link?:ValueTypes["EventLocaleCreateLinkEntityRelationInput"] | null,
	title?:string | null,
	seo?:ValueTypes["EventLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["EventUniqueWhere"] | null,
	create?:ValueTypes["EventWithoutLocalesCreateInput"] | null
};
	["EventWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleCreateCoverEntityRelationInput"]: {
	connect?:ValueTypes["CoverUniqueWhere"] | null,
	create?:ValueTypes["CoverCreateInput"] | null
};
	["CoverCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	primaryTitle?:string | null,
	secondaryTitle?:string | null,
	buttonColors?:ValueTypes["CoverCreateButtonColorsEntityRelationInput"] | null,
	medium?:ValueTypes["CoverCreateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CoverCreateButtonColorsEntityRelationInput"]: {
	connect?:ValueTypes["ColorPalleteUniqueWhere"] | null,
	create?:ValueTypes["ColorPalleteCreateInput"] | null
};
	["CoverCreateMediumEntityRelationInput"]: {
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["EventLocaleCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["EventLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null
};
	["LinkableWithoutEventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["LocalizedSeoUniqueWhere"] | null,
	create?:ValueTypes["LocalizedSeoCreateInput"] | null
};
	["LocalizedSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["LocalizedSeoCreateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LocalizedSeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LocaleCreateBlogsEntityRelationInput"]: {
	connect?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	create?:ValueTypes["BlogLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["BlogLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	pageName?:string | null,
	title?:string | null,
	lead?:string | null,
	root?:ValueTypes["BlogLocaleCreateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["BlogUniqueWhere"] | null,
	create?:ValueTypes["BlogWithoutLocalesCreateInput"] | null
};
	["BlogWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["LocaleCreateSeosEntityRelationInput"]: {
	connect?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	create?:ValueTypes["SeoLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["SeoLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	root?:ValueTypes["SeoLocaleCreateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutLocalesCreateInput"] | null
};
	["SeoWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LocaleCreateMenusEntityRelationInput"]: {
	connect?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	create?:ValueTypes["MenuLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["MenuLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["MenuLocaleCreateRootEntityRelationInput"] | null,
	items?:ValueTypes["MenuLocaleCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MenuLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["SiteMenuUniqueWhere"] | null,
	create?:ValueTypes["SiteMenuWithoutLocalesCreateInput"] | null
};
	["SiteMenuWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["MenuLocaleCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["MenuItemUniqueWhere"] | null,
	create?:ValueTypes["MenuItemWithoutMenuCreateInput"] | null,
	alias?:string | null
};
	["MenuItemWithoutMenuCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["MenuItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MenuItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LocaleCreateBusinessOrderTypesEntityRelationInput"]: {
	connect?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	create?:ValueTypes["BusinessOrderTypeLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["BusinessOrderTypeLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["BusinessOrderTypeLocaleCreateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["BusinessOrderTypeUniqueWhere"] | null,
	create?:ValueTypes["BusinessOrderTypeWithoutLocalesCreateInput"] | null
};
	["BusinessOrderTypeWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["LocalizedSeoUniqueWhere"] | null,
	create?:ValueTypes["LocalizedSeoCreateInput"] | null
};
	["PageLocaleCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["LinkableCreateEventEntityRelationInput"]: {
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	create?:ValueTypes["EventLocaleWithoutLinkCreateInput"] | null
};
	["EventLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["EventLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EventLocaleCreateLocaleEntityRelationInput"] | null,
	cover?:ValueTypes["EventLocaleCreateCoverEntityRelationInput"] | null,
	content?:ValueTypes["EventLocaleCreateContentEntityRelationInput"] | null,
	availableForWeb?:boolean | null,
	availableForMobile?:boolean | null,
	title?:string | null,
	seo?:ValueTypes["EventLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutEventsCreateInput"] | null
};
	["LocaleWithoutEventsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	blogs?:ValueTypes["LocaleCreateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleCreateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleCreateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreatePagesEntityRelationInput"]: {
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	create?:ValueTypes["PageLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["PageLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | null,
	root?:ValueTypes["PageLocaleCreateRootEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null
};
	["LinkableWithoutPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateHeroEntityRelationInput"]: {
	connect?:ValueTypes["HeroUniqueWhere"] | null,
	create?:ValueTypes["HeroCreateInput"] | null
};
	["HeroUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["HeroCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	showLogo?:boolean | null,
	middleContent?:string | null,
	medium?:ValueTypes["HeroCreateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeroCreateMediumEntityRelationInput"]: {
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["ContentReferenceCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["GalleryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["GalleryItemUniqueWhere"] | null
};
	["GalleryItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["GalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["GalleryCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GalleryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["GalleryItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	caption?:string | null,
	medium?:ValueTypes["GalleryItemCreateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemCreateMediumEntityRelationInput"]: {
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["ContentReferenceCreateSocialsAndAppsEntityRelationInput"]: {
	connect?:ValueTypes["SocialsAndAppsUniqueWhere"] | null,
	create?:ValueTypes["SocialsAndAppsCreateInput"] | null
};
	["SocialsAndAppsUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SocialsAndAppsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	instagram?:boolean | null,
	appStore?:boolean | null,
	googlePlay?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateBlogPostsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostListUniqueWhere"] | null,
	create?:ValueTypes["BlogPostListCreateInput"] | null
};
	["BlogPostListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["BlogPostListItemUniqueWhere"] | null
};
	["BlogPostListItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["BlogPostListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["BlogPostListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BlogPostListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostListItemUniqueWhere"] | null,
	create?:ValueTypes["BlogPostListItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["BlogPostListItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	caption?:string | null,
	blogPost?:ValueTypes["BlogPostListItemCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostListItemCreateBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	create?:ValueTypes["EventLocaleCreateInput"] | null
};
	["EventLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["EventLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EventLocaleCreateLocaleEntityRelationInput"] | null,
	cover?:ValueTypes["EventLocaleCreateCoverEntityRelationInput"] | null,
	content?:ValueTypes["EventLocaleCreateContentEntityRelationInput"] | null,
	availableForWeb?:boolean | null,
	availableForMobile?:boolean | null,
	link?:ValueTypes["EventLocaleCreateLinkEntityRelationInput"] | null,
	title?:string | null,
	seo?:ValueTypes["EventLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateProductGridEntityRelationInput"]: {
	connect?:ValueTypes["ProductGridUniqueWhere"] | null,
	create?:ValueTypes["ProductGridCreateInput"] | null
};
	["ProductGridUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ProductGridItemUniqueWhere"] | null
};
	["ProductGridItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ProductGridCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ProductGridCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductGridCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ProductGridItemUniqueWhere"] | null,
	create?:ValueTypes["ProductGridItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ProductGridItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	goodlokProductId?:string | null,
	title?:string | null,
	lead?:string | null,
	medium?:ValueTypes["ProductGridItemCreateMediumEntityRelationInput"] | null,
	link?:ValueTypes["ProductGridItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductGridItemCreateMediumEntityRelationInput"]: {
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["ProductGridItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentUpdateInput"]: {
	blocks?:ValueTypes["ContentUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["ContentUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	data?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	update?:ValueTypes["ContentBlockUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	jsonContent?:string | null,
	colorPallete?:ValueTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"] | null,
	medium?:ValueTypes["ContentReferenceUpdateMediumEntityRelationInput"] | null,
	misc?:string | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	hero?:ValueTypes["ContentReferenceUpdateHeroEntityRelationInput"] | null,
	gallery?:ValueTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | null,
	contentSize?:ValueTypes["ContentSize"] | null,
	socialsAndApps?:ValueTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"] | null,
	blogPosts?:ValueTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"] | null,
	productGrid?:ValueTypes["ContentReferenceUpdateProductGridEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateColorPalleteEntityRelationInput"]: {
	create?:ValueTypes["ColorPalleteCreateInput"] | null,
	update?:ValueTypes["ColorPalleteUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertColorPalleteRelationInput"] | null,
	connect?:ValueTypes["ColorPalleteUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertColorPalleteRelationInput"]: {
	update?:ValueTypes["ColorPalleteUpdateInput"] | null,
	create?:ValueTypes["ColorPalleteCreateInput"] | null
};
	["ContentReferenceUpdateMediumEntityRelationInput"]: {
	create?:ValueTypes["MediumCreateInput"] | null,
	update?:ValueTypes["MediumUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertMediumRelationInput"] | null,
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumUpdateInput"]: {
	type?:ValueTypes["MediumType"] | null,
	colorTheme?:ValueTypes["ColorTheme"] | null,
	image?:ValueTypes["MediumUpdateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumUpdateVideoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["MediumUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	title?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["MediumUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MediumUpdateVideoEntityRelationInput"]: {
	create?:ValueTypes["VideoCreateInput"] | null,
	update?:ValueTypes["VideoUpdateInput"] | null,
	upsert?:ValueTypes["MediumUpsertVideoRelationInput"] | null,
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VideoUpdateInput"]: {
	src?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	duration?:number | null,
	poster?:ValueTypes["VideoUpdatePosterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoUpdatePosterEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["VideoUpsertPosterRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VideoUpsertPosterRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MediumUpsertVideoRelationInput"]: {
	update?:ValueTypes["VideoUpdateInput"] | null,
	create?:ValueTypes["VideoCreateInput"] | null
};
	["ContentReferenceUpsertMediumRelationInput"]: {
	update?:ValueTypes["MediumUpdateInput"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["LinkUpsertInternalLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableUpdateInput"]: {
	url?:string | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdatePageEntityRelationInput"]: {
	create?:ValueTypes["PageLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["PageLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertPageRelationInput"] | null,
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["PageWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["PageWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["PageUniqueWhere"] | null,
	delete?:boolean | null
};
	["PageWithoutLocalesUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["PageLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["PageWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["PageWithoutLocalesCreateInput"] | null
};
	["PageLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutPagesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutPagesUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutPagesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleUpdateBlogsEntityRelationInput"][],
	seos?:ValueTypes["LocaleUpdateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleUpdateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateEventsEntityRelationInput"]: {
	create?:ValueTypes["EventLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateEventsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertEventsRelationInput"] | null,
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	delete?:ValueTypes["EventLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateEventsRelationInput"]: {
	by?:ValueTypes["EventLocaleUniqueWhere"] | null,
	data?:ValueTypes["EventLocaleWithoutLocaleUpdateInput"] | null
};
	["EventLocaleWithoutLocaleUpdateInput"]: {
	root?:ValueTypes["EventLocaleUpdateRootEntityRelationInput"] | null,
	cover?:ValueTypes["EventLocaleUpdateCoverEntityRelationInput"] | null,
	content?:ValueTypes["EventLocaleUpdateContentEntityRelationInput"] | null,
	availableForWeb?:boolean | null,
	availableForMobile?:boolean | null,
	link?:ValueTypes["EventLocaleUpdateLinkEntityRelationInput"] | null,
	title?:string | null,
	seo?:ValueTypes["EventLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["EventWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["EventWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["EventUniqueWhere"] | null,
	delete?:boolean | null
};
	["EventWithoutLocalesUpdateInput"]: {
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["EventWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["EventWithoutLocalesCreateInput"] | null
};
	["EventLocaleUpdateCoverEntityRelationInput"]: {
	create?:ValueTypes["CoverCreateInput"] | null,
	update?:ValueTypes["CoverUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertCoverRelationInput"] | null,
	connect?:ValueTypes["CoverUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CoverUpdateInput"]: {
	primaryTitle?:string | null,
	secondaryTitle?:string | null,
	buttonColors?:ValueTypes["CoverUpdateButtonColorsEntityRelationInput"] | null,
	medium?:ValueTypes["CoverUpdateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CoverUpdateButtonColorsEntityRelationInput"]: {
	create?:ValueTypes["ColorPalleteCreateInput"] | null,
	update?:ValueTypes["ColorPalleteUpdateInput"] | null,
	upsert?:ValueTypes["CoverUpsertButtonColorsRelationInput"] | null,
	connect?:ValueTypes["ColorPalleteUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CoverUpsertButtonColorsRelationInput"]: {
	update?:ValueTypes["ColorPalleteUpdateInput"] | null,
	create?:ValueTypes["ColorPalleteCreateInput"] | null
};
	["CoverUpdateMediumEntityRelationInput"]: {
	create?:ValueTypes["MediumCreateInput"] | null,
	update?:ValueTypes["MediumUpdateInput"] | null,
	upsert?:ValueTypes["CoverUpsertMediumRelationInput"] | null,
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CoverUpsertMediumRelationInput"]: {
	update?:ValueTypes["MediumUpdateInput"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["EventLocaleUpsertCoverRelationInput"]: {
	update?:ValueTypes["CoverUpdateInput"] | null,
	create?:ValueTypes["CoverCreateInput"] | null
};
	["EventLocaleUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventLocaleUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["EventLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutEventUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutEventUpdateInput"]: {
	url?:string | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutEventUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null
};
	["EventLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["LocalizedSeoCreateInput"] | null,
	update?:ValueTypes["LocalizedSeoUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["LocalizedSeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LocalizedSeoUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["LocalizedSeoUpdateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LocalizedSeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["LocalizedSeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LocalizedSeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EventLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["LocalizedSeoUpdateInput"] | null,
	create?:ValueTypes["LocalizedSeoCreateInput"] | null
};
	["LocaleUpsertEventsRelationInput"]: {
	by?:ValueTypes["EventLocaleUniqueWhere"] | null,
	update?:ValueTypes["EventLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["EventLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateBlogsEntityRelationInput"]: {
	create?:ValueTypes["BlogLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateBlogsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertBlogsRelationInput"] | null,
	connect?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	delete?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateBlogsRelationInput"]: {
	by?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	data?:ValueTypes["BlogLocaleWithoutLocaleUpdateInput"] | null
};
	["BlogLocaleWithoutLocaleUpdateInput"]: {
	pageName?:string | null,
	title?:string | null,
	lead?:string | null,
	root?:ValueTypes["BlogLocaleUpdateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["BlogWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["BlogWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["BlogLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["BlogUniqueWhere"] | null,
	delete?:boolean | null
};
	["BlogWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["BlogLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["BlogWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["BlogWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertBlogsRelationInput"]: {
	by?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	update?:ValueTypes["BlogLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["BlogLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateSeosEntityRelationInput"]: {
	create?:ValueTypes["SeoLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateSeosRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertSeosRelationInput"] | null,
	connect?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	delete?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateSeosRelationInput"]: {
	by?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	data?:ValueTypes["SeoLocaleWithoutLocaleUpdateInput"] | null
};
	["SeoLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	root?:ValueTypes["SeoLocaleUpdateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["SeoWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["SeoWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["SeoLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	delete?:boolean | null
};
	["SeoWithoutLocalesUpdateInput"]: {
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["SeoLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["SeoWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["SeoWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertSeosRelationInput"]: {
	by?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	update?:ValueTypes["SeoLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["SeoLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateMenusEntityRelationInput"]: {
	create?:ValueTypes["MenuLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateMenusRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertMenusRelationInput"] | null,
	connect?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	delete?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateMenusRelationInput"]: {
	by?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	data?:ValueTypes["MenuLocaleWithoutLocaleUpdateInput"] | null
};
	["MenuLocaleWithoutLocaleUpdateInput"]: {
	root?:ValueTypes["MenuLocaleUpdateRootEntityRelationInput"] | null,
	items?:ValueTypes["MenuLocaleUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MenuLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["SiteMenuWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["SiteMenuWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["MenuLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["SiteMenuUniqueWhere"] | null,
	delete?:boolean | null
};
	["SiteMenuWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["MenuLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["SiteMenuWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["SiteMenuWithoutLocalesCreateInput"] | null
};
	["MenuLocaleUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["MenuItemWithoutMenuCreateInput"] | null,
	update?:ValueTypes["MenuLocaleUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["MenuLocaleUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["MenuItemUniqueWhere"] | null,
	disconnect?:ValueTypes["MenuItemUniqueWhere"] | null,
	delete?:ValueTypes["MenuItemUniqueWhere"] | null,
	alias?:string | null
};
	["MenuLocaleUpdateItemsRelationInput"]: {
	by?:ValueTypes["MenuItemUniqueWhere"] | null,
	data?:ValueTypes["MenuItemWithoutMenuUpdateInput"] | null
};
	["MenuItemWithoutMenuUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["MenuItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MenuItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["MenuItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MenuItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["MenuLocaleUpsertItemsRelationInput"]: {
	by?:ValueTypes["MenuItemUniqueWhere"] | null,
	update?:ValueTypes["MenuItemWithoutMenuUpdateInput"] | null,
	create?:ValueTypes["MenuItemWithoutMenuCreateInput"] | null
};
	["LocaleUpsertMenusRelationInput"]: {
	by?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	update?:ValueTypes["MenuLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["MenuLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateBusinessOrderTypesEntityRelationInput"]: {
	create?:ValueTypes["BusinessOrderTypeLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateBusinessOrderTypesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertBusinessOrderTypesRelationInput"] | null,
	connect?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	delete?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateBusinessOrderTypesRelationInput"]: {
	by?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	data?:ValueTypes["BusinessOrderTypeLocaleWithoutLocaleUpdateInput"] | null
};
	["BusinessOrderTypeLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["BusinessOrderTypeLocaleUpdateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["BusinessOrderTypeWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["BusinessOrderTypeWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["BusinessOrderTypeLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["BusinessOrderTypeUniqueWhere"] | null,
	delete?:boolean | null
};
	["BusinessOrderTypeWithoutLocalesUpdateInput"]: {
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["BusinessOrderTypeWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["BusinessOrderTypeWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertBusinessOrderTypesRelationInput"]: {
	by?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	update?:ValueTypes["BusinessOrderTypeLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["BusinessOrderTypeLocaleWithoutLocaleCreateInput"] | null
};
	["PageLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutPagesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutPagesCreateInput"] | null
};
	["PageLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["LocalizedSeoCreateInput"] | null,
	update?:ValueTypes["LocalizedSeoUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["LocalizedSeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["LocalizedSeoUpdateInput"] | null,
	create?:ValueTypes["LocalizedSeoCreateInput"] | null
};
	["PageLocaleUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageLocaleUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["LinkableUpsertPageRelationInput"]: {
	update?:ValueTypes["PageLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["PageLocaleWithoutLinkCreateInput"] | null
};
	["LinkableUpdateEventEntityRelationInput"]: {
	create?:ValueTypes["EventLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["EventLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertEventRelationInput"] | null,
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventLocaleWithoutLinkUpdateInput"]: {
	root?:ValueTypes["EventLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EventLocaleUpdateLocaleEntityRelationInput"] | null,
	cover?:ValueTypes["EventLocaleUpdateCoverEntityRelationInput"] | null,
	content?:ValueTypes["EventLocaleUpdateContentEntityRelationInput"] | null,
	availableForWeb?:boolean | null,
	availableForMobile?:boolean | null,
	title?:string | null,
	seo?:ValueTypes["EventLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutEventsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutEventsUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutEventsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	blogs?:ValueTypes["LocaleUpdateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleUpdateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleUpdateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdatePagesEntityRelationInput"]: {
	create?:ValueTypes["PageLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdatePagesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertPagesRelationInput"] | null,
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["PageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdatePagesRelationInput"]: {
	by?:ValueTypes["PageLocaleUniqueWhere"] | null,
	data?:ValueTypes["PageLocaleWithoutLocaleUpdateInput"] | null
};
	["PageLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | null,
	root?:ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutPageUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutPageUpdateInput"]: {
	url?:string | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null
};
	["LocaleUpsertPagesRelationInput"]: {
	by?:ValueTypes["PageLocaleUniqueWhere"] | null,
	update?:ValueTypes["PageLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["PageLocaleWithoutLocaleCreateInput"] | null
};
	["EventLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutEventsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutEventsCreateInput"] | null
};
	["LinkableUpsertEventRelationInput"]: {
	update?:ValueTypes["EventLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["EventLocaleWithoutLinkCreateInput"] | null
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpdateHeroEntityRelationInput"]: {
	create?:ValueTypes["HeroCreateInput"] | null,
	update?:ValueTypes["HeroUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertHeroRelationInput"] | null,
	connect?:ValueTypes["HeroUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeroUpdateInput"]: {
	showLogo?:boolean | null,
	middleContent?:string | null,
	medium?:ValueTypes["HeroUpdateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeroUpdateMediumEntityRelationInput"]: {
	create?:ValueTypes["MediumCreateInput"] | null,
	update?:ValueTypes["MediumUpdateInput"] | null,
	upsert?:ValueTypes["HeroUpsertMediumRelationInput"] | null,
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeroUpsertMediumRelationInput"]: {
	update?:ValueTypes["MediumUpdateInput"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["ContentReferenceUpsertHeroRelationInput"]: {
	update?:ValueTypes["HeroUpdateInput"] | null,
	create?:ValueTypes["HeroCreateInput"] | null
};
	["ContentReferenceUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["GalleryCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryUpdateInput"]: {
	items?:ValueTypes["GalleryUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GalleryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["GalleryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	disconnect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	delete?:ValueTypes["GalleryItemUniqueWhere"] | null,
	alias?:string | null
};
	["GalleryUpdateItemsRelationInput"]: {
	by?:ValueTypes["GalleryItemUniqueWhere"] | null,
	data?:ValueTypes["GalleryItemWithoutListUpdateInput"] | null
};
	["GalleryItemWithoutListUpdateInput"]: {
	order?:number | null,
	caption?:string | null,
	medium?:ValueTypes["GalleryItemUpdateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateMediumEntityRelationInput"]: {
	create?:ValueTypes["MediumCreateInput"] | null,
	update?:ValueTypes["MediumUpdateInput"] | null,
	upsert?:ValueTypes["GalleryItemUpsertMediumRelationInput"] | null,
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryItemUpsertMediumRelationInput"]: {
	update?:ValueTypes["MediumUpdateInput"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["GalleryUpsertItemsRelationInput"]: {
	by?:ValueTypes["GalleryItemUniqueWhere"] | null,
	update?:ValueTypes["GalleryItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertGalleryRelationInput"]: {
	update?:ValueTypes["GalleryUpdateInput"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"]: {
	create?:ValueTypes["SocialsAndAppsCreateInput"] | null,
	update?:ValueTypes["SocialsAndAppsUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertSocialsAndAppsRelationInput"] | null,
	connect?:ValueTypes["SocialsAndAppsUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialsAndAppsUpdateInput"]: {
	instagram?:boolean | null,
	appStore?:boolean | null,
	googlePlay?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertSocialsAndAppsRelationInput"]: {
	update?:ValueTypes["SocialsAndAppsUpdateInput"] | null,
	create?:ValueTypes["SocialsAndAppsCreateInput"] | null
};
	["ContentReferenceUpdateBlogPostsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostListCreateInput"] | null,
	update?:ValueTypes["BlogPostListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertBlogPostsRelationInput"] | null,
	connect?:ValueTypes["BlogPostListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostListUpdateInput"]: {
	items?:ValueTypes["BlogPostListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BlogPostListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostListItemWithoutListCreateInput"] | null,
	update?:ValueTypes["BlogPostListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["BlogPostListItemUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostListItemUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostListItemUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostListUpdateItemsRelationInput"]: {
	by?:ValueTypes["BlogPostListItemUniqueWhere"] | null,
	data?:ValueTypes["BlogPostListItemWithoutListUpdateInput"] | null
};
	["BlogPostListItemWithoutListUpdateInput"]: {
	order?:number | null,
	caption?:string | null,
	blogPost?:ValueTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostListItemUpdateBlogPostEntityRelationInput"]: {
	create?:ValueTypes["EventLocaleCreateInput"] | null,
	update?:ValueTypes["EventLocaleUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostListItemUpsertBlogPostRelationInput"] | null,
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventLocaleUpdateInput"]: {
	root?:ValueTypes["EventLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EventLocaleUpdateLocaleEntityRelationInput"] | null,
	cover?:ValueTypes["EventLocaleUpdateCoverEntityRelationInput"] | null,
	content?:ValueTypes["EventLocaleUpdateContentEntityRelationInput"] | null,
	availableForWeb?:boolean | null,
	availableForMobile?:boolean | null,
	link?:ValueTypes["EventLocaleUpdateLinkEntityRelationInput"] | null,
	title?:string | null,
	seo?:ValueTypes["EventLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostListItemUpsertBlogPostRelationInput"]: {
	update?:ValueTypes["EventLocaleUpdateInput"] | null,
	create?:ValueTypes["EventLocaleCreateInput"] | null
};
	["BlogPostListUpsertItemsRelationInput"]: {
	by?:ValueTypes["BlogPostListItemUniqueWhere"] | null,
	update?:ValueTypes["BlogPostListItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["BlogPostListItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertBlogPostsRelationInput"]: {
	update?:ValueTypes["BlogPostListUpdateInput"] | null,
	create?:ValueTypes["BlogPostListCreateInput"] | null
};
	["ContentReferenceUpdateProductGridEntityRelationInput"]: {
	create?:ValueTypes["ProductGridCreateInput"] | null,
	update?:ValueTypes["ProductGridUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertProductGridRelationInput"] | null,
	connect?:ValueTypes["ProductGridUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductGridUpdateInput"]: {
	items?:ValueTypes["ProductGridUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductGridUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ProductGridItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ProductGridUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ProductGridUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ProductGridItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductGridItemUniqueWhere"] | null,
	delete?:ValueTypes["ProductGridItemUniqueWhere"] | null,
	alias?:string | null
};
	["ProductGridUpdateItemsRelationInput"]: {
	by?:ValueTypes["ProductGridItemUniqueWhere"] | null,
	data?:ValueTypes["ProductGridItemWithoutListUpdateInput"] | null
};
	["ProductGridItemWithoutListUpdateInput"]: {
	order?:number | null,
	goodlokProductId?:string | null,
	title?:string | null,
	lead?:string | null,
	medium?:ValueTypes["ProductGridItemUpdateMediumEntityRelationInput"] | null,
	link?:ValueTypes["ProductGridItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductGridItemUpdateMediumEntityRelationInput"]: {
	create?:ValueTypes["MediumCreateInput"] | null,
	update?:ValueTypes["MediumUpdateInput"] | null,
	upsert?:ValueTypes["ProductGridItemUpsertMediumRelationInput"] | null,
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductGridItemUpsertMediumRelationInput"]: {
	update?:ValueTypes["MediumUpdateInput"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["ProductGridItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ProductGridItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductGridItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ProductGridUpsertItemsRelationInput"]: {
	by?:ValueTypes["ProductGridItemUniqueWhere"] | null,
	update?:ValueTypes["ProductGridItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ProductGridItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertProductGridRelationInput"]: {
	update?:ValueTypes["ProductGridUpdateInput"] | null,
	create?:ValueTypes["ProductGridCreateInput"] | null
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null
};
	["ContentUpsertBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	update?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null
};
	["ContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null,
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	jsonContent?:string | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	colorPallete?:ValueTypes["ContentReferenceCreateColorPalleteEntityRelationInput"] | null,
	medium?:ValueTypes["ContentReferenceCreateMediumEntityRelationInput"] | null,
	misc?:string | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	hero?:ValueTypes["ContentReferenceCreateHeroEntityRelationInput"] | null,
	gallery?:ValueTypes["ContentReferenceCreateGalleryEntityRelationInput"] | null,
	contentSize?:ValueTypes["ContentSize"] | null,
	socialsAndApps?:ValueTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"] | null,
	blogPosts?:ValueTypes["ContentReferenceCreateBlogPostsEntityRelationInput"] | null,
	productGrid?:ValueTypes["ContentReferenceCreateProductGridEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	jsonContent?:string | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	colorPallete?:ValueTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"] | null,
	medium?:ValueTypes["ContentReferenceUpdateMediumEntityRelationInput"] | null,
	misc?:string | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	hero?:ValueTypes["ContentReferenceUpdateHeroEntityRelationInput"] | null,
	gallery?:ValueTypes["ContentReferenceUpdateGalleryEntityRelationInput"] | null,
	contentSize?:ValueTypes["ContentSize"] | null,
	socialsAndApps?:ValueTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"] | null,
	blogPosts?:ValueTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"] | null,
	productGrid?:ValueTypes["ContentReferenceUpdateProductGridEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null,
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertBlockRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["CoverConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CoverEdge"],
		__typename?: true
}>;
	["CoverEdge"]: AliasType<{
	node?:ValueTypes["Cover"],
		__typename?: true
}>;
	["EventConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EventEdge"],
		__typename?: true
}>;
	["EventEdge"]: AliasType<{
	node?:ValueTypes["Event"],
		__typename?: true
}>;
	["EventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	locales?:ValueTypes["EventCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EventCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	create?:ValueTypes["EventLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["EventLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locale?:ValueTypes["EventLocaleCreateLocaleEntityRelationInput"] | null,
	cover?:ValueTypes["EventLocaleCreateCoverEntityRelationInput"] | null,
	content?:ValueTypes["EventLocaleCreateContentEntityRelationInput"] | null,
	availableForWeb?:boolean | null,
	availableForMobile?:boolean | null,
	link?:ValueTypes["EventLocaleCreateLinkEntityRelationInput"] | null,
	title?:string | null,
	seo?:ValueTypes["EventLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventUpdateInput"]: {
	order?:number | null,
	locales?:ValueTypes["EventUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EventUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["EventLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["EventUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["EventUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	delete?:ValueTypes["EventLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["EventUpdateLocalesRelationInput"]: {
	by?:ValueTypes["EventLocaleUniqueWhere"] | null,
	data?:ValueTypes["EventLocaleWithoutRootUpdateInput"] | null
};
	["EventLocaleWithoutRootUpdateInput"]: {
	locale?:ValueTypes["EventLocaleUpdateLocaleEntityRelationInput"] | null,
	cover?:ValueTypes["EventLocaleUpdateCoverEntityRelationInput"] | null,
	content?:ValueTypes["EventLocaleUpdateContentEntityRelationInput"] | null,
	availableForWeb?:boolean | null,
	availableForMobile?:boolean | null,
	link?:ValueTypes["EventLocaleUpdateLinkEntityRelationInput"] | null,
	title?:string | null,
	seo?:ValueTypes["EventLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventUpsertLocalesRelationInput"]: {
	by?:ValueTypes["EventLocaleUniqueWhere"] | null,
	update?:ValueTypes["EventLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["EventLocaleWithoutRootCreateInput"] | null
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: true
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["ImageList"]: AliasType<{
	_meta?:ValueTypes["ImageListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["ImageItemWhere"] | null,	orderBy?:ValueTypes["ImageItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageItem"]],
paginateItems?: [{	filter?:ValueTypes["ImageItemWhere"] | null,	orderBy?:ValueTypes["ImageItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageItemConnection"]],
		__typename?: true
}>;
	["ImageListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ImageItem"]: AliasType<{
	_meta?:ValueTypes["ImageItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["ImageItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ImageListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ImageItemWhere"] | null,
	and?:(ValueTypes["ImageListWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageListWhere"] | undefined | null)[],
	not?:ValueTypes["ImageListWhere"] | null
};
	["ImageItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ImageListWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["ImageItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageItemWhere"] | undefined | null)[],
	not?:ValueTypes["ImageItemWhere"] | null
};
	["ImageItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ImageListOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["ImageListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ImageItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageItemEdge"],
		__typename?: true
}>;
	["ImageItemEdge"]: AliasType<{
	node?:ValueTypes["ImageItem"],
		__typename?: true
}>;
	["ImageListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ImageItemUniqueWhere"] | null
};
	["ImageItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ImageListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListEdge"],
		__typename?: true
}>;
	["ImageListEdge"]: AliasType<{
	node?:ValueTypes["ImageList"],
		__typename?: true
}>;
	["ImageListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ImageListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ImageListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ImageItemUniqueWhere"] | null,
	create?:ValueTypes["ImageItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ImageItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["ImageItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageListUpdateInput"]: {
	items?:ValueTypes["ImageListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ImageListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ImageItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ImageListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ImageListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ImageItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ImageItemUniqueWhere"] | null,
	delete?:ValueTypes["ImageItemUniqueWhere"] | null,
	alias?:string | null
};
	["ImageListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ImageItemUniqueWhere"] | null,
	data?:ValueTypes["ImageItemWithoutListUpdateInput"] | null
};
	["ImageItemWithoutListUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["ImageItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ImageItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ImageItemUniqueWhere"] | null,
	update?:ValueTypes["ImageItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ImageItemWithoutListCreateInput"] | null
};
	["ImageItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ImageItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["ImageItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ImageListUniqueWhere"] | null,
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null
};
	["ImageListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ImageItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ImageItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["ImageItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ImageListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ImageItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ImageListUniqueWhere"] | null,
	delete?:boolean | null
};
	["ImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ImageItemUpsertListRelationInput"]: {
	update?:ValueTypes["ImageListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null
};
	["LocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LocaleEdge"],
		__typename?: true
}>;
	["LocaleEdge"]: AliasType<{
	node?:ValueTypes["Locale"],
		__typename?: true
}>;
	["LocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleCreateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleCreateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleCreateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleUpdateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleUpdateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleUpdateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MediumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumEdge"],
		__typename?: true
}>;
	["MediumEdge"]: AliasType<{
	node?:ValueTypes["Medium"],
		__typename?: true
}>;
	["VideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VideoEdge"],
		__typename?: true
}>;
	["VideoEdge"]: AliasType<{
	node?:ValueTypes["Video"],
		__typename?: true
}>;
	["BlogConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogEdge"],
		__typename?: true
}>;
	["BlogEdge"]: AliasType<{
	node?:ValueTypes["Blog"],
		__typename?: true
}>;
	["BlogCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["BlogCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BlogCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	create?:ValueTypes["BlogLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["BlogLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	pageName?:string | null,
	title?:string | null,
	lead?:string | null,
	locale?:ValueTypes["BlogLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutBlogsCreateInput"] | null
};
	["LocaleWithoutBlogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleCreateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleCreateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BlogUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["BlogUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BlogUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["BlogLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["BlogUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["BlogUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	delete?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["BlogUpdateLocalesRelationInput"]: {
	by?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	data?:ValueTypes["BlogLocaleWithoutRootUpdateInput"] | null
};
	["BlogLocaleWithoutRootUpdateInput"]: {
	pageName?:string | null,
	title?:string | null,
	lead?:string | null,
	locale?:ValueTypes["BlogLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutBlogsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutBlogsUpdateInput"] | null,
	upsert?:ValueTypes["BlogLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutBlogsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleUpdateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleUpdateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BlogLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutBlogsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutBlogsCreateInput"] | null
};
	["BlogUpsertLocalesRelationInput"]: {
	by?:ValueTypes["BlogLocaleUniqueWhere"] | null,
	update?:ValueTypes["BlogLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["BlogLocaleWithoutRootCreateInput"] | null
};
	["BlogLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	pageName?:string | null,
	title?:string | null,
	lead?:string | null,
	root?:ValueTypes["BlogLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["BlogLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogLocaleUpdateInput"]: {
	pageName?:string | null,
	title?:string | null,
	lead?:string | null,
	root?:ValueTypes["BlogLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["BlogLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: true
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: true
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["PageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageEdge"],
		__typename?: true
}>;
	["PageEdge"]: AliasType<{
	node?:ValueTypes["Page"],
		__typename?: true
}>;
	["PageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["PageCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PageCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	create?:ValueTypes["PageLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["PageLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateInput"]: {
	locales?:ValueTypes["PageUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PageUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["PageLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["PageUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["PageUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["PageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["PageUpdateLocalesRelationInput"]: {
	by?:ValueTypes["PageLocaleUniqueWhere"] | null,
	data?:ValueTypes["PageLocaleWithoutRootUpdateInput"] | null
};
	["PageLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpsertLocalesRelationInput"]: {
	by?:ValueTypes["PageLocaleUniqueWhere"] | null,
	update?:ValueTypes["PageLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["PageLocaleWithoutRootCreateInput"] | null
};
	["PageLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | null,
	root?:ValueTypes["PageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | null,
	root?:ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: true
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	locales?:ValueTypes["SeoCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SeoCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	create?:ValueTypes["SeoLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["SeoLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	locale?:ValueTypes["SeoLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutSeosCreateInput"] | null
};
	["LocaleWithoutSeosCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleCreateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	menus?:ValueTypes["LocaleCreateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SeoUpdateInput"]: {
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	locales?:ValueTypes["SeoUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SeoUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["SeoLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["SeoUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["SeoUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	delete?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["SeoUpdateLocalesRelationInput"]: {
	by?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	data?:ValueTypes["SeoLocaleWithoutRootUpdateInput"] | null
};
	["SeoLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	locale?:ValueTypes["SeoLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutSeosCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutSeosUpdateInput"] | null,
	upsert?:ValueTypes["SeoLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutSeosUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleUpdateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	menus?:ValueTypes["LocaleUpdateMenusEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SeoLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutSeosUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutSeosCreateInput"] | null
};
	["SeoUpsertLocalesRelationInput"]: {
	by?:ValueTypes["SeoLocaleUniqueWhere"] | null,
	update?:ValueTypes["SeoLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["SeoLocaleWithoutRootCreateInput"] | null
};
	["SeoLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	root?:ValueTypes["SeoLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["SeoLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoLocaleUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	root?:ValueTypes["SeoLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["SeoLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LocalizedSeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LocalizedSeoEdge"],
		__typename?: true
}>;
	["LocalizedSeoEdge"]: AliasType<{
	node?:ValueTypes["LocalizedSeo"],
		__typename?: true
}>;
	["HeroConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeroEdge"],
		__typename?: true
}>;
	["HeroEdge"]: AliasType<{
	node?:ValueTypes["Hero"],
		__typename?: true
}>;
	["GalleryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryEdge"],
		__typename?: true
}>;
	["GalleryEdge"]: AliasType<{
	node?:ValueTypes["Gallery"],
		__typename?: true
}>;
	["GalleryItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	caption?:string | null,
	list?:ValueTypes["GalleryItemCreateListEntityRelationInput"] | null,
	medium?:ValueTypes["GalleryItemCreateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null
};
	["GalleryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateInput"]: {
	order?:number | null,
	caption?:string | null,
	list?:ValueTypes["GalleryItemUpdateListEntityRelationInput"] | null,
	medium?:ValueTypes["GalleryItemUpdateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null,
	update?:ValueTypes["GalleryWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["GalleryItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	delete?:boolean | null
};
	["GalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["GalleryItemUpsertListRelationInput"]: {
	update?:ValueTypes["GalleryWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null
};
	["SocialsAndAppsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialsAndAppsEdge"],
		__typename?: true
}>;
	["SocialsAndAppsEdge"]: AliasType<{
	node?:ValueTypes["SocialsAndApps"],
		__typename?: true
}>;
	["SiteMenuConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SiteMenuEdge"],
		__typename?: true
}>;
	["SiteMenuEdge"]: AliasType<{
	node?:ValueTypes["SiteMenu"],
		__typename?: true
}>;
	["SiteMenuCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["SiteMenuCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SiteMenuCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	create?:ValueTypes["MenuLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["MenuLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locale?:ValueTypes["MenuLocaleCreateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["MenuLocaleCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MenuLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutMenusCreateInput"] | null
};
	["LocaleWithoutMenusCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleCreateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleCreateSeosEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SiteMenuUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["SiteMenuUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SiteMenuUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["MenuLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["SiteMenuUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["SiteMenuUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	delete?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["SiteMenuUpdateLocalesRelationInput"]: {
	by?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	data?:ValueTypes["MenuLocaleWithoutRootUpdateInput"] | null
};
	["MenuLocaleWithoutRootUpdateInput"]: {
	locale?:ValueTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["MenuLocaleUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MenuLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutMenusCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutMenusUpdateInput"] | null,
	upsert?:ValueTypes["MenuLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutMenusUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleUpdateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleUpdateSeosEntityRelationInput"][],
	businessOrderTypes?:ValueTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MenuLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutMenusUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutMenusCreateInput"] | null
};
	["SiteMenuUpsertLocalesRelationInput"]: {
	by?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	update?:ValueTypes["MenuLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["MenuLocaleWithoutRootCreateInput"] | null
};
	["MenuItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["MenuItemCreateLinkEntityRelationInput"] | null,
	menu?:ValueTypes["MenuItemCreateMenuEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MenuItemCreateMenuEntityRelationInput"]: {
	connect?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	create?:ValueTypes["MenuLocaleWithoutItemsCreateInput"] | null
};
	["MenuLocaleWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["MenuLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["MenuLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MenuItemUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["MenuItemUpdateLinkEntityRelationInput"] | null,
	menu?:ValueTypes["MenuItemUpdateMenuEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MenuItemUpdateMenuEntityRelationInput"]: {
	create?:ValueTypes["MenuLocaleWithoutItemsCreateInput"] | null,
	update?:ValueTypes["MenuLocaleWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["MenuItemUpsertMenuRelationInput"] | null,
	connect?:ValueTypes["MenuLocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["MenuLocaleWithoutItemsUpdateInput"]: {
	root?:ValueTypes["MenuLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MenuItemUpsertMenuRelationInput"]: {
	update?:ValueTypes["MenuLocaleWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["MenuLocaleWithoutItemsCreateInput"] | null
};
	["BlogPostListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostListEdge"],
		__typename?: true
}>;
	["BlogPostListEdge"]: AliasType<{
	node?:ValueTypes["BlogPostList"],
		__typename?: true
}>;
	["BlogPostListItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	caption?:string | null,
	list?:ValueTypes["BlogPostListItemCreateListEntityRelationInput"] | null,
	blogPost?:ValueTypes["BlogPostListItemCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostListItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostListUniqueWhere"] | null,
	create?:ValueTypes["BlogPostListWithoutItemsCreateInput"] | null
};
	["BlogPostListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostListItemUpdateInput"]: {
	order?:number | null,
	caption?:string | null,
	list?:ValueTypes["BlogPostListItemUpdateListEntityRelationInput"] | null,
	blogPost?:ValueTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostListItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["BlogPostListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["BlogPostListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostListItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["BlogPostListUniqueWhere"] | null,
	delete?:boolean | null
};
	["BlogPostListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["BlogPostListItemUpsertListRelationInput"]: {
	update?:ValueTypes["BlogPostListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["BlogPostListWithoutItemsCreateInput"] | null
};
	["MenuLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["MenuLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["MenuLocaleCreateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["MenuLocaleCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MenuLocaleUpdateInput"]: {
	root?:ValueTypes["MenuLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["MenuLocaleUpdateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["MenuLocaleUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductGridConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductGridEdge"],
		__typename?: true
}>;
	["ProductGridEdge"]: AliasType<{
	node?:ValueTypes["ProductGrid"],
		__typename?: true
}>;
	["ProductGridItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	goodlokProductId?:string | null,
	title?:string | null,
	lead?:string | null,
	list?:ValueTypes["ProductGridItemCreateListEntityRelationInput"] | null,
	medium?:ValueTypes["ProductGridItemCreateMediumEntityRelationInput"] | null,
	link?:ValueTypes["ProductGridItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductGridItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ProductGridUniqueWhere"] | null,
	create?:ValueTypes["ProductGridWithoutItemsCreateInput"] | null
};
	["ProductGridWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ProductGridItemUpdateInput"]: {
	order?:number | null,
	goodlokProductId?:string | null,
	title?:string | null,
	lead?:string | null,
	list?:ValueTypes["ProductGridItemUpdateListEntityRelationInput"] | null,
	medium?:ValueTypes["ProductGridItemUpdateMediumEntityRelationInput"] | null,
	link?:ValueTypes["ProductGridItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductGridItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ProductGridWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ProductGridWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ProductGridItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ProductGridUniqueWhere"] | null,
	delete?:boolean | null
};
	["ProductGridWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ProductGridItemUpsertListRelationInput"]: {
	update?:ValueTypes["ProductGridWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ProductGridWithoutItemsCreateInput"] | null
};
	["Profile"]: AliasType<{
	_meta?:ValueTypes["ProfileMeta"],
	id?:true,
	goodlokId?:true,
	importance?:true,
	name?:true,
	vokativ?:true,
	fullName?:true,
	aliases?:true,
	quickNote?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
activityRecords?: [{	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	orderBy?:ValueTypes["ProfileActivityRecordOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileActivityRecord"]],
pins?: [{	filter?:ValueTypes["ProfilePinWhere"] | null,	orderBy?:ValueTypes["ProfilePinOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfilePin"]],
gallery?: [{	filter?:ValueTypes["ProfileGalleryWhere"] | null},ValueTypes["ProfileGallery"]],
tags?: [{	filter?:ValueTypes["ProfileTagWhere"] | null,	orderBy?:ValueTypes["ProfileTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileTag"]],
	familiarity?:true,
	vipStatus?:true,
	instagram?:true,
	facebook?:true,
	twitter?:true,
	tiktok?:true,
	youtube?:true,
	status?:true,
	visited?:true,
	iosNearbyAt?:true,
pinsByActivityRecords?: [{	by:ValueTypes["ProfilePinsByActivityRecordsUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null},ValueTypes["ProfilePin"]],
paginateActivityRecords?: [{	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	orderBy?:ValueTypes["ProfileActivityRecordOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileActivityRecordConnection"]],
paginatePins?: [{	filter?:ValueTypes["ProfilePinWhere"] | null,	orderBy?:ValueTypes["ProfilePinOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfilePinConnection"]],
paginateTags?: [{	filter?:ValueTypes["ProfileTagWhere"] | null,	orderBy?:ValueTypes["ProfileTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileTagConnection"]],
		__typename?: true
}>;
	["ProfileMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	goodlokId?:ValueTypes["FieldMeta"],
	importance?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	vokativ?:ValueTypes["FieldMeta"],
	fullName?:ValueTypes["FieldMeta"],
	aliases?:ValueTypes["FieldMeta"],
	quickNote?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	activityRecords?:ValueTypes["FieldMeta"],
	pins?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	familiarity?:ValueTypes["FieldMeta"],
	vipStatus?:ValueTypes["FieldMeta"],
	instagram?:ValueTypes["FieldMeta"],
	facebook?:ValueTypes["FieldMeta"],
	twitter?:ValueTypes["FieldMeta"],
	tiktok?:ValueTypes["FieldMeta"],
	youtube?:ValueTypes["FieldMeta"],
	status?:ValueTypes["FieldMeta"],
	visited?:ValueTypes["FieldMeta"],
	iosNearbyAt?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProfileActivityRecord"]: AliasType<{
	_meta?:ValueTypes["ProfileActivityRecordMeta"],
	id?:true,
	type?:true,
	createdAt?:true,
	updatedAt?:true,
	metadata?:true,
profile?: [{	filter?:ValueTypes["ProfileWhere"] | null},ValueTypes["Profile"]],
pin?: [{	filter?:ValueTypes["ProfilePinWhere"] | null},ValueTypes["ProfilePin"]],
		__typename?: true
}>;
	["ProfileActivityRecordMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	updatedAt?:ValueTypes["FieldMeta"],
	metadata?:ValueTypes["FieldMeta"],
	profile?:ValueTypes["FieldMeta"],
	pin?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProfileActivityRecordType"]:ProfileActivityRecordType;
	["DateTime"]:unknown;
	["ProfileWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	goodlokId?:ValueTypes["StringCondition"] | null,
	importance?:ValueTypes["IntCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	vokativ?:ValueTypes["StringCondition"] | null,
	fullName?:ValueTypes["StringCondition"] | null,
	aliases?:ValueTypes["StringCondition"] | null,
	quickNote?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	activityRecords?:ValueTypes["ProfileActivityRecordWhere"] | null,
	pins?:ValueTypes["ProfilePinWhere"] | null,
	gallery?:ValueTypes["ProfileGalleryWhere"] | null,
	tags?:ValueTypes["ProfileTagWhere"] | null,
	familiarity?:ValueTypes["FamiliarityCondition"] | null,
	vipStatus?:ValueTypes["VipStatusCondition"] | null,
	instagram?:ValueTypes["StringCondition"] | null,
	facebook?:ValueTypes["StringCondition"] | null,
	twitter?:ValueTypes["StringCondition"] | null,
	tiktok?:ValueTypes["StringCondition"] | null,
	youtube?:ValueTypes["StringCondition"] | null,
	status?:ValueTypes["ProfileStatusCondition"] | null,
	visited?:ValueTypes["IntCondition"] | null,
	iosNearbyAt?:ValueTypes["DateTimeCondition"] | null,
	and?:(ValueTypes["ProfileWhere"] | undefined | null)[],
	or?:(ValueTypes["ProfileWhere"] | undefined | null)[],
	not?:ValueTypes["ProfileWhere"] | null
};
	["ProfileActivityRecordWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ProfileActivityRecordTypeCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	updatedAt?:ValueTypes["DateTimeCondition"] | null,
	metadata?:ValueTypes["StringCondition"] | null,
	profile?:ValueTypes["ProfileWhere"] | null,
	pin?:ValueTypes["ProfilePinWhere"] | null,
	and?:(ValueTypes["ProfileActivityRecordWhere"] | undefined | null)[],
	or?:(ValueTypes["ProfileActivityRecordWhere"] | undefined | null)[],
	not?:ValueTypes["ProfileActivityRecordWhere"] | null
};
	["ProfileActivityRecordTypeCondition"]: {
	and?:ValueTypes["ProfileActivityRecordTypeCondition"][],
	or?:ValueTypes["ProfileActivityRecordTypeCondition"][],
	not?:ValueTypes["ProfileActivityRecordTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ProfileActivityRecordType"] | null,
	notEq?:ValueTypes["ProfileActivityRecordType"] | null,
	in?:ValueTypes["ProfileActivityRecordType"][],
	notIn?:ValueTypes["ProfileActivityRecordType"][],
	lt?:ValueTypes["ProfileActivityRecordType"] | null,
	lte?:ValueTypes["ProfileActivityRecordType"] | null,
	gt?:ValueTypes["ProfileActivityRecordType"] | null,
	gte?:ValueTypes["ProfileActivityRecordType"] | null
};
	["DateTimeCondition"]: {
	and?:ValueTypes["DateTimeCondition"][],
	or?:ValueTypes["DateTimeCondition"][],
	not?:ValueTypes["DateTimeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["DateTime"] | null,
	notEq?:ValueTypes["DateTime"] | null,
	in?:ValueTypes["DateTime"][],
	notIn?:ValueTypes["DateTime"][],
	lt?:ValueTypes["DateTime"] | null,
	lte?:ValueTypes["DateTime"] | null,
	gt?:ValueTypes["DateTime"] | null,
	gte?:ValueTypes["DateTime"] | null
};
	["ProfilePinWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ProfilePinTypeCondition"] | null,
	startsAt?:ValueTypes["DateTimeCondition"] | null,
	endsAt?:ValueTypes["DateTimeCondition"] | null,
	dismissedAt?:ValueTypes["DateTimeCondition"] | null,
	dismissedBy?:ValueTypes["StringCondition"] | null,
	reason?:ValueTypes["StringCondition"] | null,
	solution?:ValueTypes["StringCondition"] | null,
	activityRecords?:ValueTypes["ProfileActivityRecordWhere"] | null,
	profile?:ValueTypes["ProfileWhere"] | null,
	and?:(ValueTypes["ProfilePinWhere"] | undefined | null)[],
	or?:(ValueTypes["ProfilePinWhere"] | undefined | null)[],
	not?:ValueTypes["ProfilePinWhere"] | null
};
	["ProfilePinTypeCondition"]: {
	and?:ValueTypes["ProfilePinTypeCondition"][],
	or?:ValueTypes["ProfilePinTypeCondition"][],
	not?:ValueTypes["ProfilePinTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ProfilePinType"] | null,
	notEq?:ValueTypes["ProfilePinType"] | null,
	in?:ValueTypes["ProfilePinType"][],
	notIn?:ValueTypes["ProfilePinType"][],
	lt?:ValueTypes["ProfilePinType"] | null,
	lte?:ValueTypes["ProfilePinType"] | null,
	gt?:ValueTypes["ProfilePinType"] | null,
	gte?:ValueTypes["ProfilePinType"] | null
};
	["ProfilePinType"]:ProfilePinType;
	["ProfileGalleryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ProfileGalleryItemWhere"] | null,
	profile?:ValueTypes["ProfileWhere"] | null,
	and?:(ValueTypes["ProfileGalleryWhere"] | undefined | null)[],
	or?:(ValueTypes["ProfileGalleryWhere"] | undefined | null)[],
	not?:ValueTypes["ProfileGalleryWhere"] | null
};
	["ProfileGalleryItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	caption?:ValueTypes["StringCondition"] | null,
	gallery?:ValueTypes["ProfileGalleryWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["ProfileGalleryItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ProfileGalleryItemWhere"] | undefined | null)[],
	not?:ValueTypes["ProfileGalleryItemWhere"] | null
};
	["ProfileTagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	color?:ValueTypes["StringCondition"] | null,
	profiles?:ValueTypes["ProfileWhere"] | null,
	and?:(ValueTypes["ProfileTagWhere"] | undefined | null)[],
	or?:(ValueTypes["ProfileTagWhere"] | undefined | null)[],
	not?:ValueTypes["ProfileTagWhere"] | null
};
	["FamiliarityCondition"]: {
	and?:ValueTypes["FamiliarityCondition"][],
	or?:ValueTypes["FamiliarityCondition"][],
	not?:ValueTypes["FamiliarityCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["Familiarity"] | null,
	notEq?:ValueTypes["Familiarity"] | null,
	in?:ValueTypes["Familiarity"][],
	notIn?:ValueTypes["Familiarity"][],
	lt?:ValueTypes["Familiarity"] | null,
	lte?:ValueTypes["Familiarity"] | null,
	gt?:ValueTypes["Familiarity"] | null,
	gte?:ValueTypes["Familiarity"] | null
};
	["Familiarity"]:Familiarity;
	["VipStatusCondition"]: {
	and?:ValueTypes["VipStatusCondition"][],
	or?:ValueTypes["VipStatusCondition"][],
	not?:ValueTypes["VipStatusCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["VipStatus"] | null,
	notEq?:ValueTypes["VipStatus"] | null,
	in?:ValueTypes["VipStatus"][],
	notIn?:ValueTypes["VipStatus"][],
	lt?:ValueTypes["VipStatus"] | null,
	lte?:ValueTypes["VipStatus"] | null,
	gt?:ValueTypes["VipStatus"] | null,
	gte?:ValueTypes["VipStatus"] | null
};
	["VipStatus"]:VipStatus;
	["ProfileStatusCondition"]: {
	and?:ValueTypes["ProfileStatusCondition"][],
	or?:ValueTypes["ProfileStatusCondition"][],
	not?:ValueTypes["ProfileStatusCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ProfileStatus"] | null,
	notEq?:ValueTypes["ProfileStatus"] | null,
	in?:ValueTypes["ProfileStatus"][],
	notIn?:ValueTypes["ProfileStatus"][],
	lt?:ValueTypes["ProfileStatus"] | null,
	lte?:ValueTypes["ProfileStatus"] | null,
	gt?:ValueTypes["ProfileStatus"] | null,
	gte?:ValueTypes["ProfileStatus"] | null
};
	["ProfileStatus"]:ProfileStatus;
	["ProfilePin"]: AliasType<{
	_meta?:ValueTypes["ProfilePinMeta"],
	id?:true,
	type?:true,
	startsAt?:true,
	endsAt?:true,
	dismissedAt?:true,
	dismissedBy?:true,
	reason?:true,
	solution?:true,
activityRecords?: [{	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	orderBy?:ValueTypes["ProfileActivityRecordOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileActivityRecord"]],
profile?: [{	filter?:ValueTypes["ProfileWhere"] | null},ValueTypes["Profile"]],
paginateActivityRecords?: [{	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	orderBy?:ValueTypes["ProfileActivityRecordOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileActivityRecordConnection"]],
		__typename?: true
}>;
	["ProfilePinMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	startsAt?:ValueTypes["FieldMeta"],
	endsAt?:ValueTypes["FieldMeta"],
	dismissedAt?:ValueTypes["FieldMeta"],
	dismissedBy?:ValueTypes["FieldMeta"],
	reason?:ValueTypes["FieldMeta"],
	solution?:ValueTypes["FieldMeta"],
	activityRecords?:ValueTypes["FieldMeta"],
	profile?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProfileActivityRecordOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	updatedAt?:ValueTypes["OrderDirection"] | null,
	metadata?:ValueTypes["OrderDirection"] | null,
	profile?:ValueTypes["ProfileOrderBy"] | null,
	pin?:ValueTypes["ProfilePinOrderBy"] | null
};
	["ProfileOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	goodlokId?:ValueTypes["OrderDirection"] | null,
	importance?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	vokativ?:ValueTypes["OrderDirection"] | null,
	fullName?:ValueTypes["OrderDirection"] | null,
	aliases?:ValueTypes["OrderDirection"] | null,
	quickNote?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	gallery?:ValueTypes["ProfileGalleryOrderBy"] | null,
	familiarity?:ValueTypes["OrderDirection"] | null,
	vipStatus?:ValueTypes["OrderDirection"] | null,
	instagram?:ValueTypes["OrderDirection"] | null,
	facebook?:ValueTypes["OrderDirection"] | null,
	twitter?:ValueTypes["OrderDirection"] | null,
	tiktok?:ValueTypes["OrderDirection"] | null,
	youtube?:ValueTypes["OrderDirection"] | null,
	status?:ValueTypes["OrderDirection"] | null,
	visited?:ValueTypes["OrderDirection"] | null,
	iosNearbyAt?:ValueTypes["OrderDirection"] | null
};
	["ProfileGalleryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	profile?:ValueTypes["ProfileOrderBy"] | null
};
	["ProfilePinOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	startsAt?:ValueTypes["OrderDirection"] | null,
	endsAt?:ValueTypes["OrderDirection"] | null,
	dismissedAt?:ValueTypes["OrderDirection"] | null,
	dismissedBy?:ValueTypes["OrderDirection"] | null,
	reason?:ValueTypes["OrderDirection"] | null,
	solution?:ValueTypes["OrderDirection"] | null,
	profile?:ValueTypes["ProfileOrderBy"] | null
};
	["ProfileActivityRecordConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProfileActivityRecordEdge"],
		__typename?: true
}>;
	["ProfileActivityRecordEdge"]: AliasType<{
	node?:ValueTypes["ProfileActivityRecord"],
		__typename?: true
}>;
	["ProfileGallery"]: AliasType<{
	_meta?:ValueTypes["ProfileGalleryMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileGalleryItem"]],
profile?: [{	filter?:ValueTypes["ProfileWhere"] | null},ValueTypes["Profile"]],
paginateItems?: [{	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileGalleryItemConnection"]],
		__typename?: true
}>;
	["ProfileGalleryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	profile?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProfileGalleryItem"]: AliasType<{
	_meta?:ValueTypes["ProfileGalleryItemMeta"],
	id?:true,
	order?:true,
	caption?:true,
gallery?: [{	filter?:ValueTypes["ProfileGalleryWhere"] | null},ValueTypes["ProfileGallery"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["ProfileGalleryItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	caption?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProfileGalleryItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	caption?:ValueTypes["OrderDirection"] | null,
	gallery?:ValueTypes["ProfileGalleryOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["ProfileGalleryItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProfileGalleryItemEdge"],
		__typename?: true
}>;
	["ProfileGalleryItemEdge"]: AliasType<{
	node?:ValueTypes["ProfileGalleryItem"],
		__typename?: true
}>;
	["ProfileTag"]: AliasType<{
	_meta?:ValueTypes["ProfileTagMeta"],
	id?:true,
	name?:true,
	color?:true,
profiles?: [{	filter?:ValueTypes["ProfileWhere"] | null,	orderBy?:ValueTypes["ProfileOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Profile"]],
paginateProfiles?: [{	filter?:ValueTypes["ProfileWhere"] | null,	orderBy?:ValueTypes["ProfileOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileConnection"]],
		__typename?: true
}>;
	["ProfileTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	profiles?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ProfileConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProfileEdge"],
		__typename?: true
}>;
	["ProfileEdge"]: AliasType<{
	node?:ValueTypes["Profile"],
		__typename?: true
}>;
	["ProfileTagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	color?:ValueTypes["OrderDirection"] | null
};
	["ProfilePinsByActivityRecordsUniqueWhere"]: {
	activityRecords?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null
};
	["ProfileActivityRecordUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ProfilePinConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProfilePinEdge"],
		__typename?: true
}>;
	["ProfilePinEdge"]: AliasType<{
	node?:ValueTypes["ProfilePin"],
		__typename?: true
}>;
	["ProfileTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProfileTagEdge"],
		__typename?: true
}>;
	["ProfileTagEdge"]: AliasType<{
	node?:ValueTypes["ProfileTag"],
		__typename?: true
}>;
	["ProfileUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	goodlokId?:string | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	activityRecords?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	pins?:ValueTypes["ProfilePinUniqueWhere"] | null,
	gallery?:ValueTypes["ProfileGalleryUniqueWhere"] | null
};
	["ProfilePinUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	activityRecords?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null
};
	["ProfileGalleryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ProfileGalleryItemUniqueWhere"] | null,
	profile?:ValueTypes["ProfileUniqueWhere"] | null
};
	["ProfileGalleryItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ProfileCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileCreateContentEntityRelationInput"] | null,
	activityRecords?:ValueTypes["ProfileCreateActivityRecordsEntityRelationInput"][],
	pins?:ValueTypes["ProfileCreatePinsEntityRelationInput"][],
	gallery?:ValueTypes["ProfileCreateGalleryEntityRelationInput"] | null,
	tags?:ValueTypes["ProfileCreateTagsEntityRelationInput"][],
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ProfileCreateActivityRecordsEntityRelationInput"]: {
	connect?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	create?:ValueTypes["ProfileActivityRecordWithoutProfileCreateInput"] | null,
	alias?:string | null
};
	["ProfileActivityRecordWithoutProfileCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ProfileActivityRecordType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	updatedAt?:ValueTypes["DateTime"] | null,
	metadata?:string | null,
	pin?:ValueTypes["ProfileActivityRecordCreatePinEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileActivityRecordCreatePinEntityRelationInput"]: {
	connect?:ValueTypes["ProfilePinUniqueWhere"] | null,
	create?:ValueTypes["ProfilePinWithoutActivityRecordsCreateInput"] | null
};
	["ProfilePinWithoutActivityRecordsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ProfilePinType"] | null,
	startsAt?:ValueTypes["DateTime"] | null,
	endsAt?:ValueTypes["DateTime"] | null,
	dismissedAt?:ValueTypes["DateTime"] | null,
	dismissedBy?:string | null,
	reason?:string | null,
	solution?:string | null,
	profile?:ValueTypes["ProfilePinCreateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfilePinCreateProfileEntityRelationInput"]: {
	connect?:ValueTypes["ProfileUniqueWhere"] | null,
	create?:ValueTypes["ProfileWithoutPinsCreateInput"] | null
};
	["ProfileWithoutPinsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileCreateContentEntityRelationInput"] | null,
	activityRecords?:ValueTypes["ProfileCreateActivityRecordsEntityRelationInput"][],
	gallery?:ValueTypes["ProfileCreateGalleryEntityRelationInput"] | null,
	tags?:ValueTypes["ProfileCreateTagsEntityRelationInput"][],
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["ProfileGalleryUniqueWhere"] | null,
	create?:ValueTypes["ProfileGalleryWithoutProfileCreateInput"] | null
};
	["ProfileGalleryWithoutProfileCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ProfileGalleryCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProfileGalleryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ProfileGalleryItemUniqueWhere"] | null,
	create?:ValueTypes["ProfileGalleryItemWithoutGalleryCreateInput"] | null,
	alias?:string | null
};
	["ProfileGalleryItemWithoutGalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	caption?:string | null,
	image?:ValueTypes["ProfileGalleryItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ProfileCreateTagsEntityRelationInput"]: {
	connect?:ValueTypes["ProfileTagUniqueWhere"] | null,
	create?:ValueTypes["ProfileTagWithoutProfilesCreateInput"] | null,
	alias?:string | null
};
	["ProfileTagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null
};
	["ProfileTagWithoutProfilesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	color?:string | null,
	_dummy_field_?:boolean | null
};
	["ProfileCreatePinsEntityRelationInput"]: {
	connect?:ValueTypes["ProfilePinUniqueWhere"] | null,
	create?:ValueTypes["ProfilePinWithoutProfileCreateInput"] | null,
	alias?:string | null
};
	["ProfilePinWithoutProfileCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ProfilePinType"] | null,
	startsAt?:ValueTypes["DateTime"] | null,
	endsAt?:ValueTypes["DateTime"] | null,
	dismissedAt?:ValueTypes["DateTime"] | null,
	dismissedBy?:string | null,
	reason?:string | null,
	solution?:string | null,
	activityRecords?:ValueTypes["ProfilePinCreateActivityRecordsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProfilePinCreateActivityRecordsEntityRelationInput"]: {
	connect?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	create?:ValueTypes["ProfileActivityRecordWithoutPinCreateInput"] | null,
	alias?:string | null
};
	["ProfileActivityRecordWithoutPinCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ProfileActivityRecordType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	updatedAt?:ValueTypes["DateTime"] | null,
	metadata?:string | null,
	profile?:ValueTypes["ProfileActivityRecordCreateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileActivityRecordCreateProfileEntityRelationInput"]: {
	connect?:ValueTypes["ProfileUniqueWhere"] | null,
	create?:ValueTypes["ProfileWithoutActivityRecordsCreateInput"] | null
};
	["ProfileWithoutActivityRecordsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileCreateContentEntityRelationInput"] | null,
	pins?:ValueTypes["ProfileCreatePinsEntityRelationInput"][],
	gallery?:ValueTypes["ProfileCreateGalleryEntityRelationInput"] | null,
	tags?:ValueTypes["ProfileCreateTagsEntityRelationInput"][],
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileUpdateInput"]: {
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileUpdateContentEntityRelationInput"] | null,
	activityRecords?:ValueTypes["ProfileUpdateActivityRecordsEntityRelationInput"][],
	pins?:ValueTypes["ProfileUpdatePinsEntityRelationInput"][],
	gallery?:ValueTypes["ProfileUpdateGalleryEntityRelationInput"] | null,
	tags?:ValueTypes["ProfileUpdateTagsEntityRelationInput"][],
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ProfileUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProfileUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ProfileUpdateActivityRecordsEntityRelationInput"]: {
	create?:ValueTypes["ProfileActivityRecordWithoutProfileCreateInput"] | null,
	update?:ValueTypes["ProfileUpdateActivityRecordsRelationInput"] | null,
	upsert?:ValueTypes["ProfileUpsertActivityRecordsRelationInput"] | null,
	connect?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	disconnect?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	delete?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	alias?:string | null
};
	["ProfileUpdateActivityRecordsRelationInput"]: {
	by?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	data?:ValueTypes["ProfileActivityRecordWithoutProfileUpdateInput"] | null
};
	["ProfileActivityRecordWithoutProfileUpdateInput"]: {
	type?:ValueTypes["ProfileActivityRecordType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	updatedAt?:ValueTypes["DateTime"] | null,
	metadata?:string | null,
	pin?:ValueTypes["ProfileActivityRecordUpdatePinEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileActivityRecordUpdatePinEntityRelationInput"]: {
	create?:ValueTypes["ProfilePinWithoutActivityRecordsCreateInput"] | null,
	update?:ValueTypes["ProfilePinWithoutActivityRecordsUpdateInput"] | null,
	upsert?:ValueTypes["ProfileActivityRecordUpsertPinRelationInput"] | null,
	connect?:ValueTypes["ProfilePinUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProfilePinWithoutActivityRecordsUpdateInput"]: {
	type?:ValueTypes["ProfilePinType"] | null,
	startsAt?:ValueTypes["DateTime"] | null,
	endsAt?:ValueTypes["DateTime"] | null,
	dismissedAt?:ValueTypes["DateTime"] | null,
	dismissedBy?:string | null,
	reason?:string | null,
	solution?:string | null,
	profile?:ValueTypes["ProfilePinUpdateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfilePinUpdateProfileEntityRelationInput"]: {
	create?:ValueTypes["ProfileWithoutPinsCreateInput"] | null,
	update?:ValueTypes["ProfileWithoutPinsUpdateInput"] | null,
	upsert?:ValueTypes["ProfilePinUpsertProfileRelationInput"] | null,
	connect?:ValueTypes["ProfileUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProfileWithoutPinsUpdateInput"]: {
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileUpdateContentEntityRelationInput"] | null,
	activityRecords?:ValueTypes["ProfileUpdateActivityRecordsEntityRelationInput"][],
	gallery?:ValueTypes["ProfileUpdateGalleryEntityRelationInput"] | null,
	tags?:ValueTypes["ProfileUpdateTagsEntityRelationInput"][],
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["ProfileGalleryWithoutProfileCreateInput"] | null,
	update?:ValueTypes["ProfileGalleryWithoutProfileUpdateInput"] | null,
	upsert?:ValueTypes["ProfileUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["ProfileGalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProfileGalleryWithoutProfileUpdateInput"]: {
	items?:ValueTypes["ProfileGalleryUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProfileGalleryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ProfileGalleryItemWithoutGalleryCreateInput"] | null,
	update?:ValueTypes["ProfileGalleryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ProfileGalleryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ProfileGalleryItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ProfileGalleryItemUniqueWhere"] | null,
	delete?:ValueTypes["ProfileGalleryItemUniqueWhere"] | null,
	alias?:string | null
};
	["ProfileGalleryUpdateItemsRelationInput"]: {
	by?:ValueTypes["ProfileGalleryItemUniqueWhere"] | null,
	data?:ValueTypes["ProfileGalleryItemWithoutGalleryUpdateInput"] | null
};
	["ProfileGalleryItemWithoutGalleryUpdateInput"]: {
	order?:number | null,
	caption?:string | null,
	image?:ValueTypes["ProfileGalleryItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ProfileGalleryItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProfileGalleryItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ProfileGalleryUpsertItemsRelationInput"]: {
	by?:ValueTypes["ProfileGalleryItemUniqueWhere"] | null,
	update?:ValueTypes["ProfileGalleryItemWithoutGalleryUpdateInput"] | null,
	create?:ValueTypes["ProfileGalleryItemWithoutGalleryCreateInput"] | null
};
	["ProfileUpsertGalleryRelationInput"]: {
	update?:ValueTypes["ProfileGalleryWithoutProfileUpdateInput"] | null,
	create?:ValueTypes["ProfileGalleryWithoutProfileCreateInput"] | null
};
	["ProfileUpdateTagsEntityRelationInput"]: {
	create?:ValueTypes["ProfileTagWithoutProfilesCreateInput"] | null,
	update?:ValueTypes["ProfileUpdateTagsRelationInput"] | null,
	upsert?:ValueTypes["ProfileUpsertTagsRelationInput"] | null,
	connect?:ValueTypes["ProfileTagUniqueWhere"] | null,
	disconnect?:ValueTypes["ProfileTagUniqueWhere"] | null,
	delete?:ValueTypes["ProfileTagUniqueWhere"] | null,
	alias?:string | null
};
	["ProfileUpdateTagsRelationInput"]: {
	by?:ValueTypes["ProfileTagUniqueWhere"] | null,
	data?:ValueTypes["ProfileTagWithoutProfilesUpdateInput"] | null
};
	["ProfileTagWithoutProfilesUpdateInput"]: {
	name?:string | null,
	color?:string | null,
	_dummy_field_?:boolean | null
};
	["ProfileUpsertTagsRelationInput"]: {
	by?:ValueTypes["ProfileTagUniqueWhere"] | null,
	update?:ValueTypes["ProfileTagWithoutProfilesUpdateInput"] | null,
	create?:ValueTypes["ProfileTagWithoutProfilesCreateInput"] | null
};
	["ProfilePinUpsertProfileRelationInput"]: {
	update?:ValueTypes["ProfileWithoutPinsUpdateInput"] | null,
	create?:ValueTypes["ProfileWithoutPinsCreateInput"] | null
};
	["ProfileActivityRecordUpsertPinRelationInput"]: {
	update?:ValueTypes["ProfilePinWithoutActivityRecordsUpdateInput"] | null,
	create?:ValueTypes["ProfilePinWithoutActivityRecordsCreateInput"] | null
};
	["ProfileUpsertActivityRecordsRelationInput"]: {
	by?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	update?:ValueTypes["ProfileActivityRecordWithoutProfileUpdateInput"] | null,
	create?:ValueTypes["ProfileActivityRecordWithoutProfileCreateInput"] | null
};
	["ProfileUpdatePinsEntityRelationInput"]: {
	create?:ValueTypes["ProfilePinWithoutProfileCreateInput"] | null,
	update?:ValueTypes["ProfileUpdatePinsRelationInput"] | null,
	upsert?:ValueTypes["ProfileUpsertPinsRelationInput"] | null,
	connect?:ValueTypes["ProfilePinUniqueWhere"] | null,
	disconnect?:ValueTypes["ProfilePinUniqueWhere"] | null,
	delete?:ValueTypes["ProfilePinUniqueWhere"] | null,
	alias?:string | null
};
	["ProfileUpdatePinsRelationInput"]: {
	by?:ValueTypes["ProfilePinUniqueWhere"] | null,
	data?:ValueTypes["ProfilePinWithoutProfileUpdateInput"] | null
};
	["ProfilePinWithoutProfileUpdateInput"]: {
	type?:ValueTypes["ProfilePinType"] | null,
	startsAt?:ValueTypes["DateTime"] | null,
	endsAt?:ValueTypes["DateTime"] | null,
	dismissedAt?:ValueTypes["DateTime"] | null,
	dismissedBy?:string | null,
	reason?:string | null,
	solution?:string | null,
	activityRecords?:ValueTypes["ProfilePinUpdateActivityRecordsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProfilePinUpdateActivityRecordsEntityRelationInput"]: {
	create?:ValueTypes["ProfileActivityRecordWithoutPinCreateInput"] | null,
	update?:ValueTypes["ProfilePinUpdateActivityRecordsRelationInput"] | null,
	upsert?:ValueTypes["ProfilePinUpsertActivityRecordsRelationInput"] | null,
	connect?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	disconnect?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	delete?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	alias?:string | null
};
	["ProfilePinUpdateActivityRecordsRelationInput"]: {
	by?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	data?:ValueTypes["ProfileActivityRecordWithoutPinUpdateInput"] | null
};
	["ProfileActivityRecordWithoutPinUpdateInput"]: {
	type?:ValueTypes["ProfileActivityRecordType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	updatedAt?:ValueTypes["DateTime"] | null,
	metadata?:string | null,
	profile?:ValueTypes["ProfileActivityRecordUpdateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileActivityRecordUpdateProfileEntityRelationInput"]: {
	create?:ValueTypes["ProfileWithoutActivityRecordsCreateInput"] | null,
	update?:ValueTypes["ProfileWithoutActivityRecordsUpdateInput"] | null,
	upsert?:ValueTypes["ProfileActivityRecordUpsertProfileRelationInput"] | null,
	connect?:ValueTypes["ProfileUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProfileWithoutActivityRecordsUpdateInput"]: {
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileUpdateContentEntityRelationInput"] | null,
	pins?:ValueTypes["ProfileUpdatePinsEntityRelationInput"][],
	gallery?:ValueTypes["ProfileUpdateGalleryEntityRelationInput"] | null,
	tags?:ValueTypes["ProfileUpdateTagsEntityRelationInput"][],
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileActivityRecordUpsertProfileRelationInput"]: {
	update?:ValueTypes["ProfileWithoutActivityRecordsUpdateInput"] | null,
	create?:ValueTypes["ProfileWithoutActivityRecordsCreateInput"] | null
};
	["ProfilePinUpsertActivityRecordsRelationInput"]: {
	by?:ValueTypes["ProfileActivityRecordUniqueWhere"] | null,
	update?:ValueTypes["ProfileActivityRecordWithoutPinUpdateInput"] | null,
	create?:ValueTypes["ProfileActivityRecordWithoutPinCreateInput"] | null
};
	["ProfileUpsertPinsRelationInput"]: {
	by?:ValueTypes["ProfilePinUniqueWhere"] | null,
	update?:ValueTypes["ProfilePinWithoutProfileUpdateInput"] | null,
	create?:ValueTypes["ProfilePinWithoutProfileCreateInput"] | null
};
	["ProfileTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	color?:string | null,
	profiles?:ValueTypes["ProfileTagCreateProfilesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProfileTagCreateProfilesEntityRelationInput"]: {
	connect?:ValueTypes["ProfileUniqueWhere"] | null,
	create?:ValueTypes["ProfileWithoutTagsCreateInput"] | null,
	alias?:string | null
};
	["ProfileWithoutTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileCreateContentEntityRelationInput"] | null,
	activityRecords?:ValueTypes["ProfileCreateActivityRecordsEntityRelationInput"][],
	pins?:ValueTypes["ProfileCreatePinsEntityRelationInput"][],
	gallery?:ValueTypes["ProfileCreateGalleryEntityRelationInput"] | null,
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileTagUpdateInput"]: {
	name?:string | null,
	color?:string | null,
	profiles?:ValueTypes["ProfileTagUpdateProfilesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProfileTagUpdateProfilesEntityRelationInput"]: {
	create?:ValueTypes["ProfileWithoutTagsCreateInput"] | null,
	update?:ValueTypes["ProfileTagUpdateProfilesRelationInput"] | null,
	upsert?:ValueTypes["ProfileTagUpsertProfilesRelationInput"] | null,
	connect?:ValueTypes["ProfileUniqueWhere"] | null,
	disconnect?:ValueTypes["ProfileUniqueWhere"] | null,
	delete?:ValueTypes["ProfileUniqueWhere"] | null,
	alias?:string | null
};
	["ProfileTagUpdateProfilesRelationInput"]: {
	by?:ValueTypes["ProfileUniqueWhere"] | null,
	data?:ValueTypes["ProfileWithoutTagsUpdateInput"] | null
};
	["ProfileWithoutTagsUpdateInput"]: {
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileUpdateContentEntityRelationInput"] | null,
	activityRecords?:ValueTypes["ProfileUpdateActivityRecordsEntityRelationInput"][],
	pins?:ValueTypes["ProfileUpdatePinsEntityRelationInput"][],
	gallery?:ValueTypes["ProfileUpdateGalleryEntityRelationInput"] | null,
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileTagUpsertProfilesRelationInput"]: {
	by?:ValueTypes["ProfileUniqueWhere"] | null,
	update?:ValueTypes["ProfileWithoutTagsUpdateInput"] | null,
	create?:ValueTypes["ProfileWithoutTagsCreateInput"] | null
};
	["ProfileActivityRecordCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ProfileActivityRecordType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	updatedAt?:ValueTypes["DateTime"] | null,
	metadata?:string | null,
	profile?:ValueTypes["ProfileActivityRecordCreateProfileEntityRelationInput"] | null,
	pin?:ValueTypes["ProfileActivityRecordCreatePinEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileActivityRecordUpdateInput"]: {
	type?:ValueTypes["ProfileActivityRecordType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	updatedAt?:ValueTypes["DateTime"] | null,
	metadata?:string | null,
	profile?:ValueTypes["ProfileActivityRecordUpdateProfileEntityRelationInput"] | null,
	pin?:ValueTypes["ProfileActivityRecordUpdatePinEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfilePinCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ProfilePinType"] | null,
	startsAt?:ValueTypes["DateTime"] | null,
	endsAt?:ValueTypes["DateTime"] | null,
	dismissedAt?:ValueTypes["DateTime"] | null,
	dismissedBy?:string | null,
	reason?:string | null,
	solution?:string | null,
	activityRecords?:ValueTypes["ProfilePinCreateActivityRecordsEntityRelationInput"][],
	profile?:ValueTypes["ProfilePinCreateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfilePinUpdateInput"]: {
	type?:ValueTypes["ProfilePinType"] | null,
	startsAt?:ValueTypes["DateTime"] | null,
	endsAt?:ValueTypes["DateTime"] | null,
	dismissedAt?:ValueTypes["DateTime"] | null,
	dismissedBy?:string | null,
	reason?:string | null,
	solution?:string | null,
	activityRecords?:ValueTypes["ProfilePinUpdateActivityRecordsEntityRelationInput"][],
	profile?:ValueTypes["ProfilePinUpdateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProfileGalleryEdge"],
		__typename?: true
}>;
	["ProfileGalleryEdge"]: AliasType<{
	node?:ValueTypes["ProfileGallery"],
		__typename?: true
}>;
	["ProfileGalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ProfileGalleryCreateItemsEntityRelationInput"][],
	profile?:ValueTypes["ProfileGalleryCreateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryCreateProfileEntityRelationInput"]: {
	connect?:ValueTypes["ProfileUniqueWhere"] | null,
	create?:ValueTypes["ProfileWithoutGalleryCreateInput"] | null
};
	["ProfileWithoutGalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileCreateContentEntityRelationInput"] | null,
	activityRecords?:ValueTypes["ProfileCreateActivityRecordsEntityRelationInput"][],
	pins?:ValueTypes["ProfileCreatePinsEntityRelationInput"][],
	tags?:ValueTypes["ProfileCreateTagsEntityRelationInput"][],
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryUpdateInput"]: {
	items?:ValueTypes["ProfileGalleryUpdateItemsEntityRelationInput"][],
	profile?:ValueTypes["ProfileGalleryUpdateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryUpdateProfileEntityRelationInput"]: {
	create?:ValueTypes["ProfileWithoutGalleryCreateInput"] | null,
	update?:ValueTypes["ProfileWithoutGalleryUpdateInput"] | null,
	upsert?:ValueTypes["ProfileGalleryUpsertProfileRelationInput"] | null,
	connect?:ValueTypes["ProfileUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProfileWithoutGalleryUpdateInput"]: {
	goodlokId?:string | null,
	importance?:number | null,
	name?:string | null,
	vokativ?:string | null,
	fullName?:string | null,
	aliases?:string | null,
	quickNote?:string | null,
	content?:ValueTypes["ProfileUpdateContentEntityRelationInput"] | null,
	activityRecords?:ValueTypes["ProfileUpdateActivityRecordsEntityRelationInput"][],
	pins?:ValueTypes["ProfileUpdatePinsEntityRelationInput"][],
	tags?:ValueTypes["ProfileUpdateTagsEntityRelationInput"][],
	familiarity?:ValueTypes["Familiarity"] | null,
	vipStatus?:ValueTypes["VipStatus"] | null,
	instagram?:string | null,
	facebook?:string | null,
	twitter?:string | null,
	tiktok?:string | null,
	youtube?:string | null,
	status?:ValueTypes["ProfileStatus"] | null,
	visited?:number | null,
	iosNearbyAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryUpsertProfileRelationInput"]: {
	update?:ValueTypes["ProfileWithoutGalleryUpdateInput"] | null,
	create?:ValueTypes["ProfileWithoutGalleryCreateInput"] | null
};
	["ProfileGalleryItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	caption?:string | null,
	gallery?:ValueTypes["ProfileGalleryItemCreateGalleryEntityRelationInput"] | null,
	image?:ValueTypes["ProfileGalleryItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryItemCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["ProfileGalleryUniqueWhere"] | null,
	create?:ValueTypes["ProfileGalleryWithoutItemsCreateInput"] | null
};
	["ProfileGalleryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	profile?:ValueTypes["ProfileGalleryCreateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryItemUpdateInput"]: {
	order?:number | null,
	caption?:string | null,
	gallery?:ValueTypes["ProfileGalleryItemUpdateGalleryEntityRelationInput"] | null,
	image?:ValueTypes["ProfileGalleryItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryItemUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["ProfileGalleryWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ProfileGalleryWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ProfileGalleryItemUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["ProfileGalleryUniqueWhere"] | null,
	delete?:boolean | null
};
	["ProfileGalleryWithoutItemsUpdateInput"]: {
	profile?:ValueTypes["ProfileGalleryUpdateProfileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProfileGalleryItemUpsertGalleryRelationInput"]: {
	update?:ValueTypes["ProfileGalleryWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ProfileGalleryWithoutItemsCreateInput"] | null
};
	["ShoppingList"]: AliasType<{
	_meta?:ValueTypes["ShoppingListMeta"],
	id?:true,
	title?:true,
items?: [{	filter?:ValueTypes["ShoppingListItemWhere"] | null,	orderBy?:ValueTypes["ShoppingListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShoppingListItem"]],
paginateItems?: [{	filter?:ValueTypes["ShoppingListItemWhere"] | null,	orderBy?:ValueTypes["ShoppingListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShoppingListItemConnection"]],
		__typename?: true
}>;
	["ShoppingListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ShoppingListItem"]: AliasType<{
	_meta?:ValueTypes["ShoppingListItemMeta"],
	id?:true,
	title?:true,
	dueDate?:true,
shoppingList?: [{	filter?:ValueTypes["ShoppingListWhere"] | null},ValueTypes["ShoppingList"]],
	amount?:true,
supplier?: [{	filter?:ValueTypes["SupplierWhere"] | null},ValueTypes["Supplier"]],
	status?:true,
		__typename?: true
}>;
	["ShoppingListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	dueDate?:ValueTypes["FieldMeta"],
	shoppingList?:ValueTypes["FieldMeta"],
	amount?:ValueTypes["FieldMeta"],
	supplier?:ValueTypes["FieldMeta"],
	status?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Date"]:unknown;
	["ShoppingListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	items?:ValueTypes["ShoppingListItemWhere"] | null,
	and?:(ValueTypes["ShoppingListWhere"] | undefined | null)[],
	or?:(ValueTypes["ShoppingListWhere"] | undefined | null)[],
	not?:ValueTypes["ShoppingListWhere"] | null
};
	["ShoppingListItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	dueDate?:ValueTypes["DateCondition"] | null,
	shoppingList?:ValueTypes["ShoppingListWhere"] | null,
	amount?:ValueTypes["StringCondition"] | null,
	supplier?:ValueTypes["SupplierWhere"] | null,
	status?:ValueTypes["ShoppingListItemStatusCondition"] | null,
	and?:(ValueTypes["ShoppingListItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ShoppingListItemWhere"] | undefined | null)[],
	not?:ValueTypes["ShoppingListItemWhere"] | null
};
	["DateCondition"]: {
	and?:ValueTypes["DateCondition"][],
	or?:ValueTypes["DateCondition"][],
	not?:ValueTypes["DateCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["Date"] | null,
	notEq?:ValueTypes["Date"] | null,
	in?:ValueTypes["Date"][],
	notIn?:ValueTypes["Date"][],
	lt?:ValueTypes["Date"] | null,
	lte?:ValueTypes["Date"] | null,
	gt?:ValueTypes["Date"] | null,
	gte?:ValueTypes["Date"] | null
};
	["SupplierWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	contact?:ValueTypes["StringCondition"] | null,
	shoppingListItems?:ValueTypes["ShoppingListItemWhere"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	favouriteItems?:ValueTypes["FavouriteItemWhere"] | null,
	and?:(ValueTypes["SupplierWhere"] | undefined | null)[],
	or?:(ValueTypes["SupplierWhere"] | undefined | null)[],
	not?:ValueTypes["SupplierWhere"] | null
};
	["FavouriteItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	amount?:ValueTypes["StringCondition"] | null,
	supplier?:ValueTypes["SupplierWhere"] | null,
	and?:(ValueTypes["FavouriteItemWhere"] | undefined | null)[],
	or?:(ValueTypes["FavouriteItemWhere"] | undefined | null)[],
	not?:ValueTypes["FavouriteItemWhere"] | null
};
	["ShoppingListItemStatusCondition"]: {
	and?:ValueTypes["ShoppingListItemStatusCondition"][],
	or?:ValueTypes["ShoppingListItemStatusCondition"][],
	not?:ValueTypes["ShoppingListItemStatusCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ShoppingListItemStatus"] | null,
	notEq?:ValueTypes["ShoppingListItemStatus"] | null,
	in?:ValueTypes["ShoppingListItemStatus"][],
	notIn?:ValueTypes["ShoppingListItemStatus"][],
	lt?:ValueTypes["ShoppingListItemStatus"] | null,
	lte?:ValueTypes["ShoppingListItemStatus"] | null,
	gt?:ValueTypes["ShoppingListItemStatus"] | null,
	gte?:ValueTypes["ShoppingListItemStatus"] | null
};
	["ShoppingListItemStatus"]:ShoppingListItemStatus;
	["Supplier"]: AliasType<{
	_meta?:ValueTypes["SupplierMeta"],
	id?:true,
	name?:true,
	contact?:true,
shoppingListItems?: [{	filter?:ValueTypes["ShoppingListItemWhere"] | null,	orderBy?:ValueTypes["ShoppingListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShoppingListItem"]],
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
favouriteItems?: [{	filter?:ValueTypes["FavouriteItemWhere"] | null,	orderBy?:ValueTypes["FavouriteItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FavouriteItem"]],
paginateShoppingListItems?: [{	filter?:ValueTypes["ShoppingListItemWhere"] | null,	orderBy?:ValueTypes["ShoppingListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShoppingListItemConnection"]],
paginateFavouriteItems?: [{	filter?:ValueTypes["FavouriteItemWhere"] | null,	orderBy?:ValueTypes["FavouriteItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FavouriteItemConnection"]],
		__typename?: true
}>;
	["SupplierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	contact?:ValueTypes["FieldMeta"],
	shoppingListItems?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	favouriteItems?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ShoppingListItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	dueDate?:ValueTypes["OrderDirection"] | null,
	shoppingList?:ValueTypes["ShoppingListOrderBy"] | null,
	amount?:ValueTypes["OrderDirection"] | null,
	supplier?:ValueTypes["SupplierOrderBy"] | null,
	status?:ValueTypes["OrderDirection"] | null
};
	["ShoppingListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null
};
	["SupplierOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	contact?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null
};
	["FavouriteItem"]: AliasType<{
	_meta?:ValueTypes["FavouriteItemMeta"],
	id?:true,
	title?:true,
	amount?:true,
supplier?: [{	filter?:ValueTypes["SupplierWhere"] | null},ValueTypes["Supplier"]],
		__typename?: true
}>;
	["FavouriteItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	amount?:ValueTypes["FieldMeta"],
	supplier?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FavouriteItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	amount?:ValueTypes["OrderDirection"] | null,
	supplier?:ValueTypes["SupplierOrderBy"] | null
};
	["ShoppingListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShoppingListItemEdge"],
		__typename?: true
}>;
	["ShoppingListItemEdge"]: AliasType<{
	node?:ValueTypes["ShoppingListItem"],
		__typename?: true
}>;
	["FavouriteItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FavouriteItemEdge"],
		__typename?: true
}>;
	["FavouriteItemEdge"]: AliasType<{
	node?:ValueTypes["FavouriteItem"],
		__typename?: true
}>;
	["ShoppingListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ShoppingListItemUniqueWhere"] | null
};
	["ShoppingListItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ShoppingListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShoppingListEdge"],
		__typename?: true
}>;
	["ShoppingListEdge"]: AliasType<{
	node?:ValueTypes["ShoppingList"],
		__typename?: true
}>;
	["ShoppingListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	items?:ValueTypes["ShoppingListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ShoppingListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	create?:ValueTypes["ShoppingListItemWithoutShoppingListCreateInput"] | null,
	alias?:string | null
};
	["ShoppingListItemWithoutShoppingListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	dueDate?:ValueTypes["Date"] | null,
	amount?:string | null,
	supplier?:ValueTypes["ShoppingListItemCreateSupplierEntityRelationInput"] | null,
	status?:ValueTypes["ShoppingListItemStatus"] | null,
	_dummy_field_?:boolean | null
};
	["ShoppingListItemCreateSupplierEntityRelationInput"]: {
	connect?:ValueTypes["SupplierUniqueWhere"] | null,
	create?:ValueTypes["SupplierWithoutShoppingListItemsCreateInput"] | null
};
	["SupplierUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	shoppingListItems?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	favouriteItems?:ValueTypes["FavouriteItemUniqueWhere"] | null
};
	["FavouriteItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SupplierWithoutShoppingListItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	contact?:string | null,
	logo?:ValueTypes["SupplierCreateLogoEntityRelationInput"] | null,
	favouriteItems?:ValueTypes["SupplierCreateFavouriteItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SupplierCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["SupplierCreateFavouriteItemsEntityRelationInput"]: {
	connect?:ValueTypes["FavouriteItemUniqueWhere"] | null,
	create?:ValueTypes["FavouriteItemWithoutSupplierCreateInput"] | null,
	alias?:string | null
};
	["FavouriteItemWithoutSupplierCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	amount?:string | null,
	_dummy_field_?:boolean | null
};
	["ShoppingListUpdateInput"]: {
	title?:string | null,
	items?:ValueTypes["ShoppingListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ShoppingListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ShoppingListItemWithoutShoppingListCreateInput"] | null,
	update?:ValueTypes["ShoppingListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ShoppingListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	delete?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	alias?:string | null
};
	["ShoppingListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	data?:ValueTypes["ShoppingListItemWithoutShoppingListUpdateInput"] | null
};
	["ShoppingListItemWithoutShoppingListUpdateInput"]: {
	title?:string | null,
	dueDate?:ValueTypes["Date"] | null,
	amount?:string | null,
	supplier?:ValueTypes["ShoppingListItemUpdateSupplierEntityRelationInput"] | null,
	status?:ValueTypes["ShoppingListItemStatus"] | null,
	_dummy_field_?:boolean | null
};
	["ShoppingListItemUpdateSupplierEntityRelationInput"]: {
	create?:ValueTypes["SupplierWithoutShoppingListItemsCreateInput"] | null,
	update?:ValueTypes["SupplierWithoutShoppingListItemsUpdateInput"] | null,
	upsert?:ValueTypes["ShoppingListItemUpsertSupplierRelationInput"] | null,
	connect?:ValueTypes["SupplierUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SupplierWithoutShoppingListItemsUpdateInput"]: {
	name?:string | null,
	contact?:string | null,
	logo?:ValueTypes["SupplierUpdateLogoEntityRelationInput"] | null,
	favouriteItems?:ValueTypes["SupplierUpdateFavouriteItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SupplierUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SupplierUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SupplierUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["SupplierUpdateFavouriteItemsEntityRelationInput"]: {
	create?:ValueTypes["FavouriteItemWithoutSupplierCreateInput"] | null,
	update?:ValueTypes["SupplierUpdateFavouriteItemsRelationInput"] | null,
	upsert?:ValueTypes["SupplierUpsertFavouriteItemsRelationInput"] | null,
	connect?:ValueTypes["FavouriteItemUniqueWhere"] | null,
	disconnect?:ValueTypes["FavouriteItemUniqueWhere"] | null,
	delete?:ValueTypes["FavouriteItemUniqueWhere"] | null,
	alias?:string | null
};
	["SupplierUpdateFavouriteItemsRelationInput"]: {
	by?:ValueTypes["FavouriteItemUniqueWhere"] | null,
	data?:ValueTypes["FavouriteItemWithoutSupplierUpdateInput"] | null
};
	["FavouriteItemWithoutSupplierUpdateInput"]: {
	title?:string | null,
	amount?:string | null,
	_dummy_field_?:boolean | null
};
	["SupplierUpsertFavouriteItemsRelationInput"]: {
	by?:ValueTypes["FavouriteItemUniqueWhere"] | null,
	update?:ValueTypes["FavouriteItemWithoutSupplierUpdateInput"] | null,
	create?:ValueTypes["FavouriteItemWithoutSupplierCreateInput"] | null
};
	["ShoppingListItemUpsertSupplierRelationInput"]: {
	update?:ValueTypes["SupplierWithoutShoppingListItemsUpdateInput"] | null,
	create?:ValueTypes["SupplierWithoutShoppingListItemsCreateInput"] | null
};
	["ShoppingListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	update?:ValueTypes["ShoppingListItemWithoutShoppingListUpdateInput"] | null,
	create?:ValueTypes["ShoppingListItemWithoutShoppingListCreateInput"] | null
};
	["ShoppingListItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	dueDate?:ValueTypes["Date"] | null,
	shoppingList?:ValueTypes["ShoppingListItemCreateShoppingListEntityRelationInput"] | null,
	amount?:string | null,
	supplier?:ValueTypes["ShoppingListItemCreateSupplierEntityRelationInput"] | null,
	status?:ValueTypes["ShoppingListItemStatus"] | null,
	_dummy_field_?:boolean | null
};
	["ShoppingListItemCreateShoppingListEntityRelationInput"]: {
	connect?:ValueTypes["ShoppingListUniqueWhere"] | null,
	create?:ValueTypes["ShoppingListWithoutItemsCreateInput"] | null
};
	["ShoppingListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["ShoppingListItemUpdateInput"]: {
	title?:string | null,
	dueDate?:ValueTypes["Date"] | null,
	shoppingList?:ValueTypes["ShoppingListItemUpdateShoppingListEntityRelationInput"] | null,
	amount?:string | null,
	supplier?:ValueTypes["ShoppingListItemUpdateSupplierEntityRelationInput"] | null,
	status?:ValueTypes["ShoppingListItemStatus"] | null,
	_dummy_field_?:boolean | null
};
	["ShoppingListItemUpdateShoppingListEntityRelationInput"]: {
	create?:ValueTypes["ShoppingListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ShoppingListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ShoppingListItemUpsertShoppingListRelationInput"] | null,
	connect?:ValueTypes["ShoppingListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ShoppingListWithoutItemsUpdateInput"]: {
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["ShoppingListItemUpsertShoppingListRelationInput"]: {
	update?:ValueTypes["ShoppingListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ShoppingListWithoutItemsCreateInput"] | null
};
	["SupplierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SupplierEdge"],
		__typename?: true
}>;
	["SupplierEdge"]: AliasType<{
	node?:ValueTypes["Supplier"],
		__typename?: true
}>;
	["SupplierCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	contact?:string | null,
	shoppingListItems?:ValueTypes["SupplierCreateShoppingListItemsEntityRelationInput"][],
	logo?:ValueTypes["SupplierCreateLogoEntityRelationInput"] | null,
	favouriteItems?:ValueTypes["SupplierCreateFavouriteItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SupplierCreateShoppingListItemsEntityRelationInput"]: {
	connect?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	create?:ValueTypes["ShoppingListItemWithoutSupplierCreateInput"] | null,
	alias?:string | null
};
	["ShoppingListItemWithoutSupplierCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	dueDate?:ValueTypes["Date"] | null,
	shoppingList?:ValueTypes["ShoppingListItemCreateShoppingListEntityRelationInput"] | null,
	amount?:string | null,
	status?:ValueTypes["ShoppingListItemStatus"] | null,
	_dummy_field_?:boolean | null
};
	["SupplierUpdateInput"]: {
	name?:string | null,
	contact?:string | null,
	shoppingListItems?:ValueTypes["SupplierUpdateShoppingListItemsEntityRelationInput"][],
	logo?:ValueTypes["SupplierUpdateLogoEntityRelationInput"] | null,
	favouriteItems?:ValueTypes["SupplierUpdateFavouriteItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SupplierUpdateShoppingListItemsEntityRelationInput"]: {
	create?:ValueTypes["ShoppingListItemWithoutSupplierCreateInput"] | null,
	update?:ValueTypes["SupplierUpdateShoppingListItemsRelationInput"] | null,
	upsert?:ValueTypes["SupplierUpsertShoppingListItemsRelationInput"] | null,
	connect?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	delete?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	alias?:string | null
};
	["SupplierUpdateShoppingListItemsRelationInput"]: {
	by?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	data?:ValueTypes["ShoppingListItemWithoutSupplierUpdateInput"] | null
};
	["ShoppingListItemWithoutSupplierUpdateInput"]: {
	title?:string | null,
	dueDate?:ValueTypes["Date"] | null,
	shoppingList?:ValueTypes["ShoppingListItemUpdateShoppingListEntityRelationInput"] | null,
	amount?:string | null,
	status?:ValueTypes["ShoppingListItemStatus"] | null,
	_dummy_field_?:boolean | null
};
	["SupplierUpsertShoppingListItemsRelationInput"]: {
	by?:ValueTypes["ShoppingListItemUniqueWhere"] | null,
	update?:ValueTypes["ShoppingListItemWithoutSupplierUpdateInput"] | null,
	create?:ValueTypes["ShoppingListItemWithoutSupplierCreateInput"] | null
};
	["FavouriteItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	amount?:string | null,
	supplier?:ValueTypes["FavouriteItemCreateSupplierEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FavouriteItemCreateSupplierEntityRelationInput"]: {
	connect?:ValueTypes["SupplierUniqueWhere"] | null,
	create?:ValueTypes["SupplierWithoutFavouriteItemsCreateInput"] | null
};
	["SupplierWithoutFavouriteItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	contact?:string | null,
	shoppingListItems?:ValueTypes["SupplierCreateShoppingListItemsEntityRelationInput"][],
	logo?:ValueTypes["SupplierCreateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FavouriteItemUpdateInput"]: {
	title?:string | null,
	amount?:string | null,
	supplier?:ValueTypes["FavouriteItemUpdateSupplierEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FavouriteItemUpdateSupplierEntityRelationInput"]: {
	create?:ValueTypes["SupplierWithoutFavouriteItemsCreateInput"] | null,
	update?:ValueTypes["SupplierWithoutFavouriteItemsUpdateInput"] | null,
	upsert?:ValueTypes["FavouriteItemUpsertSupplierRelationInput"] | null,
	connect?:ValueTypes["SupplierUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SupplierWithoutFavouriteItemsUpdateInput"]: {
	name?:string | null,
	contact?:string | null,
	shoppingListItems?:ValueTypes["SupplierUpdateShoppingListItemsEntityRelationInput"][],
	logo?:ValueTypes["SupplierUpdateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FavouriteItemUpsertSupplierRelationInput"]: {
	update?:ValueTypes["SupplierWithoutFavouriteItemsUpdateInput"] | null,
	create?:ValueTypes["SupplierWithoutFavouriteItemsCreateInput"] | null
};
	["BusinessOrderTypeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BusinessOrderTypeEdge"],
		__typename?: true
}>;
	["BusinessOrderTypeEdge"]: AliasType<{
	node?:ValueTypes["BusinessOrderType"],
		__typename?: true
}>;
	["BusinessOrderTypeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	locales?:ValueTypes["BusinessOrderTypeCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	create?:ValueTypes["BusinessOrderTypeLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["BusinessOrderTypeLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	locale?:ValueTypes["BusinessOrderTypeLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutBusinessOrderTypesCreateInput"] | null
};
	["LocaleWithoutBusinessOrderTypesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleCreateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleCreateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleCreateMenusEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeUpdateInput"]: {
	order?:number | null,
	locales?:ValueTypes["BusinessOrderTypeUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["BusinessOrderTypeLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["BusinessOrderTypeUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["BusinessOrderTypeUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	delete?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["BusinessOrderTypeUpdateLocalesRelationInput"]: {
	by?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	data?:ValueTypes["BusinessOrderTypeLocaleWithoutRootUpdateInput"] | null
};
	["BusinessOrderTypeLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	locale?:ValueTypes["BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutBusinessOrderTypesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutBusinessOrderTypesUpdateInput"] | null,
	upsert?:ValueTypes["BusinessOrderTypeLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutBusinessOrderTypesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	blogs?:ValueTypes["LocaleUpdateBlogsEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seos?:ValueTypes["LocaleUpdateSeosEntityRelationInput"][],
	menus?:ValueTypes["LocaleUpdateMenusEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutBusinessOrderTypesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutBusinessOrderTypesCreateInput"] | null
};
	["BusinessOrderTypeUpsertLocalesRelationInput"]: {
	by?:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"] | null,
	update?:ValueTypes["BusinessOrderTypeLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["BusinessOrderTypeLocaleWithoutRootCreateInput"] | null
};
	["BusinessOrderTypeLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["BusinessOrderTypeLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["BusinessOrderTypeLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BusinessOrderTypeLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["BusinessOrderTypeLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["QueryTransaction"]: AliasType<{
getColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	filter?:ValueTypes["ColorPalleteWhere"] | null},ValueTypes["ColorPallete"]],
listColorPallete?: [{	filter?:ValueTypes["ColorPalleteWhere"] | null,	orderBy?:ValueTypes["ColorPalleteOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ColorPallete"]],
paginateColorPallete?: [{	filter?:ValueTypes["ColorPalleteWhere"] | null,	orderBy?:ValueTypes["ColorPalleteOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ColorPalleteConnection"]],
validateCreateColorPallete?: [{	data:ValueTypes["ColorPalleteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	data:ValueTypes["ColorPalleteUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getCover?: [{	by:ValueTypes["CoverUniqueWhere"],	filter?:ValueTypes["CoverWhere"] | null},ValueTypes["Cover"]],
listCover?: [{	filter?:ValueTypes["CoverWhere"] | null,	orderBy?:ValueTypes["CoverOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Cover"]],
paginateCover?: [{	filter?:ValueTypes["CoverWhere"] | null,	orderBy?:ValueTypes["CoverOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CoverConnection"]],
validateCreateCover?: [{	data:ValueTypes["CoverCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCover?: [{	by:ValueTypes["CoverUniqueWhere"],	data:ValueTypes["CoverUpdateInput"]},ValueTypes["_ValidationResult"]],
getEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
listEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Event"]],
paginateEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventConnection"]],
validateCreateEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	data:ValueTypes["EventUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
listEventLocale?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLocale"]],
paginateEventLocale?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLocaleConnection"]],
validateCreateEventLocale?: [{	data:ValueTypes["EventLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	data:ValueTypes["EventLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
listImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	filter?:ValueTypes["ImageItemWhere"] | null},ValueTypes["ImageItem"]],
listImageItem?: [{	filter?:ValueTypes["ImageItemWhere"] | null,	orderBy?:ValueTypes["ImageItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageItem"]],
paginateImageItem?: [{	filter?:ValueTypes["ImageItemWhere"] | null,	orderBy?:ValueTypes["ImageItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageItemConnection"]],
validateCreateImageItem?: [{	data:ValueTypes["ImageItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	data:ValueTypes["ImageItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
listLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Locale"]],
paginateLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
listMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Medium"]],
paginateMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	data:ValueTypes["MediumUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
listVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	data:ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	filter?:ValueTypes["BlogWhere"] | null},ValueTypes["Blog"]],
listBlog?: [{	filter?:ValueTypes["BlogWhere"] | null,	orderBy?:ValueTypes["BlogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Blog"]],
paginateBlog?: [{	filter?:ValueTypes["BlogWhere"] | null,	orderBy?:ValueTypes["BlogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogConnection"]],
validateCreateBlog?: [{	data:ValueTypes["BlogCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	data:ValueTypes["BlogUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null},ValueTypes["BlogLocale"]],
listBlogLocale?: [{	filter?:ValueTypes["BlogLocaleWhere"] | null,	orderBy?:ValueTypes["BlogLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogLocale"]],
paginateBlogLocale?: [{	filter?:ValueTypes["BlogLocaleWhere"] | null,	orderBy?:ValueTypes["BlogLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogLocaleConnection"]],
validateCreateBlogLocale?: [{	data:ValueTypes["BlogLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	data:ValueTypes["BlogLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getPageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
listPageLocale?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PageLocale"]],
paginatePageLocale?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageLocaleConnection"]],
validateCreatePageLocale?: [{	data:ValueTypes["PageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	data:ValueTypes["PageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null},ValueTypes["SeoLocale"]],
listSeoLocale?: [{	filter?:ValueTypes["SeoLocaleWhere"] | null,	orderBy?:ValueTypes["SeoLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoLocale"]],
paginateSeoLocale?: [{	filter?:ValueTypes["SeoLocaleWhere"] | null,	orderBy?:ValueTypes["SeoLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoLocaleConnection"]],
validateCreateSeoLocale?: [{	data:ValueTypes["SeoLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	data:ValueTypes["SeoLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	filter?:ValueTypes["LocalizedSeoWhere"] | null},ValueTypes["LocalizedSeo"]],
listLocalizedSeo?: [{	filter?:ValueTypes["LocalizedSeoWhere"] | null,	orderBy?:ValueTypes["LocalizedSeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LocalizedSeo"]],
paginateLocalizedSeo?: [{	filter?:ValueTypes["LocalizedSeoWhere"] | null,	orderBy?:ValueTypes["LocalizedSeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LocalizedSeoConnection"]],
validateCreateLocalizedSeo?: [{	data:ValueTypes["LocalizedSeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	data:ValueTypes["LocalizedSeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getHero?: [{	by:ValueTypes["HeroUniqueWhere"],	filter?:ValueTypes["HeroWhere"] | null},ValueTypes["Hero"]],
listHero?: [{	filter?:ValueTypes["HeroWhere"] | null,	orderBy?:ValueTypes["HeroOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Hero"]],
paginateHero?: [{	filter?:ValueTypes["HeroWhere"] | null,	orderBy?:ValueTypes["HeroOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeroConnection"]],
validateCreateHero?: [{	data:ValueTypes["HeroCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHero?: [{	by:ValueTypes["HeroUniqueWhere"],	data:ValueTypes["HeroUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	filter?:ValueTypes["SocialsAndAppsWhere"] | null},ValueTypes["SocialsAndApps"]],
listSocialsAndApps?: [{	filter?:ValueTypes["SocialsAndAppsWhere"] | null,	orderBy?:ValueTypes["SocialsAndAppsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialsAndApps"]],
paginateSocialsAndApps?: [{	filter?:ValueTypes["SocialsAndAppsWhere"] | null,	orderBy?:ValueTypes["SocialsAndAppsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialsAndAppsConnection"]],
validateCreateSocialsAndApps?: [{	data:ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	data:ValueTypes["SocialsAndAppsUpdateInput"]},ValueTypes["_ValidationResult"]],
getSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	filter?:ValueTypes["SiteMenuWhere"] | null},ValueTypes["SiteMenu"]],
listSiteMenu?: [{	filter?:ValueTypes["SiteMenuWhere"] | null,	orderBy?:ValueTypes["SiteMenuOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SiteMenu"]],
paginateSiteMenu?: [{	filter?:ValueTypes["SiteMenuWhere"] | null,	orderBy?:ValueTypes["SiteMenuOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SiteMenuConnection"]],
validateCreateSiteMenu?: [{	data:ValueTypes["SiteMenuCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	data:ValueTypes["SiteMenuUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	filter?:ValueTypes["MenuItemWhere"] | null},ValueTypes["MenuItem"]],
listMenuItem?: [{	filter?:ValueTypes["MenuItemWhere"] | null,	orderBy?:ValueTypes["MenuItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MenuItem"]],
paginateMenuItem?: [{	filter?:ValueTypes["MenuItemWhere"] | null,	orderBy?:ValueTypes["MenuItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MenuItemConnection"]],
validateCreateMenuItem?: [{	data:ValueTypes["MenuItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	data:ValueTypes["MenuItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	filter?:ValueTypes["BlogPostListWhere"] | null},ValueTypes["BlogPostList"]],
listBlogPostList?: [{	filter?:ValueTypes["BlogPostListWhere"] | null,	orderBy?:ValueTypes["BlogPostListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostList"]],
paginateBlogPostList?: [{	filter?:ValueTypes["BlogPostListWhere"] | null,	orderBy?:ValueTypes["BlogPostListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostListConnection"]],
validateCreateBlogPostList?: [{	data:ValueTypes["BlogPostListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	data:ValueTypes["BlogPostListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	filter?:ValueTypes["BlogPostListItemWhere"] | null},ValueTypes["BlogPostListItem"]],
listBlogPostListItem?: [{	filter?:ValueTypes["BlogPostListItemWhere"] | null,	orderBy?:ValueTypes["BlogPostListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostListItem"]],
paginateBlogPostListItem?: [{	filter?:ValueTypes["BlogPostListItemWhere"] | null,	orderBy?:ValueTypes["BlogPostListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostListItemConnection"]],
validateCreateBlogPostListItem?: [{	data:ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	data:ValueTypes["BlogPostListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocale"]],
listMenuLocale?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null,	orderBy?:ValueTypes["MenuLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MenuLocale"]],
paginateMenuLocale?: [{	filter?:ValueTypes["MenuLocaleWhere"] | null,	orderBy?:ValueTypes["MenuLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MenuLocaleConnection"]],
validateCreateMenuLocale?: [{	data:ValueTypes["MenuLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	data:ValueTypes["MenuLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	filter?:ValueTypes["ProductGridWhere"] | null},ValueTypes["ProductGrid"]],
listProductGrid?: [{	filter?:ValueTypes["ProductGridWhere"] | null,	orderBy?:ValueTypes["ProductGridOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductGrid"]],
paginateProductGrid?: [{	filter?:ValueTypes["ProductGridWhere"] | null,	orderBy?:ValueTypes["ProductGridOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductGridConnection"]],
validateCreateProductGrid?: [{	data:ValueTypes["ProductGridCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	data:ValueTypes["ProductGridUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	filter?:ValueTypes["ProductGridItemWhere"] | null},ValueTypes["ProductGridItem"]],
listProductGridItem?: [{	filter?:ValueTypes["ProductGridItemWhere"] | null,	orderBy?:ValueTypes["ProductGridItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductGridItem"]],
paginateProductGridItem?: [{	filter?:ValueTypes["ProductGridItemWhere"] | null,	orderBy?:ValueTypes["ProductGridItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductGridItemConnection"]],
validateCreateProductGridItem?: [{	data:ValueTypes["ProductGridItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	data:ValueTypes["ProductGridItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	filter?:ValueTypes["ProfileWhere"] | null},ValueTypes["Profile"]],
listProfile?: [{	filter?:ValueTypes["ProfileWhere"] | null,	orderBy?:ValueTypes["ProfileOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Profile"]],
paginateProfile?: [{	filter?:ValueTypes["ProfileWhere"] | null,	orderBy?:ValueTypes["ProfileOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileConnection"]],
validateCreateProfile?: [{	data:ValueTypes["ProfileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	data:ValueTypes["ProfileUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	filter?:ValueTypes["ProfileTagWhere"] | null},ValueTypes["ProfileTag"]],
listProfileTag?: [{	filter?:ValueTypes["ProfileTagWhere"] | null,	orderBy?:ValueTypes["ProfileTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileTag"]],
paginateProfileTag?: [{	filter?:ValueTypes["ProfileTagWhere"] | null,	orderBy?:ValueTypes["ProfileTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileTagConnection"]],
validateCreateProfileTag?: [{	data:ValueTypes["ProfileTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	data:ValueTypes["ProfileTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	filter?:ValueTypes["ProfileActivityRecordWhere"] | null},ValueTypes["ProfileActivityRecord"]],
listProfileActivityRecord?: [{	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	orderBy?:ValueTypes["ProfileActivityRecordOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileActivityRecord"]],
paginateProfileActivityRecord?: [{	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	orderBy?:ValueTypes["ProfileActivityRecordOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileActivityRecordConnection"]],
validateCreateProfileActivityRecord?: [{	data:ValueTypes["ProfileActivityRecordCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	data:ValueTypes["ProfileActivityRecordUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null},ValueTypes["ProfilePin"]],
listProfilePin?: [{	filter?:ValueTypes["ProfilePinWhere"] | null,	orderBy?:ValueTypes["ProfilePinOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfilePin"]],
paginateProfilePin?: [{	filter?:ValueTypes["ProfilePinWhere"] | null,	orderBy?:ValueTypes["ProfilePinOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfilePinConnection"]],
validateCreateProfilePin?: [{	data:ValueTypes["ProfilePinCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	data:ValueTypes["ProfilePinUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	filter?:ValueTypes["ProfileGalleryWhere"] | null},ValueTypes["ProfileGallery"]],
listProfileGallery?: [{	filter?:ValueTypes["ProfileGalleryWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileGallery"]],
paginateProfileGallery?: [{	filter?:ValueTypes["ProfileGalleryWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileGalleryConnection"]],
validateCreateProfileGallery?: [{	data:ValueTypes["ProfileGalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	data:ValueTypes["ProfileGalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	filter?:ValueTypes["ProfileGalleryItemWhere"] | null},ValueTypes["ProfileGalleryItem"]],
listProfileGalleryItem?: [{	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProfileGalleryItem"]],
paginateProfileGalleryItem?: [{	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	orderBy?:ValueTypes["ProfileGalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProfileGalleryItemConnection"]],
validateCreateProfileGalleryItem?: [{	data:ValueTypes["ProfileGalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	data:ValueTypes["ProfileGalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	filter?:ValueTypes["ShoppingListWhere"] | null},ValueTypes["ShoppingList"]],
listShoppingList?: [{	filter?:ValueTypes["ShoppingListWhere"] | null,	orderBy?:ValueTypes["ShoppingListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShoppingList"]],
paginateShoppingList?: [{	filter?:ValueTypes["ShoppingListWhere"] | null,	orderBy?:ValueTypes["ShoppingListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShoppingListConnection"]],
validateCreateShoppingList?: [{	data:ValueTypes["ShoppingListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	data:ValueTypes["ShoppingListUpdateInput"]},ValueTypes["_ValidationResult"]],
getShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	filter?:ValueTypes["ShoppingListItemWhere"] | null},ValueTypes["ShoppingListItem"]],
listShoppingListItem?: [{	filter?:ValueTypes["ShoppingListItemWhere"] | null,	orderBy?:ValueTypes["ShoppingListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShoppingListItem"]],
paginateShoppingListItem?: [{	filter?:ValueTypes["ShoppingListItemWhere"] | null,	orderBy?:ValueTypes["ShoppingListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShoppingListItemConnection"]],
validateCreateShoppingListItem?: [{	data:ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	data:ValueTypes["ShoppingListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	filter?:ValueTypes["SupplierWhere"] | null},ValueTypes["Supplier"]],
listSupplier?: [{	filter?:ValueTypes["SupplierWhere"] | null,	orderBy?:ValueTypes["SupplierOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Supplier"]],
paginateSupplier?: [{	filter?:ValueTypes["SupplierWhere"] | null,	orderBy?:ValueTypes["SupplierOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SupplierConnection"]],
validateCreateSupplier?: [{	data:ValueTypes["SupplierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	data:ValueTypes["SupplierUpdateInput"]},ValueTypes["_ValidationResult"]],
getFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	filter?:ValueTypes["FavouriteItemWhere"] | null},ValueTypes["FavouriteItem"]],
listFavouriteItem?: [{	filter?:ValueTypes["FavouriteItemWhere"] | null,	orderBy?:ValueTypes["FavouriteItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FavouriteItem"]],
paginateFavouriteItem?: [{	filter?:ValueTypes["FavouriteItemWhere"] | null,	orderBy?:ValueTypes["FavouriteItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FavouriteItemConnection"]],
validateCreateFavouriteItem?: [{	data:ValueTypes["FavouriteItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	data:ValueTypes["FavouriteItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeWhere"] | null},ValueTypes["BusinessOrderType"]],
listBusinessOrderType?: [{	filter?:ValueTypes["BusinessOrderTypeWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BusinessOrderType"]],
paginateBusinessOrderType?: [{	filter?:ValueTypes["BusinessOrderTypeWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BusinessOrderTypeConnection"]],
validateCreateBusinessOrderType?: [{	data:ValueTypes["BusinessOrderTypeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	data:ValueTypes["BusinessOrderTypeUpdateInput"]},ValueTypes["_ValidationResult"]],
getBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null},ValueTypes["BusinessOrderTypeLocale"]],
listBusinessOrderTypeLocale?: [{	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BusinessOrderTypeLocale"]],
paginateBusinessOrderTypeLocale?: [{	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	orderBy?:ValueTypes["BusinessOrderTypeLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BusinessOrderTypeLocaleConnection"]],
validateCreateBusinessOrderTypeLocale?: [{	data:ValueTypes["BusinessOrderTypeLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	data:ValueTypes["BusinessOrderTypeLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: true
}>;
	["Info"]: AliasType<{
	description?:true,
		__typename?: true
}>;
	["Mutation"]: AliasType<{
createColorPallete?: [{	data:ValueTypes["ColorPalleteCreateInput"]},ValueTypes["ColorPalleteCreateResult"]],
deleteColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	filter?:ValueTypes["ColorPalleteWhere"] | null},ValueTypes["ColorPalleteDeleteResult"]],
updateColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	filter?:ValueTypes["ColorPalleteWhere"] | null,	data:ValueTypes["ColorPalleteUpdateInput"]},ValueTypes["ColorPalleteUpdateResult"]],
upsertColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	filter?:ValueTypes["ColorPalleteWhere"] | null,	update:ValueTypes["ColorPalleteUpdateInput"],	create:ValueTypes["ColorPalleteCreateInput"]},ValueTypes["ColorPalleteUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createCover?: [{	data:ValueTypes["CoverCreateInput"]},ValueTypes["CoverCreateResult"]],
deleteCover?: [{	by:ValueTypes["CoverUniqueWhere"],	filter?:ValueTypes["CoverWhere"] | null},ValueTypes["CoverDeleteResult"]],
updateCover?: [{	by:ValueTypes["CoverUniqueWhere"],	filter?:ValueTypes["CoverWhere"] | null,	data:ValueTypes["CoverUpdateInput"]},ValueTypes["CoverUpdateResult"]],
upsertCover?: [{	by:ValueTypes["CoverUniqueWhere"],	filter?:ValueTypes["CoverWhere"] | null,	update:ValueTypes["CoverUpdateInput"],	create:ValueTypes["CoverCreateInput"]},ValueTypes["CoverUpsertResult"]],
createEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["EventCreateResult"]],
deleteEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["EventDeleteResult"]],
updateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	data:ValueTypes["EventUpdateInput"]},ValueTypes["EventUpdateResult"]],
upsertEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	update:ValueTypes["EventUpdateInput"],	create:ValueTypes["EventCreateInput"]},ValueTypes["EventUpsertResult"]],
createEventLocale?: [{	data:ValueTypes["EventLocaleCreateInput"]},ValueTypes["EventLocaleCreateResult"]],
deleteEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocaleDeleteResult"]],
updateEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null,	data:ValueTypes["EventLocaleUpdateInput"]},ValueTypes["EventLocaleUpdateResult"]],
upsertEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null,	update:ValueTypes["EventLocaleUpdateInput"],	create:ValueTypes["EventLocaleCreateInput"]},ValueTypes["EventLocaleUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	update:ValueTypes["ImageListUpdateInput"],	create:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListUpsertResult"]],
createImageItem?: [{	data:ValueTypes["ImageItemCreateInput"]},ValueTypes["ImageItemCreateResult"]],
deleteImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	filter?:ValueTypes["ImageItemWhere"] | null},ValueTypes["ImageItemDeleteResult"]],
updateImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	filter?:ValueTypes["ImageItemWhere"] | null,	data:ValueTypes["ImageItemUpdateInput"]},ValueTypes["ImageItemUpdateResult"]],
upsertImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	filter?:ValueTypes["ImageItemWhere"] | null,	update:ValueTypes["ImageItemUpdateInput"],	create:ValueTypes["ImageItemCreateInput"]},ValueTypes["ImageItemUpsertResult"]],
createLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	update:ValueTypes["LocaleUpdateInput"],	create:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleUpsertResult"]],
createMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	data:ValueTypes["MediumUpdateInput"]},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	update:ValueTypes["MediumUpdateInput"],	create:ValueTypes["MediumCreateInput"]},ValueTypes["MediumUpsertResult"]],
createVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	data:ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	update:ValueTypes["VideoUpdateInput"],	create:ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createBlog?: [{	data:ValueTypes["BlogCreateInput"]},ValueTypes["BlogCreateResult"]],
deleteBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	filter?:ValueTypes["BlogWhere"] | null},ValueTypes["BlogDeleteResult"]],
updateBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	filter?:ValueTypes["BlogWhere"] | null,	data:ValueTypes["BlogUpdateInput"]},ValueTypes["BlogUpdateResult"]],
upsertBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	filter?:ValueTypes["BlogWhere"] | null,	update:ValueTypes["BlogUpdateInput"],	create:ValueTypes["BlogCreateInput"]},ValueTypes["BlogUpsertResult"]],
createBlogLocale?: [{	data:ValueTypes["BlogLocaleCreateInput"]},ValueTypes["BlogLocaleCreateResult"]],
deleteBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null},ValueTypes["BlogLocaleDeleteResult"]],
updateBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null,	data:ValueTypes["BlogLocaleUpdateInput"]},ValueTypes["BlogLocaleUpdateResult"]],
upsertBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null,	update:ValueTypes["BlogLocaleUpdateInput"],	create:ValueTypes["BlogLocaleCreateInput"]},ValueTypes["BlogLocaleUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createPageLocale?: [{	data:ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleCreateResult"]],
deletePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocaleDeleteResult"]],
updatePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null,	data:ValueTypes["PageLocaleUpdateInput"]},ValueTypes["PageLocaleUpdateResult"]],
upsertPageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null,	update:ValueTypes["PageLocaleUpdateInput"],	create:ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createSeoLocale?: [{	data:ValueTypes["SeoLocaleCreateInput"]},ValueTypes["SeoLocaleCreateResult"]],
deleteSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null},ValueTypes["SeoLocaleDeleteResult"]],
updateSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null,	data:ValueTypes["SeoLocaleUpdateInput"]},ValueTypes["SeoLocaleUpdateResult"]],
upsertSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null,	update:ValueTypes["SeoLocaleUpdateInput"],	create:ValueTypes["SeoLocaleCreateInput"]},ValueTypes["SeoLocaleUpsertResult"]],
createLocalizedSeo?: [{	data:ValueTypes["LocalizedSeoCreateInput"]},ValueTypes["LocalizedSeoCreateResult"]],
deleteLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	filter?:ValueTypes["LocalizedSeoWhere"] | null},ValueTypes["LocalizedSeoDeleteResult"]],
updateLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	filter?:ValueTypes["LocalizedSeoWhere"] | null,	data:ValueTypes["LocalizedSeoUpdateInput"]},ValueTypes["LocalizedSeoUpdateResult"]],
upsertLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	filter?:ValueTypes["LocalizedSeoWhere"] | null,	update:ValueTypes["LocalizedSeoUpdateInput"],	create:ValueTypes["LocalizedSeoCreateInput"]},ValueTypes["LocalizedSeoUpsertResult"]],
createHero?: [{	data:ValueTypes["HeroCreateInput"]},ValueTypes["HeroCreateResult"]],
deleteHero?: [{	by:ValueTypes["HeroUniqueWhere"],	filter?:ValueTypes["HeroWhere"] | null},ValueTypes["HeroDeleteResult"]],
updateHero?: [{	by:ValueTypes["HeroUniqueWhere"],	filter?:ValueTypes["HeroWhere"] | null,	data:ValueTypes["HeroUpdateInput"]},ValueTypes["HeroUpdateResult"]],
upsertHero?: [{	by:ValueTypes["HeroUniqueWhere"],	filter?:ValueTypes["HeroWhere"] | null,	update:ValueTypes["HeroUpdateInput"],	create:ValueTypes["HeroCreateInput"]},ValueTypes["HeroUpsertResult"]],
createGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	update:ValueTypes["GalleryUpdateInput"],	create:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	update:ValueTypes["GalleryItemUpdateInput"],	create:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createSocialsAndApps?: [{	data:ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["SocialsAndAppsCreateResult"]],
deleteSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	filter?:ValueTypes["SocialsAndAppsWhere"] | null},ValueTypes["SocialsAndAppsDeleteResult"]],
updateSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	filter?:ValueTypes["SocialsAndAppsWhere"] | null,	data:ValueTypes["SocialsAndAppsUpdateInput"]},ValueTypes["SocialsAndAppsUpdateResult"]],
upsertSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	filter?:ValueTypes["SocialsAndAppsWhere"] | null,	update:ValueTypes["SocialsAndAppsUpdateInput"],	create:ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["SocialsAndAppsUpsertResult"]],
createSiteMenu?: [{	data:ValueTypes["SiteMenuCreateInput"]},ValueTypes["SiteMenuCreateResult"]],
deleteSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	filter?:ValueTypes["SiteMenuWhere"] | null},ValueTypes["SiteMenuDeleteResult"]],
updateSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	filter?:ValueTypes["SiteMenuWhere"] | null,	data:ValueTypes["SiteMenuUpdateInput"]},ValueTypes["SiteMenuUpdateResult"]],
upsertSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	filter?:ValueTypes["SiteMenuWhere"] | null,	update:ValueTypes["SiteMenuUpdateInput"],	create:ValueTypes["SiteMenuCreateInput"]},ValueTypes["SiteMenuUpsertResult"]],
createMenuItem?: [{	data:ValueTypes["MenuItemCreateInput"]},ValueTypes["MenuItemCreateResult"]],
deleteMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	filter?:ValueTypes["MenuItemWhere"] | null},ValueTypes["MenuItemDeleteResult"]],
updateMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	filter?:ValueTypes["MenuItemWhere"] | null,	data:ValueTypes["MenuItemUpdateInput"]},ValueTypes["MenuItemUpdateResult"]],
upsertMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	filter?:ValueTypes["MenuItemWhere"] | null,	update:ValueTypes["MenuItemUpdateInput"],	create:ValueTypes["MenuItemCreateInput"]},ValueTypes["MenuItemUpsertResult"]],
createBlogPostList?: [{	data:ValueTypes["BlogPostListCreateInput"]},ValueTypes["BlogPostListCreateResult"]],
deleteBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	filter?:ValueTypes["BlogPostListWhere"] | null},ValueTypes["BlogPostListDeleteResult"]],
updateBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	filter?:ValueTypes["BlogPostListWhere"] | null,	data:ValueTypes["BlogPostListUpdateInput"]},ValueTypes["BlogPostListUpdateResult"]],
upsertBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	filter?:ValueTypes["BlogPostListWhere"] | null,	update:ValueTypes["BlogPostListUpdateInput"],	create:ValueTypes["BlogPostListCreateInput"]},ValueTypes["BlogPostListUpsertResult"]],
createBlogPostListItem?: [{	data:ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["BlogPostListItemCreateResult"]],
deleteBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	filter?:ValueTypes["BlogPostListItemWhere"] | null},ValueTypes["BlogPostListItemDeleteResult"]],
updateBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	filter?:ValueTypes["BlogPostListItemWhere"] | null,	data:ValueTypes["BlogPostListItemUpdateInput"]},ValueTypes["BlogPostListItemUpdateResult"]],
upsertBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	filter?:ValueTypes["BlogPostListItemWhere"] | null,	update:ValueTypes["BlogPostListItemUpdateInput"],	create:ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["BlogPostListItemUpsertResult"]],
createMenuLocale?: [{	data:ValueTypes["MenuLocaleCreateInput"]},ValueTypes["MenuLocaleCreateResult"]],
deleteMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocaleDeleteResult"]],
updateMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null,	data:ValueTypes["MenuLocaleUpdateInput"]},ValueTypes["MenuLocaleUpdateResult"]],
upsertMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null,	update:ValueTypes["MenuLocaleUpdateInput"],	create:ValueTypes["MenuLocaleCreateInput"]},ValueTypes["MenuLocaleUpsertResult"]],
createProductGrid?: [{	data:ValueTypes["ProductGridCreateInput"]},ValueTypes["ProductGridCreateResult"]],
deleteProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	filter?:ValueTypes["ProductGridWhere"] | null},ValueTypes["ProductGridDeleteResult"]],
updateProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	filter?:ValueTypes["ProductGridWhere"] | null,	data:ValueTypes["ProductGridUpdateInput"]},ValueTypes["ProductGridUpdateResult"]],
upsertProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	filter?:ValueTypes["ProductGridWhere"] | null,	update:ValueTypes["ProductGridUpdateInput"],	create:ValueTypes["ProductGridCreateInput"]},ValueTypes["ProductGridUpsertResult"]],
createProductGridItem?: [{	data:ValueTypes["ProductGridItemCreateInput"]},ValueTypes["ProductGridItemCreateResult"]],
deleteProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	filter?:ValueTypes["ProductGridItemWhere"] | null},ValueTypes["ProductGridItemDeleteResult"]],
updateProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	filter?:ValueTypes["ProductGridItemWhere"] | null,	data:ValueTypes["ProductGridItemUpdateInput"]},ValueTypes["ProductGridItemUpdateResult"]],
upsertProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	filter?:ValueTypes["ProductGridItemWhere"] | null,	update:ValueTypes["ProductGridItemUpdateInput"],	create:ValueTypes["ProductGridItemCreateInput"]},ValueTypes["ProductGridItemUpsertResult"]],
createProfile?: [{	data:ValueTypes["ProfileCreateInput"]},ValueTypes["ProfileCreateResult"]],
deleteProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	filter?:ValueTypes["ProfileWhere"] | null},ValueTypes["ProfileDeleteResult"]],
updateProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	filter?:ValueTypes["ProfileWhere"] | null,	data:ValueTypes["ProfileUpdateInput"]},ValueTypes["ProfileUpdateResult"]],
upsertProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	filter?:ValueTypes["ProfileWhere"] | null,	update:ValueTypes["ProfileUpdateInput"],	create:ValueTypes["ProfileCreateInput"]},ValueTypes["ProfileUpsertResult"]],
createProfileTag?: [{	data:ValueTypes["ProfileTagCreateInput"]},ValueTypes["ProfileTagCreateResult"]],
deleteProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	filter?:ValueTypes["ProfileTagWhere"] | null},ValueTypes["ProfileTagDeleteResult"]],
updateProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	filter?:ValueTypes["ProfileTagWhere"] | null,	data:ValueTypes["ProfileTagUpdateInput"]},ValueTypes["ProfileTagUpdateResult"]],
upsertProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	filter?:ValueTypes["ProfileTagWhere"] | null,	update:ValueTypes["ProfileTagUpdateInput"],	create:ValueTypes["ProfileTagCreateInput"]},ValueTypes["ProfileTagUpsertResult"]],
createProfileActivityRecord?: [{	data:ValueTypes["ProfileActivityRecordCreateInput"]},ValueTypes["ProfileActivityRecordCreateResult"]],
deleteProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	filter?:ValueTypes["ProfileActivityRecordWhere"] | null},ValueTypes["ProfileActivityRecordDeleteResult"]],
updateProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	data:ValueTypes["ProfileActivityRecordUpdateInput"]},ValueTypes["ProfileActivityRecordUpdateResult"]],
upsertProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	update:ValueTypes["ProfileActivityRecordUpdateInput"],	create:ValueTypes["ProfileActivityRecordCreateInput"]},ValueTypes["ProfileActivityRecordUpsertResult"]],
createProfilePin?: [{	data:ValueTypes["ProfilePinCreateInput"]},ValueTypes["ProfilePinCreateResult"]],
deleteProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null},ValueTypes["ProfilePinDeleteResult"]],
updateProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null,	data:ValueTypes["ProfilePinUpdateInput"]},ValueTypes["ProfilePinUpdateResult"]],
upsertProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null,	update:ValueTypes["ProfilePinUpdateInput"],	create:ValueTypes["ProfilePinCreateInput"]},ValueTypes["ProfilePinUpsertResult"]],
createProfileGallery?: [{	data:ValueTypes["ProfileGalleryCreateInput"]},ValueTypes["ProfileGalleryCreateResult"]],
deleteProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	filter?:ValueTypes["ProfileGalleryWhere"] | null},ValueTypes["ProfileGalleryDeleteResult"]],
updateProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	filter?:ValueTypes["ProfileGalleryWhere"] | null,	data:ValueTypes["ProfileGalleryUpdateInput"]},ValueTypes["ProfileGalleryUpdateResult"]],
upsertProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	filter?:ValueTypes["ProfileGalleryWhere"] | null,	update:ValueTypes["ProfileGalleryUpdateInput"],	create:ValueTypes["ProfileGalleryCreateInput"]},ValueTypes["ProfileGalleryUpsertResult"]],
createProfileGalleryItem?: [{	data:ValueTypes["ProfileGalleryItemCreateInput"]},ValueTypes["ProfileGalleryItemCreateResult"]],
deleteProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	filter?:ValueTypes["ProfileGalleryItemWhere"] | null},ValueTypes["ProfileGalleryItemDeleteResult"]],
updateProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	data:ValueTypes["ProfileGalleryItemUpdateInput"]},ValueTypes["ProfileGalleryItemUpdateResult"]],
upsertProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	update:ValueTypes["ProfileGalleryItemUpdateInput"],	create:ValueTypes["ProfileGalleryItemCreateInput"]},ValueTypes["ProfileGalleryItemUpsertResult"]],
createShoppingList?: [{	data:ValueTypes["ShoppingListCreateInput"]},ValueTypes["ShoppingListCreateResult"]],
deleteShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	filter?:ValueTypes["ShoppingListWhere"] | null},ValueTypes["ShoppingListDeleteResult"]],
updateShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	filter?:ValueTypes["ShoppingListWhere"] | null,	data:ValueTypes["ShoppingListUpdateInput"]},ValueTypes["ShoppingListUpdateResult"]],
upsertShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	filter?:ValueTypes["ShoppingListWhere"] | null,	update:ValueTypes["ShoppingListUpdateInput"],	create:ValueTypes["ShoppingListCreateInput"]},ValueTypes["ShoppingListUpsertResult"]],
createShoppingListItem?: [{	data:ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["ShoppingListItemCreateResult"]],
deleteShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	filter?:ValueTypes["ShoppingListItemWhere"] | null},ValueTypes["ShoppingListItemDeleteResult"]],
updateShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	filter?:ValueTypes["ShoppingListItemWhere"] | null,	data:ValueTypes["ShoppingListItemUpdateInput"]},ValueTypes["ShoppingListItemUpdateResult"]],
upsertShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	filter?:ValueTypes["ShoppingListItemWhere"] | null,	update:ValueTypes["ShoppingListItemUpdateInput"],	create:ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["ShoppingListItemUpsertResult"]],
createSupplier?: [{	data:ValueTypes["SupplierCreateInput"]},ValueTypes["SupplierCreateResult"]],
deleteSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	filter?:ValueTypes["SupplierWhere"] | null},ValueTypes["SupplierDeleteResult"]],
updateSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	filter?:ValueTypes["SupplierWhere"] | null,	data:ValueTypes["SupplierUpdateInput"]},ValueTypes["SupplierUpdateResult"]],
upsertSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	filter?:ValueTypes["SupplierWhere"] | null,	update:ValueTypes["SupplierUpdateInput"],	create:ValueTypes["SupplierCreateInput"]},ValueTypes["SupplierUpsertResult"]],
createFavouriteItem?: [{	data:ValueTypes["FavouriteItemCreateInput"]},ValueTypes["FavouriteItemCreateResult"]],
deleteFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	filter?:ValueTypes["FavouriteItemWhere"] | null},ValueTypes["FavouriteItemDeleteResult"]],
updateFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	filter?:ValueTypes["FavouriteItemWhere"] | null,	data:ValueTypes["FavouriteItemUpdateInput"]},ValueTypes["FavouriteItemUpdateResult"]],
upsertFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	filter?:ValueTypes["FavouriteItemWhere"] | null,	update:ValueTypes["FavouriteItemUpdateInput"],	create:ValueTypes["FavouriteItemCreateInput"]},ValueTypes["FavouriteItemUpsertResult"]],
createBusinessOrderType?: [{	data:ValueTypes["BusinessOrderTypeCreateInput"]},ValueTypes["BusinessOrderTypeCreateResult"]],
deleteBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeWhere"] | null},ValueTypes["BusinessOrderTypeDeleteResult"]],
updateBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeWhere"] | null,	data:ValueTypes["BusinessOrderTypeUpdateInput"]},ValueTypes["BusinessOrderTypeUpdateResult"]],
upsertBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeWhere"] | null,	update:ValueTypes["BusinessOrderTypeUpdateInput"],	create:ValueTypes["BusinessOrderTypeCreateInput"]},ValueTypes["BusinessOrderTypeUpsertResult"]],
createBusinessOrderTypeLocale?: [{	data:ValueTypes["BusinessOrderTypeLocaleCreateInput"]},ValueTypes["BusinessOrderTypeLocaleCreateResult"]],
deleteBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null},ValueTypes["BusinessOrderTypeLocaleDeleteResult"]],
updateBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	data:ValueTypes["BusinessOrderTypeLocaleUpdateInput"]},ValueTypes["BusinessOrderTypeLocaleUpdateResult"]],
upsertBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	update:ValueTypes["BusinessOrderTypeLocaleUpdateInput"],	create:ValueTypes["BusinessOrderTypeLocaleCreateInput"]},ValueTypes["BusinessOrderTypeLocaleUpsertResult"]],
	transaction?:ValueTypes["MutationTransaction"],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType:string,	expiration?:number | null,	prefix?:string | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
		__typename?: true
}>;
	["ColorPalleteCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ColorPallete"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationResult"]:AliasType<{
		ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"];
		['...on ColorPalleteCreateResult']?: Omit<ValueTypes["ColorPalleteCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorPalleteDeleteResult']?: Omit<ValueTypes["ColorPalleteDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorPalleteUpdateResult']?: Omit<ValueTypes["ColorPalleteUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorPalleteUpsertResult']?: Omit<ValueTypes["ColorPalleteUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CoverCreateResult']?: Omit<ValueTypes["CoverCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CoverDeleteResult']?: Omit<ValueTypes["CoverDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CoverUpdateResult']?: Omit<ValueTypes["CoverUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CoverUpsertResult']?: Omit<ValueTypes["CoverUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventCreateResult']?: Omit<ValueTypes["EventCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventDeleteResult']?: Omit<ValueTypes["EventDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventUpdateResult']?: Omit<ValueTypes["EventUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventUpsertResult']?: Omit<ValueTypes["EventUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLocaleCreateResult']?: Omit<ValueTypes["EventLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLocaleDeleteResult']?: Omit<ValueTypes["EventLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLocaleUpdateResult']?: Omit<ValueTypes["EventLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLocaleUpsertResult']?: Omit<ValueTypes["EventLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListCreateResult']?: Omit<ValueTypes["ImageListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListDeleteResult']?: Omit<ValueTypes["ImageListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpdateResult']?: Omit<ValueTypes["ImageListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpsertResult']?: Omit<ValueTypes["ImageListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageItemCreateResult']?: Omit<ValueTypes["ImageItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageItemDeleteResult']?: Omit<ValueTypes["ImageItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageItemUpdateResult']?: Omit<ValueTypes["ImageItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageItemUpsertResult']?: Omit<ValueTypes["ImageItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleCreateResult']?: Omit<ValueTypes["LocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleDeleteResult']?: Omit<ValueTypes["LocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpdateResult']?: Omit<ValueTypes["LocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpsertResult']?: Omit<ValueTypes["LocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumCreateResult']?: Omit<ValueTypes["MediumCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumDeleteResult']?: Omit<ValueTypes["MediumDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpdateResult']?: Omit<ValueTypes["MediumUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpsertResult']?: Omit<ValueTypes["MediumUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ValueTypes["VideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ValueTypes["VideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ValueTypes["VideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ValueTypes["VideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogCreateResult']?: Omit<ValueTypes["BlogCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogDeleteResult']?: Omit<ValueTypes["BlogDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogUpdateResult']?: Omit<ValueTypes["BlogUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogUpsertResult']?: Omit<ValueTypes["BlogUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogLocaleCreateResult']?: Omit<ValueTypes["BlogLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogLocaleDeleteResult']?: Omit<ValueTypes["BlogLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogLocaleUpdateResult']?: Omit<ValueTypes["BlogLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogLocaleUpsertResult']?: Omit<ValueTypes["BlogLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageCreateResult']?: Omit<ValueTypes["PageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageDeleteResult']?: Omit<ValueTypes["PageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpdateResult']?: Omit<ValueTypes["PageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpsertResult']?: Omit<ValueTypes["PageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleCreateResult']?: Omit<ValueTypes["PageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleDeleteResult']?: Omit<ValueTypes["PageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleUpdateResult']?: Omit<ValueTypes["PageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleUpsertResult']?: Omit<ValueTypes["PageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoLocaleCreateResult']?: Omit<ValueTypes["SeoLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoLocaleDeleteResult']?: Omit<ValueTypes["SeoLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoLocaleUpdateResult']?: Omit<ValueTypes["SeoLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoLocaleUpsertResult']?: Omit<ValueTypes["SeoLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocalizedSeoCreateResult']?: Omit<ValueTypes["LocalizedSeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocalizedSeoDeleteResult']?: Omit<ValueTypes["LocalizedSeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocalizedSeoUpdateResult']?: Omit<ValueTypes["LocalizedSeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocalizedSeoUpsertResult']?: Omit<ValueTypes["LocalizedSeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroCreateResult']?: Omit<ValueTypes["HeroCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroDeleteResult']?: Omit<ValueTypes["HeroDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroUpdateResult']?: Omit<ValueTypes["HeroUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeroUpsertResult']?: Omit<ValueTypes["HeroUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryCreateResult']?: Omit<ValueTypes["GalleryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryDeleteResult']?: Omit<ValueTypes["GalleryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpdateResult']?: Omit<ValueTypes["GalleryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpsertResult']?: Omit<ValueTypes["GalleryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemCreateResult']?: Omit<ValueTypes["GalleryItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemDeleteResult']?: Omit<ValueTypes["GalleryItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpdateResult']?: Omit<ValueTypes["GalleryItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpsertResult']?: Omit<ValueTypes["GalleryItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialsAndAppsCreateResult']?: Omit<ValueTypes["SocialsAndAppsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialsAndAppsDeleteResult']?: Omit<ValueTypes["SocialsAndAppsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialsAndAppsUpdateResult']?: Omit<ValueTypes["SocialsAndAppsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialsAndAppsUpsertResult']?: Omit<ValueTypes["SocialsAndAppsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteMenuCreateResult']?: Omit<ValueTypes["SiteMenuCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteMenuDeleteResult']?: Omit<ValueTypes["SiteMenuDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteMenuUpdateResult']?: Omit<ValueTypes["SiteMenuUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteMenuUpsertResult']?: Omit<ValueTypes["SiteMenuUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuItemCreateResult']?: Omit<ValueTypes["MenuItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuItemDeleteResult']?: Omit<ValueTypes["MenuItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuItemUpdateResult']?: Omit<ValueTypes["MenuItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuItemUpsertResult']?: Omit<ValueTypes["MenuItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListCreateResult']?: Omit<ValueTypes["BlogPostListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListDeleteResult']?: Omit<ValueTypes["BlogPostListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListUpdateResult']?: Omit<ValueTypes["BlogPostListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListUpsertResult']?: Omit<ValueTypes["BlogPostListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListItemCreateResult']?: Omit<ValueTypes["BlogPostListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListItemDeleteResult']?: Omit<ValueTypes["BlogPostListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListItemUpdateResult']?: Omit<ValueTypes["BlogPostListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostListItemUpsertResult']?: Omit<ValueTypes["BlogPostListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLocaleCreateResult']?: Omit<ValueTypes["MenuLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLocaleDeleteResult']?: Omit<ValueTypes["MenuLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLocaleUpdateResult']?: Omit<ValueTypes["MenuLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MenuLocaleUpsertResult']?: Omit<ValueTypes["MenuLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridCreateResult']?: Omit<ValueTypes["ProductGridCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridDeleteResult']?: Omit<ValueTypes["ProductGridDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridUpdateResult']?: Omit<ValueTypes["ProductGridUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridUpsertResult']?: Omit<ValueTypes["ProductGridUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridItemCreateResult']?: Omit<ValueTypes["ProductGridItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridItemDeleteResult']?: Omit<ValueTypes["ProductGridItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridItemUpdateResult']?: Omit<ValueTypes["ProductGridItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductGridItemUpsertResult']?: Omit<ValueTypes["ProductGridItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileCreateResult']?: Omit<ValueTypes["ProfileCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileDeleteResult']?: Omit<ValueTypes["ProfileDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileUpdateResult']?: Omit<ValueTypes["ProfileUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileUpsertResult']?: Omit<ValueTypes["ProfileUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileTagCreateResult']?: Omit<ValueTypes["ProfileTagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileTagDeleteResult']?: Omit<ValueTypes["ProfileTagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileTagUpdateResult']?: Omit<ValueTypes["ProfileTagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileTagUpsertResult']?: Omit<ValueTypes["ProfileTagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileActivityRecordCreateResult']?: Omit<ValueTypes["ProfileActivityRecordCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileActivityRecordDeleteResult']?: Omit<ValueTypes["ProfileActivityRecordDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileActivityRecordUpdateResult']?: Omit<ValueTypes["ProfileActivityRecordUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileActivityRecordUpsertResult']?: Omit<ValueTypes["ProfileActivityRecordUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfilePinCreateResult']?: Omit<ValueTypes["ProfilePinCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfilePinDeleteResult']?: Omit<ValueTypes["ProfilePinDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfilePinUpdateResult']?: Omit<ValueTypes["ProfilePinUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfilePinUpsertResult']?: Omit<ValueTypes["ProfilePinUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileGalleryCreateResult']?: Omit<ValueTypes["ProfileGalleryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileGalleryDeleteResult']?: Omit<ValueTypes["ProfileGalleryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileGalleryUpdateResult']?: Omit<ValueTypes["ProfileGalleryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileGalleryUpsertResult']?: Omit<ValueTypes["ProfileGalleryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileGalleryItemCreateResult']?: Omit<ValueTypes["ProfileGalleryItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileGalleryItemDeleteResult']?: Omit<ValueTypes["ProfileGalleryItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileGalleryItemUpdateResult']?: Omit<ValueTypes["ProfileGalleryItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProfileGalleryItemUpsertResult']?: Omit<ValueTypes["ProfileGalleryItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListCreateResult']?: Omit<ValueTypes["ShoppingListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListDeleteResult']?: Omit<ValueTypes["ShoppingListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListUpdateResult']?: Omit<ValueTypes["ShoppingListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListUpsertResult']?: Omit<ValueTypes["ShoppingListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListItemCreateResult']?: Omit<ValueTypes["ShoppingListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListItemDeleteResult']?: Omit<ValueTypes["ShoppingListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListItemUpdateResult']?: Omit<ValueTypes["ShoppingListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShoppingListItemUpsertResult']?: Omit<ValueTypes["ShoppingListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SupplierCreateResult']?: Omit<ValueTypes["SupplierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SupplierDeleteResult']?: Omit<ValueTypes["SupplierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SupplierUpdateResult']?: Omit<ValueTypes["SupplierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SupplierUpsertResult']?: Omit<ValueTypes["SupplierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FavouriteItemCreateResult']?: Omit<ValueTypes["FavouriteItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FavouriteItemDeleteResult']?: Omit<ValueTypes["FavouriteItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FavouriteItemUpdateResult']?: Omit<ValueTypes["FavouriteItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FavouriteItemUpsertResult']?: Omit<ValueTypes["FavouriteItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessOrderTypeCreateResult']?: Omit<ValueTypes["BusinessOrderTypeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessOrderTypeDeleteResult']?: Omit<ValueTypes["BusinessOrderTypeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessOrderTypeUpdateResult']?: Omit<ValueTypes["BusinessOrderTypeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessOrderTypeUpsertResult']?: Omit<ValueTypes["BusinessOrderTypeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessOrderTypeLocaleCreateResult']?: Omit<ValueTypes["BusinessOrderTypeLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessOrderTypeLocaleDeleteResult']?: Omit<ValueTypes["BusinessOrderTypeLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessOrderTypeLocaleUpdateResult']?: Omit<ValueTypes["BusinessOrderTypeLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BusinessOrderTypeLocaleUpsertResult']?: Omit<ValueTypes["BusinessOrderTypeLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: true
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:true,
	message?:true,
		__typename?: true
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["ColorPalleteDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ColorPallete"],
		__typename?: true
}>;
	["ColorPalleteUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ColorPallete"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ColorPalleteUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ColorPallete"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CoverCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CoverDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cover"],
		__typename?: true
}>;
	["CoverUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CoverUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Cover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
		__typename?: true
}>;
	["EventUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLocale"],
		__typename?: true
}>;
	["EventLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
		__typename?: true
}>;
	["ImageListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageItem"],
		__typename?: true
}>;
	["ImageItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
		__typename?: true
}>;
	["LocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
		__typename?: true
}>;
	["MediumUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
		__typename?: true
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Blog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Blog"],
		__typename?: true
}>;
	["BlogUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Blog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Blog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogLocale"],
		__typename?: true
}>;
	["BlogLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
		__typename?: true
}>;
	["PageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
		__typename?: true
}>;
	["PageLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoLocale"],
		__typename?: true
}>;
	["SeoLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocalizedSeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LocalizedSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocalizedSeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LocalizedSeo"],
		__typename?: true
}>;
	["LocalizedSeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LocalizedSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocalizedSeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LocalizedSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeroCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Hero"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeroDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Hero"],
		__typename?: true
}>;
	["HeroUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Hero"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeroUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Hero"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
		__typename?: true
}>;
	["GalleryUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
		__typename?: true
}>;
	["GalleryItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialsAndAppsCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialsAndApps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialsAndAppsDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialsAndApps"],
		__typename?: true
}>;
	["SocialsAndAppsUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialsAndApps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialsAndAppsUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialsAndApps"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SiteMenuCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SiteMenuDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteMenu"],
		__typename?: true
}>;
	["SiteMenuUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SiteMenuUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SiteMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MenuItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MenuItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuItem"],
		__typename?: true
}>;
	["MenuItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MenuItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogPostListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogPostListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostList"],
		__typename?: true
}>;
	["BlogPostListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogPostListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogPostListItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogPostListItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostListItem"],
		__typename?: true
}>;
	["BlogPostListItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BlogPostListItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MenuLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MenuLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLocale"],
		__typename?: true
}>;
	["MenuLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MenuLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MenuLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProductGridCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGrid"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProductGridDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGrid"],
		__typename?: true
}>;
	["ProductGridUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGrid"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProductGridUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGrid"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProductGridItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProductGridItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridItem"],
		__typename?: true
}>;
	["ProductGridItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProductGridItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductGridItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Profile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Profile"],
		__typename?: true
}>;
	["ProfileUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Profile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Profile"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileTagCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileTagDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileTag"],
		__typename?: true
}>;
	["ProfileTagUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileTagUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileActivityRecordCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileActivityRecord"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileActivityRecordDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileActivityRecord"],
		__typename?: true
}>;
	["ProfileActivityRecordUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileActivityRecord"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileActivityRecordUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileActivityRecord"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfilePinCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfilePin"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfilePinDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfilePin"],
		__typename?: true
}>;
	["ProfilePinUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfilePin"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfilePinUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfilePin"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileGalleryCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileGallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileGalleryDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileGallery"],
		__typename?: true
}>;
	["ProfileGalleryUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileGallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileGalleryUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileGallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileGalleryItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileGalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileGalleryItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileGalleryItem"],
		__typename?: true
}>;
	["ProfileGalleryItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileGalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ProfileGalleryItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProfileGalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShoppingListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShoppingListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingList"],
		__typename?: true
}>;
	["ShoppingListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShoppingListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShoppingListItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShoppingListItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingListItem"],
		__typename?: true
}>;
	["ShoppingListItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShoppingListItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShoppingListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SupplierCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Supplier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SupplierDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Supplier"],
		__typename?: true
}>;
	["SupplierUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Supplier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SupplierUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Supplier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FavouriteItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FavouriteItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FavouriteItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FavouriteItem"],
		__typename?: true
}>;
	["FavouriteItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FavouriteItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FavouriteItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FavouriteItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BusinessOrderTypeCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessOrderType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BusinessOrderTypeDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessOrderType"],
		__typename?: true
}>;
	["BusinessOrderTypeUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessOrderType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BusinessOrderTypeUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessOrderType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BusinessOrderTypeLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessOrderTypeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BusinessOrderTypeLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessOrderTypeLocale"],
		__typename?: true
}>;
	["BusinessOrderTypeLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessOrderTypeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BusinessOrderTypeLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BusinessOrderTypeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationTransaction"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createColorPallete?: [{	data:ValueTypes["ColorPalleteCreateInput"]},ValueTypes["ColorPalleteCreateResult"]],
deleteColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	filter?:ValueTypes["ColorPalleteWhere"] | null},ValueTypes["ColorPalleteDeleteResult"]],
updateColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	filter?:ValueTypes["ColorPalleteWhere"] | null,	data:ValueTypes["ColorPalleteUpdateInput"]},ValueTypes["ColorPalleteUpdateResult"]],
upsertColorPallete?: [{	by:ValueTypes["ColorPalleteUniqueWhere"],	filter?:ValueTypes["ColorPalleteWhere"] | null,	update:ValueTypes["ColorPalleteUpdateInput"],	create:ValueTypes["ColorPalleteCreateInput"]},ValueTypes["ColorPalleteUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createCover?: [{	data:ValueTypes["CoverCreateInput"]},ValueTypes["CoverCreateResult"]],
deleteCover?: [{	by:ValueTypes["CoverUniqueWhere"],	filter?:ValueTypes["CoverWhere"] | null},ValueTypes["CoverDeleteResult"]],
updateCover?: [{	by:ValueTypes["CoverUniqueWhere"],	filter?:ValueTypes["CoverWhere"] | null,	data:ValueTypes["CoverUpdateInput"]},ValueTypes["CoverUpdateResult"]],
upsertCover?: [{	by:ValueTypes["CoverUniqueWhere"],	filter?:ValueTypes["CoverWhere"] | null,	update:ValueTypes["CoverUpdateInput"],	create:ValueTypes["CoverCreateInput"]},ValueTypes["CoverUpsertResult"]],
createEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["EventCreateResult"]],
deleteEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["EventDeleteResult"]],
updateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	data:ValueTypes["EventUpdateInput"]},ValueTypes["EventUpdateResult"]],
upsertEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	update:ValueTypes["EventUpdateInput"],	create:ValueTypes["EventCreateInput"]},ValueTypes["EventUpsertResult"]],
createEventLocale?: [{	data:ValueTypes["EventLocaleCreateInput"]},ValueTypes["EventLocaleCreateResult"]],
deleteEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocaleDeleteResult"]],
updateEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null,	data:ValueTypes["EventLocaleUpdateInput"]},ValueTypes["EventLocaleUpdateResult"]],
upsertEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null,	update:ValueTypes["EventLocaleUpdateInput"],	create:ValueTypes["EventLocaleCreateInput"]},ValueTypes["EventLocaleUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	update:ValueTypes["ImageListUpdateInput"],	create:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListUpsertResult"]],
createImageItem?: [{	data:ValueTypes["ImageItemCreateInput"]},ValueTypes["ImageItemCreateResult"]],
deleteImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	filter?:ValueTypes["ImageItemWhere"] | null},ValueTypes["ImageItemDeleteResult"]],
updateImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	filter?:ValueTypes["ImageItemWhere"] | null,	data:ValueTypes["ImageItemUpdateInput"]},ValueTypes["ImageItemUpdateResult"]],
upsertImageItem?: [{	by:ValueTypes["ImageItemUniqueWhere"],	filter?:ValueTypes["ImageItemWhere"] | null,	update:ValueTypes["ImageItemUpdateInput"],	create:ValueTypes["ImageItemCreateInput"]},ValueTypes["ImageItemUpsertResult"]],
createLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	update:ValueTypes["LocaleUpdateInput"],	create:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleUpsertResult"]],
createMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	data:ValueTypes["MediumUpdateInput"]},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	update:ValueTypes["MediumUpdateInput"],	create:ValueTypes["MediumCreateInput"]},ValueTypes["MediumUpsertResult"]],
createVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	data:ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	update:ValueTypes["VideoUpdateInput"],	create:ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createBlog?: [{	data:ValueTypes["BlogCreateInput"]},ValueTypes["BlogCreateResult"]],
deleteBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	filter?:ValueTypes["BlogWhere"] | null},ValueTypes["BlogDeleteResult"]],
updateBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	filter?:ValueTypes["BlogWhere"] | null,	data:ValueTypes["BlogUpdateInput"]},ValueTypes["BlogUpdateResult"]],
upsertBlog?: [{	by:ValueTypes["BlogUniqueWhere"],	filter?:ValueTypes["BlogWhere"] | null,	update:ValueTypes["BlogUpdateInput"],	create:ValueTypes["BlogCreateInput"]},ValueTypes["BlogUpsertResult"]],
createBlogLocale?: [{	data:ValueTypes["BlogLocaleCreateInput"]},ValueTypes["BlogLocaleCreateResult"]],
deleteBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null},ValueTypes["BlogLocaleDeleteResult"]],
updateBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null,	data:ValueTypes["BlogLocaleUpdateInput"]},ValueTypes["BlogLocaleUpdateResult"]],
upsertBlogLocale?: [{	by:ValueTypes["BlogLocaleUniqueWhere"],	filter?:ValueTypes["BlogLocaleWhere"] | null,	update:ValueTypes["BlogLocaleUpdateInput"],	create:ValueTypes["BlogLocaleCreateInput"]},ValueTypes["BlogLocaleUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createPageLocale?: [{	data:ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleCreateResult"]],
deletePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocaleDeleteResult"]],
updatePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null,	data:ValueTypes["PageLocaleUpdateInput"]},ValueTypes["PageLocaleUpdateResult"]],
upsertPageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null,	update:ValueTypes["PageLocaleUpdateInput"],	create:ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createSeoLocale?: [{	data:ValueTypes["SeoLocaleCreateInput"]},ValueTypes["SeoLocaleCreateResult"]],
deleteSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null},ValueTypes["SeoLocaleDeleteResult"]],
updateSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null,	data:ValueTypes["SeoLocaleUpdateInput"]},ValueTypes["SeoLocaleUpdateResult"]],
upsertSeoLocale?: [{	by:ValueTypes["SeoLocaleUniqueWhere"],	filter?:ValueTypes["SeoLocaleWhere"] | null,	update:ValueTypes["SeoLocaleUpdateInput"],	create:ValueTypes["SeoLocaleCreateInput"]},ValueTypes["SeoLocaleUpsertResult"]],
createLocalizedSeo?: [{	data:ValueTypes["LocalizedSeoCreateInput"]},ValueTypes["LocalizedSeoCreateResult"]],
deleteLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	filter?:ValueTypes["LocalizedSeoWhere"] | null},ValueTypes["LocalizedSeoDeleteResult"]],
updateLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	filter?:ValueTypes["LocalizedSeoWhere"] | null,	data:ValueTypes["LocalizedSeoUpdateInput"]},ValueTypes["LocalizedSeoUpdateResult"]],
upsertLocalizedSeo?: [{	by:ValueTypes["LocalizedSeoUniqueWhere"],	filter?:ValueTypes["LocalizedSeoWhere"] | null,	update:ValueTypes["LocalizedSeoUpdateInput"],	create:ValueTypes["LocalizedSeoCreateInput"]},ValueTypes["LocalizedSeoUpsertResult"]],
createHero?: [{	data:ValueTypes["HeroCreateInput"]},ValueTypes["HeroCreateResult"]],
deleteHero?: [{	by:ValueTypes["HeroUniqueWhere"],	filter?:ValueTypes["HeroWhere"] | null},ValueTypes["HeroDeleteResult"]],
updateHero?: [{	by:ValueTypes["HeroUniqueWhere"],	filter?:ValueTypes["HeroWhere"] | null,	data:ValueTypes["HeroUpdateInput"]},ValueTypes["HeroUpdateResult"]],
upsertHero?: [{	by:ValueTypes["HeroUniqueWhere"],	filter?:ValueTypes["HeroWhere"] | null,	update:ValueTypes["HeroUpdateInput"],	create:ValueTypes["HeroCreateInput"]},ValueTypes["HeroUpsertResult"]],
createGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	update:ValueTypes["GalleryUpdateInput"],	create:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	update:ValueTypes["GalleryItemUpdateInput"],	create:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createSocialsAndApps?: [{	data:ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["SocialsAndAppsCreateResult"]],
deleteSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	filter?:ValueTypes["SocialsAndAppsWhere"] | null},ValueTypes["SocialsAndAppsDeleteResult"]],
updateSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	filter?:ValueTypes["SocialsAndAppsWhere"] | null,	data:ValueTypes["SocialsAndAppsUpdateInput"]},ValueTypes["SocialsAndAppsUpdateResult"]],
upsertSocialsAndApps?: [{	by:ValueTypes["SocialsAndAppsUniqueWhere"],	filter?:ValueTypes["SocialsAndAppsWhere"] | null,	update:ValueTypes["SocialsAndAppsUpdateInput"],	create:ValueTypes["SocialsAndAppsCreateInput"]},ValueTypes["SocialsAndAppsUpsertResult"]],
createSiteMenu?: [{	data:ValueTypes["SiteMenuCreateInput"]},ValueTypes["SiteMenuCreateResult"]],
deleteSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	filter?:ValueTypes["SiteMenuWhere"] | null},ValueTypes["SiteMenuDeleteResult"]],
updateSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	filter?:ValueTypes["SiteMenuWhere"] | null,	data:ValueTypes["SiteMenuUpdateInput"]},ValueTypes["SiteMenuUpdateResult"]],
upsertSiteMenu?: [{	by:ValueTypes["SiteMenuUniqueWhere"],	filter?:ValueTypes["SiteMenuWhere"] | null,	update:ValueTypes["SiteMenuUpdateInput"],	create:ValueTypes["SiteMenuCreateInput"]},ValueTypes["SiteMenuUpsertResult"]],
createMenuItem?: [{	data:ValueTypes["MenuItemCreateInput"]},ValueTypes["MenuItemCreateResult"]],
deleteMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	filter?:ValueTypes["MenuItemWhere"] | null},ValueTypes["MenuItemDeleteResult"]],
updateMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	filter?:ValueTypes["MenuItemWhere"] | null,	data:ValueTypes["MenuItemUpdateInput"]},ValueTypes["MenuItemUpdateResult"]],
upsertMenuItem?: [{	by:ValueTypes["MenuItemUniqueWhere"],	filter?:ValueTypes["MenuItemWhere"] | null,	update:ValueTypes["MenuItemUpdateInput"],	create:ValueTypes["MenuItemCreateInput"]},ValueTypes["MenuItemUpsertResult"]],
createBlogPostList?: [{	data:ValueTypes["BlogPostListCreateInput"]},ValueTypes["BlogPostListCreateResult"]],
deleteBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	filter?:ValueTypes["BlogPostListWhere"] | null},ValueTypes["BlogPostListDeleteResult"]],
updateBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	filter?:ValueTypes["BlogPostListWhere"] | null,	data:ValueTypes["BlogPostListUpdateInput"]},ValueTypes["BlogPostListUpdateResult"]],
upsertBlogPostList?: [{	by:ValueTypes["BlogPostListUniqueWhere"],	filter?:ValueTypes["BlogPostListWhere"] | null,	update:ValueTypes["BlogPostListUpdateInput"],	create:ValueTypes["BlogPostListCreateInput"]},ValueTypes["BlogPostListUpsertResult"]],
createBlogPostListItem?: [{	data:ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["BlogPostListItemCreateResult"]],
deleteBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	filter?:ValueTypes["BlogPostListItemWhere"] | null},ValueTypes["BlogPostListItemDeleteResult"]],
updateBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	filter?:ValueTypes["BlogPostListItemWhere"] | null,	data:ValueTypes["BlogPostListItemUpdateInput"]},ValueTypes["BlogPostListItemUpdateResult"]],
upsertBlogPostListItem?: [{	by:ValueTypes["BlogPostListItemUniqueWhere"],	filter?:ValueTypes["BlogPostListItemWhere"] | null,	update:ValueTypes["BlogPostListItemUpdateInput"],	create:ValueTypes["BlogPostListItemCreateInput"]},ValueTypes["BlogPostListItemUpsertResult"]],
createMenuLocale?: [{	data:ValueTypes["MenuLocaleCreateInput"]},ValueTypes["MenuLocaleCreateResult"]],
deleteMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null},ValueTypes["MenuLocaleDeleteResult"]],
updateMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null,	data:ValueTypes["MenuLocaleUpdateInput"]},ValueTypes["MenuLocaleUpdateResult"]],
upsertMenuLocale?: [{	by:ValueTypes["MenuLocaleUniqueWhere"],	filter?:ValueTypes["MenuLocaleWhere"] | null,	update:ValueTypes["MenuLocaleUpdateInput"],	create:ValueTypes["MenuLocaleCreateInput"]},ValueTypes["MenuLocaleUpsertResult"]],
createProductGrid?: [{	data:ValueTypes["ProductGridCreateInput"]},ValueTypes["ProductGridCreateResult"]],
deleteProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	filter?:ValueTypes["ProductGridWhere"] | null},ValueTypes["ProductGridDeleteResult"]],
updateProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	filter?:ValueTypes["ProductGridWhere"] | null,	data:ValueTypes["ProductGridUpdateInput"]},ValueTypes["ProductGridUpdateResult"]],
upsertProductGrid?: [{	by:ValueTypes["ProductGridUniqueWhere"],	filter?:ValueTypes["ProductGridWhere"] | null,	update:ValueTypes["ProductGridUpdateInput"],	create:ValueTypes["ProductGridCreateInput"]},ValueTypes["ProductGridUpsertResult"]],
createProductGridItem?: [{	data:ValueTypes["ProductGridItemCreateInput"]},ValueTypes["ProductGridItemCreateResult"]],
deleteProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	filter?:ValueTypes["ProductGridItemWhere"] | null},ValueTypes["ProductGridItemDeleteResult"]],
updateProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	filter?:ValueTypes["ProductGridItemWhere"] | null,	data:ValueTypes["ProductGridItemUpdateInput"]},ValueTypes["ProductGridItemUpdateResult"]],
upsertProductGridItem?: [{	by:ValueTypes["ProductGridItemUniqueWhere"],	filter?:ValueTypes["ProductGridItemWhere"] | null,	update:ValueTypes["ProductGridItemUpdateInput"],	create:ValueTypes["ProductGridItemCreateInput"]},ValueTypes["ProductGridItemUpsertResult"]],
createProfile?: [{	data:ValueTypes["ProfileCreateInput"]},ValueTypes["ProfileCreateResult"]],
deleteProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	filter?:ValueTypes["ProfileWhere"] | null},ValueTypes["ProfileDeleteResult"]],
updateProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	filter?:ValueTypes["ProfileWhere"] | null,	data:ValueTypes["ProfileUpdateInput"]},ValueTypes["ProfileUpdateResult"]],
upsertProfile?: [{	by:ValueTypes["ProfileUniqueWhere"],	filter?:ValueTypes["ProfileWhere"] | null,	update:ValueTypes["ProfileUpdateInput"],	create:ValueTypes["ProfileCreateInput"]},ValueTypes["ProfileUpsertResult"]],
createProfileTag?: [{	data:ValueTypes["ProfileTagCreateInput"]},ValueTypes["ProfileTagCreateResult"]],
deleteProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	filter?:ValueTypes["ProfileTagWhere"] | null},ValueTypes["ProfileTagDeleteResult"]],
updateProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	filter?:ValueTypes["ProfileTagWhere"] | null,	data:ValueTypes["ProfileTagUpdateInput"]},ValueTypes["ProfileTagUpdateResult"]],
upsertProfileTag?: [{	by:ValueTypes["ProfileTagUniqueWhere"],	filter?:ValueTypes["ProfileTagWhere"] | null,	update:ValueTypes["ProfileTagUpdateInput"],	create:ValueTypes["ProfileTagCreateInput"]},ValueTypes["ProfileTagUpsertResult"]],
createProfileActivityRecord?: [{	data:ValueTypes["ProfileActivityRecordCreateInput"]},ValueTypes["ProfileActivityRecordCreateResult"]],
deleteProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	filter?:ValueTypes["ProfileActivityRecordWhere"] | null},ValueTypes["ProfileActivityRecordDeleteResult"]],
updateProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	data:ValueTypes["ProfileActivityRecordUpdateInput"]},ValueTypes["ProfileActivityRecordUpdateResult"]],
upsertProfileActivityRecord?: [{	by:ValueTypes["ProfileActivityRecordUniqueWhere"],	filter?:ValueTypes["ProfileActivityRecordWhere"] | null,	update:ValueTypes["ProfileActivityRecordUpdateInput"],	create:ValueTypes["ProfileActivityRecordCreateInput"]},ValueTypes["ProfileActivityRecordUpsertResult"]],
createProfilePin?: [{	data:ValueTypes["ProfilePinCreateInput"]},ValueTypes["ProfilePinCreateResult"]],
deleteProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null},ValueTypes["ProfilePinDeleteResult"]],
updateProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null,	data:ValueTypes["ProfilePinUpdateInput"]},ValueTypes["ProfilePinUpdateResult"]],
upsertProfilePin?: [{	by:ValueTypes["ProfilePinUniqueWhere"],	filter?:ValueTypes["ProfilePinWhere"] | null,	update:ValueTypes["ProfilePinUpdateInput"],	create:ValueTypes["ProfilePinCreateInput"]},ValueTypes["ProfilePinUpsertResult"]],
createProfileGallery?: [{	data:ValueTypes["ProfileGalleryCreateInput"]},ValueTypes["ProfileGalleryCreateResult"]],
deleteProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	filter?:ValueTypes["ProfileGalleryWhere"] | null},ValueTypes["ProfileGalleryDeleteResult"]],
updateProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	filter?:ValueTypes["ProfileGalleryWhere"] | null,	data:ValueTypes["ProfileGalleryUpdateInput"]},ValueTypes["ProfileGalleryUpdateResult"]],
upsertProfileGallery?: [{	by:ValueTypes["ProfileGalleryUniqueWhere"],	filter?:ValueTypes["ProfileGalleryWhere"] | null,	update:ValueTypes["ProfileGalleryUpdateInput"],	create:ValueTypes["ProfileGalleryCreateInput"]},ValueTypes["ProfileGalleryUpsertResult"]],
createProfileGalleryItem?: [{	data:ValueTypes["ProfileGalleryItemCreateInput"]},ValueTypes["ProfileGalleryItemCreateResult"]],
deleteProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	filter?:ValueTypes["ProfileGalleryItemWhere"] | null},ValueTypes["ProfileGalleryItemDeleteResult"]],
updateProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	data:ValueTypes["ProfileGalleryItemUpdateInput"]},ValueTypes["ProfileGalleryItemUpdateResult"]],
upsertProfileGalleryItem?: [{	by:ValueTypes["ProfileGalleryItemUniqueWhere"],	filter?:ValueTypes["ProfileGalleryItemWhere"] | null,	update:ValueTypes["ProfileGalleryItemUpdateInput"],	create:ValueTypes["ProfileGalleryItemCreateInput"]},ValueTypes["ProfileGalleryItemUpsertResult"]],
createShoppingList?: [{	data:ValueTypes["ShoppingListCreateInput"]},ValueTypes["ShoppingListCreateResult"]],
deleteShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	filter?:ValueTypes["ShoppingListWhere"] | null},ValueTypes["ShoppingListDeleteResult"]],
updateShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	filter?:ValueTypes["ShoppingListWhere"] | null,	data:ValueTypes["ShoppingListUpdateInput"]},ValueTypes["ShoppingListUpdateResult"]],
upsertShoppingList?: [{	by:ValueTypes["ShoppingListUniqueWhere"],	filter?:ValueTypes["ShoppingListWhere"] | null,	update:ValueTypes["ShoppingListUpdateInput"],	create:ValueTypes["ShoppingListCreateInput"]},ValueTypes["ShoppingListUpsertResult"]],
createShoppingListItem?: [{	data:ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["ShoppingListItemCreateResult"]],
deleteShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	filter?:ValueTypes["ShoppingListItemWhere"] | null},ValueTypes["ShoppingListItemDeleteResult"]],
updateShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	filter?:ValueTypes["ShoppingListItemWhere"] | null,	data:ValueTypes["ShoppingListItemUpdateInput"]},ValueTypes["ShoppingListItemUpdateResult"]],
upsertShoppingListItem?: [{	by:ValueTypes["ShoppingListItemUniqueWhere"],	filter?:ValueTypes["ShoppingListItemWhere"] | null,	update:ValueTypes["ShoppingListItemUpdateInput"],	create:ValueTypes["ShoppingListItemCreateInput"]},ValueTypes["ShoppingListItemUpsertResult"]],
createSupplier?: [{	data:ValueTypes["SupplierCreateInput"]},ValueTypes["SupplierCreateResult"]],
deleteSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	filter?:ValueTypes["SupplierWhere"] | null},ValueTypes["SupplierDeleteResult"]],
updateSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	filter?:ValueTypes["SupplierWhere"] | null,	data:ValueTypes["SupplierUpdateInput"]},ValueTypes["SupplierUpdateResult"]],
upsertSupplier?: [{	by:ValueTypes["SupplierUniqueWhere"],	filter?:ValueTypes["SupplierWhere"] | null,	update:ValueTypes["SupplierUpdateInput"],	create:ValueTypes["SupplierCreateInput"]},ValueTypes["SupplierUpsertResult"]],
createFavouriteItem?: [{	data:ValueTypes["FavouriteItemCreateInput"]},ValueTypes["FavouriteItemCreateResult"]],
deleteFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	filter?:ValueTypes["FavouriteItemWhere"] | null},ValueTypes["FavouriteItemDeleteResult"]],
updateFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	filter?:ValueTypes["FavouriteItemWhere"] | null,	data:ValueTypes["FavouriteItemUpdateInput"]},ValueTypes["FavouriteItemUpdateResult"]],
upsertFavouriteItem?: [{	by:ValueTypes["FavouriteItemUniqueWhere"],	filter?:ValueTypes["FavouriteItemWhere"] | null,	update:ValueTypes["FavouriteItemUpdateInput"],	create:ValueTypes["FavouriteItemCreateInput"]},ValueTypes["FavouriteItemUpsertResult"]],
createBusinessOrderType?: [{	data:ValueTypes["BusinessOrderTypeCreateInput"]},ValueTypes["BusinessOrderTypeCreateResult"]],
deleteBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeWhere"] | null},ValueTypes["BusinessOrderTypeDeleteResult"]],
updateBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeWhere"] | null,	data:ValueTypes["BusinessOrderTypeUpdateInput"]},ValueTypes["BusinessOrderTypeUpdateResult"]],
upsertBusinessOrderType?: [{	by:ValueTypes["BusinessOrderTypeUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeWhere"] | null,	update:ValueTypes["BusinessOrderTypeUpdateInput"],	create:ValueTypes["BusinessOrderTypeCreateInput"]},ValueTypes["BusinessOrderTypeUpsertResult"]],
createBusinessOrderTypeLocale?: [{	data:ValueTypes["BusinessOrderTypeLocaleCreateInput"]},ValueTypes["BusinessOrderTypeLocaleCreateResult"]],
deleteBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null},ValueTypes["BusinessOrderTypeLocaleDeleteResult"]],
updateBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	data:ValueTypes["BusinessOrderTypeLocaleUpdateInput"]},ValueTypes["BusinessOrderTypeLocaleUpdateResult"]],
upsertBusinessOrderTypeLocale?: [{	by:ValueTypes["BusinessOrderTypeLocaleUniqueWhere"],	filter?:ValueTypes["BusinessOrderTypeLocaleWhere"] | null,	update:ValueTypes["BusinessOrderTypeLocaleUpdateInput"],	create:ValueTypes["BusinessOrderTypeLocaleCreateInput"]},ValueTypes["BusinessOrderTypeLocaleUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: true
}>;
	["Json"]:unknown;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: true
}>;
	["_Entity"]: AliasType<{
	name?:true,
	customPrimaryAllowed?:true,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: true
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:true,
		__typename?: true
}>;
	["_Field"]:AliasType<{
		name?:true,
	type?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: true
}>;
	["_Column"]: AliasType<{
	name?:true,
	type?:true,
	enumName?:true,
	defaultValue?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:true,
	direction?:true,
		__typename?: true
}>;
	["_Relation"]: AliasType<{
	name?:true,
	type?:true,
	side?:true,
	targetEntity?:true,
	ownedBy?:true,
	inversedBy?:true,
	nullable?:true,
	onDelete?:true,
	orphanRemoval?:true,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:true,
		__typename?: true
}>;
	["_Validator"]: AliasType<{
	operation?:true,
	arguments?:ValueTypes["_Argument"],
		__typename?: true
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: true
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:true,
		__typename?: true
}>;
	["_PathArgument"]: AliasType<{
	path?:true,
		__typename?: true
}>;
	["_LiteralArgument"]: AliasType<{
	value?:true,
		__typename?: true
}>;
	["_RuleMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["_Enum"]: AliasType<{
	name?:true,
	values?:true,
		__typename?: true
}>;
	["S3SignedUpload"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
	publicUrl?:true,
		__typename?: true
}>;
	["S3Header"]: AliasType<{
	key?:true,
	value?:true,
		__typename?: true
}>;
	["S3SignedRead"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
		__typename?: true
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getColorPallete?:ModelTypes["ColorPallete"],
	listColorPallete:ModelTypes["ColorPallete"][],
	paginateColorPallete:ModelTypes["ColorPalleteConnection"],
	validateCreateColorPallete:ModelTypes["_ValidationResult"],
	validateUpdateColorPallete:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getCover?:ModelTypes["Cover"],
	listCover:ModelTypes["Cover"][],
	paginateCover:ModelTypes["CoverConnection"],
	validateCreateCover:ModelTypes["_ValidationResult"],
	validateUpdateCover:ModelTypes["_ValidationResult"],
	getEvent?:ModelTypes["Event"],
	listEvent:ModelTypes["Event"][],
	paginateEvent:ModelTypes["EventConnection"],
	validateCreateEvent:ModelTypes["_ValidationResult"],
	validateUpdateEvent:ModelTypes["_ValidationResult"],
	getEventLocale?:ModelTypes["EventLocale"],
	listEventLocale:ModelTypes["EventLocale"][],
	paginateEventLocale:ModelTypes["EventLocaleConnection"],
	validateCreateEventLocale:ModelTypes["_ValidationResult"],
	validateUpdateEventLocale:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getImageList?:ModelTypes["ImageList"],
	listImageList:ModelTypes["ImageList"][],
	paginateImageList:ModelTypes["ImageListConnection"],
	validateCreateImageList:ModelTypes["_ValidationResult"],
	validateUpdateImageList:ModelTypes["_ValidationResult"],
	getImageItem?:ModelTypes["ImageItem"],
	listImageItem:ModelTypes["ImageItem"][],
	paginateImageItem:ModelTypes["ImageItemConnection"],
	validateCreateImageItem:ModelTypes["_ValidationResult"],
	validateUpdateImageItem:ModelTypes["_ValidationResult"],
	getLocale?:ModelTypes["Locale"],
	listLocale:ModelTypes["Locale"][],
	paginateLocale:ModelTypes["LocaleConnection"],
	validateCreateLocale:ModelTypes["_ValidationResult"],
	validateUpdateLocale:ModelTypes["_ValidationResult"],
	getMedium?:ModelTypes["Medium"],
	listMedium:ModelTypes["Medium"][],
	paginateMedium:ModelTypes["MediumConnection"],
	validateCreateMedium:ModelTypes["_ValidationResult"],
	validateUpdateMedium:ModelTypes["_ValidationResult"],
	getVideo?:ModelTypes["Video"],
	listVideo:ModelTypes["Video"][],
	paginateVideo:ModelTypes["VideoConnection"],
	validateCreateVideo:ModelTypes["_ValidationResult"],
	validateUpdateVideo:ModelTypes["_ValidationResult"],
	getBlog?:ModelTypes["Blog"],
	listBlog:ModelTypes["Blog"][],
	paginateBlog:ModelTypes["BlogConnection"],
	validateCreateBlog:ModelTypes["_ValidationResult"],
	validateUpdateBlog:ModelTypes["_ValidationResult"],
	getBlogLocale?:ModelTypes["BlogLocale"],
	listBlogLocale:ModelTypes["BlogLocale"][],
	paginateBlogLocale:ModelTypes["BlogLocaleConnection"],
	validateCreateBlogLocale:ModelTypes["_ValidationResult"],
	validateUpdateBlogLocale:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	getPageLocale?:ModelTypes["PageLocale"],
	listPageLocale:ModelTypes["PageLocale"][],
	paginatePageLocale:ModelTypes["PageLocaleConnection"],
	validateCreatePageLocale:ModelTypes["_ValidationResult"],
	validateUpdatePageLocale:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getSeoLocale?:ModelTypes["SeoLocale"],
	listSeoLocale:ModelTypes["SeoLocale"][],
	paginateSeoLocale:ModelTypes["SeoLocaleConnection"],
	validateCreateSeoLocale:ModelTypes["_ValidationResult"],
	validateUpdateSeoLocale:ModelTypes["_ValidationResult"],
	getLocalizedSeo?:ModelTypes["LocalizedSeo"],
	listLocalizedSeo:ModelTypes["LocalizedSeo"][],
	paginateLocalizedSeo:ModelTypes["LocalizedSeoConnection"],
	validateCreateLocalizedSeo:ModelTypes["_ValidationResult"],
	validateUpdateLocalizedSeo:ModelTypes["_ValidationResult"],
	getHero?:ModelTypes["Hero"],
	listHero:ModelTypes["Hero"][],
	paginateHero:ModelTypes["HeroConnection"],
	validateCreateHero:ModelTypes["_ValidationResult"],
	validateUpdateHero:ModelTypes["_ValidationResult"],
	getGallery?:ModelTypes["Gallery"],
	listGallery:ModelTypes["Gallery"][],
	paginateGallery:ModelTypes["GalleryConnection"],
	validateCreateGallery:ModelTypes["_ValidationResult"],
	validateUpdateGallery:ModelTypes["_ValidationResult"],
	getGalleryItem?:ModelTypes["GalleryItem"],
	listGalleryItem:ModelTypes["GalleryItem"][],
	paginateGalleryItem:ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem:ModelTypes["_ValidationResult"],
	getSocialsAndApps?:ModelTypes["SocialsAndApps"],
	listSocialsAndApps:ModelTypes["SocialsAndApps"][],
	paginateSocialsAndApps:ModelTypes["SocialsAndAppsConnection"],
	validateCreateSocialsAndApps:ModelTypes["_ValidationResult"],
	validateUpdateSocialsAndApps:ModelTypes["_ValidationResult"],
	getSiteMenu?:ModelTypes["SiteMenu"],
	listSiteMenu:ModelTypes["SiteMenu"][],
	paginateSiteMenu:ModelTypes["SiteMenuConnection"],
	validateCreateSiteMenu:ModelTypes["_ValidationResult"],
	validateUpdateSiteMenu:ModelTypes["_ValidationResult"],
	getMenuItem?:ModelTypes["MenuItem"],
	listMenuItem:ModelTypes["MenuItem"][],
	paginateMenuItem:ModelTypes["MenuItemConnection"],
	validateCreateMenuItem:ModelTypes["_ValidationResult"],
	validateUpdateMenuItem:ModelTypes["_ValidationResult"],
	getBlogPostList?:ModelTypes["BlogPostList"],
	listBlogPostList:ModelTypes["BlogPostList"][],
	paginateBlogPostList:ModelTypes["BlogPostListConnection"],
	validateCreateBlogPostList:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostList:ModelTypes["_ValidationResult"],
	getBlogPostListItem?:ModelTypes["BlogPostListItem"],
	listBlogPostListItem:ModelTypes["BlogPostListItem"][],
	paginateBlogPostListItem:ModelTypes["BlogPostListItemConnection"],
	validateCreateBlogPostListItem:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostListItem:ModelTypes["_ValidationResult"],
	getMenuLocale?:ModelTypes["MenuLocale"],
	listMenuLocale:ModelTypes["MenuLocale"][],
	paginateMenuLocale:ModelTypes["MenuLocaleConnection"],
	validateCreateMenuLocale:ModelTypes["_ValidationResult"],
	validateUpdateMenuLocale:ModelTypes["_ValidationResult"],
	getProductGrid?:ModelTypes["ProductGrid"],
	listProductGrid:ModelTypes["ProductGrid"][],
	paginateProductGrid:ModelTypes["ProductGridConnection"],
	validateCreateProductGrid:ModelTypes["_ValidationResult"],
	validateUpdateProductGrid:ModelTypes["_ValidationResult"],
	getProductGridItem?:ModelTypes["ProductGridItem"],
	listProductGridItem:ModelTypes["ProductGridItem"][],
	paginateProductGridItem:ModelTypes["ProductGridItemConnection"],
	validateCreateProductGridItem:ModelTypes["_ValidationResult"],
	validateUpdateProductGridItem:ModelTypes["_ValidationResult"],
	getProfile?:ModelTypes["Profile"],
	listProfile:ModelTypes["Profile"][],
	paginateProfile:ModelTypes["ProfileConnection"],
	validateCreateProfile:ModelTypes["_ValidationResult"],
	validateUpdateProfile:ModelTypes["_ValidationResult"],
	getProfileTag?:ModelTypes["ProfileTag"],
	listProfileTag:ModelTypes["ProfileTag"][],
	paginateProfileTag:ModelTypes["ProfileTagConnection"],
	validateCreateProfileTag:ModelTypes["_ValidationResult"],
	validateUpdateProfileTag:ModelTypes["_ValidationResult"],
	getProfileActivityRecord?:ModelTypes["ProfileActivityRecord"],
	listProfileActivityRecord:ModelTypes["ProfileActivityRecord"][],
	paginateProfileActivityRecord:ModelTypes["ProfileActivityRecordConnection"],
	validateCreateProfileActivityRecord:ModelTypes["_ValidationResult"],
	validateUpdateProfileActivityRecord:ModelTypes["_ValidationResult"],
	getProfilePin?:ModelTypes["ProfilePin"],
	listProfilePin:ModelTypes["ProfilePin"][],
	paginateProfilePin:ModelTypes["ProfilePinConnection"],
	validateCreateProfilePin:ModelTypes["_ValidationResult"],
	validateUpdateProfilePin:ModelTypes["_ValidationResult"],
	getProfileGallery?:ModelTypes["ProfileGallery"],
	listProfileGallery:ModelTypes["ProfileGallery"][],
	paginateProfileGallery:ModelTypes["ProfileGalleryConnection"],
	validateCreateProfileGallery:ModelTypes["_ValidationResult"],
	validateUpdateProfileGallery:ModelTypes["_ValidationResult"],
	getProfileGalleryItem?:ModelTypes["ProfileGalleryItem"],
	listProfileGalleryItem:ModelTypes["ProfileGalleryItem"][],
	paginateProfileGalleryItem:ModelTypes["ProfileGalleryItemConnection"],
	validateCreateProfileGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateProfileGalleryItem:ModelTypes["_ValidationResult"],
	getShoppingList?:ModelTypes["ShoppingList"],
	listShoppingList:ModelTypes["ShoppingList"][],
	paginateShoppingList:ModelTypes["ShoppingListConnection"],
	validateCreateShoppingList:ModelTypes["_ValidationResult"],
	validateUpdateShoppingList:ModelTypes["_ValidationResult"],
	getShoppingListItem?:ModelTypes["ShoppingListItem"],
	listShoppingListItem:ModelTypes["ShoppingListItem"][],
	paginateShoppingListItem:ModelTypes["ShoppingListItemConnection"],
	validateCreateShoppingListItem:ModelTypes["_ValidationResult"],
	validateUpdateShoppingListItem:ModelTypes["_ValidationResult"],
	getSupplier?:ModelTypes["Supplier"],
	listSupplier:ModelTypes["Supplier"][],
	paginateSupplier:ModelTypes["SupplierConnection"],
	validateCreateSupplier:ModelTypes["_ValidationResult"],
	validateUpdateSupplier:ModelTypes["_ValidationResult"],
	getFavouriteItem?:ModelTypes["FavouriteItem"],
	listFavouriteItem:ModelTypes["FavouriteItem"][],
	paginateFavouriteItem:ModelTypes["FavouriteItemConnection"],
	validateCreateFavouriteItem:ModelTypes["_ValidationResult"],
	validateUpdateFavouriteItem:ModelTypes["_ValidationResult"],
	getBusinessOrderType?:ModelTypes["BusinessOrderType"],
	listBusinessOrderType:ModelTypes["BusinessOrderType"][],
	paginateBusinessOrderType:ModelTypes["BusinessOrderTypeConnection"],
	validateCreateBusinessOrderType:ModelTypes["_ValidationResult"],
	validateUpdateBusinessOrderType:ModelTypes["_ValidationResult"],
	getBusinessOrderTypeLocale?:ModelTypes["BusinessOrderTypeLocale"],
	listBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocale"][],
	paginateBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleConnection"],
	validateCreateBusinessOrderTypeLocale:ModelTypes["_ValidationResult"],
	validateUpdateBusinessOrderTypeLocale:ModelTypes["_ValidationResult"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"],
	schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string
};
	["ColorPallete"]: {
		_meta?:ModelTypes["ColorPalleteMeta"],
	id:ModelTypes["UUID"],
	background?:string,
	text?:string
};
	["ColorPalleteMeta"]: {
		id?:ModelTypes["FieldMeta"],
	background?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:any;
	["ColorPalleteUniqueWhere"]: GraphQLTypes["ColorPalleteUniqueWhere"];
	["ColorPalleteWhere"]: GraphQLTypes["ColorPalleteWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["ColorPalleteOrderBy"]: GraphQLTypes["ColorPalleteOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["ColorPalleteConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ColorPalleteEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["ColorPalleteEdge"]: {
		node:ModelTypes["ColorPallete"]
};
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["ColorPalleteCreateInput"]: GraphQLTypes["ColorPalleteCreateInput"];
	["ColorPalleteUpdateInput"]: GraphQLTypes["ColorPalleteUpdateInput"];
	["Content"]: {
		_meta?:ModelTypes["ContentMeta"],
	id:ModelTypes["UUID"],
	blocks:ModelTypes["ContentBlock"][],
	blocksByReferences?:ModelTypes["ContentBlock"],
	paginateBlocks:ModelTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"]
};
	["ContentBlock"]: {
		_meta?:ModelTypes["ContentBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["Content"],
	references:ModelTypes["ContentReference"][],
	paginateReferences:ModelTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"]
};
	["ContentWhere"]: GraphQLTypes["ContentWhere"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["ContentReferenceWhere"]: GraphQLTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: GraphQLTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: GraphQLTypes["ContentReferenceType"];
	["MediumWhere"]: GraphQLTypes["MediumWhere"];
	["MediumTypeCondition"]: GraphQLTypes["MediumTypeCondition"];
	["MediumType"]: GraphQLTypes["MediumType"];
	["ColorThemeCondition"]: GraphQLTypes["ColorThemeCondition"];
	["ColorTheme"]: GraphQLTypes["ColorTheme"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["VideoWhere"]: GraphQLTypes["VideoWhere"];
	["FloatCondition"]: GraphQLTypes["FloatCondition"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["PageLocaleWhere"]: GraphQLTypes["PageLocaleWhere"];
	["PageWhere"]: GraphQLTypes["PageWhere"];
	["LocaleWhere"]: GraphQLTypes["LocaleWhere"];
	["EventLocaleWhere"]: GraphQLTypes["EventLocaleWhere"];
	["EventWhere"]: GraphQLTypes["EventWhere"];
	["CoverWhere"]: GraphQLTypes["CoverWhere"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["LocalizedSeoWhere"]: GraphQLTypes["LocalizedSeoWhere"];
	["BlogLocaleWhere"]: GraphQLTypes["BlogLocaleWhere"];
	["BlogWhere"]: GraphQLTypes["BlogWhere"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["One"]: GraphQLTypes["One"];
	["SeoLocaleWhere"]: GraphQLTypes["SeoLocaleWhere"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["MenuLocaleWhere"]: GraphQLTypes["MenuLocaleWhere"];
	["SiteMenuWhere"]: GraphQLTypes["SiteMenuWhere"];
	["MenuItemWhere"]: GraphQLTypes["MenuItemWhere"];
	["BusinessOrderTypeLocaleWhere"]: GraphQLTypes["BusinessOrderTypeLocaleWhere"];
	["BusinessOrderTypeWhere"]: GraphQLTypes["BusinessOrderTypeWhere"];
	["HeroWhere"]: GraphQLTypes["HeroWhere"];
	["GalleryWhere"]: GraphQLTypes["GalleryWhere"];
	["GalleryItemWhere"]: GraphQLTypes["GalleryItemWhere"];
	["ContentSizeCondition"]: GraphQLTypes["ContentSizeCondition"];
	["ContentSize"]: GraphQLTypes["ContentSize"];
	["SocialsAndAppsWhere"]: GraphQLTypes["SocialsAndAppsWhere"];
	["BlogPostListWhere"]: GraphQLTypes["BlogPostListWhere"];
	["BlogPostListItemWhere"]: GraphQLTypes["BlogPostListItemWhere"];
	["ProductGridWhere"]: GraphQLTypes["ProductGridWhere"];
	["ProductGridItemWhere"]: GraphQLTypes["ProductGridItemWhere"];
	["ContentReference"]: {
		_meta?:ModelTypes["ContentReferenceMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["ContentReferenceType"],
	primaryText?:string,
	secondaryText?:string,
	jsonContent?:string,
	block?:ModelTypes["ContentBlock"],
	colorPallete?:ModelTypes["ColorPallete"],
	medium?:ModelTypes["Medium"],
	misc?:string,
	link?:ModelTypes["Link"],
	hero?:ModelTypes["Hero"],
	gallery?:ModelTypes["Gallery"],
	contentSize?:ModelTypes["ContentSize"],
	socialsAndApps?:ModelTypes["SocialsAndApps"],
	blogPosts?:ModelTypes["BlogPostList"],
	productGrid?:ModelTypes["ProductGrid"]
};
	["ContentReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	primaryText?:ModelTypes["FieldMeta"],
	secondaryText?:ModelTypes["FieldMeta"],
	jsonContent?:ModelTypes["FieldMeta"],
	block?:ModelTypes["FieldMeta"],
	colorPallete?:ModelTypes["FieldMeta"],
	medium?:ModelTypes["FieldMeta"],
	misc?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	hero?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"],
	contentSize?:ModelTypes["FieldMeta"],
	socialsAndApps?:ModelTypes["FieldMeta"],
	blogPosts?:ModelTypes["FieldMeta"],
	productGrid?:ModelTypes["FieldMeta"]
};
	["Medium"]: {
		_meta?:ModelTypes["MediumMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["MediumType"],
	colorTheme?:ModelTypes["ColorTheme"],
	image?:ModelTypes["Image"],
	video?:ModelTypes["Video"]
};
	["MediumMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	colorTheme?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	video?:ModelTypes["FieldMeta"]
};
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	title?:string,
	alt?:string
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	alt?:ModelTypes["FieldMeta"]
};
	["Video"]: {
		_meta?:ModelTypes["VideoMeta"],
	id:ModelTypes["UUID"],
	src?:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	duration?:number,
	poster?:ModelTypes["Image"]
};
	["VideoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	src?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	duration?:ModelTypes["FieldMeta"],
	poster?:ModelTypes["FieldMeta"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["LinkType"],
	title?:string,
	externalLink?:string,
	internalLink?:ModelTypes["Linkable"]
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	externalLink?:ModelTypes["FieldMeta"],
	internalLink?:ModelTypes["FieldMeta"]
};
	["Linkable"]: {
		_meta?:ModelTypes["LinkableMeta"],
	id:ModelTypes["UUID"],
	url:string,
	page?:ModelTypes["PageLocale"],
	event?:ModelTypes["EventLocale"]
};
	["LinkableMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	page?:ModelTypes["FieldMeta"],
	event?:ModelTypes["FieldMeta"]
};
	["PageLocale"]: {
		_meta?:ModelTypes["PageLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	link?:ModelTypes["Linkable"],
	root?:ModelTypes["Page"],
	locale?:ModelTypes["Locale"],
	seo?:ModelTypes["LocalizedSeo"],
	content?:ModelTypes["Content"]
};
	["PageLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"]
};
	["Page"]: {
		_meta?:ModelTypes["PageMeta"],
	id:ModelTypes["UUID"],
	locales:ModelTypes["PageLocale"][],
	localesByLocale?:ModelTypes["PageLocale"],
	localesByLink?:ModelTypes["PageLocale"],
	localesBySeo?:ModelTypes["PageLocale"],
	localesByContent?:ModelTypes["PageLocale"],
	paginateLocales:ModelTypes["PageLocaleConnection"]
};
	["PageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["PageLocaleOrderBy"]: GraphQLTypes["PageLocaleOrderBy"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["EventLocaleOrderBy"]: GraphQLTypes["EventLocaleOrderBy"];
	["EventOrderBy"]: GraphQLTypes["EventOrderBy"];
	["LocaleOrderBy"]: GraphQLTypes["LocaleOrderBy"];
	["CoverOrderBy"]: GraphQLTypes["CoverOrderBy"];
	["MediumOrderBy"]: GraphQLTypes["MediumOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["VideoOrderBy"]: GraphQLTypes["VideoOrderBy"];
	["ContentOrderBy"]: GraphQLTypes["ContentOrderBy"];
	["LocalizedSeoOrderBy"]: GraphQLTypes["LocalizedSeoOrderBy"];
	["PageOrderBy"]: GraphQLTypes["PageOrderBy"];
	["PageLocalesByLocaleUniqueWhere"]: GraphQLTypes["PageLocalesByLocaleUniqueWhere"];
	["LocaleUniqueWhere"]: GraphQLTypes["LocaleUniqueWhere"];
	["EventLocaleUniqueWhere"]: GraphQLTypes["EventLocaleUniqueWhere"];
	["EventUniqueWhere"]: GraphQLTypes["EventUniqueWhere"];
	["CoverUniqueWhere"]: GraphQLTypes["CoverUniqueWhere"];
	["ContentUniqueWhere"]: GraphQLTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["ContentReferenceUniqueWhere"]: GraphQLTypes["ContentReferenceUniqueWhere"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["PageLocaleUniqueWhere"]: GraphQLTypes["PageLocaleUniqueWhere"];
	["PageUniqueWhere"]: GraphQLTypes["PageUniqueWhere"];
	["LocalizedSeoUniqueWhere"]: GraphQLTypes["LocalizedSeoUniqueWhere"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["BlogLocaleUniqueWhere"]: GraphQLTypes["BlogLocaleUniqueWhere"];
	["BlogUniqueWhere"]: GraphQLTypes["BlogUniqueWhere"];
	["SeoLocaleUniqueWhere"]: GraphQLTypes["SeoLocaleUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["MenuLocaleUniqueWhere"]: GraphQLTypes["MenuLocaleUniqueWhere"];
	["SiteMenuUniqueWhere"]: GraphQLTypes["SiteMenuUniqueWhere"];
	["MenuItemUniqueWhere"]: GraphQLTypes["MenuItemUniqueWhere"];
	["BusinessOrderTypeLocaleUniqueWhere"]: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"];
	["BusinessOrderTypeUniqueWhere"]: GraphQLTypes["BusinessOrderTypeUniqueWhere"];
	["PageLocalesByLinkUniqueWhere"]: GraphQLTypes["PageLocalesByLinkUniqueWhere"];
	["PageLocalesBySeoUniqueWhere"]: GraphQLTypes["PageLocalesBySeoUniqueWhere"];
	["PageLocalesByContentUniqueWhere"]: GraphQLTypes["PageLocalesByContentUniqueWhere"];
	["PageLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PageLocaleEdge"][]
};
	["PageLocaleEdge"]: {
		node:ModelTypes["PageLocale"]
};
	["Locale"]: {
		_meta?:ModelTypes["LocaleMeta"],
	id:ModelTypes["UUID"],
	code:string,
	label?:string,
	events:ModelTypes["EventLocale"][],
	blogs:ModelTypes["BlogLocale"][],
	pages:ModelTypes["PageLocale"][],
	seos:ModelTypes["SeoLocale"][],
	menus:ModelTypes["MenuLocale"][],
	businessOrderTypes:ModelTypes["BusinessOrderTypeLocale"][],
	eventsByRoot?:ModelTypes["EventLocale"],
	eventsByCover?:ModelTypes["EventLocale"],
	eventsByContent?:ModelTypes["EventLocale"],
	eventsByLink?:ModelTypes["EventLocale"],
	eventsBySeo?:ModelTypes["EventLocale"],
	blogsByRoot?:ModelTypes["BlogLocale"],
	pagesByRoot?:ModelTypes["PageLocale"],
	pagesByLink?:ModelTypes["PageLocale"],
	pagesBySeo?:ModelTypes["PageLocale"],
	pagesByContent?:ModelTypes["PageLocale"],
	seosByRoot?:ModelTypes["SeoLocale"],
	menusByRoot?:ModelTypes["MenuLocale"],
	menusByItems?:ModelTypes["MenuLocale"],
	businessOrderTypesByRoot?:ModelTypes["BusinessOrderTypeLocale"],
	paginateEvents:ModelTypes["EventLocaleConnection"],
	paginateBlogs:ModelTypes["BlogLocaleConnection"],
	paginatePages:ModelTypes["PageLocaleConnection"],
	paginateSeos:ModelTypes["SeoLocaleConnection"],
	paginateMenus:ModelTypes["MenuLocaleConnection"],
	paginateBusinessOrderTypes:ModelTypes["BusinessOrderTypeLocaleConnection"]
};
	["LocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	code?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	events?:ModelTypes["FieldMeta"],
	blogs?:ModelTypes["FieldMeta"],
	pages?:ModelTypes["FieldMeta"],
	seos?:ModelTypes["FieldMeta"],
	menus?:ModelTypes["FieldMeta"],
	businessOrderTypes?:ModelTypes["FieldMeta"]
};
	["EventLocale"]: {
		_meta?:ModelTypes["EventLocaleMeta"],
	id:ModelTypes["UUID"],
	root?:ModelTypes["Event"],
	locale?:ModelTypes["Locale"],
	cover?:ModelTypes["Cover"],
	content?:ModelTypes["Content"],
	availableForWeb?:boolean,
	availableForMobile?:boolean,
	link?:ModelTypes["Linkable"],
	title?:string,
	seo?:ModelTypes["LocalizedSeo"]
};
	["EventLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	cover?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	availableForWeb?:ModelTypes["FieldMeta"],
	availableForMobile?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["Event"]: {
		_meta?:ModelTypes["EventMeta"],
	id:ModelTypes["UUID"],
	order:number,
	locales:ModelTypes["EventLocale"][],
	localesByLocale?:ModelTypes["EventLocale"],
	localesByCover?:ModelTypes["EventLocale"],
	localesByContent?:ModelTypes["EventLocale"],
	localesByLink?:ModelTypes["EventLocale"],
	localesBySeo?:ModelTypes["EventLocale"],
	paginateLocales:ModelTypes["EventLocaleConnection"]
};
	["EventMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["EventLocalesByLocaleUniqueWhere"]: GraphQLTypes["EventLocalesByLocaleUniqueWhere"];
	["EventLocalesByCoverUniqueWhere"]: GraphQLTypes["EventLocalesByCoverUniqueWhere"];
	["EventLocalesByContentUniqueWhere"]: GraphQLTypes["EventLocalesByContentUniqueWhere"];
	["EventLocalesByLinkUniqueWhere"]: GraphQLTypes["EventLocalesByLinkUniqueWhere"];
	["EventLocalesBySeoUniqueWhere"]: GraphQLTypes["EventLocalesBySeoUniqueWhere"];
	["EventLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EventLocaleEdge"][]
};
	["EventLocaleEdge"]: {
		node:ModelTypes["EventLocale"]
};
	["Cover"]: {
		_meta?:ModelTypes["CoverMeta"],
	id:ModelTypes["UUID"],
	primaryTitle?:string,
	secondaryTitle?:string,
	buttonColors?:ModelTypes["ColorPallete"],
	medium?:ModelTypes["Medium"]
};
	["CoverMeta"]: {
		id?:ModelTypes["FieldMeta"],
	primaryTitle?:ModelTypes["FieldMeta"],
	secondaryTitle?:ModelTypes["FieldMeta"],
	buttonColors?:ModelTypes["FieldMeta"],
	medium?:ModelTypes["FieldMeta"]
};
	["LocalizedSeo"]: {
		_meta?:ModelTypes["LocalizedSeoMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	ogImage?:ModelTypes["Image"]
};
	["LocalizedSeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"]
};
	["BlogLocale"]: {
		_meta?:ModelTypes["BlogLocaleMeta"],
	id:ModelTypes["UUID"],
	pageName?:string,
	title?:string,
	lead?:string,
	root?:ModelTypes["Blog"],
	locale?:ModelTypes["Locale"]
};
	["BlogLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	pageName?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"]
};
	["Blog"]: {
		_meta?:ModelTypes["BlogMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["BlogLocale"][],
	localesByLocale?:ModelTypes["BlogLocale"],
	paginateLocales:ModelTypes["BlogLocaleConnection"]
};
	["BlogMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["BlogLocaleOrderBy"]: GraphQLTypes["BlogLocaleOrderBy"];
	["BlogOrderBy"]: GraphQLTypes["BlogOrderBy"];
	["BlogLocalesByLocaleUniqueWhere"]: GraphQLTypes["BlogLocalesByLocaleUniqueWhere"];
	["BlogLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogLocaleEdge"][]
};
	["BlogLocaleEdge"]: {
		node:ModelTypes["BlogLocale"]
};
	["SeoLocale"]: {
		_meta?:ModelTypes["SeoLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	root?:ModelTypes["Seo"],
	locale?:ModelTypes["Locale"]
};
	["SeoLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"]
};
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	ogImage?:ModelTypes["Image"],
	locales:ModelTypes["SeoLocale"][],
	localesByLocale?:ModelTypes["SeoLocale"],
	paginateLocales:ModelTypes["SeoLocaleConnection"]
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["SeoLocaleOrderBy"]: GraphQLTypes["SeoLocaleOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["SeoLocalesByLocaleUniqueWhere"]: GraphQLTypes["SeoLocalesByLocaleUniqueWhere"];
	["SeoLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoLocaleEdge"][]
};
	["SeoLocaleEdge"]: {
		node:ModelTypes["SeoLocale"]
};
	["MenuLocale"]: {
		_meta?:ModelTypes["MenuLocaleMeta"],
	id:ModelTypes["UUID"],
	root?:ModelTypes["SiteMenu"],
	locale?:ModelTypes["Locale"],
	items:ModelTypes["MenuItem"][],
	paginateItems:ModelTypes["MenuItemConnection"]
};
	["MenuLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["SiteMenu"]: {
		_meta?:ModelTypes["SiteMenuMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["MenuLocale"][],
	localesByLocale?:ModelTypes["MenuLocale"],
	localesByItems?:ModelTypes["MenuLocale"],
	paginateLocales:ModelTypes["MenuLocaleConnection"]
};
	["SiteMenuMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["MenuLocaleOrderBy"]: GraphQLTypes["MenuLocaleOrderBy"];
	["SiteMenuOrderBy"]: GraphQLTypes["SiteMenuOrderBy"];
	["SiteMenuLocalesByLocaleUniqueWhere"]: GraphQLTypes["SiteMenuLocalesByLocaleUniqueWhere"];
	["SiteMenuLocalesByItemsUniqueWhere"]: GraphQLTypes["SiteMenuLocalesByItemsUniqueWhere"];
	["MenuLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MenuLocaleEdge"][]
};
	["MenuLocaleEdge"]: {
		node:ModelTypes["MenuLocale"]
};
	["MenuItem"]: {
		_meta?:ModelTypes["MenuItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:ModelTypes["Link"],
	menu?:ModelTypes["MenuLocale"]
};
	["MenuItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	menu?:ModelTypes["FieldMeta"]
};
	["MenuItemOrderBy"]: GraphQLTypes["MenuItemOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["MenuItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MenuItemEdge"][]
};
	["MenuItemEdge"]: {
		node:ModelTypes["MenuItem"]
};
	["BusinessOrderTypeLocale"]: {
		_meta?:ModelTypes["BusinessOrderTypeLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	root?:ModelTypes["BusinessOrderType"],
	locale?:ModelTypes["Locale"]
};
	["BusinessOrderTypeLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"]
};
	["BusinessOrderType"]: {
		_meta?:ModelTypes["BusinessOrderTypeMeta"],
	id:ModelTypes["UUID"],
	order:number,
	locales:ModelTypes["BusinessOrderTypeLocale"][],
	localesByLocale?:ModelTypes["BusinessOrderTypeLocale"],
	paginateLocales:ModelTypes["BusinessOrderTypeLocaleConnection"]
};
	["BusinessOrderTypeMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["BusinessOrderTypeLocaleOrderBy"]: GraphQLTypes["BusinessOrderTypeLocaleOrderBy"];
	["BusinessOrderTypeOrderBy"]: GraphQLTypes["BusinessOrderTypeOrderBy"];
	["BusinessOrderTypeLocalesByLocaleUniqueWhere"]: GraphQLTypes["BusinessOrderTypeLocalesByLocaleUniqueWhere"];
	["BusinessOrderTypeLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BusinessOrderTypeLocaleEdge"][]
};
	["BusinessOrderTypeLocaleEdge"]: {
		node:ModelTypes["BusinessOrderTypeLocale"]
};
	["LocaleEventsByRootUniqueWhere"]: GraphQLTypes["LocaleEventsByRootUniqueWhere"];
	["LocaleEventsByCoverUniqueWhere"]: GraphQLTypes["LocaleEventsByCoverUniqueWhere"];
	["LocaleEventsByContentUniqueWhere"]: GraphQLTypes["LocaleEventsByContentUniqueWhere"];
	["LocaleEventsByLinkUniqueWhere"]: GraphQLTypes["LocaleEventsByLinkUniqueWhere"];
	["LocaleEventsBySeoUniqueWhere"]: GraphQLTypes["LocaleEventsBySeoUniqueWhere"];
	["LocaleBlogsByRootUniqueWhere"]: GraphQLTypes["LocaleBlogsByRootUniqueWhere"];
	["LocalePagesByRootUniqueWhere"]: GraphQLTypes["LocalePagesByRootUniqueWhere"];
	["LocalePagesByLinkUniqueWhere"]: GraphQLTypes["LocalePagesByLinkUniqueWhere"];
	["LocalePagesBySeoUniqueWhere"]: GraphQLTypes["LocalePagesBySeoUniqueWhere"];
	["LocalePagesByContentUniqueWhere"]: GraphQLTypes["LocalePagesByContentUniqueWhere"];
	["LocaleSeosByRootUniqueWhere"]: GraphQLTypes["LocaleSeosByRootUniqueWhere"];
	["LocaleMenusByRootUniqueWhere"]: GraphQLTypes["LocaleMenusByRootUniqueWhere"];
	["LocaleMenusByItemsUniqueWhere"]: GraphQLTypes["LocaleMenusByItemsUniqueWhere"];
	["LocaleBusinessOrderTypesByRootUniqueWhere"]: GraphQLTypes["LocaleBusinessOrderTypesByRootUniqueWhere"];
	["Hero"]: {
		_meta?:ModelTypes["HeroMeta"],
	id:ModelTypes["UUID"],
	showLogo?:boolean,
	middleContent?:string,
	medium?:ModelTypes["Medium"]
};
	["HeroMeta"]: {
		id?:ModelTypes["FieldMeta"],
	showLogo?:ModelTypes["FieldMeta"],
	middleContent?:ModelTypes["FieldMeta"],
	medium?:ModelTypes["FieldMeta"]
};
	["Gallery"]: {
		_meta?:ModelTypes["GalleryMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["GalleryItem"][],
	paginateItems:ModelTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["GalleryItem"]: {
		_meta?:ModelTypes["GalleryItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	caption?:string,
	list?:ModelTypes["Gallery"],
	medium?:ModelTypes["Medium"]
};
	["GalleryItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	caption?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	medium?:ModelTypes["FieldMeta"]
};
	["GalleryItemOrderBy"]: GraphQLTypes["GalleryItemOrderBy"];
	["GalleryOrderBy"]: GraphQLTypes["GalleryOrderBy"];
	["GalleryItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GalleryItemEdge"][]
};
	["GalleryItemEdge"]: {
		node:ModelTypes["GalleryItem"]
};
	["SocialsAndApps"]: {
		_meta?:ModelTypes["SocialsAndAppsMeta"],
	id:ModelTypes["UUID"],
	instagram?:boolean,
	appStore?:boolean,
	googlePlay?:boolean
};
	["SocialsAndAppsMeta"]: {
		id?:ModelTypes["FieldMeta"],
	instagram?:ModelTypes["FieldMeta"],
	appStore?:ModelTypes["FieldMeta"],
	googlePlay?:ModelTypes["FieldMeta"]
};
	["BlogPostList"]: {
		_meta?:ModelTypes["BlogPostListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["BlogPostListItem"][],
	paginateItems:ModelTypes["BlogPostListItemConnection"]
};
	["BlogPostListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["BlogPostListItem"]: {
		_meta?:ModelTypes["BlogPostListItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	caption?:string,
	list?:ModelTypes["BlogPostList"],
	blogPost?:ModelTypes["EventLocale"]
};
	["BlogPostListItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	caption?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	blogPost?:ModelTypes["FieldMeta"]
};
	["BlogPostListItemOrderBy"]: GraphQLTypes["BlogPostListItemOrderBy"];
	["BlogPostListOrderBy"]: GraphQLTypes["BlogPostListOrderBy"];
	["BlogPostListItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogPostListItemEdge"][]
};
	["BlogPostListItemEdge"]: {
		node:ModelTypes["BlogPostListItem"]
};
	["ProductGrid"]: {
		_meta?:ModelTypes["ProductGridMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ProductGridItem"][],
	paginateItems:ModelTypes["ProductGridItemConnection"]
};
	["ProductGridMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ProductGridItem"]: {
		_meta?:ModelTypes["ProductGridItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	goodlokProductId?:string,
	title?:string,
	lead?:string,
	list?:ModelTypes["ProductGrid"],
	medium?:ModelTypes["Medium"],
	link?:ModelTypes["Link"]
};
	["ProductGridItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	goodlokProductId?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	medium?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["ProductGridItemOrderBy"]: GraphQLTypes["ProductGridItemOrderBy"];
	["ProductGridOrderBy"]: GraphQLTypes["ProductGridOrderBy"];
	["ProductGridItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductGridItemEdge"][]
};
	["ProductGridItemEdge"]: {
		node:ModelTypes["ProductGridItem"]
};
	["ContentReferenceOrderBy"]: GraphQLTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["HeroOrderBy"]: GraphQLTypes["HeroOrderBy"];
	["SocialsAndAppsOrderBy"]: GraphQLTypes["SocialsAndAppsOrderBy"];
	["ContentReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceEdge"][]
};
	["ContentReferenceEdge"]: {
		node:ModelTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: GraphQLTypes["ContentBlocksByReferencesUniqueWhere"];
	["ContentBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentBlockEdge"][]
};
	["ContentBlockEdge"]: {
		node:ModelTypes["ContentBlock"]
};
	["ContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentEdge"][]
};
	["ContentEdge"]: {
		node:ModelTypes["Content"]
};
	["ContentCreateInput"]: GraphQLTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: GraphQLTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: GraphQLTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateColorPalleteEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateColorPalleteEntityRelationInput"];
	["ContentReferenceCreateMediumEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateMediumEntityRelationInput"];
	["MediumUniqueWhere"]: GraphQLTypes["MediumUniqueWhere"];
	["MediumCreateInput"]: GraphQLTypes["MediumCreateInput"];
	["MediumCreateImageEntityRelationInput"]: GraphQLTypes["MediumCreateImageEntityRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["MediumCreateVideoEntityRelationInput"]: GraphQLTypes["MediumCreateVideoEntityRelationInput"];
	["VideoUniqueWhere"]: GraphQLTypes["VideoUniqueWhere"];
	["VideoCreateInput"]: GraphQLTypes["VideoCreateInput"];
	["VideoCreatePosterEntityRelationInput"]: GraphQLTypes["VideoCreatePosterEntityRelationInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreatePageEntityRelationInput"]: GraphQLTypes["LinkableCreatePageEntityRelationInput"];
	["PageLocaleWithoutLinkCreateInput"]: GraphQLTypes["PageLocaleWithoutLinkCreateInput"];
	["PageLocaleCreateRootEntityRelationInput"]: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"];
	["PageWithoutLocalesCreateInput"]: GraphQLTypes["PageWithoutLocalesCreateInput"];
	["PageLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPagesCreateInput"]: GraphQLTypes["LocaleWithoutPagesCreateInput"];
	["LocaleCreateEventsEntityRelationInput"]: GraphQLTypes["LocaleCreateEventsEntityRelationInput"];
	["EventLocaleWithoutLocaleCreateInput"]: GraphQLTypes["EventLocaleWithoutLocaleCreateInput"];
	["EventLocaleCreateRootEntityRelationInput"]: GraphQLTypes["EventLocaleCreateRootEntityRelationInput"];
	["EventWithoutLocalesCreateInput"]: GraphQLTypes["EventWithoutLocalesCreateInput"];
	["EventLocaleCreateCoverEntityRelationInput"]: GraphQLTypes["EventLocaleCreateCoverEntityRelationInput"];
	["CoverCreateInput"]: GraphQLTypes["CoverCreateInput"];
	["CoverCreateButtonColorsEntityRelationInput"]: GraphQLTypes["CoverCreateButtonColorsEntityRelationInput"];
	["CoverCreateMediumEntityRelationInput"]: GraphQLTypes["CoverCreateMediumEntityRelationInput"];
	["EventLocaleCreateContentEntityRelationInput"]: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"];
	["EventLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["EventLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutEventCreateInput"]: GraphQLTypes["LinkableWithoutEventCreateInput"];
	["EventLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"];
	["LocalizedSeoCreateInput"]: GraphQLTypes["LocalizedSeoCreateInput"];
	["LocalizedSeoCreateOgImageEntityRelationInput"]: GraphQLTypes["LocalizedSeoCreateOgImageEntityRelationInput"];
	["LocaleCreateBlogsEntityRelationInput"]: GraphQLTypes["LocaleCreateBlogsEntityRelationInput"];
	["BlogLocaleWithoutLocaleCreateInput"]: GraphQLTypes["BlogLocaleWithoutLocaleCreateInput"];
	["BlogLocaleCreateRootEntityRelationInput"]: GraphQLTypes["BlogLocaleCreateRootEntityRelationInput"];
	["BlogWithoutLocalesCreateInput"]: GraphQLTypes["BlogWithoutLocalesCreateInput"];
	["LocaleCreateSeosEntityRelationInput"]: GraphQLTypes["LocaleCreateSeosEntityRelationInput"];
	["SeoLocaleWithoutLocaleCreateInput"]: GraphQLTypes["SeoLocaleWithoutLocaleCreateInput"];
	["SeoLocaleCreateRootEntityRelationInput"]: GraphQLTypes["SeoLocaleCreateRootEntityRelationInput"];
	["SeoWithoutLocalesCreateInput"]: GraphQLTypes["SeoWithoutLocalesCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["LocaleCreateMenusEntityRelationInput"]: GraphQLTypes["LocaleCreateMenusEntityRelationInput"];
	["MenuLocaleWithoutLocaleCreateInput"]: GraphQLTypes["MenuLocaleWithoutLocaleCreateInput"];
	["MenuLocaleCreateRootEntityRelationInput"]: GraphQLTypes["MenuLocaleCreateRootEntityRelationInput"];
	["SiteMenuWithoutLocalesCreateInput"]: GraphQLTypes["SiteMenuWithoutLocalesCreateInput"];
	["MenuLocaleCreateItemsEntityRelationInput"]: GraphQLTypes["MenuLocaleCreateItemsEntityRelationInput"];
	["MenuItemWithoutMenuCreateInput"]: GraphQLTypes["MenuItemWithoutMenuCreateInput"];
	["MenuItemCreateLinkEntityRelationInput"]: GraphQLTypes["MenuItemCreateLinkEntityRelationInput"];
	["LocaleCreateBusinessOrderTypesEntityRelationInput"]: GraphQLTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"];
	["BusinessOrderTypeLocaleWithoutLocaleCreateInput"]: GraphQLTypes["BusinessOrderTypeLocaleWithoutLocaleCreateInput"];
	["BusinessOrderTypeLocaleCreateRootEntityRelationInput"]: GraphQLTypes["BusinessOrderTypeLocaleCreateRootEntityRelationInput"];
	["BusinessOrderTypeWithoutLocalesCreateInput"]: GraphQLTypes["BusinessOrderTypeWithoutLocalesCreateInput"];
	["PageLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"];
	["PageLocaleCreateContentEntityRelationInput"]: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"];
	["LinkableCreateEventEntityRelationInput"]: GraphQLTypes["LinkableCreateEventEntityRelationInput"];
	["EventLocaleWithoutLinkCreateInput"]: GraphQLTypes["EventLocaleWithoutLinkCreateInput"];
	["EventLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["EventLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutEventsCreateInput"]: GraphQLTypes["LocaleWithoutEventsCreateInput"];
	["LocaleCreatePagesEntityRelationInput"]: GraphQLTypes["LocaleCreatePagesEntityRelationInput"];
	["PageLocaleWithoutLocaleCreateInput"]: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"];
	["PageLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutPageCreateInput"]: GraphQLTypes["LinkableWithoutPageCreateInput"];
	["ContentReferenceCreateHeroEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateHeroEntityRelationInput"];
	["HeroUniqueWhere"]: GraphQLTypes["HeroUniqueWhere"];
	["HeroCreateInput"]: GraphQLTypes["HeroCreateInput"];
	["HeroCreateMediumEntityRelationInput"]: GraphQLTypes["HeroCreateMediumEntityRelationInput"];
	["ContentReferenceCreateGalleryEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateGalleryEntityRelationInput"];
	["GalleryUniqueWhere"]: GraphQLTypes["GalleryUniqueWhere"];
	["GalleryItemUniqueWhere"]: GraphQLTypes["GalleryItemUniqueWhere"];
	["GalleryCreateInput"]: GraphQLTypes["GalleryCreateInput"];
	["GalleryCreateItemsEntityRelationInput"]: GraphQLTypes["GalleryCreateItemsEntityRelationInput"];
	["GalleryItemWithoutListCreateInput"]: GraphQLTypes["GalleryItemWithoutListCreateInput"];
	["GalleryItemCreateMediumEntityRelationInput"]: GraphQLTypes["GalleryItemCreateMediumEntityRelationInput"];
	["ContentReferenceCreateSocialsAndAppsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"];
	["SocialsAndAppsUniqueWhere"]: GraphQLTypes["SocialsAndAppsUniqueWhere"];
	["SocialsAndAppsCreateInput"]: GraphQLTypes["SocialsAndAppsCreateInput"];
	["ContentReferenceCreateBlogPostsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlogPostsEntityRelationInput"];
	["BlogPostListUniqueWhere"]: GraphQLTypes["BlogPostListUniqueWhere"];
	["BlogPostListItemUniqueWhere"]: GraphQLTypes["BlogPostListItemUniqueWhere"];
	["BlogPostListCreateInput"]: GraphQLTypes["BlogPostListCreateInput"];
	["BlogPostListCreateItemsEntityRelationInput"]: GraphQLTypes["BlogPostListCreateItemsEntityRelationInput"];
	["BlogPostListItemWithoutListCreateInput"]: GraphQLTypes["BlogPostListItemWithoutListCreateInput"];
	["BlogPostListItemCreateBlogPostEntityRelationInput"]: GraphQLTypes["BlogPostListItemCreateBlogPostEntityRelationInput"];
	["EventLocaleCreateInput"]: GraphQLTypes["EventLocaleCreateInput"];
	["ContentReferenceCreateProductGridEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateProductGridEntityRelationInput"];
	["ProductGridUniqueWhere"]: GraphQLTypes["ProductGridUniqueWhere"];
	["ProductGridItemUniqueWhere"]: GraphQLTypes["ProductGridItemUniqueWhere"];
	["ProductGridCreateInput"]: GraphQLTypes["ProductGridCreateInput"];
	["ProductGridCreateItemsEntityRelationInput"]: GraphQLTypes["ProductGridCreateItemsEntityRelationInput"];
	["ProductGridItemWithoutListCreateInput"]: GraphQLTypes["ProductGridItemWithoutListCreateInput"];
	["ProductGridItemCreateMediumEntityRelationInput"]: GraphQLTypes["ProductGridItemCreateMediumEntityRelationInput"];
	["ProductGridItemCreateLinkEntityRelationInput"]: GraphQLTypes["ProductGridItemCreateLinkEntityRelationInput"];
	["ContentUpdateInput"]: GraphQLTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: GraphQLTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: GraphQLTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: GraphQLTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateColorPalleteEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"];
	["ContentReferenceUpsertColorPalleteRelationInput"]: GraphQLTypes["ContentReferenceUpsertColorPalleteRelationInput"];
	["ContentReferenceUpdateMediumEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateMediumEntityRelationInput"];
	["MediumUpdateInput"]: GraphQLTypes["MediumUpdateInput"];
	["MediumUpdateImageEntityRelationInput"]: GraphQLTypes["MediumUpdateImageEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["MediumUpsertImageRelationInput"]: GraphQLTypes["MediumUpsertImageRelationInput"];
	["MediumUpdateVideoEntityRelationInput"]: GraphQLTypes["MediumUpdateVideoEntityRelationInput"];
	["VideoUpdateInput"]: GraphQLTypes["VideoUpdateInput"];
	["VideoUpdatePosterEntityRelationInput"]: GraphQLTypes["VideoUpdatePosterEntityRelationInput"];
	["VideoUpsertPosterRelationInput"]: GraphQLTypes["VideoUpsertPosterRelationInput"];
	["MediumUpsertVideoRelationInput"]: GraphQLTypes["MediumUpsertVideoRelationInput"];
	["ContentReferenceUpsertMediumRelationInput"]: GraphQLTypes["ContentReferenceUpsertMediumRelationInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdatePageEntityRelationInput"]: GraphQLTypes["LinkableUpdatePageEntityRelationInput"];
	["PageLocaleWithoutLinkUpdateInput"]: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"];
	["PageLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"];
	["PageWithoutLocalesUpdateInput"]: GraphQLTypes["PageWithoutLocalesUpdateInput"];
	["PageLocaleUpsertRootRelationInput"]: GraphQLTypes["PageLocaleUpsertRootRelationInput"];
	["PageLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPagesUpdateInput"]: GraphQLTypes["LocaleWithoutPagesUpdateInput"];
	["LocaleUpdateEventsEntityRelationInput"]: GraphQLTypes["LocaleUpdateEventsEntityRelationInput"];
	["LocaleUpdateEventsRelationInput"]: GraphQLTypes["LocaleUpdateEventsRelationInput"];
	["EventLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["EventLocaleWithoutLocaleUpdateInput"];
	["EventLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateRootEntityRelationInput"];
	["EventWithoutLocalesUpdateInput"]: GraphQLTypes["EventWithoutLocalesUpdateInput"];
	["EventLocaleUpsertRootRelationInput"]: GraphQLTypes["EventLocaleUpsertRootRelationInput"];
	["EventLocaleUpdateCoverEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateCoverEntityRelationInput"];
	["CoverUpdateInput"]: GraphQLTypes["CoverUpdateInput"];
	["CoverUpdateButtonColorsEntityRelationInput"]: GraphQLTypes["CoverUpdateButtonColorsEntityRelationInput"];
	["CoverUpsertButtonColorsRelationInput"]: GraphQLTypes["CoverUpsertButtonColorsRelationInput"];
	["CoverUpdateMediumEntityRelationInput"]: GraphQLTypes["CoverUpdateMediumEntityRelationInput"];
	["CoverUpsertMediumRelationInput"]: GraphQLTypes["CoverUpsertMediumRelationInput"];
	["EventLocaleUpsertCoverRelationInput"]: GraphQLTypes["EventLocaleUpsertCoverRelationInput"];
	["EventLocaleUpdateContentEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"];
	["EventLocaleUpsertContentRelationInput"]: GraphQLTypes["EventLocaleUpsertContentRelationInput"];
	["EventLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutEventUpdateInput"]: GraphQLTypes["LinkableWithoutEventUpdateInput"];
	["EventLocaleUpsertLinkRelationInput"]: GraphQLTypes["EventLocaleUpsertLinkRelationInput"];
	["EventLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"];
	["LocalizedSeoUpdateInput"]: GraphQLTypes["LocalizedSeoUpdateInput"];
	["LocalizedSeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["LocalizedSeoUpdateOgImageEntityRelationInput"];
	["LocalizedSeoUpsertOgImageRelationInput"]: GraphQLTypes["LocalizedSeoUpsertOgImageRelationInput"];
	["EventLocaleUpsertSeoRelationInput"]: GraphQLTypes["EventLocaleUpsertSeoRelationInput"];
	["LocaleUpsertEventsRelationInput"]: GraphQLTypes["LocaleUpsertEventsRelationInput"];
	["LocaleUpdateBlogsEntityRelationInput"]: GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"];
	["LocaleUpdateBlogsRelationInput"]: GraphQLTypes["LocaleUpdateBlogsRelationInput"];
	["BlogLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["BlogLocaleWithoutLocaleUpdateInput"];
	["BlogLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["BlogLocaleUpdateRootEntityRelationInput"];
	["BlogWithoutLocalesUpdateInput"]: GraphQLTypes["BlogWithoutLocalesUpdateInput"];
	["BlogLocaleUpsertRootRelationInput"]: GraphQLTypes["BlogLocaleUpsertRootRelationInput"];
	["LocaleUpsertBlogsRelationInput"]: GraphQLTypes["LocaleUpsertBlogsRelationInput"];
	["LocaleUpdateSeosEntityRelationInput"]: GraphQLTypes["LocaleUpdateSeosEntityRelationInput"];
	["LocaleUpdateSeosRelationInput"]: GraphQLTypes["LocaleUpdateSeosRelationInput"];
	["SeoLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["SeoLocaleWithoutLocaleUpdateInput"];
	["SeoLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["SeoLocaleUpdateRootEntityRelationInput"];
	["SeoWithoutLocalesUpdateInput"]: GraphQLTypes["SeoWithoutLocalesUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["SeoLocaleUpsertRootRelationInput"]: GraphQLTypes["SeoLocaleUpsertRootRelationInput"];
	["LocaleUpsertSeosRelationInput"]: GraphQLTypes["LocaleUpsertSeosRelationInput"];
	["LocaleUpdateMenusEntityRelationInput"]: GraphQLTypes["LocaleUpdateMenusEntityRelationInput"];
	["LocaleUpdateMenusRelationInput"]: GraphQLTypes["LocaleUpdateMenusRelationInput"];
	["MenuLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["MenuLocaleWithoutLocaleUpdateInput"];
	["MenuLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["MenuLocaleUpdateRootEntityRelationInput"];
	["SiteMenuWithoutLocalesUpdateInput"]: GraphQLTypes["SiteMenuWithoutLocalesUpdateInput"];
	["MenuLocaleUpsertRootRelationInput"]: GraphQLTypes["MenuLocaleUpsertRootRelationInput"];
	["MenuLocaleUpdateItemsEntityRelationInput"]: GraphQLTypes["MenuLocaleUpdateItemsEntityRelationInput"];
	["MenuLocaleUpdateItemsRelationInput"]: GraphQLTypes["MenuLocaleUpdateItemsRelationInput"];
	["MenuItemWithoutMenuUpdateInput"]: GraphQLTypes["MenuItemWithoutMenuUpdateInput"];
	["MenuItemUpdateLinkEntityRelationInput"]: GraphQLTypes["MenuItemUpdateLinkEntityRelationInput"];
	["MenuItemUpsertLinkRelationInput"]: GraphQLTypes["MenuItemUpsertLinkRelationInput"];
	["MenuLocaleUpsertItemsRelationInput"]: GraphQLTypes["MenuLocaleUpsertItemsRelationInput"];
	["LocaleUpsertMenusRelationInput"]: GraphQLTypes["LocaleUpsertMenusRelationInput"];
	["LocaleUpdateBusinessOrderTypesEntityRelationInput"]: GraphQLTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"];
	["LocaleUpdateBusinessOrderTypesRelationInput"]: GraphQLTypes["LocaleUpdateBusinessOrderTypesRelationInput"];
	["BusinessOrderTypeLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["BusinessOrderTypeLocaleWithoutLocaleUpdateInput"];
	["BusinessOrderTypeLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["BusinessOrderTypeLocaleUpdateRootEntityRelationInput"];
	["BusinessOrderTypeWithoutLocalesUpdateInput"]: GraphQLTypes["BusinessOrderTypeWithoutLocalesUpdateInput"];
	["BusinessOrderTypeLocaleUpsertRootRelationInput"]: GraphQLTypes["BusinessOrderTypeLocaleUpsertRootRelationInput"];
	["LocaleUpsertBusinessOrderTypesRelationInput"]: GraphQLTypes["LocaleUpsertBusinessOrderTypesRelationInput"];
	["PageLocaleUpsertLocaleRelationInput"]: GraphQLTypes["PageLocaleUpsertLocaleRelationInput"];
	["PageLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"];
	["PageLocaleUpsertSeoRelationInput"]: GraphQLTypes["PageLocaleUpsertSeoRelationInput"];
	["PageLocaleUpdateContentEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"];
	["PageLocaleUpsertContentRelationInput"]: GraphQLTypes["PageLocaleUpsertContentRelationInput"];
	["LinkableUpsertPageRelationInput"]: GraphQLTypes["LinkableUpsertPageRelationInput"];
	["LinkableUpdateEventEntityRelationInput"]: GraphQLTypes["LinkableUpdateEventEntityRelationInput"];
	["EventLocaleWithoutLinkUpdateInput"]: GraphQLTypes["EventLocaleWithoutLinkUpdateInput"];
	["EventLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutEventsUpdateInput"]: GraphQLTypes["LocaleWithoutEventsUpdateInput"];
	["LocaleUpdatePagesEntityRelationInput"]: GraphQLTypes["LocaleUpdatePagesEntityRelationInput"];
	["LocaleUpdatePagesRelationInput"]: GraphQLTypes["LocaleUpdatePagesRelationInput"];
	["PageLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"];
	["PageLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutPageUpdateInput"]: GraphQLTypes["LinkableWithoutPageUpdateInput"];
	["PageLocaleUpsertLinkRelationInput"]: GraphQLTypes["PageLocaleUpsertLinkRelationInput"];
	["LocaleUpsertPagesRelationInput"]: GraphQLTypes["LocaleUpsertPagesRelationInput"];
	["EventLocaleUpsertLocaleRelationInput"]: GraphQLTypes["EventLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertEventRelationInput"]: GraphQLTypes["LinkableUpsertEventRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: GraphQLTypes["LinkUpsertInternalLinkRelationInput"];
	["ContentReferenceUpsertLinkRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdateHeroEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateHeroEntityRelationInput"];
	["HeroUpdateInput"]: GraphQLTypes["HeroUpdateInput"];
	["HeroUpdateMediumEntityRelationInput"]: GraphQLTypes["HeroUpdateMediumEntityRelationInput"];
	["HeroUpsertMediumRelationInput"]: GraphQLTypes["HeroUpsertMediumRelationInput"];
	["ContentReferenceUpsertHeroRelationInput"]: GraphQLTypes["ContentReferenceUpsertHeroRelationInput"];
	["ContentReferenceUpdateGalleryEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateGalleryEntityRelationInput"];
	["GalleryUpdateInput"]: GraphQLTypes["GalleryUpdateInput"];
	["GalleryUpdateItemsEntityRelationInput"]: GraphQLTypes["GalleryUpdateItemsEntityRelationInput"];
	["GalleryUpdateItemsRelationInput"]: GraphQLTypes["GalleryUpdateItemsRelationInput"];
	["GalleryItemWithoutListUpdateInput"]: GraphQLTypes["GalleryItemWithoutListUpdateInput"];
	["GalleryItemUpdateMediumEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateMediumEntityRelationInput"];
	["GalleryItemUpsertMediumRelationInput"]: GraphQLTypes["GalleryItemUpsertMediumRelationInput"];
	["GalleryUpsertItemsRelationInput"]: GraphQLTypes["GalleryUpsertItemsRelationInput"];
	["ContentReferenceUpsertGalleryRelationInput"]: GraphQLTypes["ContentReferenceUpsertGalleryRelationInput"];
	["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"];
	["SocialsAndAppsUpdateInput"]: GraphQLTypes["SocialsAndAppsUpdateInput"];
	["ContentReferenceUpsertSocialsAndAppsRelationInput"]: GraphQLTypes["ContentReferenceUpsertSocialsAndAppsRelationInput"];
	["ContentReferenceUpdateBlogPostsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"];
	["BlogPostListUpdateInput"]: GraphQLTypes["BlogPostListUpdateInput"];
	["BlogPostListUpdateItemsEntityRelationInput"]: GraphQLTypes["BlogPostListUpdateItemsEntityRelationInput"];
	["BlogPostListUpdateItemsRelationInput"]: GraphQLTypes["BlogPostListUpdateItemsRelationInput"];
	["BlogPostListItemWithoutListUpdateInput"]: GraphQLTypes["BlogPostListItemWithoutListUpdateInput"];
	["BlogPostListItemUpdateBlogPostEntityRelationInput"]: GraphQLTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"];
	["EventLocaleUpdateInput"]: GraphQLTypes["EventLocaleUpdateInput"];
	["BlogPostListItemUpsertBlogPostRelationInput"]: GraphQLTypes["BlogPostListItemUpsertBlogPostRelationInput"];
	["BlogPostListUpsertItemsRelationInput"]: GraphQLTypes["BlogPostListUpsertItemsRelationInput"];
	["ContentReferenceUpsertBlogPostsRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlogPostsRelationInput"];
	["ContentReferenceUpdateProductGridEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateProductGridEntityRelationInput"];
	["ProductGridUpdateInput"]: GraphQLTypes["ProductGridUpdateInput"];
	["ProductGridUpdateItemsEntityRelationInput"]: GraphQLTypes["ProductGridUpdateItemsEntityRelationInput"];
	["ProductGridUpdateItemsRelationInput"]: GraphQLTypes["ProductGridUpdateItemsRelationInput"];
	["ProductGridItemWithoutListUpdateInput"]: GraphQLTypes["ProductGridItemWithoutListUpdateInput"];
	["ProductGridItemUpdateMediumEntityRelationInput"]: GraphQLTypes["ProductGridItemUpdateMediumEntityRelationInput"];
	["ProductGridItemUpsertMediumRelationInput"]: GraphQLTypes["ProductGridItemUpsertMediumRelationInput"];
	["ProductGridItemUpdateLinkEntityRelationInput"]: GraphQLTypes["ProductGridItemUpdateLinkEntityRelationInput"];
	["ProductGridItemUpsertLinkRelationInput"]: GraphQLTypes["ProductGridItemUpsertLinkRelationInput"];
	["ProductGridUpsertItemsRelationInput"]: GraphQLTypes["ProductGridUpsertItemsRelationInput"];
	["ContentReferenceUpsertProductGridRelationInput"]: GraphQLTypes["ContentReferenceUpsertProductGridRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: GraphQLTypes["ContentUpsertBlocksRelationInput"];
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: GraphQLTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: GraphQLTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: GraphQLTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceCreateInput"]: GraphQLTypes["ContentReferenceCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentReferenceUpdateInput"]: GraphQLTypes["ContentReferenceUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentReferenceUpsertBlockRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"];
	["CoverConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CoverEdge"][]
};
	["CoverEdge"]: {
		node:ModelTypes["Cover"]
};
	["EventConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EventEdge"][]
};
	["EventEdge"]: {
		node:ModelTypes["Event"]
};
	["EventCreateInput"]: GraphQLTypes["EventCreateInput"];
	["EventCreateLocalesEntityRelationInput"]: GraphQLTypes["EventCreateLocalesEntityRelationInput"];
	["EventLocaleWithoutRootCreateInput"]: GraphQLTypes["EventLocaleWithoutRootCreateInput"];
	["EventUpdateInput"]: GraphQLTypes["EventUpdateInput"];
	["EventUpdateLocalesEntityRelationInput"]: GraphQLTypes["EventUpdateLocalesEntityRelationInput"];
	["EventUpdateLocalesRelationInput"]: GraphQLTypes["EventUpdateLocalesRelationInput"];
	["EventLocaleWithoutRootUpdateInput"]: GraphQLTypes["EventLocaleWithoutRootUpdateInput"];
	["EventUpsertLocalesRelationInput"]: GraphQLTypes["EventUpsertLocalesRelationInput"];
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["ImageList"]: {
		_meta?:ModelTypes["ImageListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ImageItem"][],
	paginateItems:ModelTypes["ImageItemConnection"]
};
	["ImageListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ImageItem"]: {
		_meta?:ModelTypes["ImageItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["ImageList"],
	image?:ModelTypes["Image"]
};
	["ImageItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["ImageListWhere"]: GraphQLTypes["ImageListWhere"];
	["ImageItemWhere"]: GraphQLTypes["ImageItemWhere"];
	["ImageItemOrderBy"]: GraphQLTypes["ImageItemOrderBy"];
	["ImageListOrderBy"]: GraphQLTypes["ImageListOrderBy"];
	["ImageItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageItemEdge"][]
};
	["ImageItemEdge"]: {
		node:ModelTypes["ImageItem"]
};
	["ImageListUniqueWhere"]: GraphQLTypes["ImageListUniqueWhere"];
	["ImageItemUniqueWhere"]: GraphQLTypes["ImageItemUniqueWhere"];
	["ImageListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageListEdge"][]
};
	["ImageListEdge"]: {
		node:ModelTypes["ImageList"]
};
	["ImageListCreateInput"]: GraphQLTypes["ImageListCreateInput"];
	["ImageListCreateItemsEntityRelationInput"]: GraphQLTypes["ImageListCreateItemsEntityRelationInput"];
	["ImageItemWithoutListCreateInput"]: GraphQLTypes["ImageItemWithoutListCreateInput"];
	["ImageItemCreateImageEntityRelationInput"]: GraphQLTypes["ImageItemCreateImageEntityRelationInput"];
	["ImageListUpdateInput"]: GraphQLTypes["ImageListUpdateInput"];
	["ImageListUpdateItemsEntityRelationInput"]: GraphQLTypes["ImageListUpdateItemsEntityRelationInput"];
	["ImageListUpdateItemsRelationInput"]: GraphQLTypes["ImageListUpdateItemsRelationInput"];
	["ImageItemWithoutListUpdateInput"]: GraphQLTypes["ImageItemWithoutListUpdateInput"];
	["ImageItemUpdateImageEntityRelationInput"]: GraphQLTypes["ImageItemUpdateImageEntityRelationInput"];
	["ImageItemUpsertImageRelationInput"]: GraphQLTypes["ImageItemUpsertImageRelationInput"];
	["ImageListUpsertItemsRelationInput"]: GraphQLTypes["ImageListUpsertItemsRelationInput"];
	["ImageItemCreateInput"]: GraphQLTypes["ImageItemCreateInput"];
	["ImageItemCreateListEntityRelationInput"]: GraphQLTypes["ImageItemCreateListEntityRelationInput"];
	["ImageListWithoutItemsCreateInput"]: GraphQLTypes["ImageListWithoutItemsCreateInput"];
	["ImageItemUpdateInput"]: GraphQLTypes["ImageItemUpdateInput"];
	["ImageItemUpdateListEntityRelationInput"]: GraphQLTypes["ImageItemUpdateListEntityRelationInput"];
	["ImageListWithoutItemsUpdateInput"]: GraphQLTypes["ImageListWithoutItemsUpdateInput"];
	["ImageItemUpsertListRelationInput"]: GraphQLTypes["ImageItemUpsertListRelationInput"];
	["LocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LocaleEdge"][]
};
	["LocaleEdge"]: {
		node:ModelTypes["Locale"]
};
	["LocaleCreateInput"]: GraphQLTypes["LocaleCreateInput"];
	["LocaleUpdateInput"]: GraphQLTypes["LocaleUpdateInput"];
	["MediumConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MediumEdge"][]
};
	["MediumEdge"]: {
		node:ModelTypes["Medium"]
};
	["VideoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["VideoEdge"][]
};
	["VideoEdge"]: {
		node:ModelTypes["Video"]
};
	["BlogConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogEdge"][]
};
	["BlogEdge"]: {
		node:ModelTypes["Blog"]
};
	["BlogCreateInput"]: GraphQLTypes["BlogCreateInput"];
	["BlogCreateLocalesEntityRelationInput"]: GraphQLTypes["BlogCreateLocalesEntityRelationInput"];
	["BlogLocaleWithoutRootCreateInput"]: GraphQLTypes["BlogLocaleWithoutRootCreateInput"];
	["BlogLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["BlogLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBlogsCreateInput"]: GraphQLTypes["LocaleWithoutBlogsCreateInput"];
	["BlogUpdateInput"]: GraphQLTypes["BlogUpdateInput"];
	["BlogUpdateLocalesEntityRelationInput"]: GraphQLTypes["BlogUpdateLocalesEntityRelationInput"];
	["BlogUpdateLocalesRelationInput"]: GraphQLTypes["BlogUpdateLocalesRelationInput"];
	["BlogLocaleWithoutRootUpdateInput"]: GraphQLTypes["BlogLocaleWithoutRootUpdateInput"];
	["BlogLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["BlogLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBlogsUpdateInput"]: GraphQLTypes["LocaleWithoutBlogsUpdateInput"];
	["BlogLocaleUpsertLocaleRelationInput"]: GraphQLTypes["BlogLocaleUpsertLocaleRelationInput"];
	["BlogUpsertLocalesRelationInput"]: GraphQLTypes["BlogUpsertLocalesRelationInput"];
	["BlogLocaleCreateInput"]: GraphQLTypes["BlogLocaleCreateInput"];
	["BlogLocaleUpdateInput"]: GraphQLTypes["BlogLocaleUpdateInput"];
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["LinkableConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkableEdge"][]
};
	["LinkableEdge"]: {
		node:ModelTypes["Linkable"]
};
	["PageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PageEdge"][]
};
	["PageEdge"]: {
		node:ModelTypes["Page"]
};
	["PageCreateInput"]: GraphQLTypes["PageCreateInput"];
	["PageCreateLocalesEntityRelationInput"]: GraphQLTypes["PageCreateLocalesEntityRelationInput"];
	["PageLocaleWithoutRootCreateInput"]: GraphQLTypes["PageLocaleWithoutRootCreateInput"];
	["PageUpdateInput"]: GraphQLTypes["PageUpdateInput"];
	["PageUpdateLocalesEntityRelationInput"]: GraphQLTypes["PageUpdateLocalesEntityRelationInput"];
	["PageUpdateLocalesRelationInput"]: GraphQLTypes["PageUpdateLocalesRelationInput"];
	["PageLocaleWithoutRootUpdateInput"]: GraphQLTypes["PageLocaleWithoutRootUpdateInput"];
	["PageUpsertLocalesRelationInput"]: GraphQLTypes["PageUpsertLocalesRelationInput"];
	["PageLocaleCreateInput"]: GraphQLTypes["PageLocaleCreateInput"];
	["PageLocaleUpdateInput"]: GraphQLTypes["PageLocaleUpdateInput"];
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateLocalesEntityRelationInput"]: GraphQLTypes["SeoCreateLocalesEntityRelationInput"];
	["SeoLocaleWithoutRootCreateInput"]: GraphQLTypes["SeoLocaleWithoutRootCreateInput"];
	["SeoLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["SeoLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutSeosCreateInput"]: GraphQLTypes["LocaleWithoutSeosCreateInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateLocalesEntityRelationInput"]: GraphQLTypes["SeoUpdateLocalesEntityRelationInput"];
	["SeoUpdateLocalesRelationInput"]: GraphQLTypes["SeoUpdateLocalesRelationInput"];
	["SeoLocaleWithoutRootUpdateInput"]: GraphQLTypes["SeoLocaleWithoutRootUpdateInput"];
	["SeoLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["SeoLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutSeosUpdateInput"]: GraphQLTypes["LocaleWithoutSeosUpdateInput"];
	["SeoLocaleUpsertLocaleRelationInput"]: GraphQLTypes["SeoLocaleUpsertLocaleRelationInput"];
	["SeoUpsertLocalesRelationInput"]: GraphQLTypes["SeoUpsertLocalesRelationInput"];
	["SeoLocaleCreateInput"]: GraphQLTypes["SeoLocaleCreateInput"];
	["SeoLocaleUpdateInput"]: GraphQLTypes["SeoLocaleUpdateInput"];
	["LocalizedSeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LocalizedSeoEdge"][]
};
	["LocalizedSeoEdge"]: {
		node:ModelTypes["LocalizedSeo"]
};
	["HeroConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeroEdge"][]
};
	["HeroEdge"]: {
		node:ModelTypes["Hero"]
};
	["GalleryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GalleryEdge"][]
};
	["GalleryEdge"]: {
		node:ModelTypes["Gallery"]
};
	["GalleryItemCreateInput"]: GraphQLTypes["GalleryItemCreateInput"];
	["GalleryItemCreateListEntityRelationInput"]: GraphQLTypes["GalleryItemCreateListEntityRelationInput"];
	["GalleryWithoutItemsCreateInput"]: GraphQLTypes["GalleryWithoutItemsCreateInput"];
	["GalleryItemUpdateInput"]: GraphQLTypes["GalleryItemUpdateInput"];
	["GalleryItemUpdateListEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"];
	["GalleryWithoutItemsUpdateInput"]: GraphQLTypes["GalleryWithoutItemsUpdateInput"];
	["GalleryItemUpsertListRelationInput"]: GraphQLTypes["GalleryItemUpsertListRelationInput"];
	["SocialsAndAppsConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialsAndAppsEdge"][]
};
	["SocialsAndAppsEdge"]: {
		node:ModelTypes["SocialsAndApps"]
};
	["SiteMenuConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SiteMenuEdge"][]
};
	["SiteMenuEdge"]: {
		node:ModelTypes["SiteMenu"]
};
	["SiteMenuCreateInput"]: GraphQLTypes["SiteMenuCreateInput"];
	["SiteMenuCreateLocalesEntityRelationInput"]: GraphQLTypes["SiteMenuCreateLocalesEntityRelationInput"];
	["MenuLocaleWithoutRootCreateInput"]: GraphQLTypes["MenuLocaleWithoutRootCreateInput"];
	["MenuLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["MenuLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutMenusCreateInput"]: GraphQLTypes["LocaleWithoutMenusCreateInput"];
	["SiteMenuUpdateInput"]: GraphQLTypes["SiteMenuUpdateInput"];
	["SiteMenuUpdateLocalesEntityRelationInput"]: GraphQLTypes["SiteMenuUpdateLocalesEntityRelationInput"];
	["SiteMenuUpdateLocalesRelationInput"]: GraphQLTypes["SiteMenuUpdateLocalesRelationInput"];
	["MenuLocaleWithoutRootUpdateInput"]: GraphQLTypes["MenuLocaleWithoutRootUpdateInput"];
	["MenuLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["MenuLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutMenusUpdateInput"]: GraphQLTypes["LocaleWithoutMenusUpdateInput"];
	["MenuLocaleUpsertLocaleRelationInput"]: GraphQLTypes["MenuLocaleUpsertLocaleRelationInput"];
	["SiteMenuUpsertLocalesRelationInput"]: GraphQLTypes["SiteMenuUpsertLocalesRelationInput"];
	["MenuItemCreateInput"]: GraphQLTypes["MenuItemCreateInput"];
	["MenuItemCreateMenuEntityRelationInput"]: GraphQLTypes["MenuItemCreateMenuEntityRelationInput"];
	["MenuLocaleWithoutItemsCreateInput"]: GraphQLTypes["MenuLocaleWithoutItemsCreateInput"];
	["MenuItemUpdateInput"]: GraphQLTypes["MenuItemUpdateInput"];
	["MenuItemUpdateMenuEntityRelationInput"]: GraphQLTypes["MenuItemUpdateMenuEntityRelationInput"];
	["MenuLocaleWithoutItemsUpdateInput"]: GraphQLTypes["MenuLocaleWithoutItemsUpdateInput"];
	["MenuItemUpsertMenuRelationInput"]: GraphQLTypes["MenuItemUpsertMenuRelationInput"];
	["BlogPostListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogPostListEdge"][]
};
	["BlogPostListEdge"]: {
		node:ModelTypes["BlogPostList"]
};
	["BlogPostListItemCreateInput"]: GraphQLTypes["BlogPostListItemCreateInput"];
	["BlogPostListItemCreateListEntityRelationInput"]: GraphQLTypes["BlogPostListItemCreateListEntityRelationInput"];
	["BlogPostListWithoutItemsCreateInput"]: GraphQLTypes["BlogPostListWithoutItemsCreateInput"];
	["BlogPostListItemUpdateInput"]: GraphQLTypes["BlogPostListItemUpdateInput"];
	["BlogPostListItemUpdateListEntityRelationInput"]: GraphQLTypes["BlogPostListItemUpdateListEntityRelationInput"];
	["BlogPostListWithoutItemsUpdateInput"]: GraphQLTypes["BlogPostListWithoutItemsUpdateInput"];
	["BlogPostListItemUpsertListRelationInput"]: GraphQLTypes["BlogPostListItemUpsertListRelationInput"];
	["MenuLocaleCreateInput"]: GraphQLTypes["MenuLocaleCreateInput"];
	["MenuLocaleUpdateInput"]: GraphQLTypes["MenuLocaleUpdateInput"];
	["ProductGridConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductGridEdge"][]
};
	["ProductGridEdge"]: {
		node:ModelTypes["ProductGrid"]
};
	["ProductGridItemCreateInput"]: GraphQLTypes["ProductGridItemCreateInput"];
	["ProductGridItemCreateListEntityRelationInput"]: GraphQLTypes["ProductGridItemCreateListEntityRelationInput"];
	["ProductGridWithoutItemsCreateInput"]: GraphQLTypes["ProductGridWithoutItemsCreateInput"];
	["ProductGridItemUpdateInput"]: GraphQLTypes["ProductGridItemUpdateInput"];
	["ProductGridItemUpdateListEntityRelationInput"]: GraphQLTypes["ProductGridItemUpdateListEntityRelationInput"];
	["ProductGridWithoutItemsUpdateInput"]: GraphQLTypes["ProductGridWithoutItemsUpdateInput"];
	["ProductGridItemUpsertListRelationInput"]: GraphQLTypes["ProductGridItemUpsertListRelationInput"];
	["Profile"]: {
		_meta?:ModelTypes["ProfileMeta"],
	id:ModelTypes["UUID"],
	goodlokId?:string,
	importance?:number,
	name?:string,
	vokativ?:string,
	fullName?:string,
	aliases?:string,
	quickNote?:string,
	content?:ModelTypes["Content"],
	activityRecords:ModelTypes["ProfileActivityRecord"][],
	pins:ModelTypes["ProfilePin"][],
	gallery?:ModelTypes["ProfileGallery"],
	tags:ModelTypes["ProfileTag"][],
	familiarity?:ModelTypes["Familiarity"],
	vipStatus?:ModelTypes["VipStatus"],
	instagram?:string,
	facebook?:string,
	twitter?:string,
	tiktok?:string,
	youtube?:string,
	status:ModelTypes["ProfileStatus"],
	visited?:number,
	iosNearbyAt?:ModelTypes["DateTime"],
	pinsByActivityRecords?:ModelTypes["ProfilePin"],
	paginateActivityRecords:ModelTypes["ProfileActivityRecordConnection"],
	paginatePins:ModelTypes["ProfilePinConnection"],
	paginateTags:ModelTypes["ProfileTagConnection"]
};
	["ProfileMeta"]: {
		id?:ModelTypes["FieldMeta"],
	goodlokId?:ModelTypes["FieldMeta"],
	importance?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	vokativ?:ModelTypes["FieldMeta"],
	fullName?:ModelTypes["FieldMeta"],
	aliases?:ModelTypes["FieldMeta"],
	quickNote?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	activityRecords?:ModelTypes["FieldMeta"],
	pins?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"],
	tags?:ModelTypes["FieldMeta"],
	familiarity?:ModelTypes["FieldMeta"],
	vipStatus?:ModelTypes["FieldMeta"],
	instagram?:ModelTypes["FieldMeta"],
	facebook?:ModelTypes["FieldMeta"],
	twitter?:ModelTypes["FieldMeta"],
	tiktok?:ModelTypes["FieldMeta"],
	youtube?:ModelTypes["FieldMeta"],
	status?:ModelTypes["FieldMeta"],
	visited?:ModelTypes["FieldMeta"],
	iosNearbyAt?:ModelTypes["FieldMeta"]
};
	["ProfileActivityRecord"]: {
		_meta?:ModelTypes["ProfileActivityRecordMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["ProfileActivityRecordType"],
	createdAt:ModelTypes["DateTime"],
	updatedAt?:ModelTypes["DateTime"],
	metadata?:string,
	profile?:ModelTypes["Profile"],
	pin?:ModelTypes["ProfilePin"]
};
	["ProfileActivityRecordMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	updatedAt?:ModelTypes["FieldMeta"],
	metadata?:ModelTypes["FieldMeta"],
	profile?:ModelTypes["FieldMeta"],
	pin?:ModelTypes["FieldMeta"]
};
	["ProfileActivityRecordType"]: GraphQLTypes["ProfileActivityRecordType"];
	["DateTime"]:any;
	["ProfileWhere"]: GraphQLTypes["ProfileWhere"];
	["ProfileActivityRecordWhere"]: GraphQLTypes["ProfileActivityRecordWhere"];
	["ProfileActivityRecordTypeCondition"]: GraphQLTypes["ProfileActivityRecordTypeCondition"];
	["DateTimeCondition"]: GraphQLTypes["DateTimeCondition"];
	["ProfilePinWhere"]: GraphQLTypes["ProfilePinWhere"];
	["ProfilePinTypeCondition"]: GraphQLTypes["ProfilePinTypeCondition"];
	["ProfilePinType"]: GraphQLTypes["ProfilePinType"];
	["ProfileGalleryWhere"]: GraphQLTypes["ProfileGalleryWhere"];
	["ProfileGalleryItemWhere"]: GraphQLTypes["ProfileGalleryItemWhere"];
	["ProfileTagWhere"]: GraphQLTypes["ProfileTagWhere"];
	["FamiliarityCondition"]: GraphQLTypes["FamiliarityCondition"];
	["Familiarity"]: GraphQLTypes["Familiarity"];
	["VipStatusCondition"]: GraphQLTypes["VipStatusCondition"];
	["VipStatus"]: GraphQLTypes["VipStatus"];
	["ProfileStatusCondition"]: GraphQLTypes["ProfileStatusCondition"];
	["ProfileStatus"]: GraphQLTypes["ProfileStatus"];
	["ProfilePin"]: {
		_meta?:ModelTypes["ProfilePinMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["ProfilePinType"],
	startsAt?:ModelTypes["DateTime"],
	endsAt?:ModelTypes["DateTime"],
	dismissedAt?:ModelTypes["DateTime"],
	dismissedBy?:string,
	reason?:string,
	solution?:string,
	activityRecords:ModelTypes["ProfileActivityRecord"][],
	profile?:ModelTypes["Profile"],
	paginateActivityRecords:ModelTypes["ProfileActivityRecordConnection"]
};
	["ProfilePinMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	startsAt?:ModelTypes["FieldMeta"],
	endsAt?:ModelTypes["FieldMeta"],
	dismissedAt?:ModelTypes["FieldMeta"],
	dismissedBy?:ModelTypes["FieldMeta"],
	reason?:ModelTypes["FieldMeta"],
	solution?:ModelTypes["FieldMeta"],
	activityRecords?:ModelTypes["FieldMeta"],
	profile?:ModelTypes["FieldMeta"]
};
	["ProfileActivityRecordOrderBy"]: GraphQLTypes["ProfileActivityRecordOrderBy"];
	["ProfileOrderBy"]: GraphQLTypes["ProfileOrderBy"];
	["ProfileGalleryOrderBy"]: GraphQLTypes["ProfileGalleryOrderBy"];
	["ProfilePinOrderBy"]: GraphQLTypes["ProfilePinOrderBy"];
	["ProfileActivityRecordConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProfileActivityRecordEdge"][]
};
	["ProfileActivityRecordEdge"]: {
		node:ModelTypes["ProfileActivityRecord"]
};
	["ProfileGallery"]: {
		_meta?:ModelTypes["ProfileGalleryMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ProfileGalleryItem"][],
	profile?:ModelTypes["Profile"],
	paginateItems:ModelTypes["ProfileGalleryItemConnection"]
};
	["ProfileGalleryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	profile?:ModelTypes["FieldMeta"]
};
	["ProfileGalleryItem"]: {
		_meta?:ModelTypes["ProfileGalleryItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	caption?:string,
	gallery?:ModelTypes["ProfileGallery"],
	image?:ModelTypes["Image"]
};
	["ProfileGalleryItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	caption?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["ProfileGalleryItemOrderBy"]: GraphQLTypes["ProfileGalleryItemOrderBy"];
	["ProfileGalleryItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProfileGalleryItemEdge"][]
};
	["ProfileGalleryItemEdge"]: {
		node:ModelTypes["ProfileGalleryItem"]
};
	["ProfileTag"]: {
		_meta?:ModelTypes["ProfileTagMeta"],
	id:ModelTypes["UUID"],
	name:string,
	color?:string,
	profiles:ModelTypes["Profile"][],
	paginateProfiles:ModelTypes["ProfileConnection"]
};
	["ProfileTagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	color?:ModelTypes["FieldMeta"],
	profiles?:ModelTypes["FieldMeta"]
};
	["ProfileConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProfileEdge"][]
};
	["ProfileEdge"]: {
		node:ModelTypes["Profile"]
};
	["ProfileTagOrderBy"]: GraphQLTypes["ProfileTagOrderBy"];
	["ProfilePinsByActivityRecordsUniqueWhere"]: GraphQLTypes["ProfilePinsByActivityRecordsUniqueWhere"];
	["ProfileActivityRecordUniqueWhere"]: GraphQLTypes["ProfileActivityRecordUniqueWhere"];
	["ProfilePinConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProfilePinEdge"][]
};
	["ProfilePinEdge"]: {
		node:ModelTypes["ProfilePin"]
};
	["ProfileTagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProfileTagEdge"][]
};
	["ProfileTagEdge"]: {
		node:ModelTypes["ProfileTag"]
};
	["ProfileUniqueWhere"]: GraphQLTypes["ProfileUniqueWhere"];
	["ProfilePinUniqueWhere"]: GraphQLTypes["ProfilePinUniqueWhere"];
	["ProfileGalleryUniqueWhere"]: GraphQLTypes["ProfileGalleryUniqueWhere"];
	["ProfileGalleryItemUniqueWhere"]: GraphQLTypes["ProfileGalleryItemUniqueWhere"];
	["ProfileCreateInput"]: GraphQLTypes["ProfileCreateInput"];
	["ProfileCreateContentEntityRelationInput"]: GraphQLTypes["ProfileCreateContentEntityRelationInput"];
	["ProfileCreateActivityRecordsEntityRelationInput"]: GraphQLTypes["ProfileCreateActivityRecordsEntityRelationInput"];
	["ProfileActivityRecordWithoutProfileCreateInput"]: GraphQLTypes["ProfileActivityRecordWithoutProfileCreateInput"];
	["ProfileActivityRecordCreatePinEntityRelationInput"]: GraphQLTypes["ProfileActivityRecordCreatePinEntityRelationInput"];
	["ProfilePinWithoutActivityRecordsCreateInput"]: GraphQLTypes["ProfilePinWithoutActivityRecordsCreateInput"];
	["ProfilePinCreateProfileEntityRelationInput"]: GraphQLTypes["ProfilePinCreateProfileEntityRelationInput"];
	["ProfileWithoutPinsCreateInput"]: GraphQLTypes["ProfileWithoutPinsCreateInput"];
	["ProfileCreateGalleryEntityRelationInput"]: GraphQLTypes["ProfileCreateGalleryEntityRelationInput"];
	["ProfileGalleryWithoutProfileCreateInput"]: GraphQLTypes["ProfileGalleryWithoutProfileCreateInput"];
	["ProfileGalleryCreateItemsEntityRelationInput"]: GraphQLTypes["ProfileGalleryCreateItemsEntityRelationInput"];
	["ProfileGalleryItemWithoutGalleryCreateInput"]: GraphQLTypes["ProfileGalleryItemWithoutGalleryCreateInput"];
	["ProfileGalleryItemCreateImageEntityRelationInput"]: GraphQLTypes["ProfileGalleryItemCreateImageEntityRelationInput"];
	["ProfileCreateTagsEntityRelationInput"]: GraphQLTypes["ProfileCreateTagsEntityRelationInput"];
	["ProfileTagUniqueWhere"]: GraphQLTypes["ProfileTagUniqueWhere"];
	["ProfileTagWithoutProfilesCreateInput"]: GraphQLTypes["ProfileTagWithoutProfilesCreateInput"];
	["ProfileCreatePinsEntityRelationInput"]: GraphQLTypes["ProfileCreatePinsEntityRelationInput"];
	["ProfilePinWithoutProfileCreateInput"]: GraphQLTypes["ProfilePinWithoutProfileCreateInput"];
	["ProfilePinCreateActivityRecordsEntityRelationInput"]: GraphQLTypes["ProfilePinCreateActivityRecordsEntityRelationInput"];
	["ProfileActivityRecordWithoutPinCreateInput"]: GraphQLTypes["ProfileActivityRecordWithoutPinCreateInput"];
	["ProfileActivityRecordCreateProfileEntityRelationInput"]: GraphQLTypes["ProfileActivityRecordCreateProfileEntityRelationInput"];
	["ProfileWithoutActivityRecordsCreateInput"]: GraphQLTypes["ProfileWithoutActivityRecordsCreateInput"];
	["ProfileUpdateInput"]: GraphQLTypes["ProfileUpdateInput"];
	["ProfileUpdateContentEntityRelationInput"]: GraphQLTypes["ProfileUpdateContentEntityRelationInput"];
	["ProfileUpsertContentRelationInput"]: GraphQLTypes["ProfileUpsertContentRelationInput"];
	["ProfileUpdateActivityRecordsEntityRelationInput"]: GraphQLTypes["ProfileUpdateActivityRecordsEntityRelationInput"];
	["ProfileUpdateActivityRecordsRelationInput"]: GraphQLTypes["ProfileUpdateActivityRecordsRelationInput"];
	["ProfileActivityRecordWithoutProfileUpdateInput"]: GraphQLTypes["ProfileActivityRecordWithoutProfileUpdateInput"];
	["ProfileActivityRecordUpdatePinEntityRelationInput"]: GraphQLTypes["ProfileActivityRecordUpdatePinEntityRelationInput"];
	["ProfilePinWithoutActivityRecordsUpdateInput"]: GraphQLTypes["ProfilePinWithoutActivityRecordsUpdateInput"];
	["ProfilePinUpdateProfileEntityRelationInput"]: GraphQLTypes["ProfilePinUpdateProfileEntityRelationInput"];
	["ProfileWithoutPinsUpdateInput"]: GraphQLTypes["ProfileWithoutPinsUpdateInput"];
	["ProfileUpdateGalleryEntityRelationInput"]: GraphQLTypes["ProfileUpdateGalleryEntityRelationInput"];
	["ProfileGalleryWithoutProfileUpdateInput"]: GraphQLTypes["ProfileGalleryWithoutProfileUpdateInput"];
	["ProfileGalleryUpdateItemsEntityRelationInput"]: GraphQLTypes["ProfileGalleryUpdateItemsEntityRelationInput"];
	["ProfileGalleryUpdateItemsRelationInput"]: GraphQLTypes["ProfileGalleryUpdateItemsRelationInput"];
	["ProfileGalleryItemWithoutGalleryUpdateInput"]: GraphQLTypes["ProfileGalleryItemWithoutGalleryUpdateInput"];
	["ProfileGalleryItemUpdateImageEntityRelationInput"]: GraphQLTypes["ProfileGalleryItemUpdateImageEntityRelationInput"];
	["ProfileGalleryItemUpsertImageRelationInput"]: GraphQLTypes["ProfileGalleryItemUpsertImageRelationInput"];
	["ProfileGalleryUpsertItemsRelationInput"]: GraphQLTypes["ProfileGalleryUpsertItemsRelationInput"];
	["ProfileUpsertGalleryRelationInput"]: GraphQLTypes["ProfileUpsertGalleryRelationInput"];
	["ProfileUpdateTagsEntityRelationInput"]: GraphQLTypes["ProfileUpdateTagsEntityRelationInput"];
	["ProfileUpdateTagsRelationInput"]: GraphQLTypes["ProfileUpdateTagsRelationInput"];
	["ProfileTagWithoutProfilesUpdateInput"]: GraphQLTypes["ProfileTagWithoutProfilesUpdateInput"];
	["ProfileUpsertTagsRelationInput"]: GraphQLTypes["ProfileUpsertTagsRelationInput"];
	["ProfilePinUpsertProfileRelationInput"]: GraphQLTypes["ProfilePinUpsertProfileRelationInput"];
	["ProfileActivityRecordUpsertPinRelationInput"]: GraphQLTypes["ProfileActivityRecordUpsertPinRelationInput"];
	["ProfileUpsertActivityRecordsRelationInput"]: GraphQLTypes["ProfileUpsertActivityRecordsRelationInput"];
	["ProfileUpdatePinsEntityRelationInput"]: GraphQLTypes["ProfileUpdatePinsEntityRelationInput"];
	["ProfileUpdatePinsRelationInput"]: GraphQLTypes["ProfileUpdatePinsRelationInput"];
	["ProfilePinWithoutProfileUpdateInput"]: GraphQLTypes["ProfilePinWithoutProfileUpdateInput"];
	["ProfilePinUpdateActivityRecordsEntityRelationInput"]: GraphQLTypes["ProfilePinUpdateActivityRecordsEntityRelationInput"];
	["ProfilePinUpdateActivityRecordsRelationInput"]: GraphQLTypes["ProfilePinUpdateActivityRecordsRelationInput"];
	["ProfileActivityRecordWithoutPinUpdateInput"]: GraphQLTypes["ProfileActivityRecordWithoutPinUpdateInput"];
	["ProfileActivityRecordUpdateProfileEntityRelationInput"]: GraphQLTypes["ProfileActivityRecordUpdateProfileEntityRelationInput"];
	["ProfileWithoutActivityRecordsUpdateInput"]: GraphQLTypes["ProfileWithoutActivityRecordsUpdateInput"];
	["ProfileActivityRecordUpsertProfileRelationInput"]: GraphQLTypes["ProfileActivityRecordUpsertProfileRelationInput"];
	["ProfilePinUpsertActivityRecordsRelationInput"]: GraphQLTypes["ProfilePinUpsertActivityRecordsRelationInput"];
	["ProfileUpsertPinsRelationInput"]: GraphQLTypes["ProfileUpsertPinsRelationInput"];
	["ProfileTagCreateInput"]: GraphQLTypes["ProfileTagCreateInput"];
	["ProfileTagCreateProfilesEntityRelationInput"]: GraphQLTypes["ProfileTagCreateProfilesEntityRelationInput"];
	["ProfileWithoutTagsCreateInput"]: GraphQLTypes["ProfileWithoutTagsCreateInput"];
	["ProfileTagUpdateInput"]: GraphQLTypes["ProfileTagUpdateInput"];
	["ProfileTagUpdateProfilesEntityRelationInput"]: GraphQLTypes["ProfileTagUpdateProfilesEntityRelationInput"];
	["ProfileTagUpdateProfilesRelationInput"]: GraphQLTypes["ProfileTagUpdateProfilesRelationInput"];
	["ProfileWithoutTagsUpdateInput"]: GraphQLTypes["ProfileWithoutTagsUpdateInput"];
	["ProfileTagUpsertProfilesRelationInput"]: GraphQLTypes["ProfileTagUpsertProfilesRelationInput"];
	["ProfileActivityRecordCreateInput"]: GraphQLTypes["ProfileActivityRecordCreateInput"];
	["ProfileActivityRecordUpdateInput"]: GraphQLTypes["ProfileActivityRecordUpdateInput"];
	["ProfilePinCreateInput"]: GraphQLTypes["ProfilePinCreateInput"];
	["ProfilePinUpdateInput"]: GraphQLTypes["ProfilePinUpdateInput"];
	["ProfileGalleryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProfileGalleryEdge"][]
};
	["ProfileGalleryEdge"]: {
		node:ModelTypes["ProfileGallery"]
};
	["ProfileGalleryCreateInput"]: GraphQLTypes["ProfileGalleryCreateInput"];
	["ProfileGalleryCreateProfileEntityRelationInput"]: GraphQLTypes["ProfileGalleryCreateProfileEntityRelationInput"];
	["ProfileWithoutGalleryCreateInput"]: GraphQLTypes["ProfileWithoutGalleryCreateInput"];
	["ProfileGalleryUpdateInput"]: GraphQLTypes["ProfileGalleryUpdateInput"];
	["ProfileGalleryUpdateProfileEntityRelationInput"]: GraphQLTypes["ProfileGalleryUpdateProfileEntityRelationInput"];
	["ProfileWithoutGalleryUpdateInput"]: GraphQLTypes["ProfileWithoutGalleryUpdateInput"];
	["ProfileGalleryUpsertProfileRelationInput"]: GraphQLTypes["ProfileGalleryUpsertProfileRelationInput"];
	["ProfileGalleryItemCreateInput"]: GraphQLTypes["ProfileGalleryItemCreateInput"];
	["ProfileGalleryItemCreateGalleryEntityRelationInput"]: GraphQLTypes["ProfileGalleryItemCreateGalleryEntityRelationInput"];
	["ProfileGalleryWithoutItemsCreateInput"]: GraphQLTypes["ProfileGalleryWithoutItemsCreateInput"];
	["ProfileGalleryItemUpdateInput"]: GraphQLTypes["ProfileGalleryItemUpdateInput"];
	["ProfileGalleryItemUpdateGalleryEntityRelationInput"]: GraphQLTypes["ProfileGalleryItemUpdateGalleryEntityRelationInput"];
	["ProfileGalleryWithoutItemsUpdateInput"]: GraphQLTypes["ProfileGalleryWithoutItemsUpdateInput"];
	["ProfileGalleryItemUpsertGalleryRelationInput"]: GraphQLTypes["ProfileGalleryItemUpsertGalleryRelationInput"];
	["ShoppingList"]: {
		_meta?:ModelTypes["ShoppingListMeta"],
	id:ModelTypes["UUID"],
	title:string,
	items:ModelTypes["ShoppingListItem"][],
	paginateItems:ModelTypes["ShoppingListItemConnection"]
};
	["ShoppingListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ShoppingListItem"]: {
		_meta?:ModelTypes["ShoppingListItemMeta"],
	id:ModelTypes["UUID"],
	title:string,
	dueDate?:ModelTypes["Date"],
	shoppingList?:ModelTypes["ShoppingList"],
	amount?:string,
	supplier?:ModelTypes["Supplier"],
	status:ModelTypes["ShoppingListItemStatus"]
};
	["ShoppingListItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	dueDate?:ModelTypes["FieldMeta"],
	shoppingList?:ModelTypes["FieldMeta"],
	amount?:ModelTypes["FieldMeta"],
	supplier?:ModelTypes["FieldMeta"],
	status?:ModelTypes["FieldMeta"]
};
	["Date"]:any;
	["ShoppingListWhere"]: GraphQLTypes["ShoppingListWhere"];
	["ShoppingListItemWhere"]: GraphQLTypes["ShoppingListItemWhere"];
	["DateCondition"]: GraphQLTypes["DateCondition"];
	["SupplierWhere"]: GraphQLTypes["SupplierWhere"];
	["FavouriteItemWhere"]: GraphQLTypes["FavouriteItemWhere"];
	["ShoppingListItemStatusCondition"]: GraphQLTypes["ShoppingListItemStatusCondition"];
	["ShoppingListItemStatus"]: GraphQLTypes["ShoppingListItemStatus"];
	["Supplier"]: {
		_meta?:ModelTypes["SupplierMeta"],
	id:ModelTypes["UUID"],
	name:string,
	contact?:string,
	shoppingListItems:ModelTypes["ShoppingListItem"][],
	logo?:ModelTypes["Image"],
	favouriteItems:ModelTypes["FavouriteItem"][],
	paginateShoppingListItems:ModelTypes["ShoppingListItemConnection"],
	paginateFavouriteItems:ModelTypes["FavouriteItemConnection"]
};
	["SupplierMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	contact?:ModelTypes["FieldMeta"],
	shoppingListItems?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	favouriteItems?:ModelTypes["FieldMeta"]
};
	["ShoppingListItemOrderBy"]: GraphQLTypes["ShoppingListItemOrderBy"];
	["ShoppingListOrderBy"]: GraphQLTypes["ShoppingListOrderBy"];
	["SupplierOrderBy"]: GraphQLTypes["SupplierOrderBy"];
	["FavouriteItem"]: {
		_meta?:ModelTypes["FavouriteItemMeta"],
	id:ModelTypes["UUID"],
	title:string,
	amount?:string,
	supplier?:ModelTypes["Supplier"]
};
	["FavouriteItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	amount?:ModelTypes["FieldMeta"],
	supplier?:ModelTypes["FieldMeta"]
};
	["FavouriteItemOrderBy"]: GraphQLTypes["FavouriteItemOrderBy"];
	["ShoppingListItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ShoppingListItemEdge"][]
};
	["ShoppingListItemEdge"]: {
		node:ModelTypes["ShoppingListItem"]
};
	["FavouriteItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FavouriteItemEdge"][]
};
	["FavouriteItemEdge"]: {
		node:ModelTypes["FavouriteItem"]
};
	["ShoppingListUniqueWhere"]: GraphQLTypes["ShoppingListUniqueWhere"];
	["ShoppingListItemUniqueWhere"]: GraphQLTypes["ShoppingListItemUniqueWhere"];
	["ShoppingListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ShoppingListEdge"][]
};
	["ShoppingListEdge"]: {
		node:ModelTypes["ShoppingList"]
};
	["ShoppingListCreateInput"]: GraphQLTypes["ShoppingListCreateInput"];
	["ShoppingListCreateItemsEntityRelationInput"]: GraphQLTypes["ShoppingListCreateItemsEntityRelationInput"];
	["ShoppingListItemWithoutShoppingListCreateInput"]: GraphQLTypes["ShoppingListItemWithoutShoppingListCreateInput"];
	["ShoppingListItemCreateSupplierEntityRelationInput"]: GraphQLTypes["ShoppingListItemCreateSupplierEntityRelationInput"];
	["SupplierUniqueWhere"]: GraphQLTypes["SupplierUniqueWhere"];
	["FavouriteItemUniqueWhere"]: GraphQLTypes["FavouriteItemUniqueWhere"];
	["SupplierWithoutShoppingListItemsCreateInput"]: GraphQLTypes["SupplierWithoutShoppingListItemsCreateInput"];
	["SupplierCreateLogoEntityRelationInput"]: GraphQLTypes["SupplierCreateLogoEntityRelationInput"];
	["SupplierCreateFavouriteItemsEntityRelationInput"]: GraphQLTypes["SupplierCreateFavouriteItemsEntityRelationInput"];
	["FavouriteItemWithoutSupplierCreateInput"]: GraphQLTypes["FavouriteItemWithoutSupplierCreateInput"];
	["ShoppingListUpdateInput"]: GraphQLTypes["ShoppingListUpdateInput"];
	["ShoppingListUpdateItemsEntityRelationInput"]: GraphQLTypes["ShoppingListUpdateItemsEntityRelationInput"];
	["ShoppingListUpdateItemsRelationInput"]: GraphQLTypes["ShoppingListUpdateItemsRelationInput"];
	["ShoppingListItemWithoutShoppingListUpdateInput"]: GraphQLTypes["ShoppingListItemWithoutShoppingListUpdateInput"];
	["ShoppingListItemUpdateSupplierEntityRelationInput"]: GraphQLTypes["ShoppingListItemUpdateSupplierEntityRelationInput"];
	["SupplierWithoutShoppingListItemsUpdateInput"]: GraphQLTypes["SupplierWithoutShoppingListItemsUpdateInput"];
	["SupplierUpdateLogoEntityRelationInput"]: GraphQLTypes["SupplierUpdateLogoEntityRelationInput"];
	["SupplierUpsertLogoRelationInput"]: GraphQLTypes["SupplierUpsertLogoRelationInput"];
	["SupplierUpdateFavouriteItemsEntityRelationInput"]: GraphQLTypes["SupplierUpdateFavouriteItemsEntityRelationInput"];
	["SupplierUpdateFavouriteItemsRelationInput"]: GraphQLTypes["SupplierUpdateFavouriteItemsRelationInput"];
	["FavouriteItemWithoutSupplierUpdateInput"]: GraphQLTypes["FavouriteItemWithoutSupplierUpdateInput"];
	["SupplierUpsertFavouriteItemsRelationInput"]: GraphQLTypes["SupplierUpsertFavouriteItemsRelationInput"];
	["ShoppingListItemUpsertSupplierRelationInput"]: GraphQLTypes["ShoppingListItemUpsertSupplierRelationInput"];
	["ShoppingListUpsertItemsRelationInput"]: GraphQLTypes["ShoppingListUpsertItemsRelationInput"];
	["ShoppingListItemCreateInput"]: GraphQLTypes["ShoppingListItemCreateInput"];
	["ShoppingListItemCreateShoppingListEntityRelationInput"]: GraphQLTypes["ShoppingListItemCreateShoppingListEntityRelationInput"];
	["ShoppingListWithoutItemsCreateInput"]: GraphQLTypes["ShoppingListWithoutItemsCreateInput"];
	["ShoppingListItemUpdateInput"]: GraphQLTypes["ShoppingListItemUpdateInput"];
	["ShoppingListItemUpdateShoppingListEntityRelationInput"]: GraphQLTypes["ShoppingListItemUpdateShoppingListEntityRelationInput"];
	["ShoppingListWithoutItemsUpdateInput"]: GraphQLTypes["ShoppingListWithoutItemsUpdateInput"];
	["ShoppingListItemUpsertShoppingListRelationInput"]: GraphQLTypes["ShoppingListItemUpsertShoppingListRelationInput"];
	["SupplierConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SupplierEdge"][]
};
	["SupplierEdge"]: {
		node:ModelTypes["Supplier"]
};
	["SupplierCreateInput"]: GraphQLTypes["SupplierCreateInput"];
	["SupplierCreateShoppingListItemsEntityRelationInput"]: GraphQLTypes["SupplierCreateShoppingListItemsEntityRelationInput"];
	["ShoppingListItemWithoutSupplierCreateInput"]: GraphQLTypes["ShoppingListItemWithoutSupplierCreateInput"];
	["SupplierUpdateInput"]: GraphQLTypes["SupplierUpdateInput"];
	["SupplierUpdateShoppingListItemsEntityRelationInput"]: GraphQLTypes["SupplierUpdateShoppingListItemsEntityRelationInput"];
	["SupplierUpdateShoppingListItemsRelationInput"]: GraphQLTypes["SupplierUpdateShoppingListItemsRelationInput"];
	["ShoppingListItemWithoutSupplierUpdateInput"]: GraphQLTypes["ShoppingListItemWithoutSupplierUpdateInput"];
	["SupplierUpsertShoppingListItemsRelationInput"]: GraphQLTypes["SupplierUpsertShoppingListItemsRelationInput"];
	["FavouriteItemCreateInput"]: GraphQLTypes["FavouriteItemCreateInput"];
	["FavouriteItemCreateSupplierEntityRelationInput"]: GraphQLTypes["FavouriteItemCreateSupplierEntityRelationInput"];
	["SupplierWithoutFavouriteItemsCreateInput"]: GraphQLTypes["SupplierWithoutFavouriteItemsCreateInput"];
	["FavouriteItemUpdateInput"]: GraphQLTypes["FavouriteItemUpdateInput"];
	["FavouriteItemUpdateSupplierEntityRelationInput"]: GraphQLTypes["FavouriteItemUpdateSupplierEntityRelationInput"];
	["SupplierWithoutFavouriteItemsUpdateInput"]: GraphQLTypes["SupplierWithoutFavouriteItemsUpdateInput"];
	["FavouriteItemUpsertSupplierRelationInput"]: GraphQLTypes["FavouriteItemUpsertSupplierRelationInput"];
	["BusinessOrderTypeConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BusinessOrderTypeEdge"][]
};
	["BusinessOrderTypeEdge"]: {
		node:ModelTypes["BusinessOrderType"]
};
	["BusinessOrderTypeCreateInput"]: GraphQLTypes["BusinessOrderTypeCreateInput"];
	["BusinessOrderTypeCreateLocalesEntityRelationInput"]: GraphQLTypes["BusinessOrderTypeCreateLocalesEntityRelationInput"];
	["BusinessOrderTypeLocaleWithoutRootCreateInput"]: GraphQLTypes["BusinessOrderTypeLocaleWithoutRootCreateInput"];
	["BusinessOrderTypeLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["BusinessOrderTypeLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBusinessOrderTypesCreateInput"]: GraphQLTypes["LocaleWithoutBusinessOrderTypesCreateInput"];
	["BusinessOrderTypeUpdateInput"]: GraphQLTypes["BusinessOrderTypeUpdateInput"];
	["BusinessOrderTypeUpdateLocalesEntityRelationInput"]: GraphQLTypes["BusinessOrderTypeUpdateLocalesEntityRelationInput"];
	["BusinessOrderTypeUpdateLocalesRelationInput"]: GraphQLTypes["BusinessOrderTypeUpdateLocalesRelationInput"];
	["BusinessOrderTypeLocaleWithoutRootUpdateInput"]: GraphQLTypes["BusinessOrderTypeLocaleWithoutRootUpdateInput"];
	["BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBusinessOrderTypesUpdateInput"]: GraphQLTypes["LocaleWithoutBusinessOrderTypesUpdateInput"];
	["BusinessOrderTypeLocaleUpsertLocaleRelationInput"]: GraphQLTypes["BusinessOrderTypeLocaleUpsertLocaleRelationInput"];
	["BusinessOrderTypeUpsertLocalesRelationInput"]: GraphQLTypes["BusinessOrderTypeUpsertLocalesRelationInput"];
	["BusinessOrderTypeLocaleCreateInput"]: GraphQLTypes["BusinessOrderTypeLocaleCreateInput"];
	["BusinessOrderTypeLocaleUpdateInput"]: GraphQLTypes["BusinessOrderTypeLocaleUpdateInput"];
	["QueryTransaction"]: {
		getColorPallete?:ModelTypes["ColorPallete"],
	listColorPallete:ModelTypes["ColorPallete"][],
	paginateColorPallete:ModelTypes["ColorPalleteConnection"],
	validateCreateColorPallete:ModelTypes["_ValidationResult"],
	validateUpdateColorPallete:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getCover?:ModelTypes["Cover"],
	listCover:ModelTypes["Cover"][],
	paginateCover:ModelTypes["CoverConnection"],
	validateCreateCover:ModelTypes["_ValidationResult"],
	validateUpdateCover:ModelTypes["_ValidationResult"],
	getEvent?:ModelTypes["Event"],
	listEvent:ModelTypes["Event"][],
	paginateEvent:ModelTypes["EventConnection"],
	validateCreateEvent:ModelTypes["_ValidationResult"],
	validateUpdateEvent:ModelTypes["_ValidationResult"],
	getEventLocale?:ModelTypes["EventLocale"],
	listEventLocale:ModelTypes["EventLocale"][],
	paginateEventLocale:ModelTypes["EventLocaleConnection"],
	validateCreateEventLocale:ModelTypes["_ValidationResult"],
	validateUpdateEventLocale:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getImageList?:ModelTypes["ImageList"],
	listImageList:ModelTypes["ImageList"][],
	paginateImageList:ModelTypes["ImageListConnection"],
	validateCreateImageList:ModelTypes["_ValidationResult"],
	validateUpdateImageList:ModelTypes["_ValidationResult"],
	getImageItem?:ModelTypes["ImageItem"],
	listImageItem:ModelTypes["ImageItem"][],
	paginateImageItem:ModelTypes["ImageItemConnection"],
	validateCreateImageItem:ModelTypes["_ValidationResult"],
	validateUpdateImageItem:ModelTypes["_ValidationResult"],
	getLocale?:ModelTypes["Locale"],
	listLocale:ModelTypes["Locale"][],
	paginateLocale:ModelTypes["LocaleConnection"],
	validateCreateLocale:ModelTypes["_ValidationResult"],
	validateUpdateLocale:ModelTypes["_ValidationResult"],
	getMedium?:ModelTypes["Medium"],
	listMedium:ModelTypes["Medium"][],
	paginateMedium:ModelTypes["MediumConnection"],
	validateCreateMedium:ModelTypes["_ValidationResult"],
	validateUpdateMedium:ModelTypes["_ValidationResult"],
	getVideo?:ModelTypes["Video"],
	listVideo:ModelTypes["Video"][],
	paginateVideo:ModelTypes["VideoConnection"],
	validateCreateVideo:ModelTypes["_ValidationResult"],
	validateUpdateVideo:ModelTypes["_ValidationResult"],
	getBlog?:ModelTypes["Blog"],
	listBlog:ModelTypes["Blog"][],
	paginateBlog:ModelTypes["BlogConnection"],
	validateCreateBlog:ModelTypes["_ValidationResult"],
	validateUpdateBlog:ModelTypes["_ValidationResult"],
	getBlogLocale?:ModelTypes["BlogLocale"],
	listBlogLocale:ModelTypes["BlogLocale"][],
	paginateBlogLocale:ModelTypes["BlogLocaleConnection"],
	validateCreateBlogLocale:ModelTypes["_ValidationResult"],
	validateUpdateBlogLocale:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	getPageLocale?:ModelTypes["PageLocale"],
	listPageLocale:ModelTypes["PageLocale"][],
	paginatePageLocale:ModelTypes["PageLocaleConnection"],
	validateCreatePageLocale:ModelTypes["_ValidationResult"],
	validateUpdatePageLocale:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getSeoLocale?:ModelTypes["SeoLocale"],
	listSeoLocale:ModelTypes["SeoLocale"][],
	paginateSeoLocale:ModelTypes["SeoLocaleConnection"],
	validateCreateSeoLocale:ModelTypes["_ValidationResult"],
	validateUpdateSeoLocale:ModelTypes["_ValidationResult"],
	getLocalizedSeo?:ModelTypes["LocalizedSeo"],
	listLocalizedSeo:ModelTypes["LocalizedSeo"][],
	paginateLocalizedSeo:ModelTypes["LocalizedSeoConnection"],
	validateCreateLocalizedSeo:ModelTypes["_ValidationResult"],
	validateUpdateLocalizedSeo:ModelTypes["_ValidationResult"],
	getHero?:ModelTypes["Hero"],
	listHero:ModelTypes["Hero"][],
	paginateHero:ModelTypes["HeroConnection"],
	validateCreateHero:ModelTypes["_ValidationResult"],
	validateUpdateHero:ModelTypes["_ValidationResult"],
	getGallery?:ModelTypes["Gallery"],
	listGallery:ModelTypes["Gallery"][],
	paginateGallery:ModelTypes["GalleryConnection"],
	validateCreateGallery:ModelTypes["_ValidationResult"],
	validateUpdateGallery:ModelTypes["_ValidationResult"],
	getGalleryItem?:ModelTypes["GalleryItem"],
	listGalleryItem:ModelTypes["GalleryItem"][],
	paginateGalleryItem:ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem:ModelTypes["_ValidationResult"],
	getSocialsAndApps?:ModelTypes["SocialsAndApps"],
	listSocialsAndApps:ModelTypes["SocialsAndApps"][],
	paginateSocialsAndApps:ModelTypes["SocialsAndAppsConnection"],
	validateCreateSocialsAndApps:ModelTypes["_ValidationResult"],
	validateUpdateSocialsAndApps:ModelTypes["_ValidationResult"],
	getSiteMenu?:ModelTypes["SiteMenu"],
	listSiteMenu:ModelTypes["SiteMenu"][],
	paginateSiteMenu:ModelTypes["SiteMenuConnection"],
	validateCreateSiteMenu:ModelTypes["_ValidationResult"],
	validateUpdateSiteMenu:ModelTypes["_ValidationResult"],
	getMenuItem?:ModelTypes["MenuItem"],
	listMenuItem:ModelTypes["MenuItem"][],
	paginateMenuItem:ModelTypes["MenuItemConnection"],
	validateCreateMenuItem:ModelTypes["_ValidationResult"],
	validateUpdateMenuItem:ModelTypes["_ValidationResult"],
	getBlogPostList?:ModelTypes["BlogPostList"],
	listBlogPostList:ModelTypes["BlogPostList"][],
	paginateBlogPostList:ModelTypes["BlogPostListConnection"],
	validateCreateBlogPostList:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostList:ModelTypes["_ValidationResult"],
	getBlogPostListItem?:ModelTypes["BlogPostListItem"],
	listBlogPostListItem:ModelTypes["BlogPostListItem"][],
	paginateBlogPostListItem:ModelTypes["BlogPostListItemConnection"],
	validateCreateBlogPostListItem:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostListItem:ModelTypes["_ValidationResult"],
	getMenuLocale?:ModelTypes["MenuLocale"],
	listMenuLocale:ModelTypes["MenuLocale"][],
	paginateMenuLocale:ModelTypes["MenuLocaleConnection"],
	validateCreateMenuLocale:ModelTypes["_ValidationResult"],
	validateUpdateMenuLocale:ModelTypes["_ValidationResult"],
	getProductGrid?:ModelTypes["ProductGrid"],
	listProductGrid:ModelTypes["ProductGrid"][],
	paginateProductGrid:ModelTypes["ProductGridConnection"],
	validateCreateProductGrid:ModelTypes["_ValidationResult"],
	validateUpdateProductGrid:ModelTypes["_ValidationResult"],
	getProductGridItem?:ModelTypes["ProductGridItem"],
	listProductGridItem:ModelTypes["ProductGridItem"][],
	paginateProductGridItem:ModelTypes["ProductGridItemConnection"],
	validateCreateProductGridItem:ModelTypes["_ValidationResult"],
	validateUpdateProductGridItem:ModelTypes["_ValidationResult"],
	getProfile?:ModelTypes["Profile"],
	listProfile:ModelTypes["Profile"][],
	paginateProfile:ModelTypes["ProfileConnection"],
	validateCreateProfile:ModelTypes["_ValidationResult"],
	validateUpdateProfile:ModelTypes["_ValidationResult"],
	getProfileTag?:ModelTypes["ProfileTag"],
	listProfileTag:ModelTypes["ProfileTag"][],
	paginateProfileTag:ModelTypes["ProfileTagConnection"],
	validateCreateProfileTag:ModelTypes["_ValidationResult"],
	validateUpdateProfileTag:ModelTypes["_ValidationResult"],
	getProfileActivityRecord?:ModelTypes["ProfileActivityRecord"],
	listProfileActivityRecord:ModelTypes["ProfileActivityRecord"][],
	paginateProfileActivityRecord:ModelTypes["ProfileActivityRecordConnection"],
	validateCreateProfileActivityRecord:ModelTypes["_ValidationResult"],
	validateUpdateProfileActivityRecord:ModelTypes["_ValidationResult"],
	getProfilePin?:ModelTypes["ProfilePin"],
	listProfilePin:ModelTypes["ProfilePin"][],
	paginateProfilePin:ModelTypes["ProfilePinConnection"],
	validateCreateProfilePin:ModelTypes["_ValidationResult"],
	validateUpdateProfilePin:ModelTypes["_ValidationResult"],
	getProfileGallery?:ModelTypes["ProfileGallery"],
	listProfileGallery:ModelTypes["ProfileGallery"][],
	paginateProfileGallery:ModelTypes["ProfileGalleryConnection"],
	validateCreateProfileGallery:ModelTypes["_ValidationResult"],
	validateUpdateProfileGallery:ModelTypes["_ValidationResult"],
	getProfileGalleryItem?:ModelTypes["ProfileGalleryItem"],
	listProfileGalleryItem:ModelTypes["ProfileGalleryItem"][],
	paginateProfileGalleryItem:ModelTypes["ProfileGalleryItemConnection"],
	validateCreateProfileGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateProfileGalleryItem:ModelTypes["_ValidationResult"],
	getShoppingList?:ModelTypes["ShoppingList"],
	listShoppingList:ModelTypes["ShoppingList"][],
	paginateShoppingList:ModelTypes["ShoppingListConnection"],
	validateCreateShoppingList:ModelTypes["_ValidationResult"],
	validateUpdateShoppingList:ModelTypes["_ValidationResult"],
	getShoppingListItem?:ModelTypes["ShoppingListItem"],
	listShoppingListItem:ModelTypes["ShoppingListItem"][],
	paginateShoppingListItem:ModelTypes["ShoppingListItemConnection"],
	validateCreateShoppingListItem:ModelTypes["_ValidationResult"],
	validateUpdateShoppingListItem:ModelTypes["_ValidationResult"],
	getSupplier?:ModelTypes["Supplier"],
	listSupplier:ModelTypes["Supplier"][],
	paginateSupplier:ModelTypes["SupplierConnection"],
	validateCreateSupplier:ModelTypes["_ValidationResult"],
	validateUpdateSupplier:ModelTypes["_ValidationResult"],
	getFavouriteItem?:ModelTypes["FavouriteItem"],
	listFavouriteItem:ModelTypes["FavouriteItem"][],
	paginateFavouriteItem:ModelTypes["FavouriteItemConnection"],
	validateCreateFavouriteItem:ModelTypes["_ValidationResult"],
	validateUpdateFavouriteItem:ModelTypes["_ValidationResult"],
	getBusinessOrderType?:ModelTypes["BusinessOrderType"],
	listBusinessOrderType:ModelTypes["BusinessOrderType"][],
	paginateBusinessOrderType:ModelTypes["BusinessOrderTypeConnection"],
	validateCreateBusinessOrderType:ModelTypes["_ValidationResult"],
	validateUpdateBusinessOrderType:ModelTypes["_ValidationResult"],
	getBusinessOrderTypeLocale?:ModelTypes["BusinessOrderTypeLocale"],
	listBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocale"][],
	paginateBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleConnection"],
	validateCreateBusinessOrderTypeLocale:ModelTypes["_ValidationResult"],
	validateUpdateBusinessOrderTypeLocale:ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		createColorPallete:ModelTypes["ColorPalleteCreateResult"],
	deleteColorPallete:ModelTypes["ColorPalleteDeleteResult"],
	updateColorPallete:ModelTypes["ColorPalleteUpdateResult"],
	upsertColorPallete:ModelTypes["ColorPalleteUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createCover:ModelTypes["CoverCreateResult"],
	deleteCover:ModelTypes["CoverDeleteResult"],
	updateCover:ModelTypes["CoverUpdateResult"],
	upsertCover:ModelTypes["CoverUpsertResult"],
	createEvent:ModelTypes["EventCreateResult"],
	deleteEvent:ModelTypes["EventDeleteResult"],
	updateEvent:ModelTypes["EventUpdateResult"],
	upsertEvent:ModelTypes["EventUpsertResult"],
	createEventLocale:ModelTypes["EventLocaleCreateResult"],
	deleteEventLocale:ModelTypes["EventLocaleDeleteResult"],
	updateEventLocale:ModelTypes["EventLocaleUpdateResult"],
	upsertEventLocale:ModelTypes["EventLocaleUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createImageList:ModelTypes["ImageListCreateResult"],
	deleteImageList:ModelTypes["ImageListDeleteResult"],
	updateImageList:ModelTypes["ImageListUpdateResult"],
	upsertImageList:ModelTypes["ImageListUpsertResult"],
	createImageItem:ModelTypes["ImageItemCreateResult"],
	deleteImageItem:ModelTypes["ImageItemDeleteResult"],
	updateImageItem:ModelTypes["ImageItemUpdateResult"],
	upsertImageItem:ModelTypes["ImageItemUpsertResult"],
	createLocale:ModelTypes["LocaleCreateResult"],
	deleteLocale:ModelTypes["LocaleDeleteResult"],
	updateLocale:ModelTypes["LocaleUpdateResult"],
	upsertLocale:ModelTypes["LocaleUpsertResult"],
	createMedium:ModelTypes["MediumCreateResult"],
	deleteMedium:ModelTypes["MediumDeleteResult"],
	updateMedium:ModelTypes["MediumUpdateResult"],
	upsertMedium:ModelTypes["MediumUpsertResult"],
	createVideo:ModelTypes["VideoCreateResult"],
	deleteVideo:ModelTypes["VideoDeleteResult"],
	updateVideo:ModelTypes["VideoUpdateResult"],
	upsertVideo:ModelTypes["VideoUpsertResult"],
	createBlog:ModelTypes["BlogCreateResult"],
	deleteBlog:ModelTypes["BlogDeleteResult"],
	updateBlog:ModelTypes["BlogUpdateResult"],
	upsertBlog:ModelTypes["BlogUpsertResult"],
	createBlogLocale:ModelTypes["BlogLocaleCreateResult"],
	deleteBlogLocale:ModelTypes["BlogLocaleDeleteResult"],
	updateBlogLocale:ModelTypes["BlogLocaleUpdateResult"],
	upsertBlogLocale:ModelTypes["BlogLocaleUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	createPageLocale:ModelTypes["PageLocaleCreateResult"],
	deletePageLocale:ModelTypes["PageLocaleDeleteResult"],
	updatePageLocale:ModelTypes["PageLocaleUpdateResult"],
	upsertPageLocale:ModelTypes["PageLocaleUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createSeoLocale:ModelTypes["SeoLocaleCreateResult"],
	deleteSeoLocale:ModelTypes["SeoLocaleDeleteResult"],
	updateSeoLocale:ModelTypes["SeoLocaleUpdateResult"],
	upsertSeoLocale:ModelTypes["SeoLocaleUpsertResult"],
	createLocalizedSeo:ModelTypes["LocalizedSeoCreateResult"],
	deleteLocalizedSeo:ModelTypes["LocalizedSeoDeleteResult"],
	updateLocalizedSeo:ModelTypes["LocalizedSeoUpdateResult"],
	upsertLocalizedSeo:ModelTypes["LocalizedSeoUpsertResult"],
	createHero:ModelTypes["HeroCreateResult"],
	deleteHero:ModelTypes["HeroDeleteResult"],
	updateHero:ModelTypes["HeroUpdateResult"],
	upsertHero:ModelTypes["HeroUpsertResult"],
	createGallery:ModelTypes["GalleryCreateResult"],
	deleteGallery:ModelTypes["GalleryDeleteResult"],
	updateGallery:ModelTypes["GalleryUpdateResult"],
	upsertGallery:ModelTypes["GalleryUpsertResult"],
	createGalleryItem:ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem:ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem:ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem:ModelTypes["GalleryItemUpsertResult"],
	createSocialsAndApps:ModelTypes["SocialsAndAppsCreateResult"],
	deleteSocialsAndApps:ModelTypes["SocialsAndAppsDeleteResult"],
	updateSocialsAndApps:ModelTypes["SocialsAndAppsUpdateResult"],
	upsertSocialsAndApps:ModelTypes["SocialsAndAppsUpsertResult"],
	createSiteMenu:ModelTypes["SiteMenuCreateResult"],
	deleteSiteMenu:ModelTypes["SiteMenuDeleteResult"],
	updateSiteMenu:ModelTypes["SiteMenuUpdateResult"],
	upsertSiteMenu:ModelTypes["SiteMenuUpsertResult"],
	createMenuItem:ModelTypes["MenuItemCreateResult"],
	deleteMenuItem:ModelTypes["MenuItemDeleteResult"],
	updateMenuItem:ModelTypes["MenuItemUpdateResult"],
	upsertMenuItem:ModelTypes["MenuItemUpsertResult"],
	createBlogPostList:ModelTypes["BlogPostListCreateResult"],
	deleteBlogPostList:ModelTypes["BlogPostListDeleteResult"],
	updateBlogPostList:ModelTypes["BlogPostListUpdateResult"],
	upsertBlogPostList:ModelTypes["BlogPostListUpsertResult"],
	createBlogPostListItem:ModelTypes["BlogPostListItemCreateResult"],
	deleteBlogPostListItem:ModelTypes["BlogPostListItemDeleteResult"],
	updateBlogPostListItem:ModelTypes["BlogPostListItemUpdateResult"],
	upsertBlogPostListItem:ModelTypes["BlogPostListItemUpsertResult"],
	createMenuLocale:ModelTypes["MenuLocaleCreateResult"],
	deleteMenuLocale:ModelTypes["MenuLocaleDeleteResult"],
	updateMenuLocale:ModelTypes["MenuLocaleUpdateResult"],
	upsertMenuLocale:ModelTypes["MenuLocaleUpsertResult"],
	createProductGrid:ModelTypes["ProductGridCreateResult"],
	deleteProductGrid:ModelTypes["ProductGridDeleteResult"],
	updateProductGrid:ModelTypes["ProductGridUpdateResult"],
	upsertProductGrid:ModelTypes["ProductGridUpsertResult"],
	createProductGridItem:ModelTypes["ProductGridItemCreateResult"],
	deleteProductGridItem:ModelTypes["ProductGridItemDeleteResult"],
	updateProductGridItem:ModelTypes["ProductGridItemUpdateResult"],
	upsertProductGridItem:ModelTypes["ProductGridItemUpsertResult"],
	createProfile:ModelTypes["ProfileCreateResult"],
	deleteProfile:ModelTypes["ProfileDeleteResult"],
	updateProfile:ModelTypes["ProfileUpdateResult"],
	upsertProfile:ModelTypes["ProfileUpsertResult"],
	createProfileTag:ModelTypes["ProfileTagCreateResult"],
	deleteProfileTag:ModelTypes["ProfileTagDeleteResult"],
	updateProfileTag:ModelTypes["ProfileTagUpdateResult"],
	upsertProfileTag:ModelTypes["ProfileTagUpsertResult"],
	createProfileActivityRecord:ModelTypes["ProfileActivityRecordCreateResult"],
	deleteProfileActivityRecord:ModelTypes["ProfileActivityRecordDeleteResult"],
	updateProfileActivityRecord:ModelTypes["ProfileActivityRecordUpdateResult"],
	upsertProfileActivityRecord:ModelTypes["ProfileActivityRecordUpsertResult"],
	createProfilePin:ModelTypes["ProfilePinCreateResult"],
	deleteProfilePin:ModelTypes["ProfilePinDeleteResult"],
	updateProfilePin:ModelTypes["ProfilePinUpdateResult"],
	upsertProfilePin:ModelTypes["ProfilePinUpsertResult"],
	createProfileGallery:ModelTypes["ProfileGalleryCreateResult"],
	deleteProfileGallery:ModelTypes["ProfileGalleryDeleteResult"],
	updateProfileGallery:ModelTypes["ProfileGalleryUpdateResult"],
	upsertProfileGallery:ModelTypes["ProfileGalleryUpsertResult"],
	createProfileGalleryItem:ModelTypes["ProfileGalleryItemCreateResult"],
	deleteProfileGalleryItem:ModelTypes["ProfileGalleryItemDeleteResult"],
	updateProfileGalleryItem:ModelTypes["ProfileGalleryItemUpdateResult"],
	upsertProfileGalleryItem:ModelTypes["ProfileGalleryItemUpsertResult"],
	createShoppingList:ModelTypes["ShoppingListCreateResult"],
	deleteShoppingList:ModelTypes["ShoppingListDeleteResult"],
	updateShoppingList:ModelTypes["ShoppingListUpdateResult"],
	upsertShoppingList:ModelTypes["ShoppingListUpsertResult"],
	createShoppingListItem:ModelTypes["ShoppingListItemCreateResult"],
	deleteShoppingListItem:ModelTypes["ShoppingListItemDeleteResult"],
	updateShoppingListItem:ModelTypes["ShoppingListItemUpdateResult"],
	upsertShoppingListItem:ModelTypes["ShoppingListItemUpsertResult"],
	createSupplier:ModelTypes["SupplierCreateResult"],
	deleteSupplier:ModelTypes["SupplierDeleteResult"],
	updateSupplier:ModelTypes["SupplierUpdateResult"],
	upsertSupplier:ModelTypes["SupplierUpsertResult"],
	createFavouriteItem:ModelTypes["FavouriteItemCreateResult"],
	deleteFavouriteItem:ModelTypes["FavouriteItemDeleteResult"],
	updateFavouriteItem:ModelTypes["FavouriteItemUpdateResult"],
	upsertFavouriteItem:ModelTypes["FavouriteItemUpsertResult"],
	createBusinessOrderType:ModelTypes["BusinessOrderTypeCreateResult"],
	deleteBusinessOrderType:ModelTypes["BusinessOrderTypeDeleteResult"],
	updateBusinessOrderType:ModelTypes["BusinessOrderTypeUpdateResult"],
	upsertBusinessOrderType:ModelTypes["BusinessOrderTypeUpsertResult"],
	createBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleCreateResult"],
	deleteBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleDeleteResult"],
	updateBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleUpdateResult"],
	upsertBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"]
};
	["ColorPalleteCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ColorPallete"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["ColorPalleteCreateResult"] | ModelTypes["ColorPalleteDeleteResult"] | ModelTypes["ColorPalleteUpdateResult"] | ModelTypes["ColorPalleteUpsertResult"] | ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["CoverCreateResult"] | ModelTypes["CoverDeleteResult"] | ModelTypes["CoverUpdateResult"] | ModelTypes["CoverUpsertResult"] | ModelTypes["EventCreateResult"] | ModelTypes["EventDeleteResult"] | ModelTypes["EventUpdateResult"] | ModelTypes["EventUpsertResult"] | ModelTypes["EventLocaleCreateResult"] | ModelTypes["EventLocaleDeleteResult"] | ModelTypes["EventLocaleUpdateResult"] | ModelTypes["EventLocaleUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["ImageListCreateResult"] | ModelTypes["ImageListDeleteResult"] | ModelTypes["ImageListUpdateResult"] | ModelTypes["ImageListUpsertResult"] | ModelTypes["ImageItemCreateResult"] | ModelTypes["ImageItemDeleteResult"] | ModelTypes["ImageItemUpdateResult"] | ModelTypes["ImageItemUpsertResult"] | ModelTypes["LocaleCreateResult"] | ModelTypes["LocaleDeleteResult"] | ModelTypes["LocaleUpdateResult"] | ModelTypes["LocaleUpsertResult"] | ModelTypes["MediumCreateResult"] | ModelTypes["MediumDeleteResult"] | ModelTypes["MediumUpdateResult"] | ModelTypes["MediumUpsertResult"] | ModelTypes["VideoCreateResult"] | ModelTypes["VideoDeleteResult"] | ModelTypes["VideoUpdateResult"] | ModelTypes["VideoUpsertResult"] | ModelTypes["BlogCreateResult"] | ModelTypes["BlogDeleteResult"] | ModelTypes["BlogUpdateResult"] | ModelTypes["BlogUpsertResult"] | ModelTypes["BlogLocaleCreateResult"] | ModelTypes["BlogLocaleDeleteResult"] | ModelTypes["BlogLocaleUpdateResult"] | ModelTypes["BlogLocaleUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["PageCreateResult"] | ModelTypes["PageDeleteResult"] | ModelTypes["PageUpdateResult"] | ModelTypes["PageUpsertResult"] | ModelTypes["PageLocaleCreateResult"] | ModelTypes["PageLocaleDeleteResult"] | ModelTypes["PageLocaleUpdateResult"] | ModelTypes["PageLocaleUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["SeoLocaleCreateResult"] | ModelTypes["SeoLocaleDeleteResult"] | ModelTypes["SeoLocaleUpdateResult"] | ModelTypes["SeoLocaleUpsertResult"] | ModelTypes["LocalizedSeoCreateResult"] | ModelTypes["LocalizedSeoDeleteResult"] | ModelTypes["LocalizedSeoUpdateResult"] | ModelTypes["LocalizedSeoUpsertResult"] | ModelTypes["HeroCreateResult"] | ModelTypes["HeroDeleteResult"] | ModelTypes["HeroUpdateResult"] | ModelTypes["HeroUpsertResult"] | ModelTypes["GalleryCreateResult"] | ModelTypes["GalleryDeleteResult"] | ModelTypes["GalleryUpdateResult"] | ModelTypes["GalleryUpsertResult"] | ModelTypes["GalleryItemCreateResult"] | ModelTypes["GalleryItemDeleteResult"] | ModelTypes["GalleryItemUpdateResult"] | ModelTypes["GalleryItemUpsertResult"] | ModelTypes["SocialsAndAppsCreateResult"] | ModelTypes["SocialsAndAppsDeleteResult"] | ModelTypes["SocialsAndAppsUpdateResult"] | ModelTypes["SocialsAndAppsUpsertResult"] | ModelTypes["SiteMenuCreateResult"] | ModelTypes["SiteMenuDeleteResult"] | ModelTypes["SiteMenuUpdateResult"] | ModelTypes["SiteMenuUpsertResult"] | ModelTypes["MenuItemCreateResult"] | ModelTypes["MenuItemDeleteResult"] | ModelTypes["MenuItemUpdateResult"] | ModelTypes["MenuItemUpsertResult"] | ModelTypes["BlogPostListCreateResult"] | ModelTypes["BlogPostListDeleteResult"] | ModelTypes["BlogPostListUpdateResult"] | ModelTypes["BlogPostListUpsertResult"] | ModelTypes["BlogPostListItemCreateResult"] | ModelTypes["BlogPostListItemDeleteResult"] | ModelTypes["BlogPostListItemUpdateResult"] | ModelTypes["BlogPostListItemUpsertResult"] | ModelTypes["MenuLocaleCreateResult"] | ModelTypes["MenuLocaleDeleteResult"] | ModelTypes["MenuLocaleUpdateResult"] | ModelTypes["MenuLocaleUpsertResult"] | ModelTypes["ProductGridCreateResult"] | ModelTypes["ProductGridDeleteResult"] | ModelTypes["ProductGridUpdateResult"] | ModelTypes["ProductGridUpsertResult"] | ModelTypes["ProductGridItemCreateResult"] | ModelTypes["ProductGridItemDeleteResult"] | ModelTypes["ProductGridItemUpdateResult"] | ModelTypes["ProductGridItemUpsertResult"] | ModelTypes["ProfileCreateResult"] | ModelTypes["ProfileDeleteResult"] | ModelTypes["ProfileUpdateResult"] | ModelTypes["ProfileUpsertResult"] | ModelTypes["ProfileTagCreateResult"] | ModelTypes["ProfileTagDeleteResult"] | ModelTypes["ProfileTagUpdateResult"] | ModelTypes["ProfileTagUpsertResult"] | ModelTypes["ProfileActivityRecordCreateResult"] | ModelTypes["ProfileActivityRecordDeleteResult"] | ModelTypes["ProfileActivityRecordUpdateResult"] | ModelTypes["ProfileActivityRecordUpsertResult"] | ModelTypes["ProfilePinCreateResult"] | ModelTypes["ProfilePinDeleteResult"] | ModelTypes["ProfilePinUpdateResult"] | ModelTypes["ProfilePinUpsertResult"] | ModelTypes["ProfileGalleryCreateResult"] | ModelTypes["ProfileGalleryDeleteResult"] | ModelTypes["ProfileGalleryUpdateResult"] | ModelTypes["ProfileGalleryUpsertResult"] | ModelTypes["ProfileGalleryItemCreateResult"] | ModelTypes["ProfileGalleryItemDeleteResult"] | ModelTypes["ProfileGalleryItemUpdateResult"] | ModelTypes["ProfileGalleryItemUpsertResult"] | ModelTypes["ShoppingListCreateResult"] | ModelTypes["ShoppingListDeleteResult"] | ModelTypes["ShoppingListUpdateResult"] | ModelTypes["ShoppingListUpsertResult"] | ModelTypes["ShoppingListItemCreateResult"] | ModelTypes["ShoppingListItemDeleteResult"] | ModelTypes["ShoppingListItemUpdateResult"] | ModelTypes["ShoppingListItemUpsertResult"] | ModelTypes["SupplierCreateResult"] | ModelTypes["SupplierDeleteResult"] | ModelTypes["SupplierUpdateResult"] | ModelTypes["SupplierUpsertResult"] | ModelTypes["FavouriteItemCreateResult"] | ModelTypes["FavouriteItemDeleteResult"] | ModelTypes["FavouriteItemUpdateResult"] | ModelTypes["FavouriteItemUpsertResult"] | ModelTypes["BusinessOrderTypeCreateResult"] | ModelTypes["BusinessOrderTypeDeleteResult"] | ModelTypes["BusinessOrderTypeUpdateResult"] | ModelTypes["BusinessOrderTypeUpsertResult"] | ModelTypes["BusinessOrderTypeLocaleCreateResult"] | ModelTypes["BusinessOrderTypeLocaleDeleteResult"] | ModelTypes["BusinessOrderTypeLocaleUpdateResult"] | ModelTypes["BusinessOrderTypeLocaleUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["ColorPalleteDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ColorPallete"]
};
	["ColorPalleteUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ColorPallete"],
	validation:ModelTypes["_ValidationResult"]
};
	["ColorPalleteUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ColorPallete"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"]
};
	["ContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["CoverCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Cover"],
	validation:ModelTypes["_ValidationResult"]
};
	["CoverDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Cover"]
};
	["CoverUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Cover"],
	validation:ModelTypes["_ValidationResult"]
};
	["CoverUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Cover"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"]
};
	["EventUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLocale"]
};
	["EventLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"]
};
	["ImageListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageItem"]
};
	["ImageItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"]
};
	["LocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"]
};
	["MediumUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"]
};
	["VideoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Blog"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Blog"]
};
	["BlogUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Blog"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Blog"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogLocale"]
};
	["BlogLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"]
};
	["PageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PageLocale"]
};
	["PageLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoLocale"]
};
	["SeoLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocalizedSeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LocalizedSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocalizedSeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LocalizedSeo"]
};
	["LocalizedSeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LocalizedSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocalizedSeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LocalizedSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeroCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Hero"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeroDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Hero"]
};
	["HeroUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Hero"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeroUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Hero"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"]
};
	["GalleryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"]
};
	["GalleryItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialsAndAppsCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialsAndApps"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialsAndAppsDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialsAndApps"]
};
	["SocialsAndAppsUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialsAndApps"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialsAndAppsUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialsAndApps"],
	validation:ModelTypes["_ValidationResult"]
};
	["SiteMenuCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SiteMenu"],
	validation:ModelTypes["_ValidationResult"]
};
	["SiteMenuDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SiteMenu"]
};
	["SiteMenuUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SiteMenu"],
	validation:ModelTypes["_ValidationResult"]
};
	["SiteMenuUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SiteMenu"],
	validation:ModelTypes["_ValidationResult"]
};
	["MenuItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MenuItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MenuItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MenuItem"]
};
	["MenuItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MenuItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MenuItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MenuItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostList"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostList"]
};
	["BlogPostListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostList"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostList"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostListItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostListItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostListItem"]
};
	["BlogPostListItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostListItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MenuLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MenuLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["MenuLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MenuLocale"]
};
	["MenuLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MenuLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["MenuLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MenuLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductGridCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductGrid"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductGridDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductGrid"]
};
	["ProductGridUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductGrid"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductGridUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductGrid"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductGridItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductGridItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductGridItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductGridItem"]
};
	["ProductGridItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductGridItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductGridItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductGridItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Profile"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Profile"]
};
	["ProfileUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Profile"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Profile"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileTagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileTagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileTag"]
};
	["ProfileTagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileTagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileActivityRecordCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileActivityRecord"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileActivityRecordDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileActivityRecord"]
};
	["ProfileActivityRecordUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileActivityRecord"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileActivityRecordUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileActivityRecord"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfilePinCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfilePin"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfilePinDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfilePin"]
};
	["ProfilePinUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfilePin"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfilePinUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfilePin"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileGalleryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileGallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileGalleryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileGallery"]
};
	["ProfileGalleryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileGallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileGalleryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileGallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileGalleryItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileGalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileGalleryItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileGalleryItem"]
};
	["ProfileGalleryItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileGalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProfileGalleryItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProfileGalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShoppingListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShoppingList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShoppingListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShoppingList"]
};
	["ShoppingListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShoppingList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShoppingListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShoppingList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShoppingListItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShoppingListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShoppingListItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShoppingListItem"]
};
	["ShoppingListItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShoppingListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShoppingListItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShoppingListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SupplierCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Supplier"],
	validation:ModelTypes["_ValidationResult"]
};
	["SupplierDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Supplier"]
};
	["SupplierUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Supplier"],
	validation:ModelTypes["_ValidationResult"]
};
	["SupplierUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Supplier"],
	validation:ModelTypes["_ValidationResult"]
};
	["FavouriteItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FavouriteItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FavouriteItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FavouriteItem"]
};
	["FavouriteItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FavouriteItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FavouriteItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FavouriteItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BusinessOrderTypeCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BusinessOrderType"],
	validation:ModelTypes["_ValidationResult"]
};
	["BusinessOrderTypeDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BusinessOrderType"]
};
	["BusinessOrderTypeUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BusinessOrderType"],
	validation:ModelTypes["_ValidationResult"]
};
	["BusinessOrderTypeUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BusinessOrderType"],
	validation:ModelTypes["_ValidationResult"]
};
	["BusinessOrderTypeLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BusinessOrderTypeLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["BusinessOrderTypeLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BusinessOrderTypeLocale"]
};
	["BusinessOrderTypeLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BusinessOrderTypeLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["BusinessOrderTypeLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BusinessOrderTypeLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	createColorPallete:ModelTypes["ColorPalleteCreateResult"],
	deleteColorPallete:ModelTypes["ColorPalleteDeleteResult"],
	updateColorPallete:ModelTypes["ColorPalleteUpdateResult"],
	upsertColorPallete:ModelTypes["ColorPalleteUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createCover:ModelTypes["CoverCreateResult"],
	deleteCover:ModelTypes["CoverDeleteResult"],
	updateCover:ModelTypes["CoverUpdateResult"],
	upsertCover:ModelTypes["CoverUpsertResult"],
	createEvent:ModelTypes["EventCreateResult"],
	deleteEvent:ModelTypes["EventDeleteResult"],
	updateEvent:ModelTypes["EventUpdateResult"],
	upsertEvent:ModelTypes["EventUpsertResult"],
	createEventLocale:ModelTypes["EventLocaleCreateResult"],
	deleteEventLocale:ModelTypes["EventLocaleDeleteResult"],
	updateEventLocale:ModelTypes["EventLocaleUpdateResult"],
	upsertEventLocale:ModelTypes["EventLocaleUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createImageList:ModelTypes["ImageListCreateResult"],
	deleteImageList:ModelTypes["ImageListDeleteResult"],
	updateImageList:ModelTypes["ImageListUpdateResult"],
	upsertImageList:ModelTypes["ImageListUpsertResult"],
	createImageItem:ModelTypes["ImageItemCreateResult"],
	deleteImageItem:ModelTypes["ImageItemDeleteResult"],
	updateImageItem:ModelTypes["ImageItemUpdateResult"],
	upsertImageItem:ModelTypes["ImageItemUpsertResult"],
	createLocale:ModelTypes["LocaleCreateResult"],
	deleteLocale:ModelTypes["LocaleDeleteResult"],
	updateLocale:ModelTypes["LocaleUpdateResult"],
	upsertLocale:ModelTypes["LocaleUpsertResult"],
	createMedium:ModelTypes["MediumCreateResult"],
	deleteMedium:ModelTypes["MediumDeleteResult"],
	updateMedium:ModelTypes["MediumUpdateResult"],
	upsertMedium:ModelTypes["MediumUpsertResult"],
	createVideo:ModelTypes["VideoCreateResult"],
	deleteVideo:ModelTypes["VideoDeleteResult"],
	updateVideo:ModelTypes["VideoUpdateResult"],
	upsertVideo:ModelTypes["VideoUpsertResult"],
	createBlog:ModelTypes["BlogCreateResult"],
	deleteBlog:ModelTypes["BlogDeleteResult"],
	updateBlog:ModelTypes["BlogUpdateResult"],
	upsertBlog:ModelTypes["BlogUpsertResult"],
	createBlogLocale:ModelTypes["BlogLocaleCreateResult"],
	deleteBlogLocale:ModelTypes["BlogLocaleDeleteResult"],
	updateBlogLocale:ModelTypes["BlogLocaleUpdateResult"],
	upsertBlogLocale:ModelTypes["BlogLocaleUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	createPageLocale:ModelTypes["PageLocaleCreateResult"],
	deletePageLocale:ModelTypes["PageLocaleDeleteResult"],
	updatePageLocale:ModelTypes["PageLocaleUpdateResult"],
	upsertPageLocale:ModelTypes["PageLocaleUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createSeoLocale:ModelTypes["SeoLocaleCreateResult"],
	deleteSeoLocale:ModelTypes["SeoLocaleDeleteResult"],
	updateSeoLocale:ModelTypes["SeoLocaleUpdateResult"],
	upsertSeoLocale:ModelTypes["SeoLocaleUpsertResult"],
	createLocalizedSeo:ModelTypes["LocalizedSeoCreateResult"],
	deleteLocalizedSeo:ModelTypes["LocalizedSeoDeleteResult"],
	updateLocalizedSeo:ModelTypes["LocalizedSeoUpdateResult"],
	upsertLocalizedSeo:ModelTypes["LocalizedSeoUpsertResult"],
	createHero:ModelTypes["HeroCreateResult"],
	deleteHero:ModelTypes["HeroDeleteResult"],
	updateHero:ModelTypes["HeroUpdateResult"],
	upsertHero:ModelTypes["HeroUpsertResult"],
	createGallery:ModelTypes["GalleryCreateResult"],
	deleteGallery:ModelTypes["GalleryDeleteResult"],
	updateGallery:ModelTypes["GalleryUpdateResult"],
	upsertGallery:ModelTypes["GalleryUpsertResult"],
	createGalleryItem:ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem:ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem:ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem:ModelTypes["GalleryItemUpsertResult"],
	createSocialsAndApps:ModelTypes["SocialsAndAppsCreateResult"],
	deleteSocialsAndApps:ModelTypes["SocialsAndAppsDeleteResult"],
	updateSocialsAndApps:ModelTypes["SocialsAndAppsUpdateResult"],
	upsertSocialsAndApps:ModelTypes["SocialsAndAppsUpsertResult"],
	createSiteMenu:ModelTypes["SiteMenuCreateResult"],
	deleteSiteMenu:ModelTypes["SiteMenuDeleteResult"],
	updateSiteMenu:ModelTypes["SiteMenuUpdateResult"],
	upsertSiteMenu:ModelTypes["SiteMenuUpsertResult"],
	createMenuItem:ModelTypes["MenuItemCreateResult"],
	deleteMenuItem:ModelTypes["MenuItemDeleteResult"],
	updateMenuItem:ModelTypes["MenuItemUpdateResult"],
	upsertMenuItem:ModelTypes["MenuItemUpsertResult"],
	createBlogPostList:ModelTypes["BlogPostListCreateResult"],
	deleteBlogPostList:ModelTypes["BlogPostListDeleteResult"],
	updateBlogPostList:ModelTypes["BlogPostListUpdateResult"],
	upsertBlogPostList:ModelTypes["BlogPostListUpsertResult"],
	createBlogPostListItem:ModelTypes["BlogPostListItemCreateResult"],
	deleteBlogPostListItem:ModelTypes["BlogPostListItemDeleteResult"],
	updateBlogPostListItem:ModelTypes["BlogPostListItemUpdateResult"],
	upsertBlogPostListItem:ModelTypes["BlogPostListItemUpsertResult"],
	createMenuLocale:ModelTypes["MenuLocaleCreateResult"],
	deleteMenuLocale:ModelTypes["MenuLocaleDeleteResult"],
	updateMenuLocale:ModelTypes["MenuLocaleUpdateResult"],
	upsertMenuLocale:ModelTypes["MenuLocaleUpsertResult"],
	createProductGrid:ModelTypes["ProductGridCreateResult"],
	deleteProductGrid:ModelTypes["ProductGridDeleteResult"],
	updateProductGrid:ModelTypes["ProductGridUpdateResult"],
	upsertProductGrid:ModelTypes["ProductGridUpsertResult"],
	createProductGridItem:ModelTypes["ProductGridItemCreateResult"],
	deleteProductGridItem:ModelTypes["ProductGridItemDeleteResult"],
	updateProductGridItem:ModelTypes["ProductGridItemUpdateResult"],
	upsertProductGridItem:ModelTypes["ProductGridItemUpsertResult"],
	createProfile:ModelTypes["ProfileCreateResult"],
	deleteProfile:ModelTypes["ProfileDeleteResult"],
	updateProfile:ModelTypes["ProfileUpdateResult"],
	upsertProfile:ModelTypes["ProfileUpsertResult"],
	createProfileTag:ModelTypes["ProfileTagCreateResult"],
	deleteProfileTag:ModelTypes["ProfileTagDeleteResult"],
	updateProfileTag:ModelTypes["ProfileTagUpdateResult"],
	upsertProfileTag:ModelTypes["ProfileTagUpsertResult"],
	createProfileActivityRecord:ModelTypes["ProfileActivityRecordCreateResult"],
	deleteProfileActivityRecord:ModelTypes["ProfileActivityRecordDeleteResult"],
	updateProfileActivityRecord:ModelTypes["ProfileActivityRecordUpdateResult"],
	upsertProfileActivityRecord:ModelTypes["ProfileActivityRecordUpsertResult"],
	createProfilePin:ModelTypes["ProfilePinCreateResult"],
	deleteProfilePin:ModelTypes["ProfilePinDeleteResult"],
	updateProfilePin:ModelTypes["ProfilePinUpdateResult"],
	upsertProfilePin:ModelTypes["ProfilePinUpsertResult"],
	createProfileGallery:ModelTypes["ProfileGalleryCreateResult"],
	deleteProfileGallery:ModelTypes["ProfileGalleryDeleteResult"],
	updateProfileGallery:ModelTypes["ProfileGalleryUpdateResult"],
	upsertProfileGallery:ModelTypes["ProfileGalleryUpsertResult"],
	createProfileGalleryItem:ModelTypes["ProfileGalleryItemCreateResult"],
	deleteProfileGalleryItem:ModelTypes["ProfileGalleryItemDeleteResult"],
	updateProfileGalleryItem:ModelTypes["ProfileGalleryItemUpdateResult"],
	upsertProfileGalleryItem:ModelTypes["ProfileGalleryItemUpsertResult"],
	createShoppingList:ModelTypes["ShoppingListCreateResult"],
	deleteShoppingList:ModelTypes["ShoppingListDeleteResult"],
	updateShoppingList:ModelTypes["ShoppingListUpdateResult"],
	upsertShoppingList:ModelTypes["ShoppingListUpsertResult"],
	createShoppingListItem:ModelTypes["ShoppingListItemCreateResult"],
	deleteShoppingListItem:ModelTypes["ShoppingListItemDeleteResult"],
	updateShoppingListItem:ModelTypes["ShoppingListItemUpdateResult"],
	upsertShoppingListItem:ModelTypes["ShoppingListItemUpsertResult"],
	createSupplier:ModelTypes["SupplierCreateResult"],
	deleteSupplier:ModelTypes["SupplierDeleteResult"],
	updateSupplier:ModelTypes["SupplierUpdateResult"],
	upsertSupplier:ModelTypes["SupplierUpsertResult"],
	createFavouriteItem:ModelTypes["FavouriteItemCreateResult"],
	deleteFavouriteItem:ModelTypes["FavouriteItemDeleteResult"],
	updateFavouriteItem:ModelTypes["FavouriteItemUpdateResult"],
	upsertFavouriteItem:ModelTypes["FavouriteItemUpsertResult"],
	createBusinessOrderType:ModelTypes["BusinessOrderTypeCreateResult"],
	deleteBusinessOrderType:ModelTypes["BusinessOrderTypeDeleteResult"],
	updateBusinessOrderType:ModelTypes["BusinessOrderTypeUpdateResult"],
	upsertBusinessOrderType:ModelTypes["BusinessOrderTypeUpsertResult"],
	createBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleCreateResult"],
	deleteBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleDeleteResult"],
	updateBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleUpdateResult"],
	upsertBusinessOrderTypeLocale:ModelTypes["BusinessOrderTypeLocaleUpsertResult"],
	query?:ModelTypes["Query"]
};
	["Json"]:any;
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	["_RuleMessage"]: {
		text?:string
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getColorPallete?: GraphQLTypes["ColorPallete"],
	listColorPallete: Array<GraphQLTypes["ColorPallete"]>,
	paginateColorPallete: GraphQLTypes["ColorPalleteConnection"],
	validateCreateColorPallete: GraphQLTypes["_ValidationResult"],
	validateUpdateColorPallete: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getCover?: GraphQLTypes["Cover"],
	listCover: Array<GraphQLTypes["Cover"]>,
	paginateCover: GraphQLTypes["CoverConnection"],
	validateCreateCover: GraphQLTypes["_ValidationResult"],
	validateUpdateCover: GraphQLTypes["_ValidationResult"],
	getEvent?: GraphQLTypes["Event"],
	listEvent: Array<GraphQLTypes["Event"]>,
	paginateEvent: GraphQLTypes["EventConnection"],
	validateCreateEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateEvent: GraphQLTypes["_ValidationResult"],
	getEventLocale?: GraphQLTypes["EventLocale"],
	listEventLocale: Array<GraphQLTypes["EventLocale"]>,
	paginateEventLocale: GraphQLTypes["EventLocaleConnection"],
	validateCreateEventLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateEventLocale: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"],
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageItem?: GraphQLTypes["ImageItem"],
	listImageItem: Array<GraphQLTypes["ImageItem"]>,
	paginateImageItem: GraphQLTypes["ImageItemConnection"],
	validateCreateImageItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageItem: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"],
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"],
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"],
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getBlog?: GraphQLTypes["Blog"],
	listBlog: Array<GraphQLTypes["Blog"]>,
	paginateBlog: GraphQLTypes["BlogConnection"],
	validateCreateBlog: GraphQLTypes["_ValidationResult"],
	validateUpdateBlog: GraphQLTypes["_ValidationResult"],
	getBlogLocale?: GraphQLTypes["BlogLocale"],
	listBlogLocale: Array<GraphQLTypes["BlogLocale"]>,
	paginateBlogLocale: GraphQLTypes["BlogLocaleConnection"],
	validateCreateBlogLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogLocale: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getPageLocale?: GraphQLTypes["PageLocale"],
	listPageLocale: Array<GraphQLTypes["PageLocale"]>,
	paginatePageLocale: GraphQLTypes["PageLocaleConnection"],
	validateCreatePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePageLocale: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getSeoLocale?: GraphQLTypes["SeoLocale"],
	listSeoLocale: Array<GraphQLTypes["SeoLocale"]>,
	paginateSeoLocale: GraphQLTypes["SeoLocaleConnection"],
	validateCreateSeoLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoLocale: GraphQLTypes["_ValidationResult"],
	getLocalizedSeo?: GraphQLTypes["LocalizedSeo"],
	listLocalizedSeo: Array<GraphQLTypes["LocalizedSeo"]>,
	paginateLocalizedSeo: GraphQLTypes["LocalizedSeoConnection"],
	validateCreateLocalizedSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateLocalizedSeo: GraphQLTypes["_ValidationResult"],
	getHero?: GraphQLTypes["Hero"],
	listHero: Array<GraphQLTypes["Hero"]>,
	paginateHero: GraphQLTypes["HeroConnection"],
	validateCreateHero: GraphQLTypes["_ValidationResult"],
	validateUpdateHero: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"],
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"],
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getSocialsAndApps?: GraphQLTypes["SocialsAndApps"],
	listSocialsAndApps: Array<GraphQLTypes["SocialsAndApps"]>,
	paginateSocialsAndApps: GraphQLTypes["SocialsAndAppsConnection"],
	validateCreateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	getSiteMenu?: GraphQLTypes["SiteMenu"],
	listSiteMenu: Array<GraphQLTypes["SiteMenu"]>,
	paginateSiteMenu: GraphQLTypes["SiteMenuConnection"],
	validateCreateSiteMenu: GraphQLTypes["_ValidationResult"],
	validateUpdateSiteMenu: GraphQLTypes["_ValidationResult"],
	getMenuItem?: GraphQLTypes["MenuItem"],
	listMenuItem: Array<GraphQLTypes["MenuItem"]>,
	paginateMenuItem: GraphQLTypes["MenuItemConnection"],
	validateCreateMenuItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuItem: GraphQLTypes["_ValidationResult"],
	getBlogPostList?: GraphQLTypes["BlogPostList"],
	listBlogPostList: Array<GraphQLTypes["BlogPostList"]>,
	paginateBlogPostList: GraphQLTypes["BlogPostListConnection"],
	validateCreateBlogPostList: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostList: GraphQLTypes["_ValidationResult"],
	getBlogPostListItem?: GraphQLTypes["BlogPostListItem"],
	listBlogPostListItem: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateBlogPostListItem: GraphQLTypes["BlogPostListItemConnection"],
	validateCreateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	getMenuLocale?: GraphQLTypes["MenuLocale"],
	listMenuLocale: Array<GraphQLTypes["MenuLocale"]>,
	paginateMenuLocale: GraphQLTypes["MenuLocaleConnection"],
	validateCreateMenuLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLocale: GraphQLTypes["_ValidationResult"],
	getProductGrid?: GraphQLTypes["ProductGrid"],
	listProductGrid: Array<GraphQLTypes["ProductGrid"]>,
	paginateProductGrid: GraphQLTypes["ProductGridConnection"],
	validateCreateProductGrid: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGrid: GraphQLTypes["_ValidationResult"],
	getProductGridItem?: GraphQLTypes["ProductGridItem"],
	listProductGridItem: Array<GraphQLTypes["ProductGridItem"]>,
	paginateProductGridItem: GraphQLTypes["ProductGridItemConnection"],
	validateCreateProductGridItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridItem: GraphQLTypes["_ValidationResult"],
	getProfile?: GraphQLTypes["Profile"],
	listProfile: Array<GraphQLTypes["Profile"]>,
	paginateProfile: GraphQLTypes["ProfileConnection"],
	validateCreateProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateProfile: GraphQLTypes["_ValidationResult"],
	getProfileTag?: GraphQLTypes["ProfileTag"],
	listProfileTag: Array<GraphQLTypes["ProfileTag"]>,
	paginateProfileTag: GraphQLTypes["ProfileTagConnection"],
	validateCreateProfileTag: GraphQLTypes["_ValidationResult"],
	validateUpdateProfileTag: GraphQLTypes["_ValidationResult"],
	getProfileActivityRecord?: GraphQLTypes["ProfileActivityRecord"],
	listProfileActivityRecord: Array<GraphQLTypes["ProfileActivityRecord"]>,
	paginateProfileActivityRecord: GraphQLTypes["ProfileActivityRecordConnection"],
	validateCreateProfileActivityRecord: GraphQLTypes["_ValidationResult"],
	validateUpdateProfileActivityRecord: GraphQLTypes["_ValidationResult"],
	getProfilePin?: GraphQLTypes["ProfilePin"],
	listProfilePin: Array<GraphQLTypes["ProfilePin"]>,
	paginateProfilePin: GraphQLTypes["ProfilePinConnection"],
	validateCreateProfilePin: GraphQLTypes["_ValidationResult"],
	validateUpdateProfilePin: GraphQLTypes["_ValidationResult"],
	getProfileGallery?: GraphQLTypes["ProfileGallery"],
	listProfileGallery: Array<GraphQLTypes["ProfileGallery"]>,
	paginateProfileGallery: GraphQLTypes["ProfileGalleryConnection"],
	validateCreateProfileGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateProfileGallery: GraphQLTypes["_ValidationResult"],
	getProfileGalleryItem?: GraphQLTypes["ProfileGalleryItem"],
	listProfileGalleryItem: Array<GraphQLTypes["ProfileGalleryItem"]>,
	paginateProfileGalleryItem: GraphQLTypes["ProfileGalleryItemConnection"],
	validateCreateProfileGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProfileGalleryItem: GraphQLTypes["_ValidationResult"],
	getShoppingList?: GraphQLTypes["ShoppingList"],
	listShoppingList: Array<GraphQLTypes["ShoppingList"]>,
	paginateShoppingList: GraphQLTypes["ShoppingListConnection"],
	validateCreateShoppingList: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingList: GraphQLTypes["_ValidationResult"],
	getShoppingListItem?: GraphQLTypes["ShoppingListItem"],
	listShoppingListItem: Array<GraphQLTypes["ShoppingListItem"]>,
	paginateShoppingListItem: GraphQLTypes["ShoppingListItemConnection"],
	validateCreateShoppingListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingListItem: GraphQLTypes["_ValidationResult"],
	getSupplier?: GraphQLTypes["Supplier"],
	listSupplier: Array<GraphQLTypes["Supplier"]>,
	paginateSupplier: GraphQLTypes["SupplierConnection"],
	validateCreateSupplier: GraphQLTypes["_ValidationResult"],
	validateUpdateSupplier: GraphQLTypes["_ValidationResult"],
	getFavouriteItem?: GraphQLTypes["FavouriteItem"],
	listFavouriteItem: Array<GraphQLTypes["FavouriteItem"]>,
	paginateFavouriteItem: GraphQLTypes["FavouriteItemConnection"],
	validateCreateFavouriteItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFavouriteItem: GraphQLTypes["_ValidationResult"],
	getBusinessOrderType?: GraphQLTypes["BusinessOrderType"],
	listBusinessOrderType: Array<GraphQLTypes["BusinessOrderType"]>,
	paginateBusinessOrderType: GraphQLTypes["BusinessOrderTypeConnection"],
	validateCreateBusinessOrderType: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessOrderType: GraphQLTypes["_ValidationResult"],
	getBusinessOrderTypeLocale?: GraphQLTypes["BusinessOrderTypeLocale"],
	listBusinessOrderTypeLocale: Array<GraphQLTypes["BusinessOrderTypeLocale"]>,
	paginateBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleConnection"],
	validateCreateBusinessOrderTypeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessOrderTypeLocale: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"],
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string
};
	["ColorPallete"]: {
	__typename: "ColorPallete",
	_meta?: GraphQLTypes["ColorPalleteMeta"],
	id: GraphQLTypes["UUID"],
	background?: string,
	text?: string
};
	["ColorPalleteMeta"]: {
	__typename: "ColorPalleteMeta",
	id?: GraphQLTypes["FieldMeta"],
	background?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:any;
	["ColorPalleteUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ColorPalleteWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	background?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ColorPalleteWhere"] | undefined>,
	or?: Array<GraphQLTypes["ColorPalleteWhere"] | undefined>,
	not?: GraphQLTypes["ColorPalleteWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["ColorPalleteOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	background?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"]
};
	["OrderDirection"]: OrderDirection;
	["ColorPalleteConnection"]: {
	__typename: "ColorPalleteConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ColorPalleteEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["ColorPalleteEdge"]: {
	__typename: "ColorPalleteEdge",
	node: GraphQLTypes["ColorPallete"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["ColorPalleteCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	background?: string,
	text?: string,
	_dummy_field_?: boolean
};
	["ColorPalleteUpdateInput"]: {
		background?: string,
	text?: string,
	_dummy_field_?: boolean
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"],
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"],
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"]
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"],
	references: Array<GraphQLTypes["ContentReference"]>,
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"]
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	blocks?: GraphQLTypes["ContentBlockWhere"],
	and?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	not?: GraphQLTypes["ContentWhere"]
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	references?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentBlockWhere"]
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ContentReferenceTypeCondition"],
	primaryText?: GraphQLTypes["StringCondition"],
	secondaryText?: GraphQLTypes["StringCondition"],
	jsonContent?: GraphQLTypes["StringCondition"],
	block?: GraphQLTypes["ContentBlockWhere"],
	colorPallete?: GraphQLTypes["ColorPalleteWhere"],
	medium?: GraphQLTypes["MediumWhere"],
	misc?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkWhere"],
	hero?: GraphQLTypes["HeroWhere"],
	gallery?: GraphQLTypes["GalleryWhere"],
	contentSize?: GraphQLTypes["ContentSizeCondition"],
	socialsAndApps?: GraphQLTypes["SocialsAndAppsWhere"],
	blogPosts?: GraphQLTypes["BlogPostListWhere"],
	productGrid?: GraphQLTypes["ProductGridWhere"],
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceWhere"]
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	not?: GraphQLTypes["ContentReferenceTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentReferenceType"],
	notEq?: GraphQLTypes["ContentReferenceType"],
	in?: Array<GraphQLTypes["ContentReferenceType"]>,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]>,
	lt?: GraphQLTypes["ContentReferenceType"],
	lte?: GraphQLTypes["ContentReferenceType"],
	gt?: GraphQLTypes["ContentReferenceType"],
	gte?: GraphQLTypes["ContentReferenceType"]
};
	["ContentReferenceType"]: ContentReferenceType;
	["MediumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["MediumTypeCondition"],
	colorTheme?: GraphQLTypes["ColorThemeCondition"],
	image?: GraphQLTypes["ImageWhere"],
	video?: GraphQLTypes["VideoWhere"],
	and?: Array<GraphQLTypes["MediumWhere"] | undefined>,
	or?: Array<GraphQLTypes["MediumWhere"] | undefined>,
	not?: GraphQLTypes["MediumWhere"]
};
	["MediumTypeCondition"]: {
		and?: Array<GraphQLTypes["MediumTypeCondition"]>,
	or?: Array<GraphQLTypes["MediumTypeCondition"]>,
	not?: GraphQLTypes["MediumTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["MediumType"],
	notEq?: GraphQLTypes["MediumType"],
	in?: Array<GraphQLTypes["MediumType"]>,
	notIn?: Array<GraphQLTypes["MediumType"]>,
	lt?: GraphQLTypes["MediumType"],
	lte?: GraphQLTypes["MediumType"],
	gt?: GraphQLTypes["MediumType"],
	gte?: GraphQLTypes["MediumType"]
};
	["MediumType"]: MediumType;
	["ColorThemeCondition"]: {
		and?: Array<GraphQLTypes["ColorThemeCondition"]>,
	or?: Array<GraphQLTypes["ColorThemeCondition"]>,
	not?: GraphQLTypes["ColorThemeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ColorTheme"],
	notEq?: GraphQLTypes["ColorTheme"],
	in?: Array<GraphQLTypes["ColorTheme"]>,
	notIn?: Array<GraphQLTypes["ColorTheme"]>,
	lt?: GraphQLTypes["ColorTheme"],
	lte?: GraphQLTypes["ColorTheme"],
	gt?: GraphQLTypes["ColorTheme"],
	gte?: GraphQLTypes["ColorTheme"]
};
	["ColorTheme"]: ColorTheme;
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	title?: GraphQLTypes["StringCondition"],
	alt?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["VideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	src?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	duration?: GraphQLTypes["FloatCondition"],
	poster?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["VideoWhere"] | undefined>,
	or?: Array<GraphQLTypes["VideoWhere"] | undefined>,
	not?: GraphQLTypes["VideoWhere"]
};
	["FloatCondition"]: {
		and?: Array<GraphQLTypes["FloatCondition"]>,
	or?: Array<GraphQLTypes["FloatCondition"]>,
	not?: GraphQLTypes["FloatCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["LinkTypeCondition"],
	title?: GraphQLTypes["StringCondition"],
	externalLink?: GraphQLTypes["StringCondition"],
	internalLink?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]>,
	or?: Array<GraphQLTypes["LinkTypeCondition"]>,
	not?: GraphQLTypes["LinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["LinkType"],
	notEq?: GraphQLTypes["LinkType"],
	in?: Array<GraphQLTypes["LinkType"]>,
	notIn?: Array<GraphQLTypes["LinkType"]>,
	lt?: GraphQLTypes["LinkType"],
	lte?: GraphQLTypes["LinkType"],
	gt?: GraphQLTypes["LinkType"],
	gte?: GraphQLTypes["LinkType"]
};
	["LinkType"]: LinkType;
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	page?: GraphQLTypes["PageLocaleWhere"],
	event?: GraphQLTypes["EventLocaleWhere"],
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	not?: GraphQLTypes["LinkableWhere"]
};
	["PageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	root?: GraphQLTypes["PageWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	seo?: GraphQLTypes["LocalizedSeoWhere"],
	content?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["PageLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["PageLocaleWhere"] | undefined>,
	not?: GraphQLTypes["PageLocaleWhere"]
};
	["PageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	locales?: GraphQLTypes["PageLocaleWhere"],
	and?: Array<GraphQLTypes["PageWhere"] | undefined>,
	or?: Array<GraphQLTypes["PageWhere"] | undefined>,
	not?: GraphQLTypes["PageWhere"]
};
	["LocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	code?: GraphQLTypes["StringCondition"],
	label?: GraphQLTypes["StringCondition"],
	events?: GraphQLTypes["EventLocaleWhere"],
	blogs?: GraphQLTypes["BlogLocaleWhere"],
	pages?: GraphQLTypes["PageLocaleWhere"],
	seos?: GraphQLTypes["SeoLocaleWhere"],
	menus?: GraphQLTypes["MenuLocaleWhere"],
	businessOrderTypes?: GraphQLTypes["BusinessOrderTypeLocaleWhere"],
	and?: Array<GraphQLTypes["LocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["LocaleWhere"] | undefined>,
	not?: GraphQLTypes["LocaleWhere"]
};
	["EventLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	root?: GraphQLTypes["EventWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	cover?: GraphQLTypes["CoverWhere"],
	content?: GraphQLTypes["ContentWhere"],
	availableForWeb?: GraphQLTypes["BooleanCondition"],
	availableForMobile?: GraphQLTypes["BooleanCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	title?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["LocalizedSeoWhere"],
	and?: Array<GraphQLTypes["EventLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["EventLocaleWhere"] | undefined>,
	not?: GraphQLTypes["EventLocaleWhere"]
};
	["EventWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	locales?: GraphQLTypes["EventLocaleWhere"],
	and?: Array<GraphQLTypes["EventWhere"] | undefined>,
	or?: Array<GraphQLTypes["EventWhere"] | undefined>,
	not?: GraphQLTypes["EventWhere"]
};
	["CoverWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	primaryTitle?: GraphQLTypes["StringCondition"],
	secondaryTitle?: GraphQLTypes["StringCondition"],
	buttonColors?: GraphQLTypes["ColorPalleteWhere"],
	medium?: GraphQLTypes["MediumWhere"],
	and?: Array<GraphQLTypes["CoverWhere"] | undefined>,
	or?: Array<GraphQLTypes["CoverWhere"] | undefined>,
	not?: GraphQLTypes["CoverWhere"]
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]>,
	or?: Array<GraphQLTypes["BooleanCondition"]>,
	not?: GraphQLTypes["BooleanCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: boolean,
	notEq?: boolean,
	in?: Array<boolean>,
	notIn?: Array<boolean>,
	lt?: boolean,
	lte?: boolean,
	gt?: boolean,
	gte?: boolean
};
	["LocalizedSeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["LocalizedSeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["LocalizedSeoWhere"] | undefined>,
	not?: GraphQLTypes["LocalizedSeoWhere"]
};
	["BlogLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	pageName?: GraphQLTypes["StringCondition"],
	title?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["BlogWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	and?: Array<GraphQLTypes["BlogLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogLocaleWhere"] | undefined>,
	not?: GraphQLTypes["BlogLocaleWhere"]
};
	["BlogWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["BlogLocaleWhere"],
	and?: Array<GraphQLTypes["BlogWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogWhere"] | undefined>,
	not?: GraphQLTypes["BlogWhere"]
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]>,
	or?: Array<GraphQLTypes["OneCondition"]>,
	not?: GraphQLTypes["OneCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["One"],
	notEq?: GraphQLTypes["One"],
	in?: Array<GraphQLTypes["One"]>,
	notIn?: Array<GraphQLTypes["One"]>,
	lt?: GraphQLTypes["One"],
	lte?: GraphQLTypes["One"],
	gt?: GraphQLTypes["One"],
	gte?: GraphQLTypes["One"]
};
	["One"]: One;
	["SeoLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["SeoWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	and?: Array<GraphQLTypes["SeoLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoLocaleWhere"] | undefined>,
	not?: GraphQLTypes["SeoLocaleWhere"]
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	locales?: GraphQLTypes["SeoLocaleWhere"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["MenuLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	root?: GraphQLTypes["SiteMenuWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	items?: GraphQLTypes["MenuItemWhere"],
	and?: Array<GraphQLTypes["MenuLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["MenuLocaleWhere"] | undefined>,
	not?: GraphQLTypes["MenuLocaleWhere"]
};
	["SiteMenuWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["MenuLocaleWhere"],
	and?: Array<GraphQLTypes["SiteMenuWhere"] | undefined>,
	or?: Array<GraphQLTypes["SiteMenuWhere"] | undefined>,
	not?: GraphQLTypes["SiteMenuWhere"]
};
	["MenuItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	menu?: GraphQLTypes["MenuLocaleWhere"],
	and?: Array<GraphQLTypes["MenuItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["MenuItemWhere"] | undefined>,
	not?: GraphQLTypes["MenuItemWhere"]
};
	["BusinessOrderTypeLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["BusinessOrderTypeWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	and?: Array<GraphQLTypes["BusinessOrderTypeLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["BusinessOrderTypeLocaleWhere"] | undefined>,
	not?: GraphQLTypes["BusinessOrderTypeLocaleWhere"]
};
	["BusinessOrderTypeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	locales?: GraphQLTypes["BusinessOrderTypeLocaleWhere"],
	and?: Array<GraphQLTypes["BusinessOrderTypeWhere"] | undefined>,
	or?: Array<GraphQLTypes["BusinessOrderTypeWhere"] | undefined>,
	not?: GraphQLTypes["BusinessOrderTypeWhere"]
};
	["HeroWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	showLogo?: GraphQLTypes["BooleanCondition"],
	middleContent?: GraphQLTypes["StringCondition"],
	medium?: GraphQLTypes["MediumWhere"],
	and?: Array<GraphQLTypes["HeroWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeroWhere"] | undefined>,
	not?: GraphQLTypes["HeroWhere"]
};
	["GalleryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["GalleryItemWhere"],
	and?: Array<GraphQLTypes["GalleryWhere"] | undefined>,
	or?: Array<GraphQLTypes["GalleryWhere"] | undefined>,
	not?: GraphQLTypes["GalleryWhere"]
};
	["GalleryItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	caption?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["GalleryWhere"],
	medium?: GraphQLTypes["MediumWhere"],
	and?: Array<GraphQLTypes["GalleryItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["GalleryItemWhere"] | undefined>,
	not?: GraphQLTypes["GalleryItemWhere"]
};
	["ContentSizeCondition"]: {
		and?: Array<GraphQLTypes["ContentSizeCondition"]>,
	or?: Array<GraphQLTypes["ContentSizeCondition"]>,
	not?: GraphQLTypes["ContentSizeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentSize"],
	notEq?: GraphQLTypes["ContentSize"],
	in?: Array<GraphQLTypes["ContentSize"]>,
	notIn?: Array<GraphQLTypes["ContentSize"]>,
	lt?: GraphQLTypes["ContentSize"],
	lte?: GraphQLTypes["ContentSize"],
	gt?: GraphQLTypes["ContentSize"],
	gte?: GraphQLTypes["ContentSize"]
};
	["ContentSize"]: ContentSize;
	["SocialsAndAppsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	instagram?: GraphQLTypes["BooleanCondition"],
	appStore?: GraphQLTypes["BooleanCondition"],
	googlePlay?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["SocialsAndAppsWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialsAndAppsWhere"] | undefined>,
	not?: GraphQLTypes["SocialsAndAppsWhere"]
};
	["BlogPostListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["BlogPostListItemWhere"],
	and?: Array<GraphQLTypes["BlogPostListWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogPostListWhere"] | undefined>,
	not?: GraphQLTypes["BlogPostListWhere"]
};
	["BlogPostListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	caption?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["BlogPostListWhere"],
	blogPost?: GraphQLTypes["EventLocaleWhere"],
	and?: Array<GraphQLTypes["BlogPostListItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogPostListItemWhere"] | undefined>,
	not?: GraphQLTypes["BlogPostListItemWhere"]
};
	["ProductGridWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ProductGridItemWhere"],
	and?: Array<GraphQLTypes["ProductGridWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductGridWhere"] | undefined>,
	not?: GraphQLTypes["ProductGridWhere"]
};
	["ProductGridItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	goodlokProductId?: GraphQLTypes["StringCondition"],
	title?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["ProductGridWhere"],
	medium?: GraphQLTypes["MediumWhere"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["ProductGridItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductGridItemWhere"] | undefined>,
	not?: GraphQLTypes["ProductGridItemWhere"]
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	jsonContent?: string,
	block?: GraphQLTypes["ContentBlock"],
	colorPallete?: GraphQLTypes["ColorPallete"],
	medium?: GraphQLTypes["Medium"],
	misc?: string,
	link?: GraphQLTypes["Link"],
	hero?: GraphQLTypes["Hero"],
	gallery?: GraphQLTypes["Gallery"],
	contentSize?: GraphQLTypes["ContentSize"],
	socialsAndApps?: GraphQLTypes["SocialsAndApps"],
	blogPosts?: GraphQLTypes["BlogPostList"],
	productGrid?: GraphQLTypes["ProductGrid"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	primaryText?: GraphQLTypes["FieldMeta"],
	secondaryText?: GraphQLTypes["FieldMeta"],
	jsonContent?: GraphQLTypes["FieldMeta"],
	block?: GraphQLTypes["FieldMeta"],
	colorPallete?: GraphQLTypes["FieldMeta"],
	medium?: GraphQLTypes["FieldMeta"],
	misc?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	hero?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"],
	contentSize?: GraphQLTypes["FieldMeta"],
	socialsAndApps?: GraphQLTypes["FieldMeta"],
	blogPosts?: GraphQLTypes["FieldMeta"],
	productGrid?: GraphQLTypes["FieldMeta"]
};
	["Medium"]: {
	__typename: "Medium",
	_meta?: GraphQLTypes["MediumMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MediumType"],
	colorTheme?: GraphQLTypes["ColorTheme"],
	image?: GraphQLTypes["Image"],
	video?: GraphQLTypes["Video"]
};
	["MediumMeta"]: {
	__typename: "MediumMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	colorTheme?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	video?: GraphQLTypes["FieldMeta"]
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	title?: string,
	alt?: string
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	alt?: GraphQLTypes["FieldMeta"]
};
	["Video"]: {
	__typename: "Video",
	_meta?: GraphQLTypes["VideoMeta"],
	id: GraphQLTypes["UUID"],
	src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["Image"]
};
	["VideoMeta"]: {
	__typename: "VideoMeta",
	id?: GraphQLTypes["FieldMeta"],
	src?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	duration?: GraphQLTypes["FieldMeta"],
	poster?: GraphQLTypes["FieldMeta"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["Linkable"]
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	externalLink?: GraphQLTypes["FieldMeta"],
	internalLink?: GraphQLTypes["FieldMeta"]
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	page?: GraphQLTypes["PageLocale"],
	event?: GraphQLTypes["EventLocale"]
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	page?: GraphQLTypes["FieldMeta"],
	event?: GraphQLTypes["FieldMeta"]
};
	["PageLocale"]: {
	__typename: "PageLocale",
	_meta?: GraphQLTypes["PageLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["Linkable"],
	root?: GraphQLTypes["Page"],
	locale?: GraphQLTypes["Locale"],
	seo?: GraphQLTypes["LocalizedSeo"],
	content?: GraphQLTypes["Content"]
};
	["PageLocaleMeta"]: {
	__typename: "PageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"]
};
	["Page"]: {
	__typename: "Page",
	_meta?: GraphQLTypes["PageMeta"],
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["PageLocale"]>,
	localesByLocale?: GraphQLTypes["PageLocale"],
	localesByLink?: GraphQLTypes["PageLocale"],
	localesBySeo?: GraphQLTypes["PageLocale"],
	localesByContent?: GraphQLTypes["PageLocale"],
	paginateLocales: GraphQLTypes["PageLocaleConnection"]
};
	["PageMeta"]: {
	__typename: "PageMeta",
	id?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["PageLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	root?: GraphQLTypes["PageOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	seo?: GraphQLTypes["LocalizedSeoOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["LinkableOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	page?: GraphQLTypes["PageLocaleOrderBy"],
	event?: GraphQLTypes["EventLocaleOrderBy"]
};
	["EventLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["EventOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	cover?: GraphQLTypes["CoverOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	availableForWeb?: GraphQLTypes["OrderDirection"],
	availableForMobile?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	title?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["LocalizedSeoOrderBy"]
};
	["EventOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"]
};
	["LocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	code?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"]
};
	["CoverOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	primaryTitle?: GraphQLTypes["OrderDirection"],
	secondaryTitle?: GraphQLTypes["OrderDirection"],
	buttonColors?: GraphQLTypes["ColorPalleteOrderBy"],
	medium?: GraphQLTypes["MediumOrderBy"]
};
	["MediumOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	colorTheme?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	video?: GraphQLTypes["VideoOrderBy"]
};
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	alt?: GraphQLTypes["OrderDirection"]
};
	["VideoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	src?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	duration?: GraphQLTypes["OrderDirection"],
	poster?: GraphQLTypes["ImageOrderBy"]
};
	["ContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["LocalizedSeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"]
};
	["PageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["PageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["LocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	events?: GraphQLTypes["EventLocaleUniqueWhere"],
	blogs?: GraphQLTypes["BlogLocaleUniqueWhere"],
	pages?: GraphQLTypes["PageLocaleUniqueWhere"],
	seos?: GraphQLTypes["SeoLocaleUniqueWhere"],
	menus?: GraphQLTypes["MenuLocaleUniqueWhere"],
	businessOrderTypes?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"]
};
	["EventLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["EventUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	cover?: GraphQLTypes["CoverUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["LocalizedSeoUniqueWhere"]
};
	["EventUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["EventLocaleUniqueWhere"]
};
	["CoverUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"]
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	page?: GraphQLTypes["PageLocaleUniqueWhere"],
	event?: GraphQLTypes["EventLocaleUniqueWhere"]
};
	["PageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["PageUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["LocalizedSeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"]
};
	["PageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["PageLocaleUniqueWhere"]
};
	["LocalizedSeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["BlogLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["BlogUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["BlogUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["BlogLocaleUniqueWhere"]
};
	["SeoLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SeoUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"],
	locales?: GraphQLTypes["SeoLocaleUniqueWhere"]
};
	["MenuLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SiteMenuUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	items?: GraphQLTypes["MenuItemUniqueWhere"]
};
	["SiteMenuUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["MenuLocaleUniqueWhere"]
};
	["MenuItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["BusinessOrderTypeLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["BusinessOrderTypeUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["BusinessOrderTypeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"]
};
	["PageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["PageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["LocalizedSeoUniqueWhere"]
};
	["PageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["PageLocaleConnection"]: {
	__typename: "PageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageLocaleEdge"]>
};
	["PageLocaleEdge"]: {
	__typename: "PageLocaleEdge",
	node: GraphQLTypes["PageLocale"]
};
	["Locale"]: {
	__typename: "Locale",
	_meta?: GraphQLTypes["LocaleMeta"],
	id: GraphQLTypes["UUID"],
	code: string,
	label?: string,
	events: Array<GraphQLTypes["EventLocale"]>,
	blogs: Array<GraphQLTypes["BlogLocale"]>,
	pages: Array<GraphQLTypes["PageLocale"]>,
	seos: Array<GraphQLTypes["SeoLocale"]>,
	menus: Array<GraphQLTypes["MenuLocale"]>,
	businessOrderTypes: Array<GraphQLTypes["BusinessOrderTypeLocale"]>,
	eventsByRoot?: GraphQLTypes["EventLocale"],
	eventsByCover?: GraphQLTypes["EventLocale"],
	eventsByContent?: GraphQLTypes["EventLocale"],
	eventsByLink?: GraphQLTypes["EventLocale"],
	eventsBySeo?: GraphQLTypes["EventLocale"],
	blogsByRoot?: GraphQLTypes["BlogLocale"],
	pagesByRoot?: GraphQLTypes["PageLocale"],
	pagesByLink?: GraphQLTypes["PageLocale"],
	pagesBySeo?: GraphQLTypes["PageLocale"],
	pagesByContent?: GraphQLTypes["PageLocale"],
	seosByRoot?: GraphQLTypes["SeoLocale"],
	menusByRoot?: GraphQLTypes["MenuLocale"],
	menusByItems?: GraphQLTypes["MenuLocale"],
	businessOrderTypesByRoot?: GraphQLTypes["BusinessOrderTypeLocale"],
	paginateEvents: GraphQLTypes["EventLocaleConnection"],
	paginateBlogs: GraphQLTypes["BlogLocaleConnection"],
	paginatePages: GraphQLTypes["PageLocaleConnection"],
	paginateSeos: GraphQLTypes["SeoLocaleConnection"],
	paginateMenus: GraphQLTypes["MenuLocaleConnection"],
	paginateBusinessOrderTypes: GraphQLTypes["BusinessOrderTypeLocaleConnection"]
};
	["LocaleMeta"]: {
	__typename: "LocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	code?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	events?: GraphQLTypes["FieldMeta"],
	blogs?: GraphQLTypes["FieldMeta"],
	pages?: GraphQLTypes["FieldMeta"],
	seos?: GraphQLTypes["FieldMeta"],
	menus?: GraphQLTypes["FieldMeta"],
	businessOrderTypes?: GraphQLTypes["FieldMeta"]
};
	["EventLocale"]: {
	__typename: "EventLocale",
	_meta?: GraphQLTypes["EventLocaleMeta"],
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["Event"],
	locale?: GraphQLTypes["Locale"],
	cover?: GraphQLTypes["Cover"],
	content?: GraphQLTypes["Content"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	link?: GraphQLTypes["Linkable"],
	title?: string,
	seo?: GraphQLTypes["LocalizedSeo"]
};
	["EventLocaleMeta"]: {
	__typename: "EventLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	cover?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	availableForWeb?: GraphQLTypes["FieldMeta"],
	availableForMobile?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["Event"]: {
	__typename: "Event",
	_meta?: GraphQLTypes["EventMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	locales: Array<GraphQLTypes["EventLocale"]>,
	localesByLocale?: GraphQLTypes["EventLocale"],
	localesByCover?: GraphQLTypes["EventLocale"],
	localesByContent?: GraphQLTypes["EventLocale"],
	localesByLink?: GraphQLTypes["EventLocale"],
	localesBySeo?: GraphQLTypes["EventLocale"],
	paginateLocales: GraphQLTypes["EventLocaleConnection"]
};
	["EventMeta"]: {
	__typename: "EventMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["EventLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["EventLocalesByCoverUniqueWhere"]: {
		cover?: GraphQLTypes["CoverUniqueWhere"]
};
	["EventLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["EventLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["EventLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["LocalizedSeoUniqueWhere"]
};
	["EventLocaleConnection"]: {
	__typename: "EventLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EventLocaleEdge"]>
};
	["EventLocaleEdge"]: {
	__typename: "EventLocaleEdge",
	node: GraphQLTypes["EventLocale"]
};
	["Cover"]: {
	__typename: "Cover",
	_meta?: GraphQLTypes["CoverMeta"],
	id: GraphQLTypes["UUID"],
	primaryTitle?: string,
	secondaryTitle?: string,
	buttonColors?: GraphQLTypes["ColorPallete"],
	medium?: GraphQLTypes["Medium"]
};
	["CoverMeta"]: {
	__typename: "CoverMeta",
	id?: GraphQLTypes["FieldMeta"],
	primaryTitle?: GraphQLTypes["FieldMeta"],
	secondaryTitle?: GraphQLTypes["FieldMeta"],
	buttonColors?: GraphQLTypes["FieldMeta"],
	medium?: GraphQLTypes["FieldMeta"]
};
	["LocalizedSeo"]: {
	__typename: "LocalizedSeo",
	_meta?: GraphQLTypes["LocalizedSeoMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["Image"]
};
	["LocalizedSeoMeta"]: {
	__typename: "LocalizedSeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"]
};
	["BlogLocale"]: {
	__typename: "BlogLocale",
	_meta?: GraphQLTypes["BlogLocaleMeta"],
	id: GraphQLTypes["UUID"],
	pageName?: string,
	title?: string,
	lead?: string,
	root?: GraphQLTypes["Blog"],
	locale?: GraphQLTypes["Locale"]
};
	["BlogLocaleMeta"]: {
	__typename: "BlogLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	pageName?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"]
};
	["Blog"]: {
	__typename: "Blog",
	_meta?: GraphQLTypes["BlogMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["BlogLocale"]>,
	localesByLocale?: GraphQLTypes["BlogLocale"],
	paginateLocales: GraphQLTypes["BlogLocaleConnection"]
};
	["BlogMeta"]: {
	__typename: "BlogMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["BlogLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	pageName?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["BlogOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"]
};
	["BlogOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["BlogLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["BlogLocaleConnection"]: {
	__typename: "BlogLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogLocaleEdge"]>
};
	["BlogLocaleEdge"]: {
	__typename: "BlogLocaleEdge",
	node: GraphQLTypes["BlogLocale"]
};
	["SeoLocale"]: {
	__typename: "SeoLocale",
	_meta?: GraphQLTypes["SeoLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	root?: GraphQLTypes["Seo"],
	locale?: GraphQLTypes["Locale"]
};
	["SeoLocaleMeta"]: {
	__typename: "SeoLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["Image"],
	locales: Array<GraphQLTypes["SeoLocale"]>,
	localesByLocale?: GraphQLTypes["SeoLocale"],
	paginateLocales: GraphQLTypes["SeoLocaleConnection"]
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["SeoLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["SeoOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"]
};
	["SeoLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["SeoLocaleConnection"]: {
	__typename: "SeoLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoLocaleEdge"]>
};
	["SeoLocaleEdge"]: {
	__typename: "SeoLocaleEdge",
	node: GraphQLTypes["SeoLocale"]
};
	["MenuLocale"]: {
	__typename: "MenuLocale",
	_meta?: GraphQLTypes["MenuLocaleMeta"],
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SiteMenu"],
	locale?: GraphQLTypes["Locale"],
	items: Array<GraphQLTypes["MenuItem"]>,
	paginateItems: GraphQLTypes["MenuItemConnection"]
};
	["MenuLocaleMeta"]: {
	__typename: "MenuLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["SiteMenu"]: {
	__typename: "SiteMenu",
	_meta?: GraphQLTypes["SiteMenuMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["MenuLocale"]>,
	localesByLocale?: GraphQLTypes["MenuLocale"],
	localesByItems?: GraphQLTypes["MenuLocale"],
	paginateLocales: GraphQLTypes["MenuLocaleConnection"]
};
	["SiteMenuMeta"]: {
	__typename: "SiteMenuMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["MenuLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["SiteMenuOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"]
};
	["SiteMenuOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["SiteMenuLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["SiteMenuLocalesByItemsUniqueWhere"]: {
		items?: GraphQLTypes["MenuItemUniqueWhere"]
};
	["MenuLocaleConnection"]: {
	__typename: "MenuLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuLocaleEdge"]>
};
	["MenuLocaleEdge"]: {
	__typename: "MenuLocaleEdge",
	node: GraphQLTypes["MenuLocale"]
};
	["MenuItem"]: {
	__typename: "MenuItem",
	_meta?: GraphQLTypes["MenuItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"],
	menu?: GraphQLTypes["MenuLocale"]
};
	["MenuItemMeta"]: {
	__typename: "MenuItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	menu?: GraphQLTypes["FieldMeta"]
};
	["MenuItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"],
	menu?: GraphQLTypes["MenuLocaleOrderBy"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	externalLink?: GraphQLTypes["OrderDirection"],
	internalLink?: GraphQLTypes["LinkableOrderBy"]
};
	["MenuItemConnection"]: {
	__typename: "MenuItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MenuItemEdge"]>
};
	["MenuItemEdge"]: {
	__typename: "MenuItemEdge",
	node: GraphQLTypes["MenuItem"]
};
	["BusinessOrderTypeLocale"]: {
	__typename: "BusinessOrderTypeLocale",
	_meta?: GraphQLTypes["BusinessOrderTypeLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["BusinessOrderType"],
	locale?: GraphQLTypes["Locale"]
};
	["BusinessOrderTypeLocaleMeta"]: {
	__typename: "BusinessOrderTypeLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"]
};
	["BusinessOrderType"]: {
	__typename: "BusinessOrderType",
	_meta?: GraphQLTypes["BusinessOrderTypeMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	locales: Array<GraphQLTypes["BusinessOrderTypeLocale"]>,
	localesByLocale?: GraphQLTypes["BusinessOrderTypeLocale"],
	paginateLocales: GraphQLTypes["BusinessOrderTypeLocaleConnection"]
};
	["BusinessOrderTypeMeta"]: {
	__typename: "BusinessOrderTypeMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["BusinessOrderTypeLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["BusinessOrderTypeOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"]
};
	["BusinessOrderTypeOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"]
};
	["BusinessOrderTypeLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["BusinessOrderTypeLocaleConnection"]: {
	__typename: "BusinessOrderTypeLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessOrderTypeLocaleEdge"]>
};
	["BusinessOrderTypeLocaleEdge"]: {
	__typename: "BusinessOrderTypeLocaleEdge",
	node: GraphQLTypes["BusinessOrderTypeLocale"]
};
	["LocaleEventsByRootUniqueWhere"]: {
		root?: GraphQLTypes["EventUniqueWhere"]
};
	["LocaleEventsByCoverUniqueWhere"]: {
		cover?: GraphQLTypes["CoverUniqueWhere"]
};
	["LocaleEventsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["LocaleEventsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleEventsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["LocalizedSeoUniqueWhere"]
};
	["LocaleBlogsByRootUniqueWhere"]: {
		root?: GraphQLTypes["BlogUniqueWhere"]
};
	["LocalePagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["PageUniqueWhere"]
};
	["LocalePagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocalePagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["LocalizedSeoUniqueWhere"]
};
	["LocalePagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["LocaleSeosByRootUniqueWhere"]: {
		root?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocaleMenusByRootUniqueWhere"]: {
		root?: GraphQLTypes["SiteMenuUniqueWhere"]
};
	["LocaleMenusByItemsUniqueWhere"]: {
		items?: GraphQLTypes["MenuItemUniqueWhere"]
};
	["LocaleBusinessOrderTypesByRootUniqueWhere"]: {
		root?: GraphQLTypes["BusinessOrderTypeUniqueWhere"]
};
	["Hero"]: {
	__typename: "Hero",
	_meta?: GraphQLTypes["HeroMeta"],
	id: GraphQLTypes["UUID"],
	showLogo?: boolean,
	middleContent?: string,
	medium?: GraphQLTypes["Medium"]
};
	["HeroMeta"]: {
	__typename: "HeroMeta",
	id?: GraphQLTypes["FieldMeta"],
	showLogo?: GraphQLTypes["FieldMeta"],
	middleContent?: GraphQLTypes["FieldMeta"],
	medium?: GraphQLTypes["FieldMeta"]
};
	["Gallery"]: {
	__typename: "Gallery",
	_meta?: GraphQLTypes["GalleryMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GalleryItem"]>,
	paginateItems: GraphQLTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
	__typename: "GalleryMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["GalleryItem"]: {
	__typename: "GalleryItem",
	_meta?: GraphQLTypes["GalleryItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	caption?: string,
	list?: GraphQLTypes["Gallery"],
	medium?: GraphQLTypes["Medium"]
};
	["GalleryItemMeta"]: {
	__typename: "GalleryItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	caption?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	medium?: GraphQLTypes["FieldMeta"]
};
	["GalleryItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	caption?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["GalleryOrderBy"],
	medium?: GraphQLTypes["MediumOrderBy"]
};
	["GalleryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["GalleryItemConnection"]: {
	__typename: "GalleryItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryItemEdge"]>
};
	["GalleryItemEdge"]: {
	__typename: "GalleryItemEdge",
	node: GraphQLTypes["GalleryItem"]
};
	["SocialsAndApps"]: {
	__typename: "SocialsAndApps",
	_meta?: GraphQLTypes["SocialsAndAppsMeta"],
	id: GraphQLTypes["UUID"],
	instagram?: boolean,
	appStore?: boolean,
	googlePlay?: boolean
};
	["SocialsAndAppsMeta"]: {
	__typename: "SocialsAndAppsMeta",
	id?: GraphQLTypes["FieldMeta"],
	instagram?: GraphQLTypes["FieldMeta"],
	appStore?: GraphQLTypes["FieldMeta"],
	googlePlay?: GraphQLTypes["FieldMeta"]
};
	["BlogPostList"]: {
	__typename: "BlogPostList",
	_meta?: GraphQLTypes["BlogPostListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateItems: GraphQLTypes["BlogPostListItemConnection"]
};
	["BlogPostListMeta"]: {
	__typename: "BlogPostListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["BlogPostListItem"]: {
	__typename: "BlogPostListItem",
	_meta?: GraphQLTypes["BlogPostListItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	caption?: string,
	list?: GraphQLTypes["BlogPostList"],
	blogPost?: GraphQLTypes["EventLocale"]
};
	["BlogPostListItemMeta"]: {
	__typename: "BlogPostListItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	caption?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	blogPost?: GraphQLTypes["FieldMeta"]
};
	["BlogPostListItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	caption?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["BlogPostListOrderBy"],
	blogPost?: GraphQLTypes["EventLocaleOrderBy"]
};
	["BlogPostListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["BlogPostListItemConnection"]: {
	__typename: "BlogPostListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostListItemEdge"]>
};
	["BlogPostListItemEdge"]: {
	__typename: "BlogPostListItemEdge",
	node: GraphQLTypes["BlogPostListItem"]
};
	["ProductGrid"]: {
	__typename: "ProductGrid",
	_meta?: GraphQLTypes["ProductGridMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ProductGridItem"]>,
	paginateItems: GraphQLTypes["ProductGridItemConnection"]
};
	["ProductGridMeta"]: {
	__typename: "ProductGridMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ProductGridItem"]: {
	__typename: "ProductGridItem",
	_meta?: GraphQLTypes["ProductGridItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	goodlokProductId?: string,
	title?: string,
	lead?: string,
	list?: GraphQLTypes["ProductGrid"],
	medium?: GraphQLTypes["Medium"],
	link?: GraphQLTypes["Link"]
};
	["ProductGridItemMeta"]: {
	__typename: "ProductGridItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	goodlokProductId?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	medium?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["ProductGridItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	goodlokProductId?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ProductGridOrderBy"],
	medium?: GraphQLTypes["MediumOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["ProductGridOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ProductGridItemConnection"]: {
	__typename: "ProductGridItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGridItemEdge"]>
};
	["ProductGridItemEdge"]: {
	__typename: "ProductGridItemEdge",
	node: GraphQLTypes["ProductGridItem"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	primaryText?: GraphQLTypes["OrderDirection"],
	secondaryText?: GraphQLTypes["OrderDirection"],
	jsonContent?: GraphQLTypes["OrderDirection"],
	block?: GraphQLTypes["ContentBlockOrderBy"],
	colorPallete?: GraphQLTypes["ColorPalleteOrderBy"],
	medium?: GraphQLTypes["MediumOrderBy"],
	misc?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"],
	hero?: GraphQLTypes["HeroOrderBy"],
	gallery?: GraphQLTypes["GalleryOrderBy"],
	contentSize?: GraphQLTypes["OrderDirection"],
	socialsAndApps?: GraphQLTypes["SocialsAndAppsOrderBy"],
	blogPosts?: GraphQLTypes["BlogPostListOrderBy"],
	productGrid?: GraphQLTypes["ProductGridOrderBy"]
};
	["ContentBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["HeroOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	showLogo?: GraphQLTypes["OrderDirection"],
	middleContent?: GraphQLTypes["OrderDirection"],
	medium?: GraphQLTypes["MediumOrderBy"]
};
	["SocialsAndAppsOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	instagram?: GraphQLTypes["OrderDirection"],
	appStore?: GraphQLTypes["OrderDirection"],
	googlePlay?: GraphQLTypes["OrderDirection"]
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	alias?: string
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	jsonContent?: string,
	colorPallete?: GraphQLTypes["ContentReferenceCreateColorPalleteEntityRelationInput"],
	medium?: GraphQLTypes["ContentReferenceCreateMediumEntityRelationInput"],
	misc?: string,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	hero?: GraphQLTypes["ContentReferenceCreateHeroEntityRelationInput"],
	gallery?: GraphQLTypes["ContentReferenceCreateGalleryEntityRelationInput"],
	contentSize?: GraphQLTypes["ContentSize"],
	socialsAndApps?: GraphQLTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"],
	blogPosts?: GraphQLTypes["ContentReferenceCreateBlogPostsEntityRelationInput"],
	productGrid?: GraphQLTypes["ContentReferenceCreateProductGridEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateColorPalleteEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorPalleteUniqueWhere"],
	create?: GraphQLTypes["ColorPalleteCreateInput"]
};
	["ContentReferenceCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["MediumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["MediumCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MediumType"],
	colorTheme?: GraphQLTypes["ColorTheme"],
	image?: GraphQLTypes["MediumCreateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumCreateVideoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	title?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["MediumCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"],
	create?: GraphQLTypes["VideoCreateInput"]
};
	["VideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["VideoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["VideoCreatePosterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoCreatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreatePageEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"]
};
	["PageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PageUniqueWhere"],
	create?: GraphQLTypes["PageWithoutLocalesCreateInput"]
};
	["PageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["PageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutPagesCreateInput"]
};
	["LocaleWithoutPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleCreateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateEventsEntityRelationInput"]: {
		connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	create?: GraphQLTypes["EventLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["EventLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["EventLocaleCreateRootEntityRelationInput"],
	cover?: GraphQLTypes["EventLocaleCreateCoverEntityRelationInput"],
	content?: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	link?: GraphQLTypes["EventLocaleCreateLinkEntityRelationInput"],
	title?: string,
	seo?: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["EventUniqueWhere"],
	create?: GraphQLTypes["EventWithoutLocalesCreateInput"]
};
	["EventWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	_dummy_field_?: boolean
};
	["EventLocaleCreateCoverEntityRelationInput"]: {
		connect?: GraphQLTypes["CoverUniqueWhere"],
	create?: GraphQLTypes["CoverCreateInput"]
};
	["CoverCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	primaryTitle?: string,
	secondaryTitle?: string,
	buttonColors?: GraphQLTypes["CoverCreateButtonColorsEntityRelationInput"],
	medium?: GraphQLTypes["CoverCreateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CoverCreateButtonColorsEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorPalleteUniqueWhere"],
	create?: GraphQLTypes["ColorPalleteCreateInput"]
};
	["CoverCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["EventLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["EventLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutEventCreateInput"]
};
	["LinkableWithoutEventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["LocalizedSeoUniqueWhere"],
	create?: GraphQLTypes["LocalizedSeoCreateInput"]
};
	["LocalizedSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["LocalizedSeoCreateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LocalizedSeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LocaleCreateBlogsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogLocaleUniqueWhere"],
	create?: GraphQLTypes["BlogLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["BlogLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	pageName?: string,
	title?: string,
	lead?: string,
	root?: GraphQLTypes["BlogLocaleCreateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogUniqueWhere"],
	create?: GraphQLTypes["BlogWithoutLocalesCreateInput"]
};
	["BlogWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["LocaleCreateSeosEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoLocaleUniqueWhere"],
	create?: GraphQLTypes["SeoLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["SeoLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	root?: GraphQLTypes["SeoLocaleCreateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutLocalesCreateInput"]
};
	["SeoWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LocaleCreateMenusEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLocaleUniqueWhere"],
	create?: GraphQLTypes["MenuLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["MenuLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["MenuLocaleCreateRootEntityRelationInput"],
	items?: Array<GraphQLTypes["MenuLocaleCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MenuLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SiteMenuUniqueWhere"],
	create?: GraphQLTypes["SiteMenuWithoutLocalesCreateInput"]
};
	["SiteMenuWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["MenuLocaleCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuItemUniqueWhere"],
	create?: GraphQLTypes["MenuItemWithoutMenuCreateInput"],
	alias?: string
};
	["MenuItemWithoutMenuCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["MenuItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MenuItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LocaleCreateBusinessOrderTypesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	create?: GraphQLTypes["BusinessOrderTypeLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["BusinessOrderTypeLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["BusinessOrderTypeLocaleCreateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BusinessOrderTypeLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessOrderTypeUniqueWhere"],
	create?: GraphQLTypes["BusinessOrderTypeWithoutLocalesCreateInput"]
};
	["BusinessOrderTypeWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	_dummy_field_?: boolean
};
	["PageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["LocalizedSeoUniqueWhere"],
	create?: GraphQLTypes["LocalizedSeoCreateInput"]
};
	["PageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["LinkableCreateEventEntityRelationInput"]: {
		connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	create?: GraphQLTypes["EventLocaleWithoutLinkCreateInput"]
};
	["EventLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["EventLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["EventLocaleCreateLocaleEntityRelationInput"],
	cover?: GraphQLTypes["EventLocaleCreateCoverEntityRelationInput"],
	content?: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	title?: string,
	seo?: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutEventsCreateInput"]
};
	["LocaleWithoutEventsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleCreateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreatePagesEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["PageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"],
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutPageCreateInput"]
};
	["LinkableWithoutPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateHeroEntityRelationInput"]: {
		connect?: GraphQLTypes["HeroUniqueWhere"],
	create?: GraphQLTypes["HeroCreateInput"]
};
	["HeroUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["HeroCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	showLogo?: boolean,
	middleContent?: string,
	medium?: GraphQLTypes["HeroCreateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeroCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["ContentReferenceCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["GalleryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["GalleryItemUniqueWhere"]
};
	["GalleryItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["GalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["GalleryCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GalleryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryItemUniqueWhere"],
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"],
	alias?: string
};
	["GalleryItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	caption?: string,
	medium?: GraphQLTypes["GalleryItemCreateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["ContentReferenceCreateSocialsAndAppsEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialsAndAppsUniqueWhere"],
	create?: GraphQLTypes["SocialsAndAppsCreateInput"]
};
	["SocialsAndAppsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SocialsAndAppsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	instagram?: boolean,
	appStore?: boolean,
	googlePlay?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateBlogPostsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostListUniqueWhere"],
	create?: GraphQLTypes["BlogPostListCreateInput"]
};
	["BlogPostListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["BlogPostListItemUniqueWhere"]
};
	["BlogPostListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["BlogPostListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["BlogPostListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BlogPostListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostListItemUniqueWhere"],
	create?: GraphQLTypes["BlogPostListItemWithoutListCreateInput"],
	alias?: string
};
	["BlogPostListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	caption?: string,
	blogPost?: GraphQLTypes["BlogPostListItemCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostListItemCreateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	create?: GraphQLTypes["EventLocaleCreateInput"]
};
	["EventLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["EventLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["EventLocaleCreateLocaleEntityRelationInput"],
	cover?: GraphQLTypes["EventLocaleCreateCoverEntityRelationInput"],
	content?: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	link?: GraphQLTypes["EventLocaleCreateLinkEntityRelationInput"],
	title?: string,
	seo?: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateProductGridEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGridUniqueWhere"],
	create?: GraphQLTypes["ProductGridCreateInput"]
};
	["ProductGridUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ProductGridItemUniqueWhere"]
};
	["ProductGridItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ProductGridCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ProductGridCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductGridCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGridItemUniqueWhere"],
	create?: GraphQLTypes["ProductGridItemWithoutListCreateInput"],
	alias?: string
};
	["ProductGridItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	goodlokProductId?: string,
	title?: string,
	lead?: string,
	medium?: GraphQLTypes["ProductGridItemCreateMediumEntityRelationInput"],
	link?: GraphQLTypes["ProductGridItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductGridItemCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["ProductGridItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["ContentUpdateBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	data?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	jsonContent?: string,
	colorPallete?: GraphQLTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"],
	medium?: GraphQLTypes["ContentReferenceUpdateMediumEntityRelationInput"],
	misc?: string,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	hero?: GraphQLTypes["ContentReferenceUpdateHeroEntityRelationInput"],
	gallery?: GraphQLTypes["ContentReferenceUpdateGalleryEntityRelationInput"],
	contentSize?: GraphQLTypes["ContentSize"],
	socialsAndApps?: GraphQLTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"],
	blogPosts?: GraphQLTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"],
	productGrid?: GraphQLTypes["ContentReferenceUpdateProductGridEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateColorPalleteEntityRelationInput"]: {
		create?: GraphQLTypes["ColorPalleteCreateInput"],
	update?: GraphQLTypes["ColorPalleteUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertColorPalleteRelationInput"],
	connect?: GraphQLTypes["ColorPalleteUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertColorPalleteRelationInput"]: {
		update?: GraphQLTypes["ColorPalleteUpdateInput"],
	create?: GraphQLTypes["ColorPalleteCreateInput"]
};
	["ContentReferenceUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"],
	update?: GraphQLTypes["MediumUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertMediumRelationInput"],
	connect?: GraphQLTypes["MediumUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumUpdateInput"]: {
		type?: GraphQLTypes["MediumType"],
	colorTheme?: GraphQLTypes["ColorTheme"],
	image?: GraphQLTypes["MediumUpdateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumUpdateVideoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["MediumUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	title?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["MediumUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
		create?: GraphQLTypes["VideoCreateInput"],
	update?: GraphQLTypes["VideoUpdateInput"],
	upsert?: GraphQLTypes["MediumUpsertVideoRelationInput"],
	connect?: GraphQLTypes["VideoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["VideoUpdateInput"]: {
		src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["VideoUpdatePosterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoUpdatePosterEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["VideoUpsertPosterRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["VideoUpsertPosterRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MediumUpsertVideoRelationInput"]: {
		update?: GraphQLTypes["VideoUpdateInput"],
	create?: GraphQLTypes["VideoCreateInput"]
};
	["ContentReferenceUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableUpdateInput"]: {
		url?: string,
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdatePageEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertPageRelationInput"],
	connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["PageWithoutLocalesCreateInput"],
	update?: GraphQLTypes["PageWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["PageUniqueWhere"],
	delete?: boolean
};
	["PageWithoutLocalesUpdateInput"]: {
		_dummy_field_?: boolean
};
	["PageLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["PageWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["PageWithoutLocalesCreateInput"]
};
	["PageLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutPagesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutPagesUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutPagesUpdateInput"]: {
		code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleUpdateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateEventsEntityRelationInput"]: {
		create?: GraphQLTypes["EventLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateEventsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertEventsRelationInput"],
	connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["EventLocaleUniqueWhere"],
	delete?: GraphQLTypes["EventLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateEventsRelationInput"]: {
		by?: GraphQLTypes["EventLocaleUniqueWhere"],
	data?: GraphQLTypes["EventLocaleWithoutLocaleUpdateInput"]
};
	["EventLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["EventLocaleUpdateRootEntityRelationInput"],
	cover?: GraphQLTypes["EventLocaleUpdateCoverEntityRelationInput"],
	content?: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	link?: GraphQLTypes["EventLocaleUpdateLinkEntityRelationInput"],
	title?: string,
	seo?: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["EventWithoutLocalesCreateInput"],
	update?: GraphQLTypes["EventWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["EventUniqueWhere"],
	delete?: boolean
};
	["EventWithoutLocalesUpdateInput"]: {
		order?: number,
	_dummy_field_?: boolean
};
	["EventLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["EventWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["EventWithoutLocalesCreateInput"]
};
	["EventLocaleUpdateCoverEntityRelationInput"]: {
		create?: GraphQLTypes["CoverCreateInput"],
	update?: GraphQLTypes["CoverUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertCoverRelationInput"],
	connect?: GraphQLTypes["CoverUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CoverUpdateInput"]: {
		primaryTitle?: string,
	secondaryTitle?: string,
	buttonColors?: GraphQLTypes["CoverUpdateButtonColorsEntityRelationInput"],
	medium?: GraphQLTypes["CoverUpdateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CoverUpdateButtonColorsEntityRelationInput"]: {
		create?: GraphQLTypes["ColorPalleteCreateInput"],
	update?: GraphQLTypes["ColorPalleteUpdateInput"],
	upsert?: GraphQLTypes["CoverUpsertButtonColorsRelationInput"],
	connect?: GraphQLTypes["ColorPalleteUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CoverUpsertButtonColorsRelationInput"]: {
		update?: GraphQLTypes["ColorPalleteUpdateInput"],
	create?: GraphQLTypes["ColorPalleteCreateInput"]
};
	["CoverUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"],
	update?: GraphQLTypes["MediumUpdateInput"],
	upsert?: GraphQLTypes["CoverUpsertMediumRelationInput"],
	connect?: GraphQLTypes["MediumUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CoverUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["EventLocaleUpsertCoverRelationInput"]: {
		update?: GraphQLTypes["CoverUpdateInput"],
	create?: GraphQLTypes["CoverCreateInput"]
};
	["EventLocaleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventLocaleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["EventLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutEventCreateInput"],
	update?: GraphQLTypes["LinkableWithoutEventUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutEventUpdateInput"]: {
		url?: string,
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutEventUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutEventCreateInput"]
};
	["EventLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["LocalizedSeoCreateInput"],
	update?: GraphQLTypes["LocalizedSeoUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["LocalizedSeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LocalizedSeoUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["LocalizedSeoUpdateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LocalizedSeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["LocalizedSeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LocalizedSeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EventLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["LocalizedSeoUpdateInput"],
	create?: GraphQLTypes["LocalizedSeoCreateInput"]
};
	["LocaleUpsertEventsRelationInput"]: {
		by?: GraphQLTypes["EventLocaleUniqueWhere"],
	update?: GraphQLTypes["EventLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["EventLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateBlogsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateBlogsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertBlogsRelationInput"],
	connect?: GraphQLTypes["BlogLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["BlogLocaleUniqueWhere"],
	delete?: GraphQLTypes["BlogLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateBlogsRelationInput"]: {
		by?: GraphQLTypes["BlogLocaleUniqueWhere"],
	data?: GraphQLTypes["BlogLocaleWithoutLocaleUpdateInput"]
};
	["BlogLocaleWithoutLocaleUpdateInput"]: {
		pageName?: string,
	title?: string,
	lead?: string,
	root?: GraphQLTypes["BlogLocaleUpdateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["BlogWithoutLocalesCreateInput"],
	update?: GraphQLTypes["BlogWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["BlogLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["BlogUniqueWhere"],
	delete?: boolean
};
	["BlogWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["BlogLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["BlogWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["BlogWithoutLocalesCreateInput"]
};
	["LocaleUpsertBlogsRelationInput"]: {
		by?: GraphQLTypes["BlogLocaleUniqueWhere"],
	update?: GraphQLTypes["BlogLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["BlogLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateSeosEntityRelationInput"]: {
		create?: GraphQLTypes["SeoLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateSeosRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertSeosRelationInput"],
	connect?: GraphQLTypes["SeoLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["SeoLocaleUniqueWhere"],
	delete?: GraphQLTypes["SeoLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateSeosRelationInput"]: {
		by?: GraphQLTypes["SeoLocaleUniqueWhere"],
	data?: GraphQLTypes["SeoLocaleWithoutLocaleUpdateInput"]
};
	["SeoLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	root?: GraphQLTypes["SeoLocaleUpdateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["SeoWithoutLocalesCreateInput"],
	update?: GraphQLTypes["SeoWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["SeoLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	delete?: boolean
};
	["SeoWithoutLocalesUpdateInput"]: {
		ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["SeoLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["SeoWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["SeoWithoutLocalesCreateInput"]
};
	["LocaleUpsertSeosRelationInput"]: {
		by?: GraphQLTypes["SeoLocaleUniqueWhere"],
	update?: GraphQLTypes["SeoLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["SeoLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateMenusEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateMenusRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertMenusRelationInput"],
	connect?: GraphQLTypes["MenuLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["MenuLocaleUniqueWhere"],
	delete?: GraphQLTypes["MenuLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateMenusRelationInput"]: {
		by?: GraphQLTypes["MenuLocaleUniqueWhere"],
	data?: GraphQLTypes["MenuLocaleWithoutLocaleUpdateInput"]
};
	["MenuLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["MenuLocaleUpdateRootEntityRelationInput"],
	items?: Array<GraphQLTypes["MenuLocaleUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MenuLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["SiteMenuWithoutLocalesCreateInput"],
	update?: GraphQLTypes["SiteMenuWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["MenuLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["SiteMenuUniqueWhere"],
	delete?: boolean
};
	["SiteMenuWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["MenuLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["SiteMenuWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["SiteMenuWithoutLocalesCreateInput"]
};
	["MenuLocaleUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MenuItemWithoutMenuCreateInput"],
	update?: GraphQLTypes["MenuLocaleUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["MenuLocaleUpsertItemsRelationInput"],
	connect?: GraphQLTypes["MenuItemUniqueWhere"],
	disconnect?: GraphQLTypes["MenuItemUniqueWhere"],
	delete?: GraphQLTypes["MenuItemUniqueWhere"],
	alias?: string
};
	["MenuLocaleUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["MenuItemUniqueWhere"],
	data?: GraphQLTypes["MenuItemWithoutMenuUpdateInput"]
};
	["MenuItemWithoutMenuUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["MenuItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MenuItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["MenuItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MenuItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["MenuLocaleUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["MenuItemUniqueWhere"],
	update?: GraphQLTypes["MenuItemWithoutMenuUpdateInput"],
	create?: GraphQLTypes["MenuItemWithoutMenuCreateInput"]
};
	["LocaleUpsertMenusRelationInput"]: {
		by?: GraphQLTypes["MenuLocaleUniqueWhere"],
	update?: GraphQLTypes["MenuLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["MenuLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateBusinessOrderTypesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessOrderTypeLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateBusinessOrderTypesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertBusinessOrderTypesRelationInput"],
	connect?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	delete?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateBusinessOrderTypesRelationInput"]: {
		by?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	data?: GraphQLTypes["BusinessOrderTypeLocaleWithoutLocaleUpdateInput"]
};
	["BusinessOrderTypeLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["BusinessOrderTypeLocaleUpdateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BusinessOrderTypeLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessOrderTypeWithoutLocalesCreateInput"],
	update?: GraphQLTypes["BusinessOrderTypeWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["BusinessOrderTypeLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["BusinessOrderTypeUniqueWhere"],
	delete?: boolean
};
	["BusinessOrderTypeWithoutLocalesUpdateInput"]: {
		order?: number,
	_dummy_field_?: boolean
};
	["BusinessOrderTypeLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["BusinessOrderTypeWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["BusinessOrderTypeWithoutLocalesCreateInput"]
};
	["LocaleUpsertBusinessOrderTypesRelationInput"]: {
		by?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	update?: GraphQLTypes["BusinessOrderTypeLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["BusinessOrderTypeLocaleWithoutLocaleCreateInput"]
};
	["PageLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutPagesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutPagesCreateInput"]
};
	["PageLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["LocalizedSeoCreateInput"],
	update?: GraphQLTypes["LocalizedSeoUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["LocalizedSeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["LocalizedSeoUpdateInput"],
	create?: GraphQLTypes["LocalizedSeoCreateInput"]
};
	["PageLocaleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageLocaleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["LinkableUpsertPageRelationInput"]: {
		update?: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"]
};
	["LinkableUpdateEventEntityRelationInput"]: {
		create?: GraphQLTypes["EventLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["EventLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertEventRelationInput"],
	connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventLocaleWithoutLinkUpdateInput"]: {
		root?: GraphQLTypes["EventLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["EventLocaleUpdateLocaleEntityRelationInput"],
	cover?: GraphQLTypes["EventLocaleUpdateCoverEntityRelationInput"],
	content?: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	title?: string,
	seo?: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutEventsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutEventsUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutEventsUpdateInput"]: {
		code?: string,
	label?: string,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleUpdateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdatePagesEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdatePagesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertPagesRelationInput"],
	connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["PageLocaleUniqueWhere"],
	delete?: GraphQLTypes["PageLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdatePagesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"],
	data?: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"]
};
	["PageLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"],
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutPageUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutPageUpdateInput"]: {
		url?: string,
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutPageCreateInput"]
};
	["LocaleUpsertPagesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"],
	update?: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"]
};
	["EventLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutEventsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutEventsCreateInput"]
};
	["LinkableUpsertEventRelationInput"]: {
		update?: GraphQLTypes["EventLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["EventLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateHeroEntityRelationInput"]: {
		create?: GraphQLTypes["HeroCreateInput"],
	update?: GraphQLTypes["HeroUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertHeroRelationInput"],
	connect?: GraphQLTypes["HeroUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeroUpdateInput"]: {
		showLogo?: boolean,
	middleContent?: string,
	medium?: GraphQLTypes["HeroUpdateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeroUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"],
	update?: GraphQLTypes["MediumUpdateInput"],
	upsert?: GraphQLTypes["HeroUpsertMediumRelationInput"],
	connect?: GraphQLTypes["MediumUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeroUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["ContentReferenceUpsertHeroRelationInput"]: {
		update?: GraphQLTypes["HeroUpdateInput"],
	create?: GraphQLTypes["HeroCreateInput"]
};
	["ContentReferenceUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryCreateInput"],
	update?: GraphQLTypes["GalleryUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryUpdateInput"]: {
		items?: Array<GraphQLTypes["GalleryUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GalleryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryItemWithoutListCreateInput"],
	update?: GraphQLTypes["GalleryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["GalleryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["GalleryItemUniqueWhere"],
	disconnect?: GraphQLTypes["GalleryItemUniqueWhere"],
	delete?: GraphQLTypes["GalleryItemUniqueWhere"],
	alias?: string
};
	["GalleryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"],
	data?: GraphQLTypes["GalleryItemWithoutListUpdateInput"]
};
	["GalleryItemWithoutListUpdateInput"]: {
		order?: number,
	caption?: string,
	medium?: GraphQLTypes["GalleryItemUpdateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"],
	update?: GraphQLTypes["MediumUpdateInput"],
	upsert?: GraphQLTypes["GalleryItemUpsertMediumRelationInput"],
	connect?: GraphQLTypes["MediumUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryItemUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["GalleryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"],
	update?: GraphQLTypes["GalleryItemWithoutListUpdateInput"],
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["GalleryUpdateInput"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"]: {
		create?: GraphQLTypes["SocialsAndAppsCreateInput"],
	update?: GraphQLTypes["SocialsAndAppsUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertSocialsAndAppsRelationInput"],
	connect?: GraphQLTypes["SocialsAndAppsUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialsAndAppsUpdateInput"]: {
		instagram?: boolean,
	appStore?: boolean,
	googlePlay?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertSocialsAndAppsRelationInput"]: {
		update?: GraphQLTypes["SocialsAndAppsUpdateInput"],
	create?: GraphQLTypes["SocialsAndAppsCreateInput"]
};
	["ContentReferenceUpdateBlogPostsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostListCreateInput"],
	update?: GraphQLTypes["BlogPostListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertBlogPostsRelationInput"],
	connect?: GraphQLTypes["BlogPostListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostListUpdateInput"]: {
		items?: Array<GraphQLTypes["BlogPostListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BlogPostListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostListItemWithoutListCreateInput"],
	update?: GraphQLTypes["BlogPostListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["BlogPostListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["BlogPostListItemUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostListItemUniqueWhere"],
	delete?: GraphQLTypes["BlogPostListItemUniqueWhere"],
	alias?: string
};
	["BlogPostListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["BlogPostListItemUniqueWhere"],
	data?: GraphQLTypes["BlogPostListItemWithoutListUpdateInput"]
};
	["BlogPostListItemWithoutListUpdateInput"]: {
		order?: number,
	caption?: string,
	blogPost?: GraphQLTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostListItemUpdateBlogPostEntityRelationInput"]: {
		create?: GraphQLTypes["EventLocaleCreateInput"],
	update?: GraphQLTypes["EventLocaleUpdateInput"],
	upsert?: GraphQLTypes["BlogPostListItemUpsertBlogPostRelationInput"],
	connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventLocaleUpdateInput"]: {
		root?: GraphQLTypes["EventLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["EventLocaleUpdateLocaleEntityRelationInput"],
	cover?: GraphQLTypes["EventLocaleUpdateCoverEntityRelationInput"],
	content?: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	link?: GraphQLTypes["EventLocaleUpdateLinkEntityRelationInput"],
	title?: string,
	seo?: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostListItemUpsertBlogPostRelationInput"]: {
		update?: GraphQLTypes["EventLocaleUpdateInput"],
	create?: GraphQLTypes["EventLocaleCreateInput"]
};
	["BlogPostListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["BlogPostListItemUniqueWhere"],
	update?: GraphQLTypes["BlogPostListItemWithoutListUpdateInput"],
	create?: GraphQLTypes["BlogPostListItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertBlogPostsRelationInput"]: {
		update?: GraphQLTypes["BlogPostListUpdateInput"],
	create?: GraphQLTypes["BlogPostListCreateInput"]
};
	["ContentReferenceUpdateProductGridEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGridCreateInput"],
	update?: GraphQLTypes["ProductGridUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertProductGridRelationInput"],
	connect?: GraphQLTypes["ProductGridUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductGridUpdateInput"]: {
		items?: Array<GraphQLTypes["ProductGridUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductGridUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGridItemWithoutListCreateInput"],
	update?: GraphQLTypes["ProductGridUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ProductGridUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ProductGridItemUniqueWhere"],
	disconnect?: GraphQLTypes["ProductGridItemUniqueWhere"],
	delete?: GraphQLTypes["ProductGridItemUniqueWhere"],
	alias?: string
};
	["ProductGridUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ProductGridItemUniqueWhere"],
	data?: GraphQLTypes["ProductGridItemWithoutListUpdateInput"]
};
	["ProductGridItemWithoutListUpdateInput"]: {
		order?: number,
	goodlokProductId?: string,
	title?: string,
	lead?: string,
	medium?: GraphQLTypes["ProductGridItemUpdateMediumEntityRelationInput"],
	link?: GraphQLTypes["ProductGridItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductGridItemUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"],
	update?: GraphQLTypes["MediumUpdateInput"],
	upsert?: GraphQLTypes["ProductGridItemUpsertMediumRelationInput"],
	connect?: GraphQLTypes["MediumUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductGridItemUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["ProductGridItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ProductGridItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductGridItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ProductGridUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ProductGridItemUniqueWhere"],
	update?: GraphQLTypes["ProductGridItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ProductGridItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertProductGridRelationInput"]: {
		update?: GraphQLTypes["ProductGridUpdateInput"],
	create?: GraphQLTypes["ProductGridCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	update?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentWithoutBlocksCreateInput"],
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	delete?: boolean
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentBlockUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	jsonContent?: string,
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	colorPallete?: GraphQLTypes["ContentReferenceCreateColorPalleteEntityRelationInput"],
	medium?: GraphQLTypes["ContentReferenceCreateMediumEntityRelationInput"],
	misc?: string,
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	hero?: GraphQLTypes["ContentReferenceCreateHeroEntityRelationInput"],
	gallery?: GraphQLTypes["ContentReferenceCreateGalleryEntityRelationInput"],
	contentSize?: GraphQLTypes["ContentSize"],
	socialsAndApps?: GraphQLTypes["ContentReferenceCreateSocialsAndAppsEntityRelationInput"],
	blogPosts?: GraphQLTypes["ContentReferenceCreateBlogPostsEntityRelationInput"],
	productGrid?: GraphQLTypes["ContentReferenceCreateProductGridEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	jsonContent?: string,
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	colorPallete?: GraphQLTypes["ContentReferenceUpdateColorPalleteEntityRelationInput"],
	medium?: GraphQLTypes["ContentReferenceUpdateMediumEntityRelationInput"],
	misc?: string,
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	hero?: GraphQLTypes["ContentReferenceUpdateHeroEntityRelationInput"],
	gallery?: GraphQLTypes["ContentReferenceUpdateGalleryEntityRelationInput"],
	contentSize?: GraphQLTypes["ContentSize"],
	socialsAndApps?: GraphQLTypes["ContentReferenceUpdateSocialsAndAppsEntityRelationInput"],
	blogPosts?: GraphQLTypes["ContentReferenceUpdateBlogPostsEntityRelationInput"],
	productGrid?: GraphQLTypes["ContentReferenceUpdateProductGridEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"],
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: boolean
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["CoverConnection"]: {
	__typename: "CoverConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CoverEdge"]>
};
	["CoverEdge"]: {
	__typename: "CoverEdge",
	node: GraphQLTypes["Cover"]
};
	["EventConnection"]: {
	__typename: "EventConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EventEdge"]>
};
	["EventEdge"]: {
	__typename: "EventEdge",
	node: GraphQLTypes["Event"]
};
	["EventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	locales?: Array<GraphQLTypes["EventCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EventCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	create?: GraphQLTypes["EventLocaleWithoutRootCreateInput"],
	alias?: string
};
	["EventLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locale?: GraphQLTypes["EventLocaleCreateLocaleEntityRelationInput"],
	cover?: GraphQLTypes["EventLocaleCreateCoverEntityRelationInput"],
	content?: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	link?: GraphQLTypes["EventLocaleCreateLinkEntityRelationInput"],
	title?: string,
	seo?: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventUpdateInput"]: {
		order?: number,
	locales?: Array<GraphQLTypes["EventUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EventUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["EventLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["EventUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["EventUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["EventLocaleUniqueWhere"],
	delete?: GraphQLTypes["EventLocaleUniqueWhere"],
	alias?: string
};
	["EventUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["EventLocaleUniqueWhere"],
	data?: GraphQLTypes["EventLocaleWithoutRootUpdateInput"]
};
	["EventLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["EventLocaleUpdateLocaleEntityRelationInput"],
	cover?: GraphQLTypes["EventLocaleUpdateCoverEntityRelationInput"],
	content?: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"],
	availableForWeb?: boolean,
	availableForMobile?: boolean,
	link?: GraphQLTypes["EventLocaleUpdateLinkEntityRelationInput"],
	title?: string,
	seo?: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["EventLocaleUniqueWhere"],
	update?: GraphQLTypes["EventLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["EventLocaleWithoutRootCreateInput"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["ImageList"]: {
	__typename: "ImageList",
	_meta?: GraphQLTypes["ImageListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ImageItem"]>,
	paginateItems: GraphQLTypes["ImageItemConnection"]
};
	["ImageListMeta"]: {
	__typename: "ImageListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ImageItem"]: {
	__typename: "ImageItem",
	_meta?: GraphQLTypes["ImageItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ImageList"],
	image?: GraphQLTypes["Image"]
};
	["ImageItemMeta"]: {
	__typename: "ImageItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["ImageListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ImageItemWhere"],
	and?: Array<GraphQLTypes["ImageListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageListWhere"] | undefined>,
	not?: GraphQLTypes["ImageListWhere"]
};
	["ImageItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ImageListWhere"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["ImageItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageItemWhere"] | undefined>,
	not?: GraphQLTypes["ImageItemWhere"]
};
	["ImageItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ImageListOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["ImageListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ImageItemConnection"]: {
	__typename: "ImageItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageItemEdge"]>
};
	["ImageItemEdge"]: {
	__typename: "ImageItemEdge",
	node: GraphQLTypes["ImageItem"]
};
	["ImageListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ImageItemUniqueWhere"]
};
	["ImageItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ImageListConnection"]: {
	__typename: "ImageListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListEdge"]>
};
	["ImageListEdge"]: {
	__typename: "ImageListEdge",
	node: GraphQLTypes["ImageList"]
};
	["ImageListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ImageListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ImageListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageItemUniqueWhere"],
	create?: GraphQLTypes["ImageItemWithoutListCreateInput"],
	alias?: string
};
	["ImageItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["ImageItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageListUpdateInput"]: {
		items?: Array<GraphQLTypes["ImageListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ImageListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ImageItemWithoutListCreateInput"],
	update?: GraphQLTypes["ImageListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ImageListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ImageItemUniqueWhere"],
	disconnect?: GraphQLTypes["ImageItemUniqueWhere"],
	delete?: GraphQLTypes["ImageItemUniqueWhere"],
	alias?: string
};
	["ImageListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ImageItemUniqueWhere"],
	data?: GraphQLTypes["ImageItemWithoutListUpdateInput"]
};
	["ImageItemWithoutListUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["ImageItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ImageItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ImageItemUniqueWhere"],
	update?: GraphQLTypes["ImageItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ImageItemWithoutListCreateInput"]
};
	["ImageItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ImageItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["ImageItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListUniqueWhere"],
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"]
};
	["ImageListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ImageItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ImageItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["ImageItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ImageItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ImageListUniqueWhere"],
	delete?: boolean
};
	["ImageListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ImageItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"]
};
	["LocaleConnection"]: {
	__typename: "LocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
	__typename: "LocaleEdge",
	node: GraphQLTypes["Locale"]
};
	["LocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleCreateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateInput"]: {
		code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleUpdateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MediumConnection"]: {
	__typename: "MediumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumEdge"]>
};
	["MediumEdge"]: {
	__typename: "MediumEdge",
	node: GraphQLTypes["Medium"]
};
	["VideoConnection"]: {
	__typename: "VideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VideoEdge"]>
};
	["VideoEdge"]: {
	__typename: "VideoEdge",
	node: GraphQLTypes["Video"]
};
	["BlogConnection"]: {
	__typename: "BlogConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogEdge"]>
};
	["BlogEdge"]: {
	__typename: "BlogEdge",
	node: GraphQLTypes["Blog"]
};
	["BlogCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["BlogCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BlogCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogLocaleUniqueWhere"],
	create?: GraphQLTypes["BlogLocaleWithoutRootCreateInput"],
	alias?: string
};
	["BlogLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	pageName?: string,
	title?: string,
	lead?: string,
	locale?: GraphQLTypes["BlogLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutBlogsCreateInput"]
};
	["LocaleWithoutBlogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleCreateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BlogUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["BlogUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BlogUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BlogLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["BlogUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["BlogUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["BlogLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["BlogLocaleUniqueWhere"],
	delete?: GraphQLTypes["BlogLocaleUniqueWhere"],
	alias?: string
};
	["BlogUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["BlogLocaleUniqueWhere"],
	data?: GraphQLTypes["BlogLocaleWithoutRootUpdateInput"]
};
	["BlogLocaleWithoutRootUpdateInput"]: {
		pageName?: string,
	title?: string,
	lead?: string,
	locale?: GraphQLTypes["BlogLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutBlogsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutBlogsUpdateInput"],
	upsert?: GraphQLTypes["BlogLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutBlogsUpdateInput"]: {
		code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleUpdateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BlogLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutBlogsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutBlogsCreateInput"]
};
	["BlogUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["BlogLocaleUniqueWhere"],
	update?: GraphQLTypes["BlogLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["BlogLocaleWithoutRootCreateInput"]
};
	["BlogLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	pageName?: string,
	title?: string,
	lead?: string,
	root?: GraphQLTypes["BlogLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["BlogLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogLocaleUpdateInput"]: {
		pageName?: string,
	title?: string,
	lead?: string,
	root?: GraphQLTypes["BlogLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["BlogLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["PageConnection"]: {
	__typename: "PageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageEdge"]>
};
	["PageEdge"]: {
	__typename: "PageEdge",
	node: GraphQLTypes["Page"]
};
	["PageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["PageCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"],
	alias?: string
};
	["PageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpdateInput"]: {
		locales?: Array<GraphQLTypes["PageUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["PageUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["PageUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["PageLocaleUniqueWhere"],
	delete?: GraphQLTypes["PageLocaleUniqueWhere"],
	alias?: string
};
	["PageUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"],
	data?: GraphQLTypes["PageLocaleWithoutRootUpdateInput"]
};
	["PageLocaleWithoutRootUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"],
	update?: GraphQLTypes["PageLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"]
};
	["PageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"],
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"],
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	locales?: Array<GraphQLTypes["SeoCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SeoCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoLocaleUniqueWhere"],
	create?: GraphQLTypes["SeoLocaleWithoutRootCreateInput"],
	alias?: string
};
	["SeoLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	locale?: GraphQLTypes["SeoLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutSeosCreateInput"]
};
	["LocaleWithoutSeosCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SeoUpdateInput"]: {
		ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	locales?: Array<GraphQLTypes["SeoUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SeoUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["SeoLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["SeoUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["SeoUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["SeoLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["SeoLocaleUniqueWhere"],
	delete?: GraphQLTypes["SeoLocaleUniqueWhere"],
	alias?: string
};
	["SeoUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["SeoLocaleUniqueWhere"],
	data?: GraphQLTypes["SeoLocaleWithoutRootUpdateInput"]
};
	["SeoLocaleWithoutRootUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	locale?: GraphQLTypes["SeoLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutSeosCreateInput"],
	update?: GraphQLTypes["LocaleWithoutSeosUpdateInput"],
	upsert?: GraphQLTypes["SeoLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutSeosUpdateInput"]: {
		code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SeoLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutSeosUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutSeosCreateInput"]
};
	["SeoUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["SeoLocaleUniqueWhere"],
	update?: GraphQLTypes["SeoLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["SeoLocaleWithoutRootCreateInput"]
};
	["SeoLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	root?: GraphQLTypes["SeoLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["SeoLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoLocaleUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	root?: GraphQLTypes["SeoLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["SeoLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LocalizedSeoConnection"]: {
	__typename: "LocalizedSeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LocalizedSeoEdge"]>
};
	["LocalizedSeoEdge"]: {
	__typename: "LocalizedSeoEdge",
	node: GraphQLTypes["LocalizedSeo"]
};
	["HeroConnection"]: {
	__typename: "HeroConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeroEdge"]>
};
	["HeroEdge"]: {
	__typename: "HeroEdge",
	node: GraphQLTypes["Hero"]
};
	["GalleryConnection"]: {
	__typename: "GalleryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryEdge"]>
};
	["GalleryEdge"]: {
	__typename: "GalleryEdge",
	node: GraphQLTypes["Gallery"]
};
	["GalleryItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	caption?: string,
	list?: GraphQLTypes["GalleryItemCreateListEntityRelationInput"],
	medium?: GraphQLTypes["GalleryItemCreateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["GalleryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateInput"]: {
		order?: number,
	caption?: string,
	list?: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"],
	medium?: GraphQLTypes["GalleryItemUpdateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryWithoutItemsCreateInput"],
	update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["GalleryItemUpsertListRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	delete?: boolean
};
	["GalleryWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["GalleryItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["SocialsAndAppsConnection"]: {
	__typename: "SocialsAndAppsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialsAndAppsEdge"]>
};
	["SocialsAndAppsEdge"]: {
	__typename: "SocialsAndAppsEdge",
	node: GraphQLTypes["SocialsAndApps"]
};
	["SiteMenuConnection"]: {
	__typename: "SiteMenuConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SiteMenuEdge"]>
};
	["SiteMenuEdge"]: {
	__typename: "SiteMenuEdge",
	node: GraphQLTypes["SiteMenu"]
};
	["SiteMenuCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["SiteMenuCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SiteMenuCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLocaleUniqueWhere"],
	create?: GraphQLTypes["MenuLocaleWithoutRootCreateInput"],
	alias?: string
};
	["MenuLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locale?: GraphQLTypes["MenuLocaleCreateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["MenuLocaleCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MenuLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutMenusCreateInput"]
};
	["LocaleWithoutMenusCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleCreateSeosEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleCreateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SiteMenuUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["SiteMenuUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SiteMenuUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["SiteMenuUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["SiteMenuUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["MenuLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["MenuLocaleUniqueWhere"],
	delete?: GraphQLTypes["MenuLocaleUniqueWhere"],
	alias?: string
};
	["SiteMenuUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["MenuLocaleUniqueWhere"],
	data?: GraphQLTypes["MenuLocaleWithoutRootUpdateInput"]
};
	["MenuLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["MenuLocaleUpdateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["MenuLocaleUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MenuLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutMenusCreateInput"],
	update?: GraphQLTypes["LocaleWithoutMenusUpdateInput"],
	upsert?: GraphQLTypes["MenuLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutMenusUpdateInput"]: {
		code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleUpdateSeosEntityRelationInput"]>,
	businessOrderTypes?: Array<GraphQLTypes["LocaleUpdateBusinessOrderTypesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MenuLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutMenusUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutMenusCreateInput"]
};
	["SiteMenuUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["MenuLocaleUniqueWhere"],
	update?: GraphQLTypes["MenuLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["MenuLocaleWithoutRootCreateInput"]
};
	["MenuItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["MenuItemCreateLinkEntityRelationInput"],
	menu?: GraphQLTypes["MenuItemCreateMenuEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MenuItemCreateMenuEntityRelationInput"]: {
		connect?: GraphQLTypes["MenuLocaleUniqueWhere"],
	create?: GraphQLTypes["MenuLocaleWithoutItemsCreateInput"]
};
	["MenuLocaleWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["MenuLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["MenuLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MenuItemUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["MenuItemUpdateLinkEntityRelationInput"],
	menu?: GraphQLTypes["MenuItemUpdateMenuEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MenuItemUpdateMenuEntityRelationInput"]: {
		create?: GraphQLTypes["MenuLocaleWithoutItemsCreateInput"],
	update?: GraphQLTypes["MenuLocaleWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["MenuItemUpsertMenuRelationInput"],
	connect?: GraphQLTypes["MenuLocaleUniqueWhere"],
	delete?: boolean
};
	["MenuLocaleWithoutItemsUpdateInput"]: {
		root?: GraphQLTypes["MenuLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["MenuLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MenuItemUpsertMenuRelationInput"]: {
		update?: GraphQLTypes["MenuLocaleWithoutItemsUpdateInput"],
	create?: GraphQLTypes["MenuLocaleWithoutItemsCreateInput"]
};
	["BlogPostListConnection"]: {
	__typename: "BlogPostListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostListEdge"]>
};
	["BlogPostListEdge"]: {
	__typename: "BlogPostListEdge",
	node: GraphQLTypes["BlogPostList"]
};
	["BlogPostListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	caption?: string,
	list?: GraphQLTypes["BlogPostListItemCreateListEntityRelationInput"],
	blogPost?: GraphQLTypes["BlogPostListItemCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostListUniqueWhere"],
	create?: GraphQLTypes["BlogPostListWithoutItemsCreateInput"]
};
	["BlogPostListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["BlogPostListItemUpdateInput"]: {
		order?: number,
	caption?: string,
	list?: GraphQLTypes["BlogPostListItemUpdateListEntityRelationInput"],
	blogPost?: GraphQLTypes["BlogPostListItemUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostListWithoutItemsCreateInput"],
	update?: GraphQLTypes["BlogPostListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["BlogPostListItemUpsertListRelationInput"],
	connect?: GraphQLTypes["BlogPostListUniqueWhere"],
	delete?: boolean
};
	["BlogPostListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["BlogPostListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["BlogPostListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["BlogPostListWithoutItemsCreateInput"]
};
	["MenuLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["MenuLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["MenuLocaleCreateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["MenuLocaleCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MenuLocaleUpdateInput"]: {
		root?: GraphQLTypes["MenuLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["MenuLocaleUpdateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["MenuLocaleUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductGridConnection"]: {
	__typename: "ProductGridConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductGridEdge"]>
};
	["ProductGridEdge"]: {
	__typename: "ProductGridEdge",
	node: GraphQLTypes["ProductGrid"]
};
	["ProductGridItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	goodlokProductId?: string,
	title?: string,
	lead?: string,
	list?: GraphQLTypes["ProductGridItemCreateListEntityRelationInput"],
	medium?: GraphQLTypes["ProductGridItemCreateMediumEntityRelationInput"],
	link?: GraphQLTypes["ProductGridItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductGridItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductGridUniqueWhere"],
	create?: GraphQLTypes["ProductGridWithoutItemsCreateInput"]
};
	["ProductGridWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ProductGridItemUpdateInput"]: {
		order?: number,
	goodlokProductId?: string,
	title?: string,
	lead?: string,
	list?: GraphQLTypes["ProductGridItemUpdateListEntityRelationInput"],
	medium?: GraphQLTypes["ProductGridItemUpdateMediumEntityRelationInput"],
	link?: GraphQLTypes["ProductGridItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductGridItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ProductGridWithoutItemsCreateInput"],
	update?: GraphQLTypes["ProductGridWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ProductGridItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ProductGridUniqueWhere"],
	delete?: boolean
};
	["ProductGridWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ProductGridItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ProductGridWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ProductGridWithoutItemsCreateInput"]
};
	["Profile"]: {
	__typename: "Profile",
	_meta?: GraphQLTypes["ProfileMeta"],
	id: GraphQLTypes["UUID"],
	goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["Content"],
	activityRecords: Array<GraphQLTypes["ProfileActivityRecord"]>,
	pins: Array<GraphQLTypes["ProfilePin"]>,
	gallery?: GraphQLTypes["ProfileGallery"],
	tags: Array<GraphQLTypes["ProfileTag"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	pinsByActivityRecords?: GraphQLTypes["ProfilePin"],
	paginateActivityRecords: GraphQLTypes["ProfileActivityRecordConnection"],
	paginatePins: GraphQLTypes["ProfilePinConnection"],
	paginateTags: GraphQLTypes["ProfileTagConnection"]
};
	["ProfileMeta"]: {
	__typename: "ProfileMeta",
	id?: GraphQLTypes["FieldMeta"],
	goodlokId?: GraphQLTypes["FieldMeta"],
	importance?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	vokativ?: GraphQLTypes["FieldMeta"],
	fullName?: GraphQLTypes["FieldMeta"],
	aliases?: GraphQLTypes["FieldMeta"],
	quickNote?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	activityRecords?: GraphQLTypes["FieldMeta"],
	pins?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"],
	tags?: GraphQLTypes["FieldMeta"],
	familiarity?: GraphQLTypes["FieldMeta"],
	vipStatus?: GraphQLTypes["FieldMeta"],
	instagram?: GraphQLTypes["FieldMeta"],
	facebook?: GraphQLTypes["FieldMeta"],
	twitter?: GraphQLTypes["FieldMeta"],
	tiktok?: GraphQLTypes["FieldMeta"],
	youtube?: GraphQLTypes["FieldMeta"],
	status?: GraphQLTypes["FieldMeta"],
	visited?: GraphQLTypes["FieldMeta"],
	iosNearbyAt?: GraphQLTypes["FieldMeta"]
};
	["ProfileActivityRecord"]: {
	__typename: "ProfileActivityRecord",
	_meta?: GraphQLTypes["ProfileActivityRecordMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProfileActivityRecordType"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt?: GraphQLTypes["DateTime"],
	metadata?: string,
	profile?: GraphQLTypes["Profile"],
	pin?: GraphQLTypes["ProfilePin"]
};
	["ProfileActivityRecordMeta"]: {
	__typename: "ProfileActivityRecordMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	updatedAt?: GraphQLTypes["FieldMeta"],
	metadata?: GraphQLTypes["FieldMeta"],
	profile?: GraphQLTypes["FieldMeta"],
	pin?: GraphQLTypes["FieldMeta"]
};
	["ProfileActivityRecordType"]: ProfileActivityRecordType;
	["DateTime"]:any;
	["ProfileWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	goodlokId?: GraphQLTypes["StringCondition"],
	importance?: GraphQLTypes["IntCondition"],
	name?: GraphQLTypes["StringCondition"],
	vokativ?: GraphQLTypes["StringCondition"],
	fullName?: GraphQLTypes["StringCondition"],
	aliases?: GraphQLTypes["StringCondition"],
	quickNote?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	activityRecords?: GraphQLTypes["ProfileActivityRecordWhere"],
	pins?: GraphQLTypes["ProfilePinWhere"],
	gallery?: GraphQLTypes["ProfileGalleryWhere"],
	tags?: GraphQLTypes["ProfileTagWhere"],
	familiarity?: GraphQLTypes["FamiliarityCondition"],
	vipStatus?: GraphQLTypes["VipStatusCondition"],
	instagram?: GraphQLTypes["StringCondition"],
	facebook?: GraphQLTypes["StringCondition"],
	twitter?: GraphQLTypes["StringCondition"],
	tiktok?: GraphQLTypes["StringCondition"],
	youtube?: GraphQLTypes["StringCondition"],
	status?: GraphQLTypes["ProfileStatusCondition"],
	visited?: GraphQLTypes["IntCondition"],
	iosNearbyAt?: GraphQLTypes["DateTimeCondition"],
	and?: Array<GraphQLTypes["ProfileWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProfileWhere"] | undefined>,
	not?: GraphQLTypes["ProfileWhere"]
};
	["ProfileActivityRecordWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ProfileActivityRecordTypeCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	updatedAt?: GraphQLTypes["DateTimeCondition"],
	metadata?: GraphQLTypes["StringCondition"],
	profile?: GraphQLTypes["ProfileWhere"],
	pin?: GraphQLTypes["ProfilePinWhere"],
	and?: Array<GraphQLTypes["ProfileActivityRecordWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProfileActivityRecordWhere"] | undefined>,
	not?: GraphQLTypes["ProfileActivityRecordWhere"]
};
	["ProfileActivityRecordTypeCondition"]: {
		and?: Array<GraphQLTypes["ProfileActivityRecordTypeCondition"]>,
	or?: Array<GraphQLTypes["ProfileActivityRecordTypeCondition"]>,
	not?: GraphQLTypes["ProfileActivityRecordTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ProfileActivityRecordType"],
	notEq?: GraphQLTypes["ProfileActivityRecordType"],
	in?: Array<GraphQLTypes["ProfileActivityRecordType"]>,
	notIn?: Array<GraphQLTypes["ProfileActivityRecordType"]>,
	lt?: GraphQLTypes["ProfileActivityRecordType"],
	lte?: GraphQLTypes["ProfileActivityRecordType"],
	gt?: GraphQLTypes["ProfileActivityRecordType"],
	gte?: GraphQLTypes["ProfileActivityRecordType"]
};
	["DateTimeCondition"]: {
		and?: Array<GraphQLTypes["DateTimeCondition"]>,
	or?: Array<GraphQLTypes["DateTimeCondition"]>,
	not?: GraphQLTypes["DateTimeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["DateTime"],
	notEq?: GraphQLTypes["DateTime"],
	in?: Array<GraphQLTypes["DateTime"]>,
	notIn?: Array<GraphQLTypes["DateTime"]>,
	lt?: GraphQLTypes["DateTime"],
	lte?: GraphQLTypes["DateTime"],
	gt?: GraphQLTypes["DateTime"],
	gte?: GraphQLTypes["DateTime"]
};
	["ProfilePinWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ProfilePinTypeCondition"],
	startsAt?: GraphQLTypes["DateTimeCondition"],
	endsAt?: GraphQLTypes["DateTimeCondition"],
	dismissedAt?: GraphQLTypes["DateTimeCondition"],
	dismissedBy?: GraphQLTypes["StringCondition"],
	reason?: GraphQLTypes["StringCondition"],
	solution?: GraphQLTypes["StringCondition"],
	activityRecords?: GraphQLTypes["ProfileActivityRecordWhere"],
	profile?: GraphQLTypes["ProfileWhere"],
	and?: Array<GraphQLTypes["ProfilePinWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProfilePinWhere"] | undefined>,
	not?: GraphQLTypes["ProfilePinWhere"]
};
	["ProfilePinTypeCondition"]: {
		and?: Array<GraphQLTypes["ProfilePinTypeCondition"]>,
	or?: Array<GraphQLTypes["ProfilePinTypeCondition"]>,
	not?: GraphQLTypes["ProfilePinTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ProfilePinType"],
	notEq?: GraphQLTypes["ProfilePinType"],
	in?: Array<GraphQLTypes["ProfilePinType"]>,
	notIn?: Array<GraphQLTypes["ProfilePinType"]>,
	lt?: GraphQLTypes["ProfilePinType"],
	lte?: GraphQLTypes["ProfilePinType"],
	gt?: GraphQLTypes["ProfilePinType"],
	gte?: GraphQLTypes["ProfilePinType"]
};
	["ProfilePinType"]: ProfilePinType;
	["ProfileGalleryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ProfileGalleryItemWhere"],
	profile?: GraphQLTypes["ProfileWhere"],
	and?: Array<GraphQLTypes["ProfileGalleryWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProfileGalleryWhere"] | undefined>,
	not?: GraphQLTypes["ProfileGalleryWhere"]
};
	["ProfileGalleryItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	caption?: GraphQLTypes["StringCondition"],
	gallery?: GraphQLTypes["ProfileGalleryWhere"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["ProfileGalleryItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProfileGalleryItemWhere"] | undefined>,
	not?: GraphQLTypes["ProfileGalleryItemWhere"]
};
	["ProfileTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	color?: GraphQLTypes["StringCondition"],
	profiles?: GraphQLTypes["ProfileWhere"],
	and?: Array<GraphQLTypes["ProfileTagWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProfileTagWhere"] | undefined>,
	not?: GraphQLTypes["ProfileTagWhere"]
};
	["FamiliarityCondition"]: {
		and?: Array<GraphQLTypes["FamiliarityCondition"]>,
	or?: Array<GraphQLTypes["FamiliarityCondition"]>,
	not?: GraphQLTypes["FamiliarityCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["Familiarity"],
	notEq?: GraphQLTypes["Familiarity"],
	in?: Array<GraphQLTypes["Familiarity"]>,
	notIn?: Array<GraphQLTypes["Familiarity"]>,
	lt?: GraphQLTypes["Familiarity"],
	lte?: GraphQLTypes["Familiarity"],
	gt?: GraphQLTypes["Familiarity"],
	gte?: GraphQLTypes["Familiarity"]
};
	["Familiarity"]: Familiarity;
	["VipStatusCondition"]: {
		and?: Array<GraphQLTypes["VipStatusCondition"]>,
	or?: Array<GraphQLTypes["VipStatusCondition"]>,
	not?: GraphQLTypes["VipStatusCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["VipStatus"],
	notEq?: GraphQLTypes["VipStatus"],
	in?: Array<GraphQLTypes["VipStatus"]>,
	notIn?: Array<GraphQLTypes["VipStatus"]>,
	lt?: GraphQLTypes["VipStatus"],
	lte?: GraphQLTypes["VipStatus"],
	gt?: GraphQLTypes["VipStatus"],
	gte?: GraphQLTypes["VipStatus"]
};
	["VipStatus"]: VipStatus;
	["ProfileStatusCondition"]: {
		and?: Array<GraphQLTypes["ProfileStatusCondition"]>,
	or?: Array<GraphQLTypes["ProfileStatusCondition"]>,
	not?: GraphQLTypes["ProfileStatusCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ProfileStatus"],
	notEq?: GraphQLTypes["ProfileStatus"],
	in?: Array<GraphQLTypes["ProfileStatus"]>,
	notIn?: Array<GraphQLTypes["ProfileStatus"]>,
	lt?: GraphQLTypes["ProfileStatus"],
	lte?: GraphQLTypes["ProfileStatus"],
	gt?: GraphQLTypes["ProfileStatus"],
	gte?: GraphQLTypes["ProfileStatus"]
};
	["ProfileStatus"]: ProfileStatus;
	["ProfilePin"]: {
	__typename: "ProfilePin",
	_meta?: GraphQLTypes["ProfilePinMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProfilePinType"],
	startsAt?: GraphQLTypes["DateTime"],
	endsAt?: GraphQLTypes["DateTime"],
	dismissedAt?: GraphQLTypes["DateTime"],
	dismissedBy?: string,
	reason?: string,
	solution?: string,
	activityRecords: Array<GraphQLTypes["ProfileActivityRecord"]>,
	profile?: GraphQLTypes["Profile"],
	paginateActivityRecords: GraphQLTypes["ProfileActivityRecordConnection"]
};
	["ProfilePinMeta"]: {
	__typename: "ProfilePinMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	startsAt?: GraphQLTypes["FieldMeta"],
	endsAt?: GraphQLTypes["FieldMeta"],
	dismissedAt?: GraphQLTypes["FieldMeta"],
	dismissedBy?: GraphQLTypes["FieldMeta"],
	reason?: GraphQLTypes["FieldMeta"],
	solution?: GraphQLTypes["FieldMeta"],
	activityRecords?: GraphQLTypes["FieldMeta"],
	profile?: GraphQLTypes["FieldMeta"]
};
	["ProfileActivityRecordOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	updatedAt?: GraphQLTypes["OrderDirection"],
	metadata?: GraphQLTypes["OrderDirection"],
	profile?: GraphQLTypes["ProfileOrderBy"],
	pin?: GraphQLTypes["ProfilePinOrderBy"]
};
	["ProfileOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	goodlokId?: GraphQLTypes["OrderDirection"],
	importance?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	vokativ?: GraphQLTypes["OrderDirection"],
	fullName?: GraphQLTypes["OrderDirection"],
	aliases?: GraphQLTypes["OrderDirection"],
	quickNote?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"],
	gallery?: GraphQLTypes["ProfileGalleryOrderBy"],
	familiarity?: GraphQLTypes["OrderDirection"],
	vipStatus?: GraphQLTypes["OrderDirection"],
	instagram?: GraphQLTypes["OrderDirection"],
	facebook?: GraphQLTypes["OrderDirection"],
	twitter?: GraphQLTypes["OrderDirection"],
	tiktok?: GraphQLTypes["OrderDirection"],
	youtube?: GraphQLTypes["OrderDirection"],
	status?: GraphQLTypes["OrderDirection"],
	visited?: GraphQLTypes["OrderDirection"],
	iosNearbyAt?: GraphQLTypes["OrderDirection"]
};
	["ProfileGalleryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	profile?: GraphQLTypes["ProfileOrderBy"]
};
	["ProfilePinOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	startsAt?: GraphQLTypes["OrderDirection"],
	endsAt?: GraphQLTypes["OrderDirection"],
	dismissedAt?: GraphQLTypes["OrderDirection"],
	dismissedBy?: GraphQLTypes["OrderDirection"],
	reason?: GraphQLTypes["OrderDirection"],
	solution?: GraphQLTypes["OrderDirection"],
	profile?: GraphQLTypes["ProfileOrderBy"]
};
	["ProfileActivityRecordConnection"]: {
	__typename: "ProfileActivityRecordConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProfileActivityRecordEdge"]>
};
	["ProfileActivityRecordEdge"]: {
	__typename: "ProfileActivityRecordEdge",
	node: GraphQLTypes["ProfileActivityRecord"]
};
	["ProfileGallery"]: {
	__typename: "ProfileGallery",
	_meta?: GraphQLTypes["ProfileGalleryMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ProfileGalleryItem"]>,
	profile?: GraphQLTypes["Profile"],
	paginateItems: GraphQLTypes["ProfileGalleryItemConnection"]
};
	["ProfileGalleryMeta"]: {
	__typename: "ProfileGalleryMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	profile?: GraphQLTypes["FieldMeta"]
};
	["ProfileGalleryItem"]: {
	__typename: "ProfileGalleryItem",
	_meta?: GraphQLTypes["ProfileGalleryItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	caption?: string,
	gallery?: GraphQLTypes["ProfileGallery"],
	image?: GraphQLTypes["Image"]
};
	["ProfileGalleryItemMeta"]: {
	__typename: "ProfileGalleryItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	caption?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["ProfileGalleryItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	caption?: GraphQLTypes["OrderDirection"],
	gallery?: GraphQLTypes["ProfileGalleryOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["ProfileGalleryItemConnection"]: {
	__typename: "ProfileGalleryItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProfileGalleryItemEdge"]>
};
	["ProfileGalleryItemEdge"]: {
	__typename: "ProfileGalleryItemEdge",
	node: GraphQLTypes["ProfileGalleryItem"]
};
	["ProfileTag"]: {
	__typename: "ProfileTag",
	_meta?: GraphQLTypes["ProfileTagMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	color?: string,
	profiles: Array<GraphQLTypes["Profile"]>,
	paginateProfiles: GraphQLTypes["ProfileConnection"]
};
	["ProfileTagMeta"]: {
	__typename: "ProfileTagMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	color?: GraphQLTypes["FieldMeta"],
	profiles?: GraphQLTypes["FieldMeta"]
};
	["ProfileConnection"]: {
	__typename: "ProfileConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProfileEdge"]>
};
	["ProfileEdge"]: {
	__typename: "ProfileEdge",
	node: GraphQLTypes["Profile"]
};
	["ProfileTagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	color?: GraphQLTypes["OrderDirection"]
};
	["ProfilePinsByActivityRecordsUniqueWhere"]: {
		activityRecords?: GraphQLTypes["ProfileActivityRecordUniqueWhere"]
};
	["ProfileActivityRecordUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ProfilePinConnection"]: {
	__typename: "ProfilePinConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProfilePinEdge"]>
};
	["ProfilePinEdge"]: {
	__typename: "ProfilePinEdge",
	node: GraphQLTypes["ProfilePin"]
};
	["ProfileTagConnection"]: {
	__typename: "ProfileTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProfileTagEdge"]>
};
	["ProfileTagEdge"]: {
	__typename: "ProfileTagEdge",
	node: GraphQLTypes["ProfileTag"]
};
	["ProfileUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	goodlokId?: string,
	content?: GraphQLTypes["ContentUniqueWhere"],
	activityRecords?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	pins?: GraphQLTypes["ProfilePinUniqueWhere"],
	gallery?: GraphQLTypes["ProfileGalleryUniqueWhere"]
};
	["ProfilePinUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	activityRecords?: GraphQLTypes["ProfileActivityRecordUniqueWhere"]
};
	["ProfileGalleryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ProfileGalleryItemUniqueWhere"],
	profile?: GraphQLTypes["ProfileUniqueWhere"]
};
	["ProfileGalleryItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileCreateContentEntityRelationInput"],
	activityRecords?: Array<GraphQLTypes["ProfileCreateActivityRecordsEntityRelationInput"]>,
	pins?: Array<GraphQLTypes["ProfileCreatePinsEntityRelationInput"]>,
	gallery?: GraphQLTypes["ProfileCreateGalleryEntityRelationInput"],
	tags?: Array<GraphQLTypes["ProfileCreateTagsEntityRelationInput"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ProfileCreateActivityRecordsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	create?: GraphQLTypes["ProfileActivityRecordWithoutProfileCreateInput"],
	alias?: string
};
	["ProfileActivityRecordWithoutProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProfileActivityRecordType"],
	createdAt?: GraphQLTypes["DateTime"],
	updatedAt?: GraphQLTypes["DateTime"],
	metadata?: string,
	pin?: GraphQLTypes["ProfileActivityRecordCreatePinEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileActivityRecordCreatePinEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfilePinUniqueWhere"],
	create?: GraphQLTypes["ProfilePinWithoutActivityRecordsCreateInput"]
};
	["ProfilePinWithoutActivityRecordsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProfilePinType"],
	startsAt?: GraphQLTypes["DateTime"],
	endsAt?: GraphQLTypes["DateTime"],
	dismissedAt?: GraphQLTypes["DateTime"],
	dismissedBy?: string,
	reason?: string,
	solution?: string,
	profile?: GraphQLTypes["ProfilePinCreateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfilePinCreateProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileUniqueWhere"],
	create?: GraphQLTypes["ProfileWithoutPinsCreateInput"]
};
	["ProfileWithoutPinsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileCreateContentEntityRelationInput"],
	activityRecords?: Array<GraphQLTypes["ProfileCreateActivityRecordsEntityRelationInput"]>,
	gallery?: GraphQLTypes["ProfileCreateGalleryEntityRelationInput"],
	tags?: Array<GraphQLTypes["ProfileCreateTagsEntityRelationInput"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileGalleryUniqueWhere"],
	create?: GraphQLTypes["ProfileGalleryWithoutProfileCreateInput"]
};
	["ProfileGalleryWithoutProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ProfileGalleryCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProfileGalleryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileGalleryItemUniqueWhere"],
	create?: GraphQLTypes["ProfileGalleryItemWithoutGalleryCreateInput"],
	alias?: string
};
	["ProfileGalleryItemWithoutGalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	caption?: string,
	image?: GraphQLTypes["ProfileGalleryItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ProfileCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileTagUniqueWhere"],
	create?: GraphQLTypes["ProfileTagWithoutProfilesCreateInput"],
	alias?: string
};
	["ProfileTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	name?: string
};
	["ProfileTagWithoutProfilesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	color?: string,
	_dummy_field_?: boolean
};
	["ProfileCreatePinsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfilePinUniqueWhere"],
	create?: GraphQLTypes["ProfilePinWithoutProfileCreateInput"],
	alias?: string
};
	["ProfilePinWithoutProfileCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProfilePinType"],
	startsAt?: GraphQLTypes["DateTime"],
	endsAt?: GraphQLTypes["DateTime"],
	dismissedAt?: GraphQLTypes["DateTime"],
	dismissedBy?: string,
	reason?: string,
	solution?: string,
	activityRecords?: Array<GraphQLTypes["ProfilePinCreateActivityRecordsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProfilePinCreateActivityRecordsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	create?: GraphQLTypes["ProfileActivityRecordWithoutPinCreateInput"],
	alias?: string
};
	["ProfileActivityRecordWithoutPinCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProfileActivityRecordType"],
	createdAt?: GraphQLTypes["DateTime"],
	updatedAt?: GraphQLTypes["DateTime"],
	metadata?: string,
	profile?: GraphQLTypes["ProfileActivityRecordCreateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileActivityRecordCreateProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileUniqueWhere"],
	create?: GraphQLTypes["ProfileWithoutActivityRecordsCreateInput"]
};
	["ProfileWithoutActivityRecordsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileCreateContentEntityRelationInput"],
	pins?: Array<GraphQLTypes["ProfileCreatePinsEntityRelationInput"]>,
	gallery?: GraphQLTypes["ProfileCreateGalleryEntityRelationInput"],
	tags?: Array<GraphQLTypes["ProfileCreateTagsEntityRelationInput"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileUpdateInput"]: {
		goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileUpdateContentEntityRelationInput"],
	activityRecords?: Array<GraphQLTypes["ProfileUpdateActivityRecordsEntityRelationInput"]>,
	pins?: Array<GraphQLTypes["ProfileUpdatePinsEntityRelationInput"]>,
	gallery?: GraphQLTypes["ProfileUpdateGalleryEntityRelationInput"],
	tags?: Array<GraphQLTypes["ProfileUpdateTagsEntityRelationInput"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ProfileUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProfileUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ProfileUpdateActivityRecordsEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileActivityRecordWithoutProfileCreateInput"],
	update?: GraphQLTypes["ProfileUpdateActivityRecordsRelationInput"],
	upsert?: GraphQLTypes["ProfileUpsertActivityRecordsRelationInput"],
	connect?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	disconnect?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	delete?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	alias?: string
};
	["ProfileUpdateActivityRecordsRelationInput"]: {
		by?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	data?: GraphQLTypes["ProfileActivityRecordWithoutProfileUpdateInput"]
};
	["ProfileActivityRecordWithoutProfileUpdateInput"]: {
		type?: GraphQLTypes["ProfileActivityRecordType"],
	createdAt?: GraphQLTypes["DateTime"],
	updatedAt?: GraphQLTypes["DateTime"],
	metadata?: string,
	pin?: GraphQLTypes["ProfileActivityRecordUpdatePinEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileActivityRecordUpdatePinEntityRelationInput"]: {
		create?: GraphQLTypes["ProfilePinWithoutActivityRecordsCreateInput"],
	update?: GraphQLTypes["ProfilePinWithoutActivityRecordsUpdateInput"],
	upsert?: GraphQLTypes["ProfileActivityRecordUpsertPinRelationInput"],
	connect?: GraphQLTypes["ProfilePinUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProfilePinWithoutActivityRecordsUpdateInput"]: {
		type?: GraphQLTypes["ProfilePinType"],
	startsAt?: GraphQLTypes["DateTime"],
	endsAt?: GraphQLTypes["DateTime"],
	dismissedAt?: GraphQLTypes["DateTime"],
	dismissedBy?: string,
	reason?: string,
	solution?: string,
	profile?: GraphQLTypes["ProfilePinUpdateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfilePinUpdateProfileEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileWithoutPinsCreateInput"],
	update?: GraphQLTypes["ProfileWithoutPinsUpdateInput"],
	upsert?: GraphQLTypes["ProfilePinUpsertProfileRelationInput"],
	connect?: GraphQLTypes["ProfileUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProfileWithoutPinsUpdateInput"]: {
		goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileUpdateContentEntityRelationInput"],
	activityRecords?: Array<GraphQLTypes["ProfileUpdateActivityRecordsEntityRelationInput"]>,
	gallery?: GraphQLTypes["ProfileUpdateGalleryEntityRelationInput"],
	tags?: Array<GraphQLTypes["ProfileUpdateTagsEntityRelationInput"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileGalleryWithoutProfileCreateInput"],
	update?: GraphQLTypes["ProfileGalleryWithoutProfileUpdateInput"],
	upsert?: GraphQLTypes["ProfileUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["ProfileGalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProfileGalleryWithoutProfileUpdateInput"]: {
		items?: Array<GraphQLTypes["ProfileGalleryUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProfileGalleryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileGalleryItemWithoutGalleryCreateInput"],
	update?: GraphQLTypes["ProfileGalleryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ProfileGalleryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ProfileGalleryItemUniqueWhere"],
	disconnect?: GraphQLTypes["ProfileGalleryItemUniqueWhere"],
	delete?: GraphQLTypes["ProfileGalleryItemUniqueWhere"],
	alias?: string
};
	["ProfileGalleryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ProfileGalleryItemUniqueWhere"],
	data?: GraphQLTypes["ProfileGalleryItemWithoutGalleryUpdateInput"]
};
	["ProfileGalleryItemWithoutGalleryUpdateInput"]: {
		order?: number,
	caption?: string,
	image?: GraphQLTypes["ProfileGalleryItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ProfileGalleryItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProfileGalleryItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ProfileGalleryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ProfileGalleryItemUniqueWhere"],
	update?: GraphQLTypes["ProfileGalleryItemWithoutGalleryUpdateInput"],
	create?: GraphQLTypes["ProfileGalleryItemWithoutGalleryCreateInput"]
};
	["ProfileUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["ProfileGalleryWithoutProfileUpdateInput"],
	create?: GraphQLTypes["ProfileGalleryWithoutProfileCreateInput"]
};
	["ProfileUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileTagWithoutProfilesCreateInput"],
	update?: GraphQLTypes["ProfileUpdateTagsRelationInput"],
	upsert?: GraphQLTypes["ProfileUpsertTagsRelationInput"],
	connect?: GraphQLTypes["ProfileTagUniqueWhere"],
	disconnect?: GraphQLTypes["ProfileTagUniqueWhere"],
	delete?: GraphQLTypes["ProfileTagUniqueWhere"],
	alias?: string
};
	["ProfileUpdateTagsRelationInput"]: {
		by?: GraphQLTypes["ProfileTagUniqueWhere"],
	data?: GraphQLTypes["ProfileTagWithoutProfilesUpdateInput"]
};
	["ProfileTagWithoutProfilesUpdateInput"]: {
		name?: string,
	color?: string,
	_dummy_field_?: boolean
};
	["ProfileUpsertTagsRelationInput"]: {
		by?: GraphQLTypes["ProfileTagUniqueWhere"],
	update?: GraphQLTypes["ProfileTagWithoutProfilesUpdateInput"],
	create?: GraphQLTypes["ProfileTagWithoutProfilesCreateInput"]
};
	["ProfilePinUpsertProfileRelationInput"]: {
		update?: GraphQLTypes["ProfileWithoutPinsUpdateInput"],
	create?: GraphQLTypes["ProfileWithoutPinsCreateInput"]
};
	["ProfileActivityRecordUpsertPinRelationInput"]: {
		update?: GraphQLTypes["ProfilePinWithoutActivityRecordsUpdateInput"],
	create?: GraphQLTypes["ProfilePinWithoutActivityRecordsCreateInput"]
};
	["ProfileUpsertActivityRecordsRelationInput"]: {
		by?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	update?: GraphQLTypes["ProfileActivityRecordWithoutProfileUpdateInput"],
	create?: GraphQLTypes["ProfileActivityRecordWithoutProfileCreateInput"]
};
	["ProfileUpdatePinsEntityRelationInput"]: {
		create?: GraphQLTypes["ProfilePinWithoutProfileCreateInput"],
	update?: GraphQLTypes["ProfileUpdatePinsRelationInput"],
	upsert?: GraphQLTypes["ProfileUpsertPinsRelationInput"],
	connect?: GraphQLTypes["ProfilePinUniqueWhere"],
	disconnect?: GraphQLTypes["ProfilePinUniqueWhere"],
	delete?: GraphQLTypes["ProfilePinUniqueWhere"],
	alias?: string
};
	["ProfileUpdatePinsRelationInput"]: {
		by?: GraphQLTypes["ProfilePinUniqueWhere"],
	data?: GraphQLTypes["ProfilePinWithoutProfileUpdateInput"]
};
	["ProfilePinWithoutProfileUpdateInput"]: {
		type?: GraphQLTypes["ProfilePinType"],
	startsAt?: GraphQLTypes["DateTime"],
	endsAt?: GraphQLTypes["DateTime"],
	dismissedAt?: GraphQLTypes["DateTime"],
	dismissedBy?: string,
	reason?: string,
	solution?: string,
	activityRecords?: Array<GraphQLTypes["ProfilePinUpdateActivityRecordsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProfilePinUpdateActivityRecordsEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileActivityRecordWithoutPinCreateInput"],
	update?: GraphQLTypes["ProfilePinUpdateActivityRecordsRelationInput"],
	upsert?: GraphQLTypes["ProfilePinUpsertActivityRecordsRelationInput"],
	connect?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	disconnect?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	delete?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	alias?: string
};
	["ProfilePinUpdateActivityRecordsRelationInput"]: {
		by?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	data?: GraphQLTypes["ProfileActivityRecordWithoutPinUpdateInput"]
};
	["ProfileActivityRecordWithoutPinUpdateInput"]: {
		type?: GraphQLTypes["ProfileActivityRecordType"],
	createdAt?: GraphQLTypes["DateTime"],
	updatedAt?: GraphQLTypes["DateTime"],
	metadata?: string,
	profile?: GraphQLTypes["ProfileActivityRecordUpdateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileActivityRecordUpdateProfileEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileWithoutActivityRecordsCreateInput"],
	update?: GraphQLTypes["ProfileWithoutActivityRecordsUpdateInput"],
	upsert?: GraphQLTypes["ProfileActivityRecordUpsertProfileRelationInput"],
	connect?: GraphQLTypes["ProfileUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProfileWithoutActivityRecordsUpdateInput"]: {
		goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileUpdateContentEntityRelationInput"],
	pins?: Array<GraphQLTypes["ProfileUpdatePinsEntityRelationInput"]>,
	gallery?: GraphQLTypes["ProfileUpdateGalleryEntityRelationInput"],
	tags?: Array<GraphQLTypes["ProfileUpdateTagsEntityRelationInput"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileActivityRecordUpsertProfileRelationInput"]: {
		update?: GraphQLTypes["ProfileWithoutActivityRecordsUpdateInput"],
	create?: GraphQLTypes["ProfileWithoutActivityRecordsCreateInput"]
};
	["ProfilePinUpsertActivityRecordsRelationInput"]: {
		by?: GraphQLTypes["ProfileActivityRecordUniqueWhere"],
	update?: GraphQLTypes["ProfileActivityRecordWithoutPinUpdateInput"],
	create?: GraphQLTypes["ProfileActivityRecordWithoutPinCreateInput"]
};
	["ProfileUpsertPinsRelationInput"]: {
		by?: GraphQLTypes["ProfilePinUniqueWhere"],
	update?: GraphQLTypes["ProfilePinWithoutProfileUpdateInput"],
	create?: GraphQLTypes["ProfilePinWithoutProfileCreateInput"]
};
	["ProfileTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	color?: string,
	profiles?: Array<GraphQLTypes["ProfileTagCreateProfilesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProfileTagCreateProfilesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileUniqueWhere"],
	create?: GraphQLTypes["ProfileWithoutTagsCreateInput"],
	alias?: string
};
	["ProfileWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileCreateContentEntityRelationInput"],
	activityRecords?: Array<GraphQLTypes["ProfileCreateActivityRecordsEntityRelationInput"]>,
	pins?: Array<GraphQLTypes["ProfileCreatePinsEntityRelationInput"]>,
	gallery?: GraphQLTypes["ProfileCreateGalleryEntityRelationInput"],
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileTagUpdateInput"]: {
		name?: string,
	color?: string,
	profiles?: Array<GraphQLTypes["ProfileTagUpdateProfilesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProfileTagUpdateProfilesEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileWithoutTagsCreateInput"],
	update?: GraphQLTypes["ProfileTagUpdateProfilesRelationInput"],
	upsert?: GraphQLTypes["ProfileTagUpsertProfilesRelationInput"],
	connect?: GraphQLTypes["ProfileUniqueWhere"],
	disconnect?: GraphQLTypes["ProfileUniqueWhere"],
	delete?: GraphQLTypes["ProfileUniqueWhere"],
	alias?: string
};
	["ProfileTagUpdateProfilesRelationInput"]: {
		by?: GraphQLTypes["ProfileUniqueWhere"],
	data?: GraphQLTypes["ProfileWithoutTagsUpdateInput"]
};
	["ProfileWithoutTagsUpdateInput"]: {
		goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileUpdateContentEntityRelationInput"],
	activityRecords?: Array<GraphQLTypes["ProfileUpdateActivityRecordsEntityRelationInput"]>,
	pins?: Array<GraphQLTypes["ProfileUpdatePinsEntityRelationInput"]>,
	gallery?: GraphQLTypes["ProfileUpdateGalleryEntityRelationInput"],
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileTagUpsertProfilesRelationInput"]: {
		by?: GraphQLTypes["ProfileUniqueWhere"],
	update?: GraphQLTypes["ProfileWithoutTagsUpdateInput"],
	create?: GraphQLTypes["ProfileWithoutTagsCreateInput"]
};
	["ProfileActivityRecordCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProfileActivityRecordType"],
	createdAt?: GraphQLTypes["DateTime"],
	updatedAt?: GraphQLTypes["DateTime"],
	metadata?: string,
	profile?: GraphQLTypes["ProfileActivityRecordCreateProfileEntityRelationInput"],
	pin?: GraphQLTypes["ProfileActivityRecordCreatePinEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileActivityRecordUpdateInput"]: {
		type?: GraphQLTypes["ProfileActivityRecordType"],
	createdAt?: GraphQLTypes["DateTime"],
	updatedAt?: GraphQLTypes["DateTime"],
	metadata?: string,
	profile?: GraphQLTypes["ProfileActivityRecordUpdateProfileEntityRelationInput"],
	pin?: GraphQLTypes["ProfileActivityRecordUpdatePinEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfilePinCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProfilePinType"],
	startsAt?: GraphQLTypes["DateTime"],
	endsAt?: GraphQLTypes["DateTime"],
	dismissedAt?: GraphQLTypes["DateTime"],
	dismissedBy?: string,
	reason?: string,
	solution?: string,
	activityRecords?: Array<GraphQLTypes["ProfilePinCreateActivityRecordsEntityRelationInput"]>,
	profile?: GraphQLTypes["ProfilePinCreateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfilePinUpdateInput"]: {
		type?: GraphQLTypes["ProfilePinType"],
	startsAt?: GraphQLTypes["DateTime"],
	endsAt?: GraphQLTypes["DateTime"],
	dismissedAt?: GraphQLTypes["DateTime"],
	dismissedBy?: string,
	reason?: string,
	solution?: string,
	activityRecords?: Array<GraphQLTypes["ProfilePinUpdateActivityRecordsEntityRelationInput"]>,
	profile?: GraphQLTypes["ProfilePinUpdateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryConnection"]: {
	__typename: "ProfileGalleryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProfileGalleryEdge"]>
};
	["ProfileGalleryEdge"]: {
	__typename: "ProfileGalleryEdge",
	node: GraphQLTypes["ProfileGallery"]
};
	["ProfileGalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ProfileGalleryCreateItemsEntityRelationInput"]>,
	profile?: GraphQLTypes["ProfileGalleryCreateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryCreateProfileEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileUniqueWhere"],
	create?: GraphQLTypes["ProfileWithoutGalleryCreateInput"]
};
	["ProfileWithoutGalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileCreateContentEntityRelationInput"],
	activityRecords?: Array<GraphQLTypes["ProfileCreateActivityRecordsEntityRelationInput"]>,
	pins?: Array<GraphQLTypes["ProfileCreatePinsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["ProfileCreateTagsEntityRelationInput"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileGalleryUpdateInput"]: {
		items?: Array<GraphQLTypes["ProfileGalleryUpdateItemsEntityRelationInput"]>,
	profile?: GraphQLTypes["ProfileGalleryUpdateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryUpdateProfileEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileWithoutGalleryCreateInput"],
	update?: GraphQLTypes["ProfileWithoutGalleryUpdateInput"],
	upsert?: GraphQLTypes["ProfileGalleryUpsertProfileRelationInput"],
	connect?: GraphQLTypes["ProfileUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProfileWithoutGalleryUpdateInput"]: {
		goodlokId?: string,
	importance?: number,
	name?: string,
	vokativ?: string,
	fullName?: string,
	aliases?: string,
	quickNote?: string,
	content?: GraphQLTypes["ProfileUpdateContentEntityRelationInput"],
	activityRecords?: Array<GraphQLTypes["ProfileUpdateActivityRecordsEntityRelationInput"]>,
	pins?: Array<GraphQLTypes["ProfileUpdatePinsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["ProfileUpdateTagsEntityRelationInput"]>,
	familiarity?: GraphQLTypes["Familiarity"],
	vipStatus?: GraphQLTypes["VipStatus"],
	instagram?: string,
	facebook?: string,
	twitter?: string,
	tiktok?: string,
	youtube?: string,
	status?: GraphQLTypes["ProfileStatus"],
	visited?: number,
	iosNearbyAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ProfileGalleryUpsertProfileRelationInput"]: {
		update?: GraphQLTypes["ProfileWithoutGalleryUpdateInput"],
	create?: GraphQLTypes["ProfileWithoutGalleryCreateInput"]
};
	["ProfileGalleryItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	caption?: string,
	gallery?: GraphQLTypes["ProfileGalleryItemCreateGalleryEntityRelationInput"],
	image?: GraphQLTypes["ProfileGalleryItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryItemCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["ProfileGalleryUniqueWhere"],
	create?: GraphQLTypes["ProfileGalleryWithoutItemsCreateInput"]
};
	["ProfileGalleryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	profile?: GraphQLTypes["ProfileGalleryCreateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryItemUpdateInput"]: {
		order?: number,
	caption?: string,
	gallery?: GraphQLTypes["ProfileGalleryItemUpdateGalleryEntityRelationInput"],
	image?: GraphQLTypes["ProfileGalleryItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryItemUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["ProfileGalleryWithoutItemsCreateInput"],
	update?: GraphQLTypes["ProfileGalleryWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ProfileGalleryItemUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["ProfileGalleryUniqueWhere"],
	delete?: boolean
};
	["ProfileGalleryWithoutItemsUpdateInput"]: {
		profile?: GraphQLTypes["ProfileGalleryUpdateProfileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProfileGalleryItemUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["ProfileGalleryWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ProfileGalleryWithoutItemsCreateInput"]
};
	["ShoppingList"]: {
	__typename: "ShoppingList",
	_meta?: GraphQLTypes["ShoppingListMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	items: Array<GraphQLTypes["ShoppingListItem"]>,
	paginateItems: GraphQLTypes["ShoppingListItemConnection"]
};
	["ShoppingListMeta"]: {
	__typename: "ShoppingListMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ShoppingListItem"]: {
	__typename: "ShoppingListItem",
	_meta?: GraphQLTypes["ShoppingListItemMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	dueDate?: GraphQLTypes["Date"],
	shoppingList?: GraphQLTypes["ShoppingList"],
	amount?: string,
	supplier?: GraphQLTypes["Supplier"],
	status: GraphQLTypes["ShoppingListItemStatus"]
};
	["ShoppingListItemMeta"]: {
	__typename: "ShoppingListItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	dueDate?: GraphQLTypes["FieldMeta"],
	shoppingList?: GraphQLTypes["FieldMeta"],
	amount?: GraphQLTypes["FieldMeta"],
	supplier?: GraphQLTypes["FieldMeta"],
	status?: GraphQLTypes["FieldMeta"]
};
	["Date"]:any;
	["ShoppingListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	items?: GraphQLTypes["ShoppingListItemWhere"],
	and?: Array<GraphQLTypes["ShoppingListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ShoppingListWhere"] | undefined>,
	not?: GraphQLTypes["ShoppingListWhere"]
};
	["ShoppingListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	dueDate?: GraphQLTypes["DateCondition"],
	shoppingList?: GraphQLTypes["ShoppingListWhere"],
	amount?: GraphQLTypes["StringCondition"],
	supplier?: GraphQLTypes["SupplierWhere"],
	status?: GraphQLTypes["ShoppingListItemStatusCondition"],
	and?: Array<GraphQLTypes["ShoppingListItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ShoppingListItemWhere"] | undefined>,
	not?: GraphQLTypes["ShoppingListItemWhere"]
};
	["DateCondition"]: {
		and?: Array<GraphQLTypes["DateCondition"]>,
	or?: Array<GraphQLTypes["DateCondition"]>,
	not?: GraphQLTypes["DateCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["Date"],
	notEq?: GraphQLTypes["Date"],
	in?: Array<GraphQLTypes["Date"]>,
	notIn?: Array<GraphQLTypes["Date"]>,
	lt?: GraphQLTypes["Date"],
	lte?: GraphQLTypes["Date"],
	gt?: GraphQLTypes["Date"],
	gte?: GraphQLTypes["Date"]
};
	["SupplierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	contact?: GraphQLTypes["StringCondition"],
	shoppingListItems?: GraphQLTypes["ShoppingListItemWhere"],
	logo?: GraphQLTypes["ImageWhere"],
	favouriteItems?: GraphQLTypes["FavouriteItemWhere"],
	and?: Array<GraphQLTypes["SupplierWhere"] | undefined>,
	or?: Array<GraphQLTypes["SupplierWhere"] | undefined>,
	not?: GraphQLTypes["SupplierWhere"]
};
	["FavouriteItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	amount?: GraphQLTypes["StringCondition"],
	supplier?: GraphQLTypes["SupplierWhere"],
	and?: Array<GraphQLTypes["FavouriteItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["FavouriteItemWhere"] | undefined>,
	not?: GraphQLTypes["FavouriteItemWhere"]
};
	["ShoppingListItemStatusCondition"]: {
		and?: Array<GraphQLTypes["ShoppingListItemStatusCondition"]>,
	or?: Array<GraphQLTypes["ShoppingListItemStatusCondition"]>,
	not?: GraphQLTypes["ShoppingListItemStatusCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ShoppingListItemStatus"],
	notEq?: GraphQLTypes["ShoppingListItemStatus"],
	in?: Array<GraphQLTypes["ShoppingListItemStatus"]>,
	notIn?: Array<GraphQLTypes["ShoppingListItemStatus"]>,
	lt?: GraphQLTypes["ShoppingListItemStatus"],
	lte?: GraphQLTypes["ShoppingListItemStatus"],
	gt?: GraphQLTypes["ShoppingListItemStatus"],
	gte?: GraphQLTypes["ShoppingListItemStatus"]
};
	["ShoppingListItemStatus"]: ShoppingListItemStatus;
	["Supplier"]: {
	__typename: "Supplier",
	_meta?: GraphQLTypes["SupplierMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	contact?: string,
	shoppingListItems: Array<GraphQLTypes["ShoppingListItem"]>,
	logo?: GraphQLTypes["Image"],
	favouriteItems: Array<GraphQLTypes["FavouriteItem"]>,
	paginateShoppingListItems: GraphQLTypes["ShoppingListItemConnection"],
	paginateFavouriteItems: GraphQLTypes["FavouriteItemConnection"]
};
	["SupplierMeta"]: {
	__typename: "SupplierMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	contact?: GraphQLTypes["FieldMeta"],
	shoppingListItems?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	favouriteItems?: GraphQLTypes["FieldMeta"]
};
	["ShoppingListItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	dueDate?: GraphQLTypes["OrderDirection"],
	shoppingList?: GraphQLTypes["ShoppingListOrderBy"],
	amount?: GraphQLTypes["OrderDirection"],
	supplier?: GraphQLTypes["SupplierOrderBy"],
	status?: GraphQLTypes["OrderDirection"]
};
	["ShoppingListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"]
};
	["SupplierOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	contact?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"]
};
	["FavouriteItem"]: {
	__typename: "FavouriteItem",
	_meta?: GraphQLTypes["FavouriteItemMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	amount?: string,
	supplier?: GraphQLTypes["Supplier"]
};
	["FavouriteItemMeta"]: {
	__typename: "FavouriteItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	amount?: GraphQLTypes["FieldMeta"],
	supplier?: GraphQLTypes["FieldMeta"]
};
	["FavouriteItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	amount?: GraphQLTypes["OrderDirection"],
	supplier?: GraphQLTypes["SupplierOrderBy"]
};
	["ShoppingListItemConnection"]: {
	__typename: "ShoppingListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShoppingListItemEdge"]>
};
	["ShoppingListItemEdge"]: {
	__typename: "ShoppingListItemEdge",
	node: GraphQLTypes["ShoppingListItem"]
};
	["FavouriteItemConnection"]: {
	__typename: "FavouriteItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FavouriteItemEdge"]>
};
	["FavouriteItemEdge"]: {
	__typename: "FavouriteItemEdge",
	node: GraphQLTypes["FavouriteItem"]
};
	["ShoppingListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ShoppingListItemUniqueWhere"]
};
	["ShoppingListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ShoppingListConnection"]: {
	__typename: "ShoppingListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShoppingListEdge"]>
};
	["ShoppingListEdge"]: {
	__typename: "ShoppingListEdge",
	node: GraphQLTypes["ShoppingList"]
};
	["ShoppingListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	items?: Array<GraphQLTypes["ShoppingListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ShoppingListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	create?: GraphQLTypes["ShoppingListItemWithoutShoppingListCreateInput"],
	alias?: string
};
	["ShoppingListItemWithoutShoppingListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	dueDate?: GraphQLTypes["Date"],
	amount?: string,
	supplier?: GraphQLTypes["ShoppingListItemCreateSupplierEntityRelationInput"],
	status?: GraphQLTypes["ShoppingListItemStatus"],
	_dummy_field_?: boolean
};
	["ShoppingListItemCreateSupplierEntityRelationInput"]: {
		connect?: GraphQLTypes["SupplierUniqueWhere"],
	create?: GraphQLTypes["SupplierWithoutShoppingListItemsCreateInput"]
};
	["SupplierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	shoppingListItems?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	favouriteItems?: GraphQLTypes["FavouriteItemUniqueWhere"]
};
	["FavouriteItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SupplierWithoutShoppingListItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	contact?: string,
	logo?: GraphQLTypes["SupplierCreateLogoEntityRelationInput"],
	favouriteItems?: Array<GraphQLTypes["SupplierCreateFavouriteItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SupplierCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["SupplierCreateFavouriteItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["FavouriteItemUniqueWhere"],
	create?: GraphQLTypes["FavouriteItemWithoutSupplierCreateInput"],
	alias?: string
};
	["FavouriteItemWithoutSupplierCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	amount?: string,
	_dummy_field_?: boolean
};
	["ShoppingListUpdateInput"]: {
		title?: string,
	items?: Array<GraphQLTypes["ShoppingListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ShoppingListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ShoppingListItemWithoutShoppingListCreateInput"],
	update?: GraphQLTypes["ShoppingListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ShoppingListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	disconnect?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	delete?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	alias?: string
};
	["ShoppingListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	data?: GraphQLTypes["ShoppingListItemWithoutShoppingListUpdateInput"]
};
	["ShoppingListItemWithoutShoppingListUpdateInput"]: {
		title?: string,
	dueDate?: GraphQLTypes["Date"],
	amount?: string,
	supplier?: GraphQLTypes["ShoppingListItemUpdateSupplierEntityRelationInput"],
	status?: GraphQLTypes["ShoppingListItemStatus"],
	_dummy_field_?: boolean
};
	["ShoppingListItemUpdateSupplierEntityRelationInput"]: {
		create?: GraphQLTypes["SupplierWithoutShoppingListItemsCreateInput"],
	update?: GraphQLTypes["SupplierWithoutShoppingListItemsUpdateInput"],
	upsert?: GraphQLTypes["ShoppingListItemUpsertSupplierRelationInput"],
	connect?: GraphQLTypes["SupplierUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SupplierWithoutShoppingListItemsUpdateInput"]: {
		name?: string,
	contact?: string,
	logo?: GraphQLTypes["SupplierUpdateLogoEntityRelationInput"],
	favouriteItems?: Array<GraphQLTypes["SupplierUpdateFavouriteItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SupplierUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SupplierUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SupplierUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["SupplierUpdateFavouriteItemsEntityRelationInput"]: {
		create?: GraphQLTypes["FavouriteItemWithoutSupplierCreateInput"],
	update?: GraphQLTypes["SupplierUpdateFavouriteItemsRelationInput"],
	upsert?: GraphQLTypes["SupplierUpsertFavouriteItemsRelationInput"],
	connect?: GraphQLTypes["FavouriteItemUniqueWhere"],
	disconnect?: GraphQLTypes["FavouriteItemUniqueWhere"],
	delete?: GraphQLTypes["FavouriteItemUniqueWhere"],
	alias?: string
};
	["SupplierUpdateFavouriteItemsRelationInput"]: {
		by?: GraphQLTypes["FavouriteItemUniqueWhere"],
	data?: GraphQLTypes["FavouriteItemWithoutSupplierUpdateInput"]
};
	["FavouriteItemWithoutSupplierUpdateInput"]: {
		title?: string,
	amount?: string,
	_dummy_field_?: boolean
};
	["SupplierUpsertFavouriteItemsRelationInput"]: {
		by?: GraphQLTypes["FavouriteItemUniqueWhere"],
	update?: GraphQLTypes["FavouriteItemWithoutSupplierUpdateInput"],
	create?: GraphQLTypes["FavouriteItemWithoutSupplierCreateInput"]
};
	["ShoppingListItemUpsertSupplierRelationInput"]: {
		update?: GraphQLTypes["SupplierWithoutShoppingListItemsUpdateInput"],
	create?: GraphQLTypes["SupplierWithoutShoppingListItemsCreateInput"]
};
	["ShoppingListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	update?: GraphQLTypes["ShoppingListItemWithoutShoppingListUpdateInput"],
	create?: GraphQLTypes["ShoppingListItemWithoutShoppingListCreateInput"]
};
	["ShoppingListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	dueDate?: GraphQLTypes["Date"],
	shoppingList?: GraphQLTypes["ShoppingListItemCreateShoppingListEntityRelationInput"],
	amount?: string,
	supplier?: GraphQLTypes["ShoppingListItemCreateSupplierEntityRelationInput"],
	status?: GraphQLTypes["ShoppingListItemStatus"],
	_dummy_field_?: boolean
};
	["ShoppingListItemCreateShoppingListEntityRelationInput"]: {
		connect?: GraphQLTypes["ShoppingListUniqueWhere"],
	create?: GraphQLTypes["ShoppingListWithoutItemsCreateInput"]
};
	["ShoppingListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	_dummy_field_?: boolean
};
	["ShoppingListItemUpdateInput"]: {
		title?: string,
	dueDate?: GraphQLTypes["Date"],
	shoppingList?: GraphQLTypes["ShoppingListItemUpdateShoppingListEntityRelationInput"],
	amount?: string,
	supplier?: GraphQLTypes["ShoppingListItemUpdateSupplierEntityRelationInput"],
	status?: GraphQLTypes["ShoppingListItemStatus"],
	_dummy_field_?: boolean
};
	["ShoppingListItemUpdateShoppingListEntityRelationInput"]: {
		create?: GraphQLTypes["ShoppingListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ShoppingListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ShoppingListItemUpsertShoppingListRelationInput"],
	connect?: GraphQLTypes["ShoppingListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ShoppingListWithoutItemsUpdateInput"]: {
		title?: string,
	_dummy_field_?: boolean
};
	["ShoppingListItemUpsertShoppingListRelationInput"]: {
		update?: GraphQLTypes["ShoppingListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ShoppingListWithoutItemsCreateInput"]
};
	["SupplierConnection"]: {
	__typename: "SupplierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SupplierEdge"]>
};
	["SupplierEdge"]: {
	__typename: "SupplierEdge",
	node: GraphQLTypes["Supplier"]
};
	["SupplierCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	contact?: string,
	shoppingListItems?: Array<GraphQLTypes["SupplierCreateShoppingListItemsEntityRelationInput"]>,
	logo?: GraphQLTypes["SupplierCreateLogoEntityRelationInput"],
	favouriteItems?: Array<GraphQLTypes["SupplierCreateFavouriteItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SupplierCreateShoppingListItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	create?: GraphQLTypes["ShoppingListItemWithoutSupplierCreateInput"],
	alias?: string
};
	["ShoppingListItemWithoutSupplierCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	dueDate?: GraphQLTypes["Date"],
	shoppingList?: GraphQLTypes["ShoppingListItemCreateShoppingListEntityRelationInput"],
	amount?: string,
	status?: GraphQLTypes["ShoppingListItemStatus"],
	_dummy_field_?: boolean
};
	["SupplierUpdateInput"]: {
		name?: string,
	contact?: string,
	shoppingListItems?: Array<GraphQLTypes["SupplierUpdateShoppingListItemsEntityRelationInput"]>,
	logo?: GraphQLTypes["SupplierUpdateLogoEntityRelationInput"],
	favouriteItems?: Array<GraphQLTypes["SupplierUpdateFavouriteItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SupplierUpdateShoppingListItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ShoppingListItemWithoutSupplierCreateInput"],
	update?: GraphQLTypes["SupplierUpdateShoppingListItemsRelationInput"],
	upsert?: GraphQLTypes["SupplierUpsertShoppingListItemsRelationInput"],
	connect?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	disconnect?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	delete?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	alias?: string
};
	["SupplierUpdateShoppingListItemsRelationInput"]: {
		by?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	data?: GraphQLTypes["ShoppingListItemWithoutSupplierUpdateInput"]
};
	["ShoppingListItemWithoutSupplierUpdateInput"]: {
		title?: string,
	dueDate?: GraphQLTypes["Date"],
	shoppingList?: GraphQLTypes["ShoppingListItemUpdateShoppingListEntityRelationInput"],
	amount?: string,
	status?: GraphQLTypes["ShoppingListItemStatus"],
	_dummy_field_?: boolean
};
	["SupplierUpsertShoppingListItemsRelationInput"]: {
		by?: GraphQLTypes["ShoppingListItemUniqueWhere"],
	update?: GraphQLTypes["ShoppingListItemWithoutSupplierUpdateInput"],
	create?: GraphQLTypes["ShoppingListItemWithoutSupplierCreateInput"]
};
	["FavouriteItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	amount?: string,
	supplier?: GraphQLTypes["FavouriteItemCreateSupplierEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FavouriteItemCreateSupplierEntityRelationInput"]: {
		connect?: GraphQLTypes["SupplierUniqueWhere"],
	create?: GraphQLTypes["SupplierWithoutFavouriteItemsCreateInput"]
};
	["SupplierWithoutFavouriteItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	contact?: string,
	shoppingListItems?: Array<GraphQLTypes["SupplierCreateShoppingListItemsEntityRelationInput"]>,
	logo?: GraphQLTypes["SupplierCreateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FavouriteItemUpdateInput"]: {
		title?: string,
	amount?: string,
	supplier?: GraphQLTypes["FavouriteItemUpdateSupplierEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FavouriteItemUpdateSupplierEntityRelationInput"]: {
		create?: GraphQLTypes["SupplierWithoutFavouriteItemsCreateInput"],
	update?: GraphQLTypes["SupplierWithoutFavouriteItemsUpdateInput"],
	upsert?: GraphQLTypes["FavouriteItemUpsertSupplierRelationInput"],
	connect?: GraphQLTypes["SupplierUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SupplierWithoutFavouriteItemsUpdateInput"]: {
		name?: string,
	contact?: string,
	shoppingListItems?: Array<GraphQLTypes["SupplierUpdateShoppingListItemsEntityRelationInput"]>,
	logo?: GraphQLTypes["SupplierUpdateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FavouriteItemUpsertSupplierRelationInput"]: {
		update?: GraphQLTypes["SupplierWithoutFavouriteItemsUpdateInput"],
	create?: GraphQLTypes["SupplierWithoutFavouriteItemsCreateInput"]
};
	["BusinessOrderTypeConnection"]: {
	__typename: "BusinessOrderTypeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BusinessOrderTypeEdge"]>
};
	["BusinessOrderTypeEdge"]: {
	__typename: "BusinessOrderTypeEdge",
	node: GraphQLTypes["BusinessOrderType"]
};
	["BusinessOrderTypeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	locales?: Array<GraphQLTypes["BusinessOrderTypeCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BusinessOrderTypeCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	create?: GraphQLTypes["BusinessOrderTypeLocaleWithoutRootCreateInput"],
	alias?: string
};
	["BusinessOrderTypeLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	locale?: GraphQLTypes["BusinessOrderTypeLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BusinessOrderTypeLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutBusinessOrderTypesCreateInput"]
};
	["LocaleWithoutBusinessOrderTypesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleCreateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleCreateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleCreateMenusEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BusinessOrderTypeUpdateInput"]: {
		order?: number,
	locales?: Array<GraphQLTypes["BusinessOrderTypeUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BusinessOrderTypeUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BusinessOrderTypeLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["BusinessOrderTypeUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["BusinessOrderTypeUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	delete?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	alias?: string
};
	["BusinessOrderTypeUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	data?: GraphQLTypes["BusinessOrderTypeLocaleWithoutRootUpdateInput"]
};
	["BusinessOrderTypeLocaleWithoutRootUpdateInput"]: {
		title?: string,
	locale?: GraphQLTypes["BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutBusinessOrderTypesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutBusinessOrderTypesUpdateInput"],
	upsert?: GraphQLTypes["BusinessOrderTypeLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutBusinessOrderTypesUpdateInput"]: {
		code?: string,
	label?: string,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	blogs?: Array<GraphQLTypes["LocaleUpdateBlogsEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seos?: Array<GraphQLTypes["LocaleUpdateSeosEntityRelationInput"]>,
	menus?: Array<GraphQLTypes["LocaleUpdateMenusEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BusinessOrderTypeLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutBusinessOrderTypesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutBusinessOrderTypesCreateInput"]
};
	["BusinessOrderTypeUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["BusinessOrderTypeLocaleUniqueWhere"],
	update?: GraphQLTypes["BusinessOrderTypeLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["BusinessOrderTypeLocaleWithoutRootCreateInput"]
};
	["BusinessOrderTypeLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["BusinessOrderTypeLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["BusinessOrderTypeLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BusinessOrderTypeLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["BusinessOrderTypeLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["BusinessOrderTypeLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getColorPallete?: GraphQLTypes["ColorPallete"],
	listColorPallete: Array<GraphQLTypes["ColorPallete"]>,
	paginateColorPallete: GraphQLTypes["ColorPalleteConnection"],
	validateCreateColorPallete: GraphQLTypes["_ValidationResult"],
	validateUpdateColorPallete: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getCover?: GraphQLTypes["Cover"],
	listCover: Array<GraphQLTypes["Cover"]>,
	paginateCover: GraphQLTypes["CoverConnection"],
	validateCreateCover: GraphQLTypes["_ValidationResult"],
	validateUpdateCover: GraphQLTypes["_ValidationResult"],
	getEvent?: GraphQLTypes["Event"],
	listEvent: Array<GraphQLTypes["Event"]>,
	paginateEvent: GraphQLTypes["EventConnection"],
	validateCreateEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateEvent: GraphQLTypes["_ValidationResult"],
	getEventLocale?: GraphQLTypes["EventLocale"],
	listEventLocale: Array<GraphQLTypes["EventLocale"]>,
	paginateEventLocale: GraphQLTypes["EventLocaleConnection"],
	validateCreateEventLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateEventLocale: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"],
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageItem?: GraphQLTypes["ImageItem"],
	listImageItem: Array<GraphQLTypes["ImageItem"]>,
	paginateImageItem: GraphQLTypes["ImageItemConnection"],
	validateCreateImageItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageItem: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"],
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"],
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"],
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getBlog?: GraphQLTypes["Blog"],
	listBlog: Array<GraphQLTypes["Blog"]>,
	paginateBlog: GraphQLTypes["BlogConnection"],
	validateCreateBlog: GraphQLTypes["_ValidationResult"],
	validateUpdateBlog: GraphQLTypes["_ValidationResult"],
	getBlogLocale?: GraphQLTypes["BlogLocale"],
	listBlogLocale: Array<GraphQLTypes["BlogLocale"]>,
	paginateBlogLocale: GraphQLTypes["BlogLocaleConnection"],
	validateCreateBlogLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogLocale: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getPageLocale?: GraphQLTypes["PageLocale"],
	listPageLocale: Array<GraphQLTypes["PageLocale"]>,
	paginatePageLocale: GraphQLTypes["PageLocaleConnection"],
	validateCreatePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePageLocale: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getSeoLocale?: GraphQLTypes["SeoLocale"],
	listSeoLocale: Array<GraphQLTypes["SeoLocale"]>,
	paginateSeoLocale: GraphQLTypes["SeoLocaleConnection"],
	validateCreateSeoLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoLocale: GraphQLTypes["_ValidationResult"],
	getLocalizedSeo?: GraphQLTypes["LocalizedSeo"],
	listLocalizedSeo: Array<GraphQLTypes["LocalizedSeo"]>,
	paginateLocalizedSeo: GraphQLTypes["LocalizedSeoConnection"],
	validateCreateLocalizedSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateLocalizedSeo: GraphQLTypes["_ValidationResult"],
	getHero?: GraphQLTypes["Hero"],
	listHero: Array<GraphQLTypes["Hero"]>,
	paginateHero: GraphQLTypes["HeroConnection"],
	validateCreateHero: GraphQLTypes["_ValidationResult"],
	validateUpdateHero: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"],
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"],
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getSocialsAndApps?: GraphQLTypes["SocialsAndApps"],
	listSocialsAndApps: Array<GraphQLTypes["SocialsAndApps"]>,
	paginateSocialsAndApps: GraphQLTypes["SocialsAndAppsConnection"],
	validateCreateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialsAndApps: GraphQLTypes["_ValidationResult"],
	getSiteMenu?: GraphQLTypes["SiteMenu"],
	listSiteMenu: Array<GraphQLTypes["SiteMenu"]>,
	paginateSiteMenu: GraphQLTypes["SiteMenuConnection"],
	validateCreateSiteMenu: GraphQLTypes["_ValidationResult"],
	validateUpdateSiteMenu: GraphQLTypes["_ValidationResult"],
	getMenuItem?: GraphQLTypes["MenuItem"],
	listMenuItem: Array<GraphQLTypes["MenuItem"]>,
	paginateMenuItem: GraphQLTypes["MenuItemConnection"],
	validateCreateMenuItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuItem: GraphQLTypes["_ValidationResult"],
	getBlogPostList?: GraphQLTypes["BlogPostList"],
	listBlogPostList: Array<GraphQLTypes["BlogPostList"]>,
	paginateBlogPostList: GraphQLTypes["BlogPostListConnection"],
	validateCreateBlogPostList: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostList: GraphQLTypes["_ValidationResult"],
	getBlogPostListItem?: GraphQLTypes["BlogPostListItem"],
	listBlogPostListItem: Array<GraphQLTypes["BlogPostListItem"]>,
	paginateBlogPostListItem: GraphQLTypes["BlogPostListItemConnection"],
	validateCreateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostListItem: GraphQLTypes["_ValidationResult"],
	getMenuLocale?: GraphQLTypes["MenuLocale"],
	listMenuLocale: Array<GraphQLTypes["MenuLocale"]>,
	paginateMenuLocale: GraphQLTypes["MenuLocaleConnection"],
	validateCreateMenuLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateMenuLocale: GraphQLTypes["_ValidationResult"],
	getProductGrid?: GraphQLTypes["ProductGrid"],
	listProductGrid: Array<GraphQLTypes["ProductGrid"]>,
	paginateProductGrid: GraphQLTypes["ProductGridConnection"],
	validateCreateProductGrid: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGrid: GraphQLTypes["_ValidationResult"],
	getProductGridItem?: GraphQLTypes["ProductGridItem"],
	listProductGridItem: Array<GraphQLTypes["ProductGridItem"]>,
	paginateProductGridItem: GraphQLTypes["ProductGridItemConnection"],
	validateCreateProductGridItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProductGridItem: GraphQLTypes["_ValidationResult"],
	getProfile?: GraphQLTypes["Profile"],
	listProfile: Array<GraphQLTypes["Profile"]>,
	paginateProfile: GraphQLTypes["ProfileConnection"],
	validateCreateProfile: GraphQLTypes["_ValidationResult"],
	validateUpdateProfile: GraphQLTypes["_ValidationResult"],
	getProfileTag?: GraphQLTypes["ProfileTag"],
	listProfileTag: Array<GraphQLTypes["ProfileTag"]>,
	paginateProfileTag: GraphQLTypes["ProfileTagConnection"],
	validateCreateProfileTag: GraphQLTypes["_ValidationResult"],
	validateUpdateProfileTag: GraphQLTypes["_ValidationResult"],
	getProfileActivityRecord?: GraphQLTypes["ProfileActivityRecord"],
	listProfileActivityRecord: Array<GraphQLTypes["ProfileActivityRecord"]>,
	paginateProfileActivityRecord: GraphQLTypes["ProfileActivityRecordConnection"],
	validateCreateProfileActivityRecord: GraphQLTypes["_ValidationResult"],
	validateUpdateProfileActivityRecord: GraphQLTypes["_ValidationResult"],
	getProfilePin?: GraphQLTypes["ProfilePin"],
	listProfilePin: Array<GraphQLTypes["ProfilePin"]>,
	paginateProfilePin: GraphQLTypes["ProfilePinConnection"],
	validateCreateProfilePin: GraphQLTypes["_ValidationResult"],
	validateUpdateProfilePin: GraphQLTypes["_ValidationResult"],
	getProfileGallery?: GraphQLTypes["ProfileGallery"],
	listProfileGallery: Array<GraphQLTypes["ProfileGallery"]>,
	paginateProfileGallery: GraphQLTypes["ProfileGalleryConnection"],
	validateCreateProfileGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateProfileGallery: GraphQLTypes["_ValidationResult"],
	getProfileGalleryItem?: GraphQLTypes["ProfileGalleryItem"],
	listProfileGalleryItem: Array<GraphQLTypes["ProfileGalleryItem"]>,
	paginateProfileGalleryItem: GraphQLTypes["ProfileGalleryItemConnection"],
	validateCreateProfileGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateProfileGalleryItem: GraphQLTypes["_ValidationResult"],
	getShoppingList?: GraphQLTypes["ShoppingList"],
	listShoppingList: Array<GraphQLTypes["ShoppingList"]>,
	paginateShoppingList: GraphQLTypes["ShoppingListConnection"],
	validateCreateShoppingList: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingList: GraphQLTypes["_ValidationResult"],
	getShoppingListItem?: GraphQLTypes["ShoppingListItem"],
	listShoppingListItem: Array<GraphQLTypes["ShoppingListItem"]>,
	paginateShoppingListItem: GraphQLTypes["ShoppingListItemConnection"],
	validateCreateShoppingListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShoppingListItem: GraphQLTypes["_ValidationResult"],
	getSupplier?: GraphQLTypes["Supplier"],
	listSupplier: Array<GraphQLTypes["Supplier"]>,
	paginateSupplier: GraphQLTypes["SupplierConnection"],
	validateCreateSupplier: GraphQLTypes["_ValidationResult"],
	validateUpdateSupplier: GraphQLTypes["_ValidationResult"],
	getFavouriteItem?: GraphQLTypes["FavouriteItem"],
	listFavouriteItem: Array<GraphQLTypes["FavouriteItem"]>,
	paginateFavouriteItem: GraphQLTypes["FavouriteItemConnection"],
	validateCreateFavouriteItem: GraphQLTypes["_ValidationResult"],
	validateUpdateFavouriteItem: GraphQLTypes["_ValidationResult"],
	getBusinessOrderType?: GraphQLTypes["BusinessOrderType"],
	listBusinessOrderType: Array<GraphQLTypes["BusinessOrderType"]>,
	paginateBusinessOrderType: GraphQLTypes["BusinessOrderTypeConnection"],
	validateCreateBusinessOrderType: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessOrderType: GraphQLTypes["_ValidationResult"],
	getBusinessOrderTypeLocale?: GraphQLTypes["BusinessOrderTypeLocale"],
	listBusinessOrderTypeLocale: Array<GraphQLTypes["BusinessOrderTypeLocale"]>,
	paginateBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleConnection"],
	validateCreateBusinessOrderTypeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBusinessOrderTypeLocale: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	createColorPallete: GraphQLTypes["ColorPalleteCreateResult"],
	deleteColorPallete: GraphQLTypes["ColorPalleteDeleteResult"],
	updateColorPallete: GraphQLTypes["ColorPalleteUpdateResult"],
	upsertColorPallete: GraphQLTypes["ColorPalleteUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createCover: GraphQLTypes["CoverCreateResult"],
	deleteCover: GraphQLTypes["CoverDeleteResult"],
	updateCover: GraphQLTypes["CoverUpdateResult"],
	upsertCover: GraphQLTypes["CoverUpsertResult"],
	createEvent: GraphQLTypes["EventCreateResult"],
	deleteEvent: GraphQLTypes["EventDeleteResult"],
	updateEvent: GraphQLTypes["EventUpdateResult"],
	upsertEvent: GraphQLTypes["EventUpsertResult"],
	createEventLocale: GraphQLTypes["EventLocaleCreateResult"],
	deleteEventLocale: GraphQLTypes["EventLocaleDeleteResult"],
	updateEventLocale: GraphQLTypes["EventLocaleUpdateResult"],
	upsertEventLocale: GraphQLTypes["EventLocaleUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageItem: GraphQLTypes["ImageItemCreateResult"],
	deleteImageItem: GraphQLTypes["ImageItemDeleteResult"],
	updateImageItem: GraphQLTypes["ImageItemUpdateResult"],
	upsertImageItem: GraphQLTypes["ImageItemUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createBlog: GraphQLTypes["BlogCreateResult"],
	deleteBlog: GraphQLTypes["BlogDeleteResult"],
	updateBlog: GraphQLTypes["BlogUpdateResult"],
	upsertBlog: GraphQLTypes["BlogUpsertResult"],
	createBlogLocale: GraphQLTypes["BlogLocaleCreateResult"],
	deleteBlogLocale: GraphQLTypes["BlogLocaleDeleteResult"],
	updateBlogLocale: GraphQLTypes["BlogLocaleUpdateResult"],
	upsertBlogLocale: GraphQLTypes["BlogLocaleUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createPageLocale: GraphQLTypes["PageLocaleCreateResult"],
	deletePageLocale: GraphQLTypes["PageLocaleDeleteResult"],
	updatePageLocale: GraphQLTypes["PageLocaleUpdateResult"],
	upsertPageLocale: GraphQLTypes["PageLocaleUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createSeoLocale: GraphQLTypes["SeoLocaleCreateResult"],
	deleteSeoLocale: GraphQLTypes["SeoLocaleDeleteResult"],
	updateSeoLocale: GraphQLTypes["SeoLocaleUpdateResult"],
	upsertSeoLocale: GraphQLTypes["SeoLocaleUpsertResult"],
	createLocalizedSeo: GraphQLTypes["LocalizedSeoCreateResult"],
	deleteLocalizedSeo: GraphQLTypes["LocalizedSeoDeleteResult"],
	updateLocalizedSeo: GraphQLTypes["LocalizedSeoUpdateResult"],
	upsertLocalizedSeo: GraphQLTypes["LocalizedSeoUpsertResult"],
	createHero: GraphQLTypes["HeroCreateResult"],
	deleteHero: GraphQLTypes["HeroDeleteResult"],
	updateHero: GraphQLTypes["HeroUpdateResult"],
	upsertHero: GraphQLTypes["HeroUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createSocialsAndApps: GraphQLTypes["SocialsAndAppsCreateResult"],
	deleteSocialsAndApps: GraphQLTypes["SocialsAndAppsDeleteResult"],
	updateSocialsAndApps: GraphQLTypes["SocialsAndAppsUpdateResult"],
	upsertSocialsAndApps: GraphQLTypes["SocialsAndAppsUpsertResult"],
	createSiteMenu: GraphQLTypes["SiteMenuCreateResult"],
	deleteSiteMenu: GraphQLTypes["SiteMenuDeleteResult"],
	updateSiteMenu: GraphQLTypes["SiteMenuUpdateResult"],
	upsertSiteMenu: GraphQLTypes["SiteMenuUpsertResult"],
	createMenuItem: GraphQLTypes["MenuItemCreateResult"],
	deleteMenuItem: GraphQLTypes["MenuItemDeleteResult"],
	updateMenuItem: GraphQLTypes["MenuItemUpdateResult"],
	upsertMenuItem: GraphQLTypes["MenuItemUpsertResult"],
	createBlogPostList: GraphQLTypes["BlogPostListCreateResult"],
	deleteBlogPostList: GraphQLTypes["BlogPostListDeleteResult"],
	updateBlogPostList: GraphQLTypes["BlogPostListUpdateResult"],
	upsertBlogPostList: GraphQLTypes["BlogPostListUpsertResult"],
	createBlogPostListItem: GraphQLTypes["BlogPostListItemCreateResult"],
	deleteBlogPostListItem: GraphQLTypes["BlogPostListItemDeleteResult"],
	updateBlogPostListItem: GraphQLTypes["BlogPostListItemUpdateResult"],
	upsertBlogPostListItem: GraphQLTypes["BlogPostListItemUpsertResult"],
	createMenuLocale: GraphQLTypes["MenuLocaleCreateResult"],
	deleteMenuLocale: GraphQLTypes["MenuLocaleDeleteResult"],
	updateMenuLocale: GraphQLTypes["MenuLocaleUpdateResult"],
	upsertMenuLocale: GraphQLTypes["MenuLocaleUpsertResult"],
	createProductGrid: GraphQLTypes["ProductGridCreateResult"],
	deleteProductGrid: GraphQLTypes["ProductGridDeleteResult"],
	updateProductGrid: GraphQLTypes["ProductGridUpdateResult"],
	upsertProductGrid: GraphQLTypes["ProductGridUpsertResult"],
	createProductGridItem: GraphQLTypes["ProductGridItemCreateResult"],
	deleteProductGridItem: GraphQLTypes["ProductGridItemDeleteResult"],
	updateProductGridItem: GraphQLTypes["ProductGridItemUpdateResult"],
	upsertProductGridItem: GraphQLTypes["ProductGridItemUpsertResult"],
	createProfile: GraphQLTypes["ProfileCreateResult"],
	deleteProfile: GraphQLTypes["ProfileDeleteResult"],
	updateProfile: GraphQLTypes["ProfileUpdateResult"],
	upsertProfile: GraphQLTypes["ProfileUpsertResult"],
	createProfileTag: GraphQLTypes["ProfileTagCreateResult"],
	deleteProfileTag: GraphQLTypes["ProfileTagDeleteResult"],
	updateProfileTag: GraphQLTypes["ProfileTagUpdateResult"],
	upsertProfileTag: GraphQLTypes["ProfileTagUpsertResult"],
	createProfileActivityRecord: GraphQLTypes["ProfileActivityRecordCreateResult"],
	deleteProfileActivityRecord: GraphQLTypes["ProfileActivityRecordDeleteResult"],
	updateProfileActivityRecord: GraphQLTypes["ProfileActivityRecordUpdateResult"],
	upsertProfileActivityRecord: GraphQLTypes["ProfileActivityRecordUpsertResult"],
	createProfilePin: GraphQLTypes["ProfilePinCreateResult"],
	deleteProfilePin: GraphQLTypes["ProfilePinDeleteResult"],
	updateProfilePin: GraphQLTypes["ProfilePinUpdateResult"],
	upsertProfilePin: GraphQLTypes["ProfilePinUpsertResult"],
	createProfileGallery: GraphQLTypes["ProfileGalleryCreateResult"],
	deleteProfileGallery: GraphQLTypes["ProfileGalleryDeleteResult"],
	updateProfileGallery: GraphQLTypes["ProfileGalleryUpdateResult"],
	upsertProfileGallery: GraphQLTypes["ProfileGalleryUpsertResult"],
	createProfileGalleryItem: GraphQLTypes["ProfileGalleryItemCreateResult"],
	deleteProfileGalleryItem: GraphQLTypes["ProfileGalleryItemDeleteResult"],
	updateProfileGalleryItem: GraphQLTypes["ProfileGalleryItemUpdateResult"],
	upsertProfileGalleryItem: GraphQLTypes["ProfileGalleryItemUpsertResult"],
	createShoppingList: GraphQLTypes["ShoppingListCreateResult"],
	deleteShoppingList: GraphQLTypes["ShoppingListDeleteResult"],
	updateShoppingList: GraphQLTypes["ShoppingListUpdateResult"],
	upsertShoppingList: GraphQLTypes["ShoppingListUpsertResult"],
	createShoppingListItem: GraphQLTypes["ShoppingListItemCreateResult"],
	deleteShoppingListItem: GraphQLTypes["ShoppingListItemDeleteResult"],
	updateShoppingListItem: GraphQLTypes["ShoppingListItemUpdateResult"],
	upsertShoppingListItem: GraphQLTypes["ShoppingListItemUpsertResult"],
	createSupplier: GraphQLTypes["SupplierCreateResult"],
	deleteSupplier: GraphQLTypes["SupplierDeleteResult"],
	updateSupplier: GraphQLTypes["SupplierUpdateResult"],
	upsertSupplier: GraphQLTypes["SupplierUpsertResult"],
	createFavouriteItem: GraphQLTypes["FavouriteItemCreateResult"],
	deleteFavouriteItem: GraphQLTypes["FavouriteItemDeleteResult"],
	updateFavouriteItem: GraphQLTypes["FavouriteItemUpdateResult"],
	upsertFavouriteItem: GraphQLTypes["FavouriteItemUpsertResult"],
	createBusinessOrderType: GraphQLTypes["BusinessOrderTypeCreateResult"],
	deleteBusinessOrderType: GraphQLTypes["BusinessOrderTypeDeleteResult"],
	updateBusinessOrderType: GraphQLTypes["BusinessOrderTypeUpdateResult"],
	upsertBusinessOrderType: GraphQLTypes["BusinessOrderTypeUpsertResult"],
	createBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleCreateResult"],
	deleteBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleDeleteResult"],
	updateBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleUpdateResult"],
	upsertBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["ColorPalleteCreateResult"]: {
	__typename: "ColorPalleteCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"ColorPalleteCreateResult" | "ColorPalleteDeleteResult" | "ColorPalleteUpdateResult" | "ColorPalleteUpsertResult" | "ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "CoverCreateResult" | "CoverDeleteResult" | "CoverUpdateResult" | "CoverUpsertResult" | "EventCreateResult" | "EventDeleteResult" | "EventUpdateResult" | "EventUpsertResult" | "EventLocaleCreateResult" | "EventLocaleDeleteResult" | "EventLocaleUpdateResult" | "EventLocaleUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "ImageListCreateResult" | "ImageListDeleteResult" | "ImageListUpdateResult" | "ImageListUpsertResult" | "ImageItemCreateResult" | "ImageItemDeleteResult" | "ImageItemUpdateResult" | "ImageItemUpsertResult" | "LocaleCreateResult" | "LocaleDeleteResult" | "LocaleUpdateResult" | "LocaleUpsertResult" | "MediumCreateResult" | "MediumDeleteResult" | "MediumUpdateResult" | "MediumUpsertResult" | "VideoCreateResult" | "VideoDeleteResult" | "VideoUpdateResult" | "VideoUpsertResult" | "BlogCreateResult" | "BlogDeleteResult" | "BlogUpdateResult" | "BlogUpsertResult" | "BlogLocaleCreateResult" | "BlogLocaleDeleteResult" | "BlogLocaleUpdateResult" | "BlogLocaleUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "PageCreateResult" | "PageDeleteResult" | "PageUpdateResult" | "PageUpsertResult" | "PageLocaleCreateResult" | "PageLocaleDeleteResult" | "PageLocaleUpdateResult" | "PageLocaleUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "SeoLocaleCreateResult" | "SeoLocaleDeleteResult" | "SeoLocaleUpdateResult" | "SeoLocaleUpsertResult" | "LocalizedSeoCreateResult" | "LocalizedSeoDeleteResult" | "LocalizedSeoUpdateResult" | "LocalizedSeoUpsertResult" | "HeroCreateResult" | "HeroDeleteResult" | "HeroUpdateResult" | "HeroUpsertResult" | "GalleryCreateResult" | "GalleryDeleteResult" | "GalleryUpdateResult" | "GalleryUpsertResult" | "GalleryItemCreateResult" | "GalleryItemDeleteResult" | "GalleryItemUpdateResult" | "GalleryItemUpsertResult" | "SocialsAndAppsCreateResult" | "SocialsAndAppsDeleteResult" | "SocialsAndAppsUpdateResult" | "SocialsAndAppsUpsertResult" | "SiteMenuCreateResult" | "SiteMenuDeleteResult" | "SiteMenuUpdateResult" | "SiteMenuUpsertResult" | "MenuItemCreateResult" | "MenuItemDeleteResult" | "MenuItemUpdateResult" | "MenuItemUpsertResult" | "BlogPostListCreateResult" | "BlogPostListDeleteResult" | "BlogPostListUpdateResult" | "BlogPostListUpsertResult" | "BlogPostListItemCreateResult" | "BlogPostListItemDeleteResult" | "BlogPostListItemUpdateResult" | "BlogPostListItemUpsertResult" | "MenuLocaleCreateResult" | "MenuLocaleDeleteResult" | "MenuLocaleUpdateResult" | "MenuLocaleUpsertResult" | "ProductGridCreateResult" | "ProductGridDeleteResult" | "ProductGridUpdateResult" | "ProductGridUpsertResult" | "ProductGridItemCreateResult" | "ProductGridItemDeleteResult" | "ProductGridItemUpdateResult" | "ProductGridItemUpsertResult" | "ProfileCreateResult" | "ProfileDeleteResult" | "ProfileUpdateResult" | "ProfileUpsertResult" | "ProfileTagCreateResult" | "ProfileTagDeleteResult" | "ProfileTagUpdateResult" | "ProfileTagUpsertResult" | "ProfileActivityRecordCreateResult" | "ProfileActivityRecordDeleteResult" | "ProfileActivityRecordUpdateResult" | "ProfileActivityRecordUpsertResult" | "ProfilePinCreateResult" | "ProfilePinDeleteResult" | "ProfilePinUpdateResult" | "ProfilePinUpsertResult" | "ProfileGalleryCreateResult" | "ProfileGalleryDeleteResult" | "ProfileGalleryUpdateResult" | "ProfileGalleryUpsertResult" | "ProfileGalleryItemCreateResult" | "ProfileGalleryItemDeleteResult" | "ProfileGalleryItemUpdateResult" | "ProfileGalleryItemUpsertResult" | "ShoppingListCreateResult" | "ShoppingListDeleteResult" | "ShoppingListUpdateResult" | "ShoppingListUpsertResult" | "ShoppingListItemCreateResult" | "ShoppingListItemDeleteResult" | "ShoppingListItemUpdateResult" | "ShoppingListItemUpsertResult" | "SupplierCreateResult" | "SupplierDeleteResult" | "SupplierUpdateResult" | "SupplierUpsertResult" | "FavouriteItemCreateResult" | "FavouriteItemDeleteResult" | "FavouriteItemUpdateResult" | "FavouriteItemUpsertResult" | "BusinessOrderTypeCreateResult" | "BusinessOrderTypeDeleteResult" | "BusinessOrderTypeUpdateResult" | "BusinessOrderTypeUpsertResult" | "BusinessOrderTypeLocaleCreateResult" | "BusinessOrderTypeLocaleDeleteResult" | "BusinessOrderTypeLocaleUpdateResult" | "BusinessOrderTypeLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on ColorPalleteCreateResult']: '__union' & GraphQLTypes["ColorPalleteCreateResult"];
	['...on ColorPalleteDeleteResult']: '__union' & GraphQLTypes["ColorPalleteDeleteResult"];
	['...on ColorPalleteUpdateResult']: '__union' & GraphQLTypes["ColorPalleteUpdateResult"];
	['...on ColorPalleteUpsertResult']: '__union' & GraphQLTypes["ColorPalleteUpsertResult"];
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on CoverCreateResult']: '__union' & GraphQLTypes["CoverCreateResult"];
	['...on CoverDeleteResult']: '__union' & GraphQLTypes["CoverDeleteResult"];
	['...on CoverUpdateResult']: '__union' & GraphQLTypes["CoverUpdateResult"];
	['...on CoverUpsertResult']: '__union' & GraphQLTypes["CoverUpsertResult"];
	['...on EventCreateResult']: '__union' & GraphQLTypes["EventCreateResult"];
	['...on EventDeleteResult']: '__union' & GraphQLTypes["EventDeleteResult"];
	['...on EventUpdateResult']: '__union' & GraphQLTypes["EventUpdateResult"];
	['...on EventUpsertResult']: '__union' & GraphQLTypes["EventUpsertResult"];
	['...on EventLocaleCreateResult']: '__union' & GraphQLTypes["EventLocaleCreateResult"];
	['...on EventLocaleDeleteResult']: '__union' & GraphQLTypes["EventLocaleDeleteResult"];
	['...on EventLocaleUpdateResult']: '__union' & GraphQLTypes["EventLocaleUpdateResult"];
	['...on EventLocaleUpsertResult']: '__union' & GraphQLTypes["EventLocaleUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on ImageListCreateResult']: '__union' & GraphQLTypes["ImageListCreateResult"];
	['...on ImageListDeleteResult']: '__union' & GraphQLTypes["ImageListDeleteResult"];
	['...on ImageListUpdateResult']: '__union' & GraphQLTypes["ImageListUpdateResult"];
	['...on ImageListUpsertResult']: '__union' & GraphQLTypes["ImageListUpsertResult"];
	['...on ImageItemCreateResult']: '__union' & GraphQLTypes["ImageItemCreateResult"];
	['...on ImageItemDeleteResult']: '__union' & GraphQLTypes["ImageItemDeleteResult"];
	['...on ImageItemUpdateResult']: '__union' & GraphQLTypes["ImageItemUpdateResult"];
	['...on ImageItemUpsertResult']: '__union' & GraphQLTypes["ImageItemUpsertResult"];
	['...on LocaleCreateResult']: '__union' & GraphQLTypes["LocaleCreateResult"];
	['...on LocaleDeleteResult']: '__union' & GraphQLTypes["LocaleDeleteResult"];
	['...on LocaleUpdateResult']: '__union' & GraphQLTypes["LocaleUpdateResult"];
	['...on LocaleUpsertResult']: '__union' & GraphQLTypes["LocaleUpsertResult"];
	['...on MediumCreateResult']: '__union' & GraphQLTypes["MediumCreateResult"];
	['...on MediumDeleteResult']: '__union' & GraphQLTypes["MediumDeleteResult"];
	['...on MediumUpdateResult']: '__union' & GraphQLTypes["MediumUpdateResult"];
	['...on MediumUpsertResult']: '__union' & GraphQLTypes["MediumUpsertResult"];
	['...on VideoCreateResult']: '__union' & GraphQLTypes["VideoCreateResult"];
	['...on VideoDeleteResult']: '__union' & GraphQLTypes["VideoDeleteResult"];
	['...on VideoUpdateResult']: '__union' & GraphQLTypes["VideoUpdateResult"];
	['...on VideoUpsertResult']: '__union' & GraphQLTypes["VideoUpsertResult"];
	['...on BlogCreateResult']: '__union' & GraphQLTypes["BlogCreateResult"];
	['...on BlogDeleteResult']: '__union' & GraphQLTypes["BlogDeleteResult"];
	['...on BlogUpdateResult']: '__union' & GraphQLTypes["BlogUpdateResult"];
	['...on BlogUpsertResult']: '__union' & GraphQLTypes["BlogUpsertResult"];
	['...on BlogLocaleCreateResult']: '__union' & GraphQLTypes["BlogLocaleCreateResult"];
	['...on BlogLocaleDeleteResult']: '__union' & GraphQLTypes["BlogLocaleDeleteResult"];
	['...on BlogLocaleUpdateResult']: '__union' & GraphQLTypes["BlogLocaleUpdateResult"];
	['...on BlogLocaleUpsertResult']: '__union' & GraphQLTypes["BlogLocaleUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on PageCreateResult']: '__union' & GraphQLTypes["PageCreateResult"];
	['...on PageDeleteResult']: '__union' & GraphQLTypes["PageDeleteResult"];
	['...on PageUpdateResult']: '__union' & GraphQLTypes["PageUpdateResult"];
	['...on PageUpsertResult']: '__union' & GraphQLTypes["PageUpsertResult"];
	['...on PageLocaleCreateResult']: '__union' & GraphQLTypes["PageLocaleCreateResult"];
	['...on PageLocaleDeleteResult']: '__union' & GraphQLTypes["PageLocaleDeleteResult"];
	['...on PageLocaleUpdateResult']: '__union' & GraphQLTypes["PageLocaleUpdateResult"];
	['...on PageLocaleUpsertResult']: '__union' & GraphQLTypes["PageLocaleUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on SeoLocaleCreateResult']: '__union' & GraphQLTypes["SeoLocaleCreateResult"];
	['...on SeoLocaleDeleteResult']: '__union' & GraphQLTypes["SeoLocaleDeleteResult"];
	['...on SeoLocaleUpdateResult']: '__union' & GraphQLTypes["SeoLocaleUpdateResult"];
	['...on SeoLocaleUpsertResult']: '__union' & GraphQLTypes["SeoLocaleUpsertResult"];
	['...on LocalizedSeoCreateResult']: '__union' & GraphQLTypes["LocalizedSeoCreateResult"];
	['...on LocalizedSeoDeleteResult']: '__union' & GraphQLTypes["LocalizedSeoDeleteResult"];
	['...on LocalizedSeoUpdateResult']: '__union' & GraphQLTypes["LocalizedSeoUpdateResult"];
	['...on LocalizedSeoUpsertResult']: '__union' & GraphQLTypes["LocalizedSeoUpsertResult"];
	['...on HeroCreateResult']: '__union' & GraphQLTypes["HeroCreateResult"];
	['...on HeroDeleteResult']: '__union' & GraphQLTypes["HeroDeleteResult"];
	['...on HeroUpdateResult']: '__union' & GraphQLTypes["HeroUpdateResult"];
	['...on HeroUpsertResult']: '__union' & GraphQLTypes["HeroUpsertResult"];
	['...on GalleryCreateResult']: '__union' & GraphQLTypes["GalleryCreateResult"];
	['...on GalleryDeleteResult']: '__union' & GraphQLTypes["GalleryDeleteResult"];
	['...on GalleryUpdateResult']: '__union' & GraphQLTypes["GalleryUpdateResult"];
	['...on GalleryUpsertResult']: '__union' & GraphQLTypes["GalleryUpsertResult"];
	['...on GalleryItemCreateResult']: '__union' & GraphQLTypes["GalleryItemCreateResult"];
	['...on GalleryItemDeleteResult']: '__union' & GraphQLTypes["GalleryItemDeleteResult"];
	['...on GalleryItemUpdateResult']: '__union' & GraphQLTypes["GalleryItemUpdateResult"];
	['...on GalleryItemUpsertResult']: '__union' & GraphQLTypes["GalleryItemUpsertResult"];
	['...on SocialsAndAppsCreateResult']: '__union' & GraphQLTypes["SocialsAndAppsCreateResult"];
	['...on SocialsAndAppsDeleteResult']: '__union' & GraphQLTypes["SocialsAndAppsDeleteResult"];
	['...on SocialsAndAppsUpdateResult']: '__union' & GraphQLTypes["SocialsAndAppsUpdateResult"];
	['...on SocialsAndAppsUpsertResult']: '__union' & GraphQLTypes["SocialsAndAppsUpsertResult"];
	['...on SiteMenuCreateResult']: '__union' & GraphQLTypes["SiteMenuCreateResult"];
	['...on SiteMenuDeleteResult']: '__union' & GraphQLTypes["SiteMenuDeleteResult"];
	['...on SiteMenuUpdateResult']: '__union' & GraphQLTypes["SiteMenuUpdateResult"];
	['...on SiteMenuUpsertResult']: '__union' & GraphQLTypes["SiteMenuUpsertResult"];
	['...on MenuItemCreateResult']: '__union' & GraphQLTypes["MenuItemCreateResult"];
	['...on MenuItemDeleteResult']: '__union' & GraphQLTypes["MenuItemDeleteResult"];
	['...on MenuItemUpdateResult']: '__union' & GraphQLTypes["MenuItemUpdateResult"];
	['...on MenuItemUpsertResult']: '__union' & GraphQLTypes["MenuItemUpsertResult"];
	['...on BlogPostListCreateResult']: '__union' & GraphQLTypes["BlogPostListCreateResult"];
	['...on BlogPostListDeleteResult']: '__union' & GraphQLTypes["BlogPostListDeleteResult"];
	['...on BlogPostListUpdateResult']: '__union' & GraphQLTypes["BlogPostListUpdateResult"];
	['...on BlogPostListUpsertResult']: '__union' & GraphQLTypes["BlogPostListUpsertResult"];
	['...on BlogPostListItemCreateResult']: '__union' & GraphQLTypes["BlogPostListItemCreateResult"];
	['...on BlogPostListItemDeleteResult']: '__union' & GraphQLTypes["BlogPostListItemDeleteResult"];
	['...on BlogPostListItemUpdateResult']: '__union' & GraphQLTypes["BlogPostListItemUpdateResult"];
	['...on BlogPostListItemUpsertResult']: '__union' & GraphQLTypes["BlogPostListItemUpsertResult"];
	['...on MenuLocaleCreateResult']: '__union' & GraphQLTypes["MenuLocaleCreateResult"];
	['...on MenuLocaleDeleteResult']: '__union' & GraphQLTypes["MenuLocaleDeleteResult"];
	['...on MenuLocaleUpdateResult']: '__union' & GraphQLTypes["MenuLocaleUpdateResult"];
	['...on MenuLocaleUpsertResult']: '__union' & GraphQLTypes["MenuLocaleUpsertResult"];
	['...on ProductGridCreateResult']: '__union' & GraphQLTypes["ProductGridCreateResult"];
	['...on ProductGridDeleteResult']: '__union' & GraphQLTypes["ProductGridDeleteResult"];
	['...on ProductGridUpdateResult']: '__union' & GraphQLTypes["ProductGridUpdateResult"];
	['...on ProductGridUpsertResult']: '__union' & GraphQLTypes["ProductGridUpsertResult"];
	['...on ProductGridItemCreateResult']: '__union' & GraphQLTypes["ProductGridItemCreateResult"];
	['...on ProductGridItemDeleteResult']: '__union' & GraphQLTypes["ProductGridItemDeleteResult"];
	['...on ProductGridItemUpdateResult']: '__union' & GraphQLTypes["ProductGridItemUpdateResult"];
	['...on ProductGridItemUpsertResult']: '__union' & GraphQLTypes["ProductGridItemUpsertResult"];
	['...on ProfileCreateResult']: '__union' & GraphQLTypes["ProfileCreateResult"];
	['...on ProfileDeleteResult']: '__union' & GraphQLTypes["ProfileDeleteResult"];
	['...on ProfileUpdateResult']: '__union' & GraphQLTypes["ProfileUpdateResult"];
	['...on ProfileUpsertResult']: '__union' & GraphQLTypes["ProfileUpsertResult"];
	['...on ProfileTagCreateResult']: '__union' & GraphQLTypes["ProfileTagCreateResult"];
	['...on ProfileTagDeleteResult']: '__union' & GraphQLTypes["ProfileTagDeleteResult"];
	['...on ProfileTagUpdateResult']: '__union' & GraphQLTypes["ProfileTagUpdateResult"];
	['...on ProfileTagUpsertResult']: '__union' & GraphQLTypes["ProfileTagUpsertResult"];
	['...on ProfileActivityRecordCreateResult']: '__union' & GraphQLTypes["ProfileActivityRecordCreateResult"];
	['...on ProfileActivityRecordDeleteResult']: '__union' & GraphQLTypes["ProfileActivityRecordDeleteResult"];
	['...on ProfileActivityRecordUpdateResult']: '__union' & GraphQLTypes["ProfileActivityRecordUpdateResult"];
	['...on ProfileActivityRecordUpsertResult']: '__union' & GraphQLTypes["ProfileActivityRecordUpsertResult"];
	['...on ProfilePinCreateResult']: '__union' & GraphQLTypes["ProfilePinCreateResult"];
	['...on ProfilePinDeleteResult']: '__union' & GraphQLTypes["ProfilePinDeleteResult"];
	['...on ProfilePinUpdateResult']: '__union' & GraphQLTypes["ProfilePinUpdateResult"];
	['...on ProfilePinUpsertResult']: '__union' & GraphQLTypes["ProfilePinUpsertResult"];
	['...on ProfileGalleryCreateResult']: '__union' & GraphQLTypes["ProfileGalleryCreateResult"];
	['...on ProfileGalleryDeleteResult']: '__union' & GraphQLTypes["ProfileGalleryDeleteResult"];
	['...on ProfileGalleryUpdateResult']: '__union' & GraphQLTypes["ProfileGalleryUpdateResult"];
	['...on ProfileGalleryUpsertResult']: '__union' & GraphQLTypes["ProfileGalleryUpsertResult"];
	['...on ProfileGalleryItemCreateResult']: '__union' & GraphQLTypes["ProfileGalleryItemCreateResult"];
	['...on ProfileGalleryItemDeleteResult']: '__union' & GraphQLTypes["ProfileGalleryItemDeleteResult"];
	['...on ProfileGalleryItemUpdateResult']: '__union' & GraphQLTypes["ProfileGalleryItemUpdateResult"];
	['...on ProfileGalleryItemUpsertResult']: '__union' & GraphQLTypes["ProfileGalleryItemUpsertResult"];
	['...on ShoppingListCreateResult']: '__union' & GraphQLTypes["ShoppingListCreateResult"];
	['...on ShoppingListDeleteResult']: '__union' & GraphQLTypes["ShoppingListDeleteResult"];
	['...on ShoppingListUpdateResult']: '__union' & GraphQLTypes["ShoppingListUpdateResult"];
	['...on ShoppingListUpsertResult']: '__union' & GraphQLTypes["ShoppingListUpsertResult"];
	['...on ShoppingListItemCreateResult']: '__union' & GraphQLTypes["ShoppingListItemCreateResult"];
	['...on ShoppingListItemDeleteResult']: '__union' & GraphQLTypes["ShoppingListItemDeleteResult"];
	['...on ShoppingListItemUpdateResult']: '__union' & GraphQLTypes["ShoppingListItemUpdateResult"];
	['...on ShoppingListItemUpsertResult']: '__union' & GraphQLTypes["ShoppingListItemUpsertResult"];
	['...on SupplierCreateResult']: '__union' & GraphQLTypes["SupplierCreateResult"];
	['...on SupplierDeleteResult']: '__union' & GraphQLTypes["SupplierDeleteResult"];
	['...on SupplierUpdateResult']: '__union' & GraphQLTypes["SupplierUpdateResult"];
	['...on SupplierUpsertResult']: '__union' & GraphQLTypes["SupplierUpsertResult"];
	['...on FavouriteItemCreateResult']: '__union' & GraphQLTypes["FavouriteItemCreateResult"];
	['...on FavouriteItemDeleteResult']: '__union' & GraphQLTypes["FavouriteItemDeleteResult"];
	['...on FavouriteItemUpdateResult']: '__union' & GraphQLTypes["FavouriteItemUpdateResult"];
	['...on FavouriteItemUpsertResult']: '__union' & GraphQLTypes["FavouriteItemUpsertResult"];
	['...on BusinessOrderTypeCreateResult']: '__union' & GraphQLTypes["BusinessOrderTypeCreateResult"];
	['...on BusinessOrderTypeDeleteResult']: '__union' & GraphQLTypes["BusinessOrderTypeDeleteResult"];
	['...on BusinessOrderTypeUpdateResult']: '__union' & GraphQLTypes["BusinessOrderTypeUpdateResult"];
	['...on BusinessOrderTypeUpsertResult']: '__union' & GraphQLTypes["BusinessOrderTypeUpsertResult"];
	['...on BusinessOrderTypeLocaleCreateResult']: '__union' & GraphQLTypes["BusinessOrderTypeLocaleCreateResult"];
	['...on BusinessOrderTypeLocaleDeleteResult']: '__union' & GraphQLTypes["BusinessOrderTypeLocaleDeleteResult"];
	['...on BusinessOrderTypeLocaleUpdateResult']: '__union' & GraphQLTypes["BusinessOrderTypeLocaleUpdateResult"];
	['...on BusinessOrderTypeLocaleUpsertResult']: '__union' & GraphQLTypes["BusinessOrderTypeLocaleUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["ColorPalleteDeleteResult"]: {
	__typename: "ColorPalleteDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"]
};
	["ColorPalleteUpdateResult"]: {
	__typename: "ColorPalleteUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorPalleteUpsertResult"]: {
	__typename: "ColorPalleteUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ColorPallete"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"]
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverCreateResult"]: {
	__typename: "CoverCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverDeleteResult"]: {
	__typename: "CoverDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"]
};
	["CoverUpdateResult"]: {
	__typename: "CoverUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CoverUpsertResult"]: {
	__typename: "CoverUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Cover"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventCreateResult"]: {
	__typename: "EventCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventDeleteResult"]: {
	__typename: "EventDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"]
};
	["EventUpdateResult"]: {
	__typename: "EventUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventUpsertResult"]: {
	__typename: "EventUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLocaleCreateResult"]: {
	__typename: "EventLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLocaleDeleteResult"]: {
	__typename: "EventLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLocale"]
};
	["EventLocaleUpdateResult"]: {
	__typename: "EventLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLocaleUpsertResult"]: {
	__typename: "EventLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
	__typename: "ImageListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
	__typename: "ImageListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"]
};
	["ImageListUpdateResult"]: {
	__typename: "ImageListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
	__typename: "ImageListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageItemCreateResult"]: {
	__typename: "ImageItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageItemDeleteResult"]: {
	__typename: "ImageItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageItem"]
};
	["ImageItemUpdateResult"]: {
	__typename: "ImageItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageItemUpsertResult"]: {
	__typename: "ImageItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
	__typename: "LocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
	__typename: "LocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"]
};
	["LocaleUpdateResult"]: {
	__typename: "LocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
	__typename: "LocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
	__typename: "MediumCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
	__typename: "MediumDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"]
};
	["MediumUpdateResult"]: {
	__typename: "MediumUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
	__typename: "MediumUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
	__typename: "VideoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
	__typename: "VideoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"]
};
	["VideoUpdateResult"]: {
	__typename: "VideoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
	__typename: "VideoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogCreateResult"]: {
	__typename: "BlogCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogDeleteResult"]: {
	__typename: "BlogDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"]
};
	["BlogUpdateResult"]: {
	__typename: "BlogUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogUpsertResult"]: {
	__typename: "BlogUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Blog"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleCreateResult"]: {
	__typename: "BlogLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleDeleteResult"]: {
	__typename: "BlogLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"]
};
	["BlogLocaleUpdateResult"]: {
	__typename: "BlogLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogLocaleUpsertResult"]: {
	__typename: "BlogLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
	__typename: "PageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
	__typename: "PageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"]
};
	["PageUpdateResult"]: {
	__typename: "PageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
	__typename: "PageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleCreateResult"]: {
	__typename: "PageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleDeleteResult"]: {
	__typename: "PageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"]
};
	["PageLocaleUpdateResult"]: {
	__typename: "PageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleUpsertResult"]: {
	__typename: "PageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoLocaleCreateResult"]: {
	__typename: "SeoLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoLocaleDeleteResult"]: {
	__typename: "SeoLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoLocale"]
};
	["SeoLocaleUpdateResult"]: {
	__typename: "SeoLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoLocaleUpsertResult"]: {
	__typename: "SeoLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocalizedSeoCreateResult"]: {
	__typename: "LocalizedSeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LocalizedSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocalizedSeoDeleteResult"]: {
	__typename: "LocalizedSeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LocalizedSeo"]
};
	["LocalizedSeoUpdateResult"]: {
	__typename: "LocalizedSeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LocalizedSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocalizedSeoUpsertResult"]: {
	__typename: "LocalizedSeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LocalizedSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroCreateResult"]: {
	__typename: "HeroCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroDeleteResult"]: {
	__typename: "HeroDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"]
};
	["HeroUpdateResult"]: {
	__typename: "HeroUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeroUpsertResult"]: {
	__typename: "HeroUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Hero"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
	__typename: "GalleryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
	__typename: "GalleryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"]
};
	["GalleryUpdateResult"]: {
	__typename: "GalleryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
	__typename: "GalleryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
	__typename: "GalleryItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
	__typename: "GalleryItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"]
};
	["GalleryItemUpdateResult"]: {
	__typename: "GalleryItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
	__typename: "GalleryItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsCreateResult"]: {
	__typename: "SocialsAndAppsCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsDeleteResult"]: {
	__typename: "SocialsAndAppsDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"]
};
	["SocialsAndAppsUpdateResult"]: {
	__typename: "SocialsAndAppsUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialsAndAppsUpsertResult"]: {
	__typename: "SocialsAndAppsUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialsAndApps"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuCreateResult"]: {
	__typename: "SiteMenuCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuDeleteResult"]: {
	__typename: "SiteMenuDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"]
};
	["SiteMenuUpdateResult"]: {
	__typename: "SiteMenuUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteMenuUpsertResult"]: {
	__typename: "SiteMenuUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SiteMenu"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemCreateResult"]: {
	__typename: "MenuItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemDeleteResult"]: {
	__typename: "MenuItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"]
};
	["MenuItemUpdateResult"]: {
	__typename: "MenuItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuItemUpsertResult"]: {
	__typename: "MenuItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListCreateResult"]: {
	__typename: "BlogPostListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListDeleteResult"]: {
	__typename: "BlogPostListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"]
};
	["BlogPostListUpdateResult"]: {
	__typename: "BlogPostListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListUpsertResult"]: {
	__typename: "BlogPostListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemCreateResult"]: {
	__typename: "BlogPostListItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemDeleteResult"]: {
	__typename: "BlogPostListItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"]
};
	["BlogPostListItemUpdateResult"]: {
	__typename: "BlogPostListItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostListItemUpsertResult"]: {
	__typename: "BlogPostListItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleCreateResult"]: {
	__typename: "MenuLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleDeleteResult"]: {
	__typename: "MenuLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"]
};
	["MenuLocaleUpdateResult"]: {
	__typename: "MenuLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MenuLocaleUpsertResult"]: {
	__typename: "MenuLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MenuLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridCreateResult"]: {
	__typename: "ProductGridCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridDeleteResult"]: {
	__typename: "ProductGridDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"]
};
	["ProductGridUpdateResult"]: {
	__typename: "ProductGridUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridUpsertResult"]: {
	__typename: "ProductGridUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGrid"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemCreateResult"]: {
	__typename: "ProductGridItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemDeleteResult"]: {
	__typename: "ProductGridItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"]
};
	["ProductGridItemUpdateResult"]: {
	__typename: "ProductGridItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductGridItemUpsertResult"]: {
	__typename: "ProductGridItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductGridItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileCreateResult"]: {
	__typename: "ProfileCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Profile"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileDeleteResult"]: {
	__typename: "ProfileDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Profile"]
};
	["ProfileUpdateResult"]: {
	__typename: "ProfileUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Profile"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileUpsertResult"]: {
	__typename: "ProfileUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Profile"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileTagCreateResult"]: {
	__typename: "ProfileTagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileTagDeleteResult"]: {
	__typename: "ProfileTagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileTag"]
};
	["ProfileTagUpdateResult"]: {
	__typename: "ProfileTagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileTagUpsertResult"]: {
	__typename: "ProfileTagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileActivityRecordCreateResult"]: {
	__typename: "ProfileActivityRecordCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileActivityRecord"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileActivityRecordDeleteResult"]: {
	__typename: "ProfileActivityRecordDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileActivityRecord"]
};
	["ProfileActivityRecordUpdateResult"]: {
	__typename: "ProfileActivityRecordUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileActivityRecord"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileActivityRecordUpsertResult"]: {
	__typename: "ProfileActivityRecordUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileActivityRecord"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfilePinCreateResult"]: {
	__typename: "ProfilePinCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfilePin"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfilePinDeleteResult"]: {
	__typename: "ProfilePinDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfilePin"]
};
	["ProfilePinUpdateResult"]: {
	__typename: "ProfilePinUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfilePin"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfilePinUpsertResult"]: {
	__typename: "ProfilePinUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfilePin"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileGalleryCreateResult"]: {
	__typename: "ProfileGalleryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileGallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileGalleryDeleteResult"]: {
	__typename: "ProfileGalleryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileGallery"]
};
	["ProfileGalleryUpdateResult"]: {
	__typename: "ProfileGalleryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileGallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileGalleryUpsertResult"]: {
	__typename: "ProfileGalleryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileGallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileGalleryItemCreateResult"]: {
	__typename: "ProfileGalleryItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileGalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileGalleryItemDeleteResult"]: {
	__typename: "ProfileGalleryItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileGalleryItem"]
};
	["ProfileGalleryItemUpdateResult"]: {
	__typename: "ProfileGalleryItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileGalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProfileGalleryItemUpsertResult"]: {
	__typename: "ProfileGalleryItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProfileGalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListCreateResult"]: {
	__typename: "ShoppingListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListDeleteResult"]: {
	__typename: "ShoppingListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"]
};
	["ShoppingListUpdateResult"]: {
	__typename: "ShoppingListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListUpsertResult"]: {
	__typename: "ShoppingListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemCreateResult"]: {
	__typename: "ShoppingListItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemDeleteResult"]: {
	__typename: "ShoppingListItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"]
};
	["ShoppingListItemUpdateResult"]: {
	__typename: "ShoppingListItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShoppingListItemUpsertResult"]: {
	__typename: "ShoppingListItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShoppingListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SupplierCreateResult"]: {
	__typename: "SupplierCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Supplier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SupplierDeleteResult"]: {
	__typename: "SupplierDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Supplier"]
};
	["SupplierUpdateResult"]: {
	__typename: "SupplierUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Supplier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SupplierUpsertResult"]: {
	__typename: "SupplierUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Supplier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FavouriteItemCreateResult"]: {
	__typename: "FavouriteItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FavouriteItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FavouriteItemDeleteResult"]: {
	__typename: "FavouriteItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FavouriteItem"]
};
	["FavouriteItemUpdateResult"]: {
	__typename: "FavouriteItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FavouriteItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FavouriteItemUpsertResult"]: {
	__typename: "FavouriteItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FavouriteItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessOrderTypeCreateResult"]: {
	__typename: "BusinessOrderTypeCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessOrderType"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessOrderTypeDeleteResult"]: {
	__typename: "BusinessOrderTypeDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessOrderType"]
};
	["BusinessOrderTypeUpdateResult"]: {
	__typename: "BusinessOrderTypeUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessOrderType"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessOrderTypeUpsertResult"]: {
	__typename: "BusinessOrderTypeUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessOrderType"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessOrderTypeLocaleCreateResult"]: {
	__typename: "BusinessOrderTypeLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessOrderTypeLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessOrderTypeLocaleDeleteResult"]: {
	__typename: "BusinessOrderTypeLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessOrderTypeLocale"]
};
	["BusinessOrderTypeLocaleUpdateResult"]: {
	__typename: "BusinessOrderTypeLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessOrderTypeLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BusinessOrderTypeLocaleUpsertResult"]: {
	__typename: "BusinessOrderTypeLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BusinessOrderTypeLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createColorPallete: GraphQLTypes["ColorPalleteCreateResult"],
	deleteColorPallete: GraphQLTypes["ColorPalleteDeleteResult"],
	updateColorPallete: GraphQLTypes["ColorPalleteUpdateResult"],
	upsertColorPallete: GraphQLTypes["ColorPalleteUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createCover: GraphQLTypes["CoverCreateResult"],
	deleteCover: GraphQLTypes["CoverDeleteResult"],
	updateCover: GraphQLTypes["CoverUpdateResult"],
	upsertCover: GraphQLTypes["CoverUpsertResult"],
	createEvent: GraphQLTypes["EventCreateResult"],
	deleteEvent: GraphQLTypes["EventDeleteResult"],
	updateEvent: GraphQLTypes["EventUpdateResult"],
	upsertEvent: GraphQLTypes["EventUpsertResult"],
	createEventLocale: GraphQLTypes["EventLocaleCreateResult"],
	deleteEventLocale: GraphQLTypes["EventLocaleDeleteResult"],
	updateEventLocale: GraphQLTypes["EventLocaleUpdateResult"],
	upsertEventLocale: GraphQLTypes["EventLocaleUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageItem: GraphQLTypes["ImageItemCreateResult"],
	deleteImageItem: GraphQLTypes["ImageItemDeleteResult"],
	updateImageItem: GraphQLTypes["ImageItemUpdateResult"],
	upsertImageItem: GraphQLTypes["ImageItemUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createBlog: GraphQLTypes["BlogCreateResult"],
	deleteBlog: GraphQLTypes["BlogDeleteResult"],
	updateBlog: GraphQLTypes["BlogUpdateResult"],
	upsertBlog: GraphQLTypes["BlogUpsertResult"],
	createBlogLocale: GraphQLTypes["BlogLocaleCreateResult"],
	deleteBlogLocale: GraphQLTypes["BlogLocaleDeleteResult"],
	updateBlogLocale: GraphQLTypes["BlogLocaleUpdateResult"],
	upsertBlogLocale: GraphQLTypes["BlogLocaleUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createPageLocale: GraphQLTypes["PageLocaleCreateResult"],
	deletePageLocale: GraphQLTypes["PageLocaleDeleteResult"],
	updatePageLocale: GraphQLTypes["PageLocaleUpdateResult"],
	upsertPageLocale: GraphQLTypes["PageLocaleUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createSeoLocale: GraphQLTypes["SeoLocaleCreateResult"],
	deleteSeoLocale: GraphQLTypes["SeoLocaleDeleteResult"],
	updateSeoLocale: GraphQLTypes["SeoLocaleUpdateResult"],
	upsertSeoLocale: GraphQLTypes["SeoLocaleUpsertResult"],
	createLocalizedSeo: GraphQLTypes["LocalizedSeoCreateResult"],
	deleteLocalizedSeo: GraphQLTypes["LocalizedSeoDeleteResult"],
	updateLocalizedSeo: GraphQLTypes["LocalizedSeoUpdateResult"],
	upsertLocalizedSeo: GraphQLTypes["LocalizedSeoUpsertResult"],
	createHero: GraphQLTypes["HeroCreateResult"],
	deleteHero: GraphQLTypes["HeroDeleteResult"],
	updateHero: GraphQLTypes["HeroUpdateResult"],
	upsertHero: GraphQLTypes["HeroUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createSocialsAndApps: GraphQLTypes["SocialsAndAppsCreateResult"],
	deleteSocialsAndApps: GraphQLTypes["SocialsAndAppsDeleteResult"],
	updateSocialsAndApps: GraphQLTypes["SocialsAndAppsUpdateResult"],
	upsertSocialsAndApps: GraphQLTypes["SocialsAndAppsUpsertResult"],
	createSiteMenu: GraphQLTypes["SiteMenuCreateResult"],
	deleteSiteMenu: GraphQLTypes["SiteMenuDeleteResult"],
	updateSiteMenu: GraphQLTypes["SiteMenuUpdateResult"],
	upsertSiteMenu: GraphQLTypes["SiteMenuUpsertResult"],
	createMenuItem: GraphQLTypes["MenuItemCreateResult"],
	deleteMenuItem: GraphQLTypes["MenuItemDeleteResult"],
	updateMenuItem: GraphQLTypes["MenuItemUpdateResult"],
	upsertMenuItem: GraphQLTypes["MenuItemUpsertResult"],
	createBlogPostList: GraphQLTypes["BlogPostListCreateResult"],
	deleteBlogPostList: GraphQLTypes["BlogPostListDeleteResult"],
	updateBlogPostList: GraphQLTypes["BlogPostListUpdateResult"],
	upsertBlogPostList: GraphQLTypes["BlogPostListUpsertResult"],
	createBlogPostListItem: GraphQLTypes["BlogPostListItemCreateResult"],
	deleteBlogPostListItem: GraphQLTypes["BlogPostListItemDeleteResult"],
	updateBlogPostListItem: GraphQLTypes["BlogPostListItemUpdateResult"],
	upsertBlogPostListItem: GraphQLTypes["BlogPostListItemUpsertResult"],
	createMenuLocale: GraphQLTypes["MenuLocaleCreateResult"],
	deleteMenuLocale: GraphQLTypes["MenuLocaleDeleteResult"],
	updateMenuLocale: GraphQLTypes["MenuLocaleUpdateResult"],
	upsertMenuLocale: GraphQLTypes["MenuLocaleUpsertResult"],
	createProductGrid: GraphQLTypes["ProductGridCreateResult"],
	deleteProductGrid: GraphQLTypes["ProductGridDeleteResult"],
	updateProductGrid: GraphQLTypes["ProductGridUpdateResult"],
	upsertProductGrid: GraphQLTypes["ProductGridUpsertResult"],
	createProductGridItem: GraphQLTypes["ProductGridItemCreateResult"],
	deleteProductGridItem: GraphQLTypes["ProductGridItemDeleteResult"],
	updateProductGridItem: GraphQLTypes["ProductGridItemUpdateResult"],
	upsertProductGridItem: GraphQLTypes["ProductGridItemUpsertResult"],
	createProfile: GraphQLTypes["ProfileCreateResult"],
	deleteProfile: GraphQLTypes["ProfileDeleteResult"],
	updateProfile: GraphQLTypes["ProfileUpdateResult"],
	upsertProfile: GraphQLTypes["ProfileUpsertResult"],
	createProfileTag: GraphQLTypes["ProfileTagCreateResult"],
	deleteProfileTag: GraphQLTypes["ProfileTagDeleteResult"],
	updateProfileTag: GraphQLTypes["ProfileTagUpdateResult"],
	upsertProfileTag: GraphQLTypes["ProfileTagUpsertResult"],
	createProfileActivityRecord: GraphQLTypes["ProfileActivityRecordCreateResult"],
	deleteProfileActivityRecord: GraphQLTypes["ProfileActivityRecordDeleteResult"],
	updateProfileActivityRecord: GraphQLTypes["ProfileActivityRecordUpdateResult"],
	upsertProfileActivityRecord: GraphQLTypes["ProfileActivityRecordUpsertResult"],
	createProfilePin: GraphQLTypes["ProfilePinCreateResult"],
	deleteProfilePin: GraphQLTypes["ProfilePinDeleteResult"],
	updateProfilePin: GraphQLTypes["ProfilePinUpdateResult"],
	upsertProfilePin: GraphQLTypes["ProfilePinUpsertResult"],
	createProfileGallery: GraphQLTypes["ProfileGalleryCreateResult"],
	deleteProfileGallery: GraphQLTypes["ProfileGalleryDeleteResult"],
	updateProfileGallery: GraphQLTypes["ProfileGalleryUpdateResult"],
	upsertProfileGallery: GraphQLTypes["ProfileGalleryUpsertResult"],
	createProfileGalleryItem: GraphQLTypes["ProfileGalleryItemCreateResult"],
	deleteProfileGalleryItem: GraphQLTypes["ProfileGalleryItemDeleteResult"],
	updateProfileGalleryItem: GraphQLTypes["ProfileGalleryItemUpdateResult"],
	upsertProfileGalleryItem: GraphQLTypes["ProfileGalleryItemUpsertResult"],
	createShoppingList: GraphQLTypes["ShoppingListCreateResult"],
	deleteShoppingList: GraphQLTypes["ShoppingListDeleteResult"],
	updateShoppingList: GraphQLTypes["ShoppingListUpdateResult"],
	upsertShoppingList: GraphQLTypes["ShoppingListUpsertResult"],
	createShoppingListItem: GraphQLTypes["ShoppingListItemCreateResult"],
	deleteShoppingListItem: GraphQLTypes["ShoppingListItemDeleteResult"],
	updateShoppingListItem: GraphQLTypes["ShoppingListItemUpdateResult"],
	upsertShoppingListItem: GraphQLTypes["ShoppingListItemUpsertResult"],
	createSupplier: GraphQLTypes["SupplierCreateResult"],
	deleteSupplier: GraphQLTypes["SupplierDeleteResult"],
	updateSupplier: GraphQLTypes["SupplierUpdateResult"],
	upsertSupplier: GraphQLTypes["SupplierUpsertResult"],
	createFavouriteItem: GraphQLTypes["FavouriteItemCreateResult"],
	deleteFavouriteItem: GraphQLTypes["FavouriteItemDeleteResult"],
	updateFavouriteItem: GraphQLTypes["FavouriteItemUpdateResult"],
	upsertFavouriteItem: GraphQLTypes["FavouriteItemUpsertResult"],
	createBusinessOrderType: GraphQLTypes["BusinessOrderTypeCreateResult"],
	deleteBusinessOrderType: GraphQLTypes["BusinessOrderTypeDeleteResult"],
	updateBusinessOrderType: GraphQLTypes["BusinessOrderTypeUpdateResult"],
	upsertBusinessOrderType: GraphQLTypes["BusinessOrderTypeUpsertResult"],
	createBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleCreateResult"],
	deleteBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleDeleteResult"],
	updateBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleUpdateResult"],
	upsertBusinessOrderTypeLocale: GraphQLTypes["BusinessOrderTypeLocaleUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["Json"]:any;
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export const enum OrderDirection {
	asc = "asc",
	desc = "desc"
}
export const enum ContentReferenceType {
	button = "button",
	content = "content",
	gallery = "gallery",
	hero = "hero",
	hr = "hr",
	marquee = "marquee",
	blogPosts = "blogPosts",
	productGrid = "productGrid",
	relatedBlogPosts = "relatedBlogPosts",
	medium = "medium",
	products = "products",
	socialsAndApps = "socialsAndApps"
}
export const enum MediumType {
	image = "image",
	video = "video"
}
export const enum ColorTheme {
	light = "light",
	dark = "dark"
}
export const enum LinkType {
	internal = "internal",
	external = "external",
	download = "download"
}
export const enum One {
	One = "One"
}
export const enum ContentSize {
	small = "small",
	medium = "medium",
	large = "large"
}
export const enum ProfileActivityRecordType {
	visit = "visit"
}
export const enum ProfilePinType {
	visit = "visit"
}
export const enum Familiarity {
	cizi = "cizi",
	pratelskeVykani = "pratelskeVykani",
	slusneTykani = "slusneTykani",
	tykani = "tykani",
	sikana = "sikana"
}
export const enum VipStatus {
	gold = "gold",
	silver = "silver",
	bronze = "bronze"
}
export const enum ProfileStatus {
	regular = "regular",
	waiting = "waiting"
}
export const enum ShoppingListItemStatus {
	pending = "pending",
	removed = "removed",
	purchased = "purchased"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: true;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type OperationToGraphQL<V, T> = <Z extends V>(o: Z | V, options?: OperationOptions) => Promise<InputType<T, Z>>;
export type SubscriptionToGraphQL<V, T> = <Z extends V>(
  o: Z | V,
  options?: OperationOptions,
) => {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?:string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => void;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});

export const fullChainConstructor = <F extends FetchFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullChainConstruct(fn)(operation, key)(o as any, options)) as OperationToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));

export const fullSubscriptionConstructor = <F extends SubscriptionFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullSubscriptionConstruct(fn)(operation, key)(o as any, options)) as SubscriptionToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };


export const Thunder = (fn: FetchFunction, subscriptionFn: SubscriptionFunction) => ({
  query: fullChainConstructor(fn,'query', 'Query'),
mutation: fullChainConstructor(fn,'mutation', 'Mutation')
});

export const Chain = (...options: chainOptions) => ({
  query: fullChainConstructor(apiFetch(options),'query', 'Query'),
mutation: fullChainConstructor(apiFetch(options),'mutation', 'Mutation')
});
export const Zeus = {
  query: (o:ValueTypes["Query"], operationName?: string) => queryConstruct('query', 'Query', operationName)(o),
mutation: (o:ValueTypes["Mutation"], operationName?: string) => queryConstruct('mutation', 'Mutation', operationName)(o)
};
export const Selectors = {
  query: ZeusSelect<ValueTypes["Query"]>(),
mutation: ZeusSelect<ValueTypes["Mutation"]>()
};
  
export type FragmentResult<K extends keyof ModelTypes, Q extends () => unknown> = MapType<
	ModelTypes[K],
	ReturnType<Q>
>